"use client";
import {
  lightTheme
} from "./chunk-Q4HVINFA.js";

// src/components/ConnectButton/ConnectButton.tsx
import React56, { useContext as useContext18 } from "react";

// src/css/sprinkles.css.ts
import { createMapValueFn as _51c72 } from "@vanilla-extract/sprinkles/createUtils";
import { createNormalizeValueFn as _a49f6 } from "@vanilla-extract/sprinkles/createUtils";
import { createSprinkles as _ad221 } from "@vanilla-extract/sprinkles/createRuntimeSprinkles";
var largeScreenMinWidth = 768;
var mapResponsiveValue = _51c72({ conditions: { defaultCondition: "smallScreen", conditionNames: ["smallScreen", "largeScreen"], responsiveArray: void 0 } });
var normalizeResponsiveValue = _a49f6({ conditions: { defaultCondition: "smallScreen", conditionNames: ["smallScreen", "largeScreen"], responsiveArray: void 0 } });
var sprinkles = _ad221({ conditions: { defaultCondition: "base", conditionNames: ["base", "hover", "active"], responsiveArray: void 0 }, styles: { background: { values: { accentColor: { conditions: { base: "ju367v9c", hover: "ju367v9d", active: "ju367v9e" }, defaultClass: "ju367v9c" }, accentColorForeground: { conditions: { base: "ju367v9f", hover: "ju367v9g", active: "ju367v9h" }, defaultClass: "ju367v9f" }, actionButtonBorder: { conditions: { base: "ju367v9i", hover: "ju367v9j", active: "ju367v9k" }, defaultClass: "ju367v9i" }, actionButtonBorderMobile: { conditions: { base: "ju367v9l", hover: "ju367v9m", active: "ju367v9n" }, defaultClass: "ju367v9l" }, actionButtonSecondaryBackground: { conditions: { base: "ju367v9o", hover: "ju367v9p", active: "ju367v9q" }, defaultClass: "ju367v9o" }, closeButton: { conditions: { base: "ju367v9r", hover: "ju367v9s", active: "ju367v9t" }, defaultClass: "ju367v9r" }, closeButtonBackground: { conditions: { base: "ju367v9u", hover: "ju367v9v", active: "ju367v9w" }, defaultClass: "ju367v9u" }, connectButtonBackground: { conditions: { base: "ju367v9x", hover: "ju367v9y", active: "ju367v9z" }, defaultClass: "ju367v9x" }, connectButtonBackgroundError: { conditions: { base: "ju367va0", hover: "ju367va1", active: "ju367va2" }, defaultClass: "ju367va0" }, connectButtonInnerBackground: { conditions: { base: "ju367va3", hover: "ju367va4", active: "ju367va5" }, defaultClass: "ju367va3" }, connectButtonText: { conditions: { base: "ju367va6", hover: "ju367va7", active: "ju367va8" }, defaultClass: "ju367va6" }, connectButtonTextError: { conditions: { base: "ju367va9", hover: "ju367vaa", active: "ju367vab" }, defaultClass: "ju367va9" }, connectionIndicator: { conditions: { base: "ju367vac", hover: "ju367vad", active: "ju367vae" }, defaultClass: "ju367vac" }, downloadBottomCardBackground: { conditions: { base: "ju367vaf", hover: "ju367vag", active: "ju367vah" }, defaultClass: "ju367vaf" }, downloadTopCardBackground: { conditions: { base: "ju367vai", hover: "ju367vaj", active: "ju367vak" }, defaultClass: "ju367vai" }, error: { conditions: { base: "ju367val", hover: "ju367vam", active: "ju367van" }, defaultClass: "ju367val" }, generalBorder: { conditions: { base: "ju367vao", hover: "ju367vap", active: "ju367vaq" }, defaultClass: "ju367vao" }, generalBorderDim: { conditions: { base: "ju367var", hover: "ju367vas", active: "ju367vat" }, defaultClass: "ju367var" }, menuItemBackground: { conditions: { base: "ju367vau", hover: "ju367vav", active: "ju367vaw" }, defaultClass: "ju367vau" }, modalBackdrop: { conditions: { base: "ju367vax", hover: "ju367vay", active: "ju367vaz" }, defaultClass: "ju367vax" }, modalBackground: { conditions: { base: "ju367vb0", hover: "ju367vb1", active: "ju367vb2" }, defaultClass: "ju367vb0" }, modalBorder: { conditions: { base: "ju367vb3", hover: "ju367vb4", active: "ju367vb5" }, defaultClass: "ju367vb3" }, modalText: { conditions: { base: "ju367vb6", hover: "ju367vb7", active: "ju367vb8" }, defaultClass: "ju367vb6" }, modalTextDim: { conditions: { base: "ju367vb9", hover: "ju367vba", active: "ju367vbb" }, defaultClass: "ju367vb9" }, modalTextSecondary: { conditions: { base: "ju367vbc", hover: "ju367vbd", active: "ju367vbe" }, defaultClass: "ju367vbc" }, profileAction: { conditions: { base: "ju367vbf", hover: "ju367vbg", active: "ju367vbh" }, defaultClass: "ju367vbf" }, profileActionHover: { conditions: { base: "ju367vbi", hover: "ju367vbj", active: "ju367vbk" }, defaultClass: "ju367vbi" }, profileForeground: { conditions: { base: "ju367vbl", hover: "ju367vbm", active: "ju367vbn" }, defaultClass: "ju367vbl" }, selectedOptionBorder: { conditions: { base: "ju367vbo", hover: "ju367vbp", active: "ju367vbq" }, defaultClass: "ju367vbo" }, standby: { conditions: { base: "ju367vbr", hover: "ju367vbs", active: "ju367vbt" }, defaultClass: "ju367vbr" } } }, borderColor: { values: { accentColor: { conditions: { base: "ju367vbu", hover: "ju367vbv", active: "ju367vbw" }, defaultClass: "ju367vbu" }, accentColorForeground: { conditions: { base: "ju367vbx", hover: "ju367vby", active: "ju367vbz" }, defaultClass: "ju367vbx" }, actionButtonBorder: { conditions: { base: "ju367vc0", hover: "ju367vc1", active: "ju367vc2" }, defaultClass: "ju367vc0" }, actionButtonBorderMobile: { conditions: { base: "ju367vc3", hover: "ju367vc4", active: "ju367vc5" }, defaultClass: "ju367vc3" }, actionButtonSecondaryBackground: { conditions: { base: "ju367vc6", hover: "ju367vc7", active: "ju367vc8" }, defaultClass: "ju367vc6" }, closeButton: { conditions: { base: "ju367vc9", hover: "ju367vca", active: "ju367vcb" }, defaultClass: "ju367vc9" }, closeButtonBackground: { conditions: { base: "ju367vcc", hover: "ju367vcd", active: "ju367vce" }, defaultClass: "ju367vcc" }, connectButtonBackground: { conditions: { base: "ju367vcf", hover: "ju367vcg", active: "ju367vch" }, defaultClass: "ju367vcf" }, connectButtonBackgroundError: { conditions: { base: "ju367vci", hover: "ju367vcj", active: "ju367vck" }, defaultClass: "ju367vci" }, connectButtonInnerBackground: { conditions: { base: "ju367vcl", hover: "ju367vcm", active: "ju367vcn" }, defaultClass: "ju367vcl" }, connectButtonText: { conditions: { base: "ju367vco", hover: "ju367vcp", active: "ju367vcq" }, defaultClass: "ju367vco" }, connectButtonTextError: { conditions: { base: "ju367vcr", hover: "ju367vcs", active: "ju367vct" }, defaultClass: "ju367vcr" }, connectionIndicator: { conditions: { base: "ju367vcu", hover: "ju367vcv", active: "ju367vcw" }, defaultClass: "ju367vcu" }, downloadBottomCardBackground: { conditions: { base: "ju367vcx", hover: "ju367vcy", active: "ju367vcz" }, defaultClass: "ju367vcx" }, downloadTopCardBackground: { conditions: { base: "ju367vd0", hover: "ju367vd1", active: "ju367vd2" }, defaultClass: "ju367vd0" }, error: { conditions: { base: "ju367vd3", hover: "ju367vd4", active: "ju367vd5" }, defaultClass: "ju367vd3" }, generalBorder: { conditions: { base: "ju367vd6", hover: "ju367vd7", active: "ju367vd8" }, defaultClass: "ju367vd6" }, generalBorderDim: { conditions: { base: "ju367vd9", hover: "ju367vda", active: "ju367vdb" }, defaultClass: "ju367vd9" }, menuItemBackground: { conditions: { base: "ju367vdc", hover: "ju367vdd", active: "ju367vde" }, defaultClass: "ju367vdc" }, modalBackdrop: { conditions: { base: "ju367vdf", hover: "ju367vdg", active: "ju367vdh" }, defaultClass: "ju367vdf" }, modalBackground: { conditions: { base: "ju367vdi", hover: "ju367vdj", active: "ju367vdk" }, defaultClass: "ju367vdi" }, modalBorder: { conditions: { base: "ju367vdl", hover: "ju367vdm", active: "ju367vdn" }, defaultClass: "ju367vdl" }, modalText: { conditions: { base: "ju367vdo", hover: "ju367vdp", active: "ju367vdq" }, defaultClass: "ju367vdo" }, modalTextDim: { conditions: { base: "ju367vdr", hover: "ju367vds", active: "ju367vdt" }, defaultClass: "ju367vdr" }, modalTextSecondary: { conditions: { base: "ju367vdu", hover: "ju367vdv", active: "ju367vdw" }, defaultClass: "ju367vdu" }, profileAction: { conditions: { base: "ju367vdx", hover: "ju367vdy", active: "ju367vdz" }, defaultClass: "ju367vdx" }, profileActionHover: { conditions: { base: "ju367ve0", hover: "ju367ve1", active: "ju367ve2" }, defaultClass: "ju367ve0" }, profileForeground: { conditions: { base: "ju367ve3", hover: "ju367ve4", active: "ju367ve5" }, defaultClass: "ju367ve3" }, selectedOptionBorder: { conditions: { base: "ju367ve6", hover: "ju367ve7", active: "ju367ve8" }, defaultClass: "ju367ve6" }, standby: { conditions: { base: "ju367ve9", hover: "ju367vea", active: "ju367veb" }, defaultClass: "ju367ve9" } } }, boxShadow: { values: { connectButton: { conditions: { base: "ju367vec", hover: "ju367ved", active: "ju367vee" }, defaultClass: "ju367vec" }, dialog: { conditions: { base: "ju367vef", hover: "ju367veg", active: "ju367veh" }, defaultClass: "ju367vef" }, profileDetailsAction: { conditions: { base: "ju367vei", hover: "ju367vej", active: "ju367vek" }, defaultClass: "ju367vei" }, selectedOption: { conditions: { base: "ju367vel", hover: "ju367vem", active: "ju367ven" }, defaultClass: "ju367vel" }, selectedWallet: { conditions: { base: "ju367veo", hover: "ju367vep", active: "ju367veq" }, defaultClass: "ju367veo" }, walletLogo: { conditions: { base: "ju367ver", hover: "ju367ves", active: "ju367vet" }, defaultClass: "ju367ver" } } }, color: { values: { accentColor: { conditions: { base: "ju367veu", hover: "ju367vev", active: "ju367vew" }, defaultClass: "ju367veu" }, accentColorForeground: { conditions: { base: "ju367vex", hover: "ju367vey", active: "ju367vez" }, defaultClass: "ju367vex" }, actionButtonBorder: { conditions: { base: "ju367vf0", hover: "ju367vf1", active: "ju367vf2" }, defaultClass: "ju367vf0" }, actionButtonBorderMobile: { conditions: { base: "ju367vf3", hover: "ju367vf4", active: "ju367vf5" }, defaultClass: "ju367vf3" }, actionButtonSecondaryBackground: { conditions: { base: "ju367vf6", hover: "ju367vf7", active: "ju367vf8" }, defaultClass: "ju367vf6" }, closeButton: { conditions: { base: "ju367vf9", hover: "ju367vfa", active: "ju367vfb" }, defaultClass: "ju367vf9" }, closeButtonBackground: { conditions: { base: "ju367vfc", hover: "ju367vfd", active: "ju367vfe" }, defaultClass: "ju367vfc" }, connectButtonBackground: { conditions: { base: "ju367vff", hover: "ju367vfg", active: "ju367vfh" }, defaultClass: "ju367vff" }, connectButtonBackgroundError: { conditions: { base: "ju367vfi", hover: "ju367vfj", active: "ju367vfk" }, defaultClass: "ju367vfi" }, connectButtonInnerBackground: { conditions: { base: "ju367vfl", hover: "ju367vfm", active: "ju367vfn" }, defaultClass: "ju367vfl" }, connectButtonText: { conditions: { base: "ju367vfo", hover: "ju367vfp", active: "ju367vfq" }, defaultClass: "ju367vfo" }, connectButtonTextError: { conditions: { base: "ju367vfr", hover: "ju367vfs", active: "ju367vft" }, defaultClass: "ju367vfr" }, connectionIndicator: { conditions: { base: "ju367vfu", hover: "ju367vfv", active: "ju367vfw" }, defaultClass: "ju367vfu" }, downloadBottomCardBackground: { conditions: { base: "ju367vfx", hover: "ju367vfy", active: "ju367vfz" }, defaultClass: "ju367vfx" }, downloadTopCardBackground: { conditions: { base: "ju367vg0", hover: "ju367vg1", active: "ju367vg2" }, defaultClass: "ju367vg0" }, error: { conditions: { base: "ju367vg3", hover: "ju367vg4", active: "ju367vg5" }, defaultClass: "ju367vg3" }, generalBorder: { conditions: { base: "ju367vg6", hover: "ju367vg7", active: "ju367vg8" }, defaultClass: "ju367vg6" }, generalBorderDim: { conditions: { base: "ju367vg9", hover: "ju367vga", active: "ju367vgb" }, defaultClass: "ju367vg9" }, menuItemBackground: { conditions: { base: "ju367vgc", hover: "ju367vgd", active: "ju367vge" }, defaultClass: "ju367vgc" }, modalBackdrop: { conditions: { base: "ju367vgf", hover: "ju367vgg", active: "ju367vgh" }, defaultClass: "ju367vgf" }, modalBackground: { conditions: { base: "ju367vgi", hover: "ju367vgj", active: "ju367vgk" }, defaultClass: "ju367vgi" }, modalBorder: { conditions: { base: "ju367vgl", hover: "ju367vgm", active: "ju367vgn" }, defaultClass: "ju367vgl" }, modalText: { conditions: { base: "ju367vgo", hover: "ju367vgp", active: "ju367vgq" }, defaultClass: "ju367vgo" }, modalTextDim: { conditions: { base: "ju367vgr", hover: "ju367vgs", active: "ju367vgt" }, defaultClass: "ju367vgr" }, modalTextSecondary: { conditions: { base: "ju367vgu", hover: "ju367vgv", active: "ju367vgw" }, defaultClass: "ju367vgu" }, profileAction: { conditions: { base: "ju367vgx", hover: "ju367vgy", active: "ju367vgz" }, defaultClass: "ju367vgx" }, profileActionHover: { conditions: { base: "ju367vh0", hover: "ju367vh1", active: "ju367vh2" }, defaultClass: "ju367vh0" }, profileForeground: { conditions: { base: "ju367vh3", hover: "ju367vh4", active: "ju367vh5" }, defaultClass: "ju367vh3" }, selectedOptionBorder: { conditions: { base: "ju367vh6", hover: "ju367vh7", active: "ju367vh8" }, defaultClass: "ju367vh6" }, standby: { conditions: { base: "ju367vh9", hover: "ju367vha", active: "ju367vhb" }, defaultClass: "ju367vh9" } } } } }, { conditions: { defaultCondition: "smallScreen", conditionNames: ["smallScreen", "largeScreen"], responsiveArray: void 0 }, styles: { alignItems: { values: { "flex-start": { conditions: { smallScreen: "ju367v0", largeScreen: "ju367v1" }, defaultClass: "ju367v0" }, "flex-end": { conditions: { smallScreen: "ju367v2", largeScreen: "ju367v3" }, defaultClass: "ju367v2" }, center: { conditions: { smallScreen: "ju367v4", largeScreen: "ju367v5" }, defaultClass: "ju367v4" } } }, display: { values: { none: { conditions: { smallScreen: "ju367v6", largeScreen: "ju367v7" }, defaultClass: "ju367v6" }, block: { conditions: { smallScreen: "ju367v8", largeScreen: "ju367v9" }, defaultClass: "ju367v8" }, flex: { conditions: { smallScreen: "ju367va", largeScreen: "ju367vb" }, defaultClass: "ju367va" }, inline: { conditions: { smallScreen: "ju367vc", largeScreen: "ju367vd" }, defaultClass: "ju367vc" } } } } }, { conditions: void 0, styles: { margin: { mappings: ["marginTop", "marginBottom", "marginLeft", "marginRight"] }, marginX: { mappings: ["marginLeft", "marginRight"] }, marginY: { mappings: ["marginTop", "marginBottom"] }, padding: { mappings: ["paddingTop", "paddingBottom", "paddingLeft", "paddingRight"] }, paddingX: { mappings: ["paddingLeft", "paddingRight"] }, paddingY: { mappings: ["paddingTop", "paddingBottom"] }, alignSelf: { values: { "flex-start": { defaultClass: "ju367ve" }, "flex-end": { defaultClass: "ju367vf" }, center: { defaultClass: "ju367vg" } } }, backgroundSize: { values: { cover: { defaultClass: "ju367vh" } } }, borderRadius: { values: { "1": { defaultClass: "ju367vi" }, "6": { defaultClass: "ju367vj" }, "10": { defaultClass: "ju367vk" }, "13": { defaultClass: "ju367vl" }, actionButton: { defaultClass: "ju367vm" }, connectButton: { defaultClass: "ju367vn" }, menuButton: { defaultClass: "ju367vo" }, modal: { defaultClass: "ju367vp" }, modalMobile: { defaultClass: "ju367vq" }, "25%": { defaultClass: "ju367vr" }, full: { defaultClass: "ju367vs" } } }, borderStyle: { values: { solid: { defaultClass: "ju367vt" } } }, borderWidth: { values: { "0": { defaultClass: "ju367vu" }, "1": { defaultClass: "ju367vv" }, "2": { defaultClass: "ju367vw" }, "4": { defaultClass: "ju367vx" } } }, cursor: { values: { pointer: { defaultClass: "ju367vy" } } }, flexDirection: { values: { row: { defaultClass: "ju367vz" }, column: { defaultClass: "ju367v10" } } }, fontFamily: { values: { body: { defaultClass: "ju367v11" } } }, fontSize: { values: { "12": { defaultClass: "ju367v12" }, "13": { defaultClass: "ju367v13" }, "14": { defaultClass: "ju367v14" }, "16": { defaultClass: "ju367v15" }, "18": { defaultClass: "ju367v16" }, "20": { defaultClass: "ju367v17" }, "23": { defaultClass: "ju367v18" } } }, fontWeight: { values: { regular: { defaultClass: "ju367v19" }, medium: { defaultClass: "ju367v1a" }, semibold: { defaultClass: "ju367v1b" }, bold: { defaultClass: "ju367v1c" }, heavy: { defaultClass: "ju367v1d" } } }, gap: { values: { "0": { defaultClass: "ju367v1e" }, "1": { defaultClass: "ju367v1f" }, "2": { defaultClass: "ju367v1g" }, "3": { defaultClass: "ju367v1h" }, "4": { defaultClass: "ju367v1i" }, "5": { defaultClass: "ju367v1j" }, "6": { defaultClass: "ju367v1k" }, "8": { defaultClass: "ju367v1l" }, "10": { defaultClass: "ju367v1m" }, "12": { defaultClass: "ju367v1n" }, "14": { defaultClass: "ju367v1o" }, "16": { defaultClass: "ju367v1p" }, "18": { defaultClass: "ju367v1q" }, "20": { defaultClass: "ju367v1r" }, "24": { defaultClass: "ju367v1s" }, "28": { defaultClass: "ju367v1t" }, "32": { defaultClass: "ju367v1u" }, "36": { defaultClass: "ju367v1v" }, "44": { defaultClass: "ju367v1w" }, "64": { defaultClass: "ju367v1x" }, "-1": { defaultClass: "ju367v1y" } } }, height: { values: { "1": { defaultClass: "ju367v1z" }, "2": { defaultClass: "ju367v20" }, "4": { defaultClass: "ju367v21" }, "8": { defaultClass: "ju367v22" }, "12": { defaultClass: "ju367v23" }, "20": { defaultClass: "ju367v24" }, "24": { defaultClass: "ju367v25" }, "28": { defaultClass: "ju367v26" }, "30": { defaultClass: "ju367v27" }, "32": { defaultClass: "ju367v28" }, "34": { defaultClass: "ju367v29" }, "36": { defaultClass: "ju367v2a" }, "40": { defaultClass: "ju367v2b" }, "44": { defaultClass: "ju367v2c" }, "48": { defaultClass: "ju367v2d" }, "54": { defaultClass: "ju367v2e" }, "60": { defaultClass: "ju367v2f" }, "200": { defaultClass: "ju367v2g" }, full: { defaultClass: "ju367v2h" }, max: { defaultClass: "ju367v2i" } } }, justifyContent: { values: { "flex-start": { defaultClass: "ju367v2j" }, "flex-end": { defaultClass: "ju367v2k" }, center: { defaultClass: "ju367v2l" }, "space-between": { defaultClass: "ju367v2m" }, "space-around": { defaultClass: "ju367v2n" } } }, textAlign: { values: { left: { defaultClass: "ju367v2o" }, center: { defaultClass: "ju367v2p" }, inherit: { defaultClass: "ju367v2q" } } }, marginBottom: { values: { "0": { defaultClass: "ju367v2r" }, "1": { defaultClass: "ju367v2s" }, "2": { defaultClass: "ju367v2t" }, "3": { defaultClass: "ju367v2u" }, "4": { defaultClass: "ju367v2v" }, "5": { defaultClass: "ju367v2w" }, "6": { defaultClass: "ju367v2x" }, "8": { defaultClass: "ju367v2y" }, "10": { defaultClass: "ju367v2z" }, "12": { defaultClass: "ju367v30" }, "14": { defaultClass: "ju367v31" }, "16": { defaultClass: "ju367v32" }, "18": { defaultClass: "ju367v33" }, "20": { defaultClass: "ju367v34" }, "24": { defaultClass: "ju367v35" }, "28": { defaultClass: "ju367v36" }, "32": { defaultClass: "ju367v37" }, "36": { defaultClass: "ju367v38" }, "44": { defaultClass: "ju367v39" }, "64": { defaultClass: "ju367v3a" }, "-1": { defaultClass: "ju367v3b" } } }, marginLeft: { values: { "0": { defaultClass: "ju367v3c" }, "1": { defaultClass: "ju367v3d" }, "2": { defaultClass: "ju367v3e" }, "3": { defaultClass: "ju367v3f" }, "4": { defaultClass: "ju367v3g" }, "5": { defaultClass: "ju367v3h" }, "6": { defaultClass: "ju367v3i" }, "8": { defaultClass: "ju367v3j" }, "10": { defaultClass: "ju367v3k" }, "12": { defaultClass: "ju367v3l" }, "14": { defaultClass: "ju367v3m" }, "16": { defaultClass: "ju367v3n" }, "18": { defaultClass: "ju367v3o" }, "20": { defaultClass: "ju367v3p" }, "24": { defaultClass: "ju367v3q" }, "28": { defaultClass: "ju367v3r" }, "32": { defaultClass: "ju367v3s" }, "36": { defaultClass: "ju367v3t" }, "44": { defaultClass: "ju367v3u" }, "64": { defaultClass: "ju367v3v" }, "-1": { defaultClass: "ju367v3w" } } }, marginRight: { values: { "0": { defaultClass: "ju367v3x" }, "1": { defaultClass: "ju367v3y" }, "2": { defaultClass: "ju367v3z" }, "3": { defaultClass: "ju367v40" }, "4": { defaultClass: "ju367v41" }, "5": { defaultClass: "ju367v42" }, "6": { defaultClass: "ju367v43" }, "8": { defaultClass: "ju367v44" }, "10": { defaultClass: "ju367v45" }, "12": { defaultClass: "ju367v46" }, "14": { defaultClass: "ju367v47" }, "16": { defaultClass: "ju367v48" }, "18": { defaultClass: "ju367v49" }, "20": { defaultClass: "ju367v4a" }, "24": { defaultClass: "ju367v4b" }, "28": { defaultClass: "ju367v4c" }, "32": { defaultClass: "ju367v4d" }, "36": { defaultClass: "ju367v4e" }, "44": { defaultClass: "ju367v4f" }, "64": { defaultClass: "ju367v4g" }, "-1": { defaultClass: "ju367v4h" } } }, marginTop: { values: { "0": { defaultClass: "ju367v4i" }, "1": { defaultClass: "ju367v4j" }, "2": { defaultClass: "ju367v4k" }, "3": { defaultClass: "ju367v4l" }, "4": { defaultClass: "ju367v4m" }, "5": { defaultClass: "ju367v4n" }, "6": { defaultClass: "ju367v4o" }, "8": { defaultClass: "ju367v4p" }, "10": { defaultClass: "ju367v4q" }, "12": { defaultClass: "ju367v4r" }, "14": { defaultClass: "ju367v4s" }, "16": { defaultClass: "ju367v4t" }, "18": { defaultClass: "ju367v4u" }, "20": { defaultClass: "ju367v4v" }, "24": { defaultClass: "ju367v4w" }, "28": { defaultClass: "ju367v4x" }, "32": { defaultClass: "ju367v4y" }, "36": { defaultClass: "ju367v4z" }, "44": { defaultClass: "ju367v50" }, "64": { defaultClass: "ju367v51" }, "-1": { defaultClass: "ju367v52" } } }, maxWidth: { values: { "1": { defaultClass: "ju367v53" }, "2": { defaultClass: "ju367v54" }, "4": { defaultClass: "ju367v55" }, "8": { defaultClass: "ju367v56" }, "12": { defaultClass: "ju367v57" }, "20": { defaultClass: "ju367v58" }, "24": { defaultClass: "ju367v59" }, "28": { defaultClass: "ju367v5a" }, "30": { defaultClass: "ju367v5b" }, "32": { defaultClass: "ju367v5c" }, "34": { defaultClass: "ju367v5d" }, "36": { defaultClass: "ju367v5e" }, "40": { defaultClass: "ju367v5f" }, "44": { defaultClass: "ju367v5g" }, "48": { defaultClass: "ju367v5h" }, "54": { defaultClass: "ju367v5i" }, "60": { defaultClass: "ju367v5j" }, "200": { defaultClass: "ju367v5k" }, full: { defaultClass: "ju367v5l" }, max: { defaultClass: "ju367v5m" } } }, minWidth: { values: { "1": { defaultClass: "ju367v5n" }, "2": { defaultClass: "ju367v5o" }, "4": { defaultClass: "ju367v5p" }, "8": { defaultClass: "ju367v5q" }, "12": { defaultClass: "ju367v5r" }, "20": { defaultClass: "ju367v5s" }, "24": { defaultClass: "ju367v5t" }, "28": { defaultClass: "ju367v5u" }, "30": { defaultClass: "ju367v5v" }, "32": { defaultClass: "ju367v5w" }, "34": { defaultClass: "ju367v5x" }, "36": { defaultClass: "ju367v5y" }, "40": { defaultClass: "ju367v5z" }, "44": { defaultClass: "ju367v60" }, "48": { defaultClass: "ju367v61" }, "54": { defaultClass: "ju367v62" }, "60": { defaultClass: "ju367v63" }, "200": { defaultClass: "ju367v64" }, full: { defaultClass: "ju367v65" }, max: { defaultClass: "ju367v66" } } }, overflow: { values: { hidden: { defaultClass: "ju367v67" } } }, paddingBottom: { values: { "0": { defaultClass: "ju367v68" }, "1": { defaultClass: "ju367v69" }, "2": { defaultClass: "ju367v6a" }, "3": { defaultClass: "ju367v6b" }, "4": { defaultClass: "ju367v6c" }, "5": { defaultClass: "ju367v6d" }, "6": { defaultClass: "ju367v6e" }, "8": { defaultClass: "ju367v6f" }, "10": { defaultClass: "ju367v6g" }, "12": { defaultClass: "ju367v6h" }, "14": { defaultClass: "ju367v6i" }, "16": { defaultClass: "ju367v6j" }, "18": { defaultClass: "ju367v6k" }, "20": { defaultClass: "ju367v6l" }, "24": { defaultClass: "ju367v6m" }, "28": { defaultClass: "ju367v6n" }, "32": { defaultClass: "ju367v6o" }, "36": { defaultClass: "ju367v6p" }, "44": { defaultClass: "ju367v6q" }, "64": { defaultClass: "ju367v6r" }, "-1": { defaultClass: "ju367v6s" } } }, paddingLeft: { values: { "0": { defaultClass: "ju367v6t" }, "1": { defaultClass: "ju367v6u" }, "2": { defaultClass: "ju367v6v" }, "3": { defaultClass: "ju367v6w" }, "4": { defaultClass: "ju367v6x" }, "5": { defaultClass: "ju367v6y" }, "6": { defaultClass: "ju367v6z" }, "8": { defaultClass: "ju367v70" }, "10": { defaultClass: "ju367v71" }, "12": { defaultClass: "ju367v72" }, "14": { defaultClass: "ju367v73" }, "16": { defaultClass: "ju367v74" }, "18": { defaultClass: "ju367v75" }, "20": { defaultClass: "ju367v76" }, "24": { defaultClass: "ju367v77" }, "28": { defaultClass: "ju367v78" }, "32": { defaultClass: "ju367v79" }, "36": { defaultClass: "ju367v7a" }, "44": { defaultClass: "ju367v7b" }, "64": { defaultClass: "ju367v7c" }, "-1": { defaultClass: "ju367v7d" } } }, paddingRight: { values: { "0": { defaultClass: "ju367v7e" }, "1": { defaultClass: "ju367v7f" }, "2": { defaultClass: "ju367v7g" }, "3": { defaultClass: "ju367v7h" }, "4": { defaultClass: "ju367v7i" }, "5": { defaultClass: "ju367v7j" }, "6": { defaultClass: "ju367v7k" }, "8": { defaultClass: "ju367v7l" }, "10": { defaultClass: "ju367v7m" }, "12": { defaultClass: "ju367v7n" }, "14": { defaultClass: "ju367v7o" }, "16": { defaultClass: "ju367v7p" }, "18": { defaultClass: "ju367v7q" }, "20": { defaultClass: "ju367v7r" }, "24": { defaultClass: "ju367v7s" }, "28": { defaultClass: "ju367v7t" }, "32": { defaultClass: "ju367v7u" }, "36": { defaultClass: "ju367v7v" }, "44": { defaultClass: "ju367v7w" }, "64": { defaultClass: "ju367v7x" }, "-1": { defaultClass: "ju367v7y" } } }, paddingTop: { values: { "0": { defaultClass: "ju367v7z" }, "1": { defaultClass: "ju367v80" }, "2": { defaultClass: "ju367v81" }, "3": { defaultClass: "ju367v82" }, "4": { defaultClass: "ju367v83" }, "5": { defaultClass: "ju367v84" }, "6": { defaultClass: "ju367v85" }, "8": { defaultClass: "ju367v86" }, "10": { defaultClass: "ju367v87" }, "12": { defaultClass: "ju367v88" }, "14": { defaultClass: "ju367v89" }, "16": { defaultClass: "ju367v8a" }, "18": { defaultClass: "ju367v8b" }, "20": { defaultClass: "ju367v8c" }, "24": { defaultClass: "ju367v8d" }, "28": { defaultClass: "ju367v8e" }, "32": { defaultClass: "ju367v8f" }, "36": { defaultClass: "ju367v8g" }, "44": { defaultClass: "ju367v8h" }, "64": { defaultClass: "ju367v8i" }, "-1": { defaultClass: "ju367v8j" } } }, position: { values: { absolute: { defaultClass: "ju367v8k" }, fixed: { defaultClass: "ju367v8l" }, relative: { defaultClass: "ju367v8m" } } }, right: { values: { "0": { defaultClass: "ju367v8n" } } }, transition: { values: { "default": { defaultClass: "ju367v8o" }, transform: { defaultClass: "ju367v8p" } } }, userSelect: { values: { none: { defaultClass: "ju367v8q" } } }, width: { values: { "1": { defaultClass: "ju367v8r" }, "2": { defaultClass: "ju367v8s" }, "4": { defaultClass: "ju367v8t" }, "8": { defaultClass: "ju367v8u" }, "12": { defaultClass: "ju367v8v" }, "20": { defaultClass: "ju367v8w" }, "24": { defaultClass: "ju367v8x" }, "28": { defaultClass: "ju367v8y" }, "30": { defaultClass: "ju367v8z" }, "32": { defaultClass: "ju367v90" }, "34": { defaultClass: "ju367v91" }, "36": { defaultClass: "ju367v92" }, "40": { defaultClass: "ju367v93" }, "44": { defaultClass: "ju367v94" }, "48": { defaultClass: "ju367v95" }, "54": { defaultClass: "ju367v96" }, "60": { defaultClass: "ju367v97" }, "200": { defaultClass: "ju367v98" }, full: { defaultClass: "ju367v99" }, max: { defaultClass: "ju367v9a" } } }, backdropFilter: { values: { modalOverlay: { defaultClass: "ju367v9b" } } } } });
var themeVars = { colors: { accentColor: "var(--rk-colors-accentColor)", accentColorForeground: "var(--rk-colors-accentColorForeground)", actionButtonBorder: "var(--rk-colors-actionButtonBorder)", actionButtonBorderMobile: "var(--rk-colors-actionButtonBorderMobile)", actionButtonSecondaryBackground: "var(--rk-colors-actionButtonSecondaryBackground)", closeButton: "var(--rk-colors-closeButton)", closeButtonBackground: "var(--rk-colors-closeButtonBackground)", connectButtonBackground: "var(--rk-colors-connectButtonBackground)", connectButtonBackgroundError: "var(--rk-colors-connectButtonBackgroundError)", connectButtonInnerBackground: "var(--rk-colors-connectButtonInnerBackground)", connectButtonText: "var(--rk-colors-connectButtonText)", connectButtonTextError: "var(--rk-colors-connectButtonTextError)", connectionIndicator: "var(--rk-colors-connectionIndicator)", downloadBottomCardBackground: "var(--rk-colors-downloadBottomCardBackground)", downloadTopCardBackground: "var(--rk-colors-downloadTopCardBackground)", error: "var(--rk-colors-error)", generalBorder: "var(--rk-colors-generalBorder)", generalBorderDim: "var(--rk-colors-generalBorderDim)", menuItemBackground: "var(--rk-colors-menuItemBackground)", modalBackdrop: "var(--rk-colors-modalBackdrop)", modalBackground: "var(--rk-colors-modalBackground)", modalBorder: "var(--rk-colors-modalBorder)", modalText: "var(--rk-colors-modalText)", modalTextDim: "var(--rk-colors-modalTextDim)", modalTextSecondary: "var(--rk-colors-modalTextSecondary)", profileAction: "var(--rk-colors-profileAction)", profileActionHover: "var(--rk-colors-profileActionHover)", profileForeground: "var(--rk-colors-profileForeground)", selectedOptionBorder: "var(--rk-colors-selectedOptionBorder)", standby: "var(--rk-colors-standby)" }, fonts: { body: "var(--rk-fonts-body)" }, radii: { actionButton: "var(--rk-radii-actionButton)", connectButton: "var(--rk-radii-connectButton)", menuButton: "var(--rk-radii-menuButton)", modal: "var(--rk-radii-modal)", modalMobile: "var(--rk-radii-modalMobile)" }, shadows: { connectButton: "var(--rk-shadows-connectButton)", dialog: "var(--rk-shadows-dialog)", profileDetailsAction: "var(--rk-shadows-profileDetailsAction)", selectedOption: "var(--rk-shadows-selectedOption)", selectedWallet: "var(--rk-shadows-selectedWallet)", walletLogo: "var(--rk-shadows-walletLogo)" }, blurs: { modalOverlay: "var(--rk-blurs-modalOverlay)" } };

// src/css/touchableStyles.css.ts
var active = { shrink: "_12cbo8i6", shrinkSm: "_12cbo8i7" };
var base = "_12cbo8i3 ju367v8m";
var hover = { grow: "_12cbo8i4", growLg: "_12cbo8i5" };

// src/css/touchableStyles.ts
function touchableStyles({ active: active2, hover: hover2 }) {
  return [base, hover2 && hover[hover2], active[active2]];
}

// src/hooks/useConnectionStatus.ts
import { useAccount as useAccount2 } from "wagmi";

// src/components/RainbowKitProvider/AuthenticationContext.tsx
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useRef
} from "react";
import { useAccount } from "wagmi";
function createAuthenticationAdapter(adapter) {
  return adapter;
}
var AuthenticationContext = createContext(null);
function RainbowKitAuthenticationProvider({
  adapter,
  children,
  enabled = true,
  status
}) {
  const { connector } = useAccount({
    onDisconnect: () => {
      adapter.signOut();
    }
  });
  const { isDisconnected } = useAccount();
  const onceRef = useRef(false);
  useEffect(() => {
    if (onceRef.current)
      return;
    onceRef.current = true;
    if (isDisconnected && status === "authenticated") {
      adapter.signOut();
    }
  }, [status, adapter, isDisconnected]);
  const handleChangedAccount = ({ account }) => {
    if (account)
      adapter.signOut();
  };
  useEffect(() => {
    if (connector && status === "authenticated") {
      connector.on("change", handleChangedAccount);
      return () => {
        connector == null ? void 0 : connector.off("change", handleChangedAccount);
      };
    }
  }, [connector, status]);
  return /* @__PURE__ */ React.createElement(AuthenticationContext.Provider, {
    value: useMemo(() => enabled ? { adapter, status } : null, [enabled, adapter, status])
  }, children);
}
function useAuthenticationAdapter() {
  var _a;
  const { adapter } = (_a = useContext(AuthenticationContext)) != null ? _a : {};
  if (!adapter) {
    throw new Error("No authentication adapter found");
  }
  return adapter;
}
function useAuthenticationStatus() {
  var _a;
  const contextValue = useContext(AuthenticationContext);
  return (_a = contextValue == null ? void 0 : contextValue.status) != null ? _a : null;
}

// src/hooks/useConnectionStatus.ts
function useConnectionStatus() {
  const authenticationStatus = useAuthenticationStatus();
  const { isConnected } = useAccount2();
  if (!isConnected) {
    return "disconnected";
  }
  if (!authenticationStatus) {
    return "connected";
  }
  if (authenticationStatus === "loading" || authenticationStatus === "unauthenticated") {
    return authenticationStatus;
  }
  return "connected";
}

// src/utils/isMobile.ts
function isAndroid() {
  return typeof navigator !== "undefined" && /android/i.test(navigator.userAgent);
}
function isSmallIOS() {
  return typeof navigator !== "undefined" && /iPhone|iPod/.test(navigator.userAgent);
}
function isLargeIOS() {
  return typeof navigator !== "undefined" && (/iPad/.test(navigator.userAgent) || navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}
function isIOS() {
  return isSmallIOS() || isLargeIOS();
}
function isMobile() {
  return isAndroid() || isIOS();
}

// src/components/AsyncImage/AsyncImage.tsx
import React3, { useReducer as useReducer2 } from "react";

// src/components/Box/Box.ts
import clsx2 from "clsx";
import * as React2 from "react";

// src/css/atoms.ts
import clsx from "clsx";

// src/css/reset.css.ts
var base2 = "iekbcc0";
var element = { a: "iekbcca", blockquote: "iekbcc2", button: "iekbcc9", input: "iekbcc8 iekbcc5 iekbcc4", mark: "iekbcc6", ol: "iekbcc1", q: "iekbcc2", select: "iekbcc7 iekbcc5 iekbcc4", table: "iekbcc3", textarea: "iekbcc5 iekbcc4", ul: "iekbcc1" };

// src/css/atoms.ts
var atoms = ({ reset, ...rest }) => {
  if (!reset)
    return sprinkles(rest);
  const elementReset = element[reset];
  const sprinklesClasses = sprinkles(rest);
  return clsx(base2, elementReset, sprinklesClasses);
};

// src/components/Box/Box.ts
var Box = React2.forwardRef(({ as = "div", className, testId, ...props }, ref) => {
  const atomProps = {};
  const nativeProps = {};
  for (const key in props) {
    if (sprinkles.properties.has(key)) {
      atomProps[key] = props[key];
    } else {
      nativeProps[key] = props[key];
    }
  }
  const atomicClasses = atoms({
    reset: typeof as === "string" ? as : "div",
    ...atomProps
  });
  return React2.createElement(as, {
    className: clsx2(atomicClasses, className),
    ...nativeProps,
    "data-testid": testId ? `rk-${testId.replace(/^rk-/, "")}` : void 0,
    ref
  });
});
Box.displayName = "Box";

// src/components/AsyncImage/useAsyncImage.ts
import { useEffect as useEffect2, useReducer } from "react";
var cachedUrls = /* @__PURE__ */ new Map();
var cachedRequestPromises = /* @__PURE__ */ new Map();
async function loadAsyncImage(asyncImage) {
  const cachedRequestPromise = cachedRequestPromises.get(asyncImage);
  if (cachedRequestPromise) {
    return cachedRequestPromise;
  }
  const load = async () => asyncImage().then(async (url) => {
    cachedUrls.set(asyncImage, url);
    return url;
  });
  const requestPromise = load().catch((_err) => {
    return load().catch((_err2) => {
      cachedRequestPromises.delete(asyncImage);
    });
  });
  cachedRequestPromises.set(asyncImage, requestPromise);
  return requestPromise;
}
async function loadImages(...urls) {
  return await Promise.all(urls.map((url) => typeof url === "function" ? loadAsyncImage(url) : url));
}
function useForceUpdate() {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  return forceUpdate;
}
function useAsyncImage(url) {
  const cachedUrl = typeof url === "function" ? cachedUrls.get(url) : void 0;
  const forceUpdate = useForceUpdate();
  useEffect2(() => {
    if (typeof url === "function" && !cachedUrl) {
      loadAsyncImage(url).then(forceUpdate);
    }
  }, [url, cachedUrl, forceUpdate]);
  return typeof url === "function" ? cachedUrl : url;
}

// src/components/AsyncImage/AsyncImage.tsx
function AsyncImage({
  alt,
  background,
  borderColor,
  borderRadius,
  boxShadow,
  height,
  src: srcProp,
  width,
  testId
}) {
  const src6 = useAsyncImage(srcProp);
  const isRemoteImage = src6 && /^http/.test(src6);
  const [isRemoteImageLoaded, setRemoteImageLoaded] = useReducer2(() => true, false);
  return /* @__PURE__ */ React3.createElement(Box, {
    "aria-label": alt,
    borderRadius,
    boxShadow,
    height: typeof height === "string" ? height : void 0,
    overflow: "hidden",
    position: "relative",
    role: "img",
    style: {
      background,
      height: typeof height === "number" ? height : void 0,
      width: typeof width === "number" ? width : void 0
    },
    width: typeof width === "string" ? width : void 0,
    testId
  }, /* @__PURE__ */ React3.createElement(Box, {
    ...isRemoteImage ? {
      "aria-hidden": true,
      "as": "img",
      "onLoad": setRemoteImageLoaded,
      "src": src6
    } : {
      backgroundSize: "cover"
    },
    height: "full",
    position: "absolute",
    style: {
      touchCallout: "none",
      transition: "opacity .15s linear",
      userSelect: "none",
      ...isRemoteImage ? {
        opacity: isRemoteImageLoaded ? 1 : 0
      } : {
        backgroundImage: src6 ? `url(${src6})` : void 0,
        backgroundRepeat: "no-repeat",
        opacity: src6 ? 1 : 0
      }
    },
    width: "full"
  }), borderColor ? /* @__PURE__ */ React3.createElement(Box, {
    ...typeof borderColor === "object" && "custom" in borderColor ? { style: { borderColor: borderColor.custom } } : { borderColor },
    borderRadius,
    borderStyle: "solid",
    borderWidth: "1",
    height: "full",
    position: "relative",
    width: "full"
  }) : null);
}

// src/components/Avatar/Avatar.tsx
import React7, { useContext as useContext2 } from "react";

// src/components/Icons/Spinner.tsx
import React4, { useMemo as useMemo2 } from "react";

// src/components/Icons/Icons.css.ts
var SpinnerIconClassName = "_1luule42";
var SpinnerIconPathClassName = "_1luule43";

// src/components/Icons/Spinner.tsx
var useRandomId = (prefix) => useMemo2(() => `${prefix}_${Math.round(Math.random() * 1e9)}`, [prefix]);
var SpinnerIcon = ({
  height = 21,
  width = 21
}) => {
  const id = useRandomId("spinner");
  return /* @__PURE__ */ React4.createElement("svg", {
    className: SpinnerIconClassName,
    fill: "none",
    height,
    viewBox: "0 0 21 21",
    width,
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React4.createElement("clipPath", {
    id
  }, /* @__PURE__ */ React4.createElement("path", {
    d: "M10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C11.3284 18 12 18.6716 12 19.5C12 20.3284 11.3284 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5C21 11.3284 20.3284 12 19.5 12C18.6716 12 18 11.3284 18 10.5C18 6.35786 14.6421 3 10.5 3Z"
  })), /* @__PURE__ */ React4.createElement("foreignObject", {
    clipPath: `url(#${id})`,
    height: "21",
    width: "21",
    x: "0",
    y: "0"
  }, /* @__PURE__ */ React4.createElement("div", {
    className: SpinnerIconPathClassName
  })));
};

// src/components/RainbowKitProvider/AvatarContext.ts
import { createContext as createContext2 } from "react";

// src/components/Avatar/EmojiAvatar.tsx
import React5, { useEffect as useEffect3, useMemo as useMemo3, useState } from "react";

// src/components/Avatar/emojiAvatarForAddress.ts
var colors = [
  "#FC5C54",
  "#FFD95A",
  "#E95D72",
  "#6A87C8",
  "#5FD0F3",
  "#75C06B",
  "#FFDD86",
  "#5FC6D4",
  "#FF949A",
  "#FF8024",
  "#9BA1A4",
  "#EC66FF",
  "#FF8CBC",
  "#FF9A23",
  "#C5DADB",
  "#A8CE63",
  "#71ABFF",
  "#FFE279",
  "#B6B1B6",
  "#FF6780",
  "#A575FF",
  "#4D82FF",
  "#FFB35A"
];
var avatars = [
  { color: colors[0], emoji: "\u{1F336}" },
  { color: colors[1], emoji: "\u{1F911}" },
  { color: colors[2], emoji: "\u{1F419}" },
  { color: colors[3], emoji: "\u{1FAD0}" },
  { color: colors[4], emoji: "\u{1F433}" },
  { color: colors[0], emoji: "\u{1F936}" },
  { color: colors[5], emoji: "\u{1F332}" },
  { color: colors[6], emoji: "\u{1F31E}" },
  { color: colors[7], emoji: "\u{1F412}" },
  { color: colors[8], emoji: "\u{1F435}" },
  { color: colors[9], emoji: "\u{1F98A}" },
  { color: colors[10], emoji: "\u{1F43C}" },
  { color: colors[11], emoji: "\u{1F984}" },
  { color: colors[12], emoji: "\u{1F437}" },
  { color: colors[13], emoji: "\u{1F427}" },
  { color: colors[8], emoji: "\u{1F9A9}" },
  { color: colors[14], emoji: "\u{1F47D}" },
  { color: colors[0], emoji: "\u{1F388}" },
  { color: colors[8], emoji: "\u{1F349}" },
  { color: colors[1], emoji: "\u{1F389}" },
  { color: colors[15], emoji: "\u{1F432}" },
  { color: colors[16], emoji: "\u{1F30E}" },
  { color: colors[17], emoji: "\u{1F34A}" },
  { color: colors[18], emoji: "\u{1F42D}" },
  { color: colors[19], emoji: "\u{1F363}" },
  { color: colors[1], emoji: "\u{1F425}" },
  { color: colors[20], emoji: "\u{1F47E}" },
  { color: colors[15], emoji: "\u{1F966}" },
  { color: colors[0], emoji: "\u{1F479}" },
  { color: colors[17], emoji: "\u{1F640}" },
  { color: colors[4], emoji: "\u26F1" },
  { color: colors[21], emoji: "\u26F5\uFE0F" },
  { color: colors[17], emoji: "\u{1F973}" },
  { color: colors[8], emoji: "\u{1F92F}" },
  { color: colors[22], emoji: "\u{1F920}" }
];
function hashCode(text) {
  let hash = 0;
  if (text.length === 0)
    return hash;
  for (let i = 0; i < text.length; i++) {
    const chr = text.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}
function emojiAvatarForAddress(address) {
  const resolvedAddress = typeof address === "string" ? address : "";
  const avatarIndex = Math.abs(hashCode(resolvedAddress.toLowerCase()) % avatars.length);
  return avatars[avatarIndex != null ? avatarIndex : 0];
}

// src/components/Avatar/EmojiAvatar.tsx
var EmojiAvatar = ({ address, ensImage, size }) => {
  const [loaded, setLoaded] = useState(false);
  useEffect3(() => {
    if (ensImage) {
      const img = new Image();
      img.src = ensImage;
      img.onload = () => setLoaded(true);
    }
  }, [ensImage]);
  const { color: backgroundColor, emoji } = useMemo3(() => emojiAvatarForAddress(address), [address]);
  return ensImage ? loaded ? /* @__PURE__ */ React5.createElement(Box, {
    backgroundSize: "cover",
    borderRadius: "full",
    position: "absolute",
    style: {
      backgroundImage: `url(${ensImage})`,
      backgroundPosition: "center",
      height: size,
      width: size
    }
  }) : /* @__PURE__ */ React5.createElement(Box, {
    alignItems: "center",
    backgroundSize: "cover",
    borderRadius: "full",
    color: "modalText",
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    style: {
      height: size,
      width: size
    }
  }, /* @__PURE__ */ React5.createElement(SpinnerIcon, null)) : /* @__PURE__ */ React5.createElement(Box, {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    style: {
      ...!ensImage && { backgroundColor },
      height: size,
      width: size
    }
  }, emoji);
};

// src/components/RainbowKitProvider/AvatarContext.ts
var defaultAvatar = EmojiAvatar;
var AvatarContext = createContext2(defaultAvatar);

// src/components/Avatar/Avatar.tsx
function Avatar({ address, imageUrl, loading, size }) {
  const AvatarComponent2 = useContext2(AvatarContext);
  return /* @__PURE__ */ React7.createElement(Box, {
    "aria-hidden": true,
    borderRadius: "full",
    overflow: "hidden",
    position: "relative",
    style: {
      height: `${size}px`,
      width: `${size}px`
    },
    userSelect: "none"
  }, /* @__PURE__ */ React7.createElement(Box, {
    alignItems: "center",
    borderRadius: "full",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    position: "absolute",
    style: {
      fontSize: `${Math.round(size * 0.55)}px`,
      height: `${size}px`,
      transform: loading ? "scale(0.72)" : void 0,
      transition: ".25s ease",
      transitionDelay: loading ? void 0 : ".1s",
      width: `${size}px`,
      willChange: "transform"
    },
    userSelect: "none"
  }, /* @__PURE__ */ React7.createElement(AvatarComponent2, {
    address,
    ensImage: imageUrl,
    size
  })), typeof loading === "boolean" && /* @__PURE__ */ React7.createElement(Box, {
    color: "accentColor",
    display: "flex",
    height: "full",
    position: "absolute",
    style: {
      opacity: loading ? 1 : 0,
      transition: loading ? "0.6s ease" : "0.2s ease",
      transitionDelay: loading ? ".05s" : void 0
    },
    width: "full"
  }, /* @__PURE__ */ React7.createElement(SpinnerIcon, {
    height: "100%",
    width: "100%"
  })));
}

// src/components/Icons/Dropdown.tsx
import React8 from "react";
var DropdownIcon = () => /* @__PURE__ */ React8.createElement("svg", {
  fill: "none",
  height: "7",
  width: "14",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React8.createElement("path", {
  d: "M12.75 1.54001L8.51647 5.0038C7.77974 5.60658 6.72026 5.60658 5.98352 5.0038L1.75 1.54001",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2.5",
  xmlns: "http://www.w3.org/2000/svg"
}));

// src/components/RainbowKitProvider/I18nContext.tsx
import React9, { createContext as createContext3, useMemo as useMemo4 } from "react";

// src/locales/index.ts
import { I18n } from "i18n-js/dist/require/index.js";

// src/locales/ar_AR.json
var connect_wallet = {
  label: "\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u0645\u062D\u0641\u0638\u0629"
};
var intro = {
  title: "\u0645\u0627 \u0647\u0648 \u0627\u0644\u0645\u062D\u0641\u0638\u0629\u061F",
  description: "\u062A\u064F\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0644\u0625\u0631\u0633\u0627\u0644 \u0648\u0627\u0633\u062A\u0644\u0627\u0645 \u0648\u062A\u062E\u0632\u064A\u0646 \u0648\u0639\u0631\u0636 \u0627\u0644\u0623\u0635\u0648\u0644 \u0627\u0644\u0631\u0642\u0645\u064A\u0629. \u0625\u0646\u0647\u0627 \u0623\u064A\u0636\u0627\u064B \u0637\u0631\u064A\u0642\u0629 \u062C\u062F\u064A\u062F\u0629 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644\u060C \u062F\u0648\u0646 \u0627\u0644\u062D\u0627\u062C\u0629 \u0625\u0644\u0649 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628\u0627\u062A \u0648\u0643\u0644\u0645\u0627\u062A \u0645\u0631\u0648\u0631 \u062C\u062F\u064A\u062F\u0629 \u0639\u0644\u0649 \u0643\u0644 \u0645\u0648\u0642\u0639.",
  digital_asset: {
    title: "\u062F\u0627\u0631 \u0644\u0623\u0635\u0648\u0644\u0643 \u0627\u0644\u0631\u0642\u0645\u064A\u0629",
    description: "\u062A\u064F\u0633\u062A\u062E\u062F\u0645 \u0627\u0644\u0645\u062D\u0627\u0641\u0638 \u0644\u0625\u0631\u0633\u0627\u0644 \u0648\u0627\u0633\u062A\u0644\u0627\u0645 \u0648\u062A\u062E\u0632\u064A\u0646 \u0648\u0639\u0631\u0636 \u0627\u0644\u0623\u0635\u0648\u0644 \u0627\u0644\u0631\u0642\u0645\u064A\u0629 \u0645\u062B\u0644 \u0625\u064A\u062B\u064A\u0631\u064A\u0648\u0645 \u0648\u0627\u0644\u0640 NFTs."
  },
  login: {
    title: "\u0637\u0631\u064A\u0642\u0629 \u062C\u062F\u064A\u062F\u0629 \u0644\u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644",
    description: "\u0628\u062F\u0644\u0627\u064B \u0645\u0646 \u0625\u0646\u0634\u0627\u0621 \u062D\u0633\u0627\u0628\u0627\u062A \u0648\u0643\u0644\u0645\u0627\u062A \u0645\u0631\u0648\u0631 \u062C\u062F\u064A\u062F\u0629 \u0639\u0644\u0649 \u0643\u0644 \u0645\u0648\u0642\u0639\u060C \u0641\u0642\u0637 \u0642\u0645 \u0628\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643."
  },
  get: {
    label: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0645\u062D\u0641\u0638\u0629"
  },
  learn_more: {
    label: "\u062A\u0639\u0644\u0645 \u0627\u0644\u0645\u0632\u064A\u062F"
  }
};
var connect = {
  label: "\u0627\u062A\u0635\u0644",
  title: "\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u062D\u0641\u0638\u0629",
  new_to_ethereum: {
    description: "\u062C\u062F\u064A\u062F \u0641\u064A \u0645\u062D\u0627\u0641\u0638 Ethereum\u061F",
    learn_more: {
      label: "\u062A\u0639\u0644\u0645 \u0627\u0644\u0645\u0632\u064A\u062F"
    }
  },
  learn_more: {
    label: "\u0623\u0639\u0631\u0641 \u0623\u0643\u062B\u0631"
  },
  recent: "\u0627\u0644\u0623\u062E\u064A\u0631",
  status: {
    opening: "\u062C\u0627\u0631 \u0641\u062A\u062D %{wallet}...",
    not_installed: "%{wallet} \u063A\u064A\u0631 \u0645\u062B\u0628\u062A",
    not_available: "%{wallet} \u063A\u064A\u0631 \u0645\u062A\u0627\u062D",
    confirm: "\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0641\u064A \u0627\u0644\u0627\u0645\u062A\u062F\u0627\u062F"
  },
  secondary_action: {
    get: {
      description: "\u0644\u0627 \u064A\u0648\u062C\u062F \u0644\u062F\u064A\u0643 %{wallet}\u061F",
      label: "\u0627\u062D\u0635\u0644"
    },
    install: {
      label: "\u062A\u062B\u0628\u064A\u062A"
    },
    retry: {
      label: "\u0623\u0639\u062F \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629"
    }
  },
  walletconnect: {
    description: {
      full: "\u0647\u0644 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0631\u0633\u0645\u064A\u0629 \u0644\u0640 WalletConnect\u061F",
      compact: "\u0647\u0644 \u062A\u062D\u062A\u0627\u062C \u0625\u0644\u0649 \u0627\u0644\u0646\u0627\u0641\u0630\u0629 \u0644\u0640 WalletConnect\u061F"
    },
    open: {
      label: "\u0627\u0641\u062A\u062D"
    }
  }
};
var connect_scan = {
  title: "\u0627\u0644\u0645\u0633\u062D \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 %{wallet}",
  fallback_title: "\u0627\u0644\u0645\u0633\u062D \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0647\u0627\u062A\u0641\u0643"
};
var connector_group = {
  recommended: "\u0645\u0648\u0635\u0649 \u0628\u0647",
  other: "\u0622\u062E\u0631",
  popular: "\u0634\u0627\u0626\u0639",
  more: "\u0627\u0644\u0645\u0632\u064A\u062F",
  others: "\u0627\u0644\u0622\u062E\u0631\u064A\u0646"
};
var get = {
  title: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0645\u062D\u0641\u0638\u0629",
  action: {
    label: "\u0627\u062D\u0635\u0644"
  },
  mobile: {
    description: "\u0645\u062D\u0641\u0638\u0629 \u0627\u0644\u0645\u0648\u0628\u0627\u064A\u0644"
  },
  extension: {
    description: "\u0645\u0644\u062D\u0642 \u0627\u0644\u0645\u062A\u0635\u0641\u062D"
  },
  mobile_and_extension: {
    description: "\u0645\u062D\u0641\u0638\u0629 \u0645\u0648\u0628\u0627\u064A\u0644 \u0648\u0645\u0644\u062D\u0642"
  },
  looking_for: {
    title: "\u0644\u064A\u0633\u062A \u0647\u0630\u0647 \u0647\u064A \u0645\u0627 \u062A\u0628\u062D\u062B \u0639\u0646\u0647\u061F",
    mobile: {
      description: "\u062D\u062F\u062F \u0645\u062D\u0641\u0638\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0628\u062F\u0621 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0648\u0641\u0631 \u0645\u062D\u0641\u0638\u0629 \u0645\u062E\u062A\u0644\u0641."
    },
    desktop: {
      compact_description: "\u062D\u062F\u062F \u0645\u062D\u0641\u0638\u0629 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0628\u062F\u0621 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0648\u0641\u0631 \u0645\u062D\u0641\u0638\u0629 \u0645\u062E\u062A\u0644\u0641.",
      wide_description: "\u062D\u062F\u062F \u0645\u062D\u0641\u0638\u0629 \u0639\u0644\u0649 \u0627\u0644\u064A\u0633\u0627\u0631 \u0644\u0644\u0628\u062F\u0621 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u0648\u0641\u0631 \u0645\u062D\u0641\u0638\u0629 \u0645\u062E\u062A\u0644\u0641."
    }
  }
};
var get_options = {
  title: "\u0627\u0628\u062F\u0623 \u0645\u0639 %{wallet}",
  short_title: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 %{wallet}",
  mobile: {
    title: "%{wallet} \u0644\u0644\u062C\u0648\u0627\u0644",
    description: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0645\u062D\u0641\u0638\u0629 \u0627\u0644\u0645\u0648\u0628\u0627\u064A\u0644 \u0644\u0627\u0633\u062A\u0643\u0634\u0627\u0641 \u0639\u0627\u0644\u0645 Ethereum.",
    download: {
      label: "\u0627\u062D\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u062A\u0637\u0628\u064A\u0642"
    }
  },
  extension: {
    title: "%{wallet} \u0644\u0640 %{browser}",
    description: "\u0648\u0635\u0648\u0644 \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0645\u0628\u0627\u0634\u0631\u0629 \u0645\u0646 \u0645\u062A\u0635\u0641\u062D \u0627\u0644\u0648\u064A\u0628 \u0627\u0644\u0645\u0641\u0636\u0644 \u0644\u062F\u064A\u0643.",
    download: {
      label: "\u0623\u0636\u0641 \u0625\u0644\u0649 %{browser}"
    }
  }
};
var get_mobile = {
  title: "\u0642\u0645 \u0628\u0627\u0644\u062A\u062B\u0628\u064A\u062A %{wallet}",
  description: "\u0627\u0633\u062A\u062E\u062F\u0645 \u0647\u0627\u062A\u0641\u0643 \u0644\u0644\u062A\u062D\u0645\u064A\u0644 \u0639\u0644\u0649 iOS \u0623\u0648 Android",
  continue: {
    label: "\u0627\u0633\u062A\u0645\u0631"
  }
};
var get_instructions = {
  mobile: {
    connect: {
      label: "\u0627\u062A\u0635\u0644"
    },
    learn_more: {
      label: "\u062A\u0639\u0644\u0645 \u0627\u0644\u0645\u0632\u064A\u062F"
    }
  },
  extension: {
    refresh: {
      label: "\u062A\u062D\u062F\u064A\u062B"
    },
    learn_more: {
      label: "\u062A\u0639\u0644\u0645 \u0627\u0644\u0645\u0632\u064A\u062F"
    }
  }
};
var chains = {
  title: "\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0634\u0628\u0643\u0627\u062A",
  wrong_network: "\u062A\u0645 \u0627\u0643\u062A\u0634\u0627\u0641 \u0634\u0628\u0643\u0629 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629\u060C \u0642\u0645 \u0628\u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0623\u0648 \u0627\u0644\u0642\u0637\u0639 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.",
  confirm: "\u0627\u0644\u062A\u0623\u0643\u064A\u062F \u0641\u064A \u0627\u0644\u0645\u062D\u0641\u0638\u0629",
  switching_not_supported: "\u0645\u062D\u0641\u0638\u062A\u0643 \u0644\u0627 \u062A\u062F\u0639\u0645 \u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0628\u064A\u0646 \u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0645\u0646 %{appName}. \u062C\u0631\u0628 \u0627\u0644\u062A\u0628\u062F\u064A\u0644 \u0628\u064A\u0646 \u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0645\u0646 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0628\u062F\u0644\u0627\u064B \u0645\u0646 \u0630\u0644\u0643.",
  switching_not_supported_fallback: "\u0645\u062D\u0641\u0638\u062A\u0643 \u0644\u0627 \u062A\u062F\u0639\u0645 \u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0645\u0646 \u0647\u0630\u0627 \u0627\u0644\u062A\u0637\u0628\u064A\u0642. \u062D\u0627\u0648\u0644 \u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0634\u0628\u0643\u0627\u062A \u0645\u0646 \u062F\u0627\u062E\u0644 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0628\u062F\u0644\u0627\u064B \u0645\u0646 \u0630\u0644\u0643.",
  disconnect: "\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644",
  connected: "\u0645\u062A\u0635\u0644"
};
var profile = {
  disconnect: {
    label: "\u0642\u0637\u0639 \u0627\u0644\u0627\u062A\u0635\u0627\u0644"
  },
  copy_address: {
    label: "\u0646\u0633\u062E \u0627\u0644\u0639\u0646\u0648\u0627\u0646",
    copied: "\u062A\u0645 \u0627\u0644\u0646\u0633\u062E!"
  },
  explorer: {
    label: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0632\u064A\u062F \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u0643\u0634\u0641"
  },
  transactions: {
    description: "%{appName} \u0633\u062A\u0638\u0647\u0631 \u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0647\u0646\u0627...",
    description_fallback: "\u0633\u0648\u0641 \u062A\u0638\u0647\u0631 \u0645\u0639\u0627\u0645\u0644\u0627\u062A\u0643 \u0647\u0646\u0627...",
    recent: {
      title: "\u0627\u0644\u0645\u0639\u0627\u0645\u0644\u0627\u062A \u0627\u0644\u0623\u062E\u064A\u0631\u0629"
    },
    clear: {
      label: "\u0645\u0633\u062D \u0627\u0644\u0643\u0644"
    }
  }
};
var wallet_connectors = {
  argent: {
    qr_code: {
      step1: {
        description: "\u0636\u0639 \u0623\u0631\u062C\u0646\u062A \u0639\u0644\u0649 \u0634\u0627\u0634\u062A\u0643 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0633\u0631\u064A\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Argent"
      },
      step2: {
        description: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u0648\u0627\u0633\u0645 \u0645\u0633\u062A\u062E\u062F\u0645\u060C \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u0627\u0644\u0641\u0639\u0644.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u064A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0648\u062C\u0647 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0641\u062D\u0635 \u0627\u0644\u0643\u0648\u062F \u0627\u0644\u0634\u0631\u064A\u0637\u064A"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 \u0645\u062D\u0641\u0638\u0629 Bifrost \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 \u0645\u062D\u0641\u0638\u0629 Bifrost"
      },
      step2: {
        description: "\u0623\u0646\u0634\u0626 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0639\u0628\u0627\u0631\u0629 \u0627\u0644\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u064A\u0638\u0647\u0631 \u0645\u0648\u062C\u0647 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u0643 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0645\u0633\u062D"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 \u0645\u062D\u0641\u0638\u0629 Bitget \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 \u0645\u062D\u0641\u0638\u0629 Bitget"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0639\u0645\u0644 \u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u062D\u062F.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0648\u062C\u0647 \u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0641\u062D\u0635"
      }
    },
    extension: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A \u0645\u062D\u0641\u0638\u0629 Bitget \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u0629 Bitget"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0645\u062D\u0641\u0638\u062A\u0643 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u064B\u0627 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0627\u0645\u062A\u062F\u0627\u062F.",
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0645\u062A\u0635\u0641\u062D\u0643"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Bitski \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F Bitski"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0645\u0646 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0645\u062D\u0641\u0638\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629.",
        title: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 \u0645\u062D\u0641\u0638\u0629 Coin98 \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0633\u0631\u0639\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 \u0645\u062D\u0641\u0638\u0629 Coin98"
      },
      step2: {
        description: "\u064A\u0645\u0643\u0646\u0643 \u0628\u0633\u0647\u0648\u0644\u0629 \u0646\u0633\u062E \u0645\u062D\u0641\u0638\u062A\u0643 \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u064A\u0632\u0629 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0639\u0644\u0649 \u0647\u0627\u062A\u0641\u0643.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0637\u0627\u0644\u0628\u0629 \u0628\u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "\u0627\u0646\u0642\u0631 \u0641\u064A \u0627\u0644\u062C\u0632\u0621 \u0627\u0644\u0639\u0644\u0648\u064A \u0627\u0644\u0623\u064A\u0645\u0646 \u0645\u0646 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062B\u0628\u062A Coin98 Wallet \u0644\u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0648\u0635\u0648\u0644.",
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F Coin98 Wallet"
      },
      step2: {
        description: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u062C\u062F\u064A\u062F\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0648\u0627\u062D\u062F\u0629 \u0645\u0648\u062C\u0648\u062F\u0629 \u0628\u0627\u0644\u0641\u0639\u0644.",
        title: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F Coin98 Wallet \u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0627\u0645\u062A\u062F\u0627\u062F.",
        title: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 Coinbase Wallet \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0648\u0635\u0648\u0644.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Coinbase Wallet"
      },
      step2: {
        description: "\u064A\u0645\u0643\u0646\u0643 \u0628\u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u064A\u0632\u0629 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0627\u0644\u0633\u062D\u0627\u0628\u064A.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0637\u0627\u0644\u0628\u0629 \u0628\u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0641\u062D\u0635"
      }
    },
    extension: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A \u0645\u062D\u0641\u0638\u0629 Coinbase \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u0629 Coinbase"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0627\u0644\u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629.",
        title: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 Core \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0633\u0631\u064A\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Core"
      },
      step2: {
        description: "\u064A\u0645\u0643\u0646\u0643 \u0628\u0633\u0647\u0648\u0644\u0629 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u064A\u0632\u0629 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0639\u0644\u0649 \u0647\u0627\u062A\u0641\u0643.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0627\u0644\u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u064A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0648\u062C\u0647 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Core \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F Core"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0639\u0645\u0644 \u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0627\u0645\u062A\u062F\u0627\u062F.",
        title: "\u062A\u062D\u062F\u064A\u062B \u0645\u062A\u0635\u0641\u062D\u0643"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 FoxWallet \u0639\u0644\u0649 \u0634\u0627\u0634\u062A\u0643 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 FoxWallet"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0645\u0646 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0648\u062C\u0647 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u062A\u0645\u0643\u0646 \u0645\u0646 \u0627\u062A\u0635\u0627\u0644 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0641\u062D\u0635"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 Frontier Wallet \u0639\u0644\u0649 \u0634\u0627\u0634\u062A\u0643 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639.",
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Frontier Wallet"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0645\u062D\u0641\u0638\u062A\u0643 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0627 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0648\u062C\u0647 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u0631\u0628\u0637 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0641\u062D\u0635"
      }
    },
    extension: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A \u0645\u062D\u0641\u0638\u0629 Frontier \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u0629 Frontier"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0645\u062D\u0641\u0638\u062A\u0643 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0627 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629.",
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 imToken",
        description: "\u0636\u0639 \u062A\u0637\u0628\u064A\u0642 imToken \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u0642\u0645 \u0628\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 \u062C\u062F\u064A\u062F\u0629 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0648\u0627\u062D\u062F\u0629 \u0645\u0648\u062C\u0648\u062F\u0629."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0623\u064A\u0642\u0648\u0646\u0629 \u0627\u0644\u0645\u0627\u0633\u062D \u0627\u0644\u0636\u0648\u0626\u064A \u0641\u064A \u0627\u0644\u0632\u0627\u0648\u064A\u0629 \u0627\u0644\u0639\u0644\u064A\u0627 \u0627\u0644\u064A\u0645\u0646\u0649",
        description: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u062C\u062F\u064A\u062F\u060C \u062B\u0645 \u0627\u0645\u0633\u062D \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0634\u0631\u064A\u0637\u064A \u0648\u0623\u0643\u062F \u0627\u0644\u0645\u0648\u062C\u0647 \u0644\u0644\u0627\u062A\u0635\u0627\u0644."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 MetaMask",
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 MetaMask \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u062F\u064A\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0628\u0634\u0643\u0644 \u0623\u0633\u0631\u0639."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0627\u0644\u062D\u0641\u0627\u0638 \u0639\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0645\u0633\u062D",
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0648\u062C\u0647 \u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643."
      }
    },
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F MetaMask",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A MetaMask \u0641\u064A \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u062A\u062D\u062F\u064A\u062B \u0645\u062A\u0635\u0641\u062D\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0627\u0645\u062A\u062F\u0627\u062F."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 \u0645\u062D\u0641\u0638\u0629 OKX",
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 \u0645\u062D\u0641\u0638\u0629 OKX \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0645\u0633\u062D",
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0637\u0627\u0644\u0628\u0629 \u0628\u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643."
      }
    },
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u0629 OKX",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A \u0645\u062D\u0641\u0638\u0629 OKX \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u062D\u0641\u0638 \u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0645\u0646 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Omni",
        description: "\u0623\u0636\u0641 Omni \u0625\u0644\u0649 \u0634\u0627\u0634\u062A\u0643 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 \u062C\u062F\u064A\u062F\u0629 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0648\u0627\u062D\u062F\u0629 \u0645\u0648\u062C\u0648\u062F\u0629."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0623\u064A\u0642\u0648\u0646\u0629 \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062A\u062C\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064A\u0639\u0629 \u0648\u0627\u0645\u0633\u062D\u0647\u0627",
        description: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632 QR \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643\u060C \u0627\u0645\u0633\u062D \u0627\u0644\u0631\u0645\u0632 \u0648\u0623\u0643\u062F \u0627\u0644\u0645\u0648\u0627\u0641\u0642\u0629 \u0644\u0644\u0627\u062A\u0635\u0627\u0644."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 TokenPocket",
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 TokenPocket \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0633\u0631\u064A\u0639."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0645\u0633\u062D",
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u062A\u0638\u0647\u0631 \u0644\u0643 \u0631\u0633\u0627\u0644\u0629 \u0645\u0648\u062C\u0647\u0629 \u0644\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0645\u062D\u0641\u0638\u062A\u0643."
      }
    },
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F TokenPocket",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A TokenPocket \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0642\u0645 \u0628\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0645\u0646 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Trust Wallet",
        description: "\u0636\u0639 Trust Wallet \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0633\u0631\u064A\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u062C\u062F\u064A\u062F\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0648\u0627\u062D\u062F\u0629 \u0645\u0648\u062C\u0648\u062F\u0629."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 WalletConnect \u0641\u064A \u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
        description: "\u0627\u062E\u062A\u0631 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0627\u0644\u062C\u062F\u064A\u062F\u060C \u062B\u0645 \u0627\u0645\u0633\u062D \u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0634\u0631\u064A\u0637\u064A QR \u0648\u0623\u0643\u062F \u0627\u0644\u0645\u0648\u062C\u0647 \u0644\u0644\u0627\u062A\u0635\u0627\u0644."
      }
    },
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F Trust Wallet",
        description: "\u0627\u0646\u0642\u0631 \u0641\u064A \u0627\u0644\u062C\u0632\u0621 \u0627\u0644\u0639\u0644\u0648\u064A \u0627\u0644\u0623\u064A\u0645\u0646 \u0645\u0646 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062B\u0628\u062A Trust Wallet \u0644\u0644\u0648\u0635\u0648\u0644 \u0628\u0633\u0647\u0648\u0644\u0629."
      },
      step2: {
        title: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u062C\u062F\u064A\u062F\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0648\u0627\u062D\u062F\u0629 \u0645\u0648\u062C\u0648\u062F\u0629."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0645\u062A\u0635\u0641\u062D\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F Trust Wallet\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Uniswap",
        description: "\u0623\u0636\u0641 \u0645\u062D\u0641\u0638\u0629 Uniswap \u0625\u0644\u0649 \u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u0642\u0645 \u0628\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 \u062C\u062F\u064A\u062F\u0629 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0648\u0627\u062D\u062F\u0629 \u0645\u0648\u062C\u0648\u062F\u0629."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0623\u064A\u0642\u0648\u0646\u0629 QR \u0648\u0627\u0642\u0631\u0623 \u0627\u0644\u0631\u0645\u0632",
        description: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0623\u064A\u0642\u0648\u0646\u0629 QR \u0639\u0644\u0649 \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629\u060C \u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u0631\u0645\u0632 \u0648\u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0631\u0633\u0627\u0644\u0629 \u0627\u0644\u0645\u0648\u062C\u0647\u0629 \u0644\u0644\u0627\u062A\u0635\u0627\u0644."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Zerion",
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 Zerion \u0639\u0644\u0649 \u0634\u0627\u0634\u062A\u0643 \u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u062D\u0641\u0638 \u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0645\u0646 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0632\u0631 \u0627\u0644\u0645\u0633\u062D",
        description: "\u0628\u0639\u062F \u0627\u0644\u0645\u0633\u062D\u060C \u0633\u0648\u0641 \u064A\u0638\u0647\u0631 \u0644\u0643 \u0646\u0627\u0641\u0630\u0629 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0644\u062A\u0648\u0635\u064A\u0644 \u0645\u062D\u0641\u0638\u062A\u0643."
      }
    },
    extension: {
      step1: {
        title: "\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F Zerion",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Zerion \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0627\u062D\u062A\u0641\u0627\u0638 \u0628\u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0645\u0646 \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "\u0627\u0641\u062A\u062D \u062A\u0637\u0628\u064A\u0642 Rainbow",
        description: "\u0646\u0648\u0635\u064A \u0628\u0648\u0636\u0639 Rainbow \u0639\u0644\u0649 \u0634\u0627\u0634\u0629 \u0627\u0644\u0628\u062F\u0627\u064A\u0629 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u064A\u0645\u0643\u0646\u0643 \u0639\u0645\u0644 \u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0628\u0633\u0647\u0648\u0644\u0629 \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0645\u064A\u0632\u0629 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0639\u0644\u0649 \u0647\u0627\u062A\u0641\u0643."
      },
      step3: {
        title: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0632\u0631 \u0627\u0644\u0645\u0627\u0633\u062D \u0627\u0644\u0636\u0648\u0626\u064A",
        description: "\u0628\u0639\u062F \u0627\u0644\u0641\u062D\u0635\u060C \u0633\u064A\u0638\u0647\u0631 \u0644\u0643 \u0645\u0648\u062C\u0647 \u0627\u062A\u0635\u0627\u0644 \u0644\u0631\u0628\u0637 \u0645\u062D\u0641\u0638\u062A\u0643."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A \u0645\u062D\u0641\u0638\u0629 Enkrypt \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u0629 Enkrypt"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0639\u0645\u0644 \u0646\u0633\u062E\u0629 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u0629 \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0623\u0646\u0634\u0626 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629.",
        title: "\u062D\u062F\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u0639\u0644\u064A\u0642 Frame \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0633\u0631\u064A\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643.",
        title: "\u062B\u0628\u062A Frame \u0648\u0627\u0644\u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0645\u0635\u0627\u062D\u0628\u0629"
      },
      step2: {
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635.",
        title: "\u0623\u0646\u0634\u0626 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629"
      },
      step3: {
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629.",
        title: "\u062D\u062F\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u0629 OneKey",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A \u0645\u062D\u0641\u0638\u0629 OneKey \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0633\u0631\u064A\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0627\u0645\u062A\u062F\u0627\u062F."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0627\u0645\u062A\u062F\u0627\u062F Phantom",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Phantom \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0647\u0644 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0645\u062D\u0641\u0638\u062A\u0643 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u064B\u0627 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u0629 \u0627\u0644\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u0633\u0631\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0627\u0644\u0645\u062D\u0641\u0638\u0629\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "\u062B\u0628\u062A \u0627\u0645\u062A\u062F\u0627\u062F Rabby",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Rabby \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0645\u062D\u0641\u0638\u062A\u0643 \u0627\u062D\u062A\u064A\u0627\u0637\u064A\u064B\u0627 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0627\u0644\u0639\u0628\u0627\u0631\u0629 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0625\u0636\u0627\u0641\u0629 \u0627\u0644\u0646\u0648\u0627\u0629",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Safeheron \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0633\u0631\u064A\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0646\u0633\u062E \u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "\u062A\u062B\u0628\u064A\u062A \u0625\u0636\u0627\u0641\u0629 Taho",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Taho \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u062A\u0643 \u0627\u0644\u0633\u0631\u064A\u0629 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "\u062A\u062B\u0628\u064A\u062A \u0625\u0636\u0627\u0641\u0629 Talisman",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A Talisman \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0625\u0646\u0634\u0627\u0621 \u0645\u062D\u0641\u0638\u0629 Ethereum \u0623\u0648 \u0627\u0633\u062A\u064A\u0631\u0627\u062F\u0647\u0627",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0639\u0628\u0627\u0631\u0629 \u0627\u0644\u0627\u0633\u062A\u0639\u0627\u062F\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0633\u062A\u0639\u0631\u0636 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0633\u062A\u0639\u0631\u0636 \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "\u0642\u0645 \u0628\u062A\u062B\u0628\u064A\u062A \u0625\u0636\u0627\u0641\u0629 XDEFI Wallet",
        description: "\u0646\u0648\u0635\u064A \u0628\u062A\u062B\u0628\u064A\u062A XDEFI Wallet \u0639\u0644\u0649 \u0634\u0631\u064A\u0637 \u0627\u0644\u0645\u0647\u0627\u0645 \u0644\u0644\u0648\u0635\u0648\u0644 \u0627\u0644\u0623\u0633\u0631\u0639 \u0625\u0644\u0649 \u0645\u062D\u0641\u0638\u062A\u0643."
      },
      step2: {
        title: "\u0623\u0646\u0634\u0626 \u0645\u062D\u0641\u0638\u0629 \u0623\u0648 \u0627\u0633\u062A\u0648\u0631\u062F \u0645\u062D\u0641\u0638\u0629",
        description: "\u062A\u0623\u0643\u062F \u0645\u0646 \u0627\u0644\u0646\u0633\u062E \u0627\u0644\u0627\u062D\u062A\u064A\u0627\u0637\u064A \u0644\u0645\u062D\u0641\u0638\u062A\u0643 \u0628\u0627\u0633\u062A\u062E\u062F\u0627\u0645 \u0637\u0631\u064A\u0642\u0629 \u0622\u0645\u0646\u0629. \u0644\u0627 \u062A\u0634\u0627\u0631\u0643 \u0627\u0644\u0639\u0628\u0627\u0631\u0629 \u0627\u0644\u0633\u0631\u064A\u0629 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643 \u0645\u0639 \u0623\u064A \u0634\u062E\u0635."
      },
      step3: {
        title: "\u0642\u0645 \u0628\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u0633\u062A\u0639\u0631\u0636 \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        description: "\u0628\u0645\u062C\u0631\u062F \u0625\u0639\u062F\u0627\u062F \u0645\u062D\u0641\u0638\u062A\u0643\u060C \u0627\u0646\u0642\u0631 \u0623\u062F\u0646\u0627\u0647 \u0644\u062A\u062D\u062F\u064A\u062B \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u0648\u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0625\u0636\u0627\u0641\u0629."
      }
    }
  }
};
var ar_AR_default = {
  connect_wallet,
  intro,
  connect,
  connect_scan,
  connector_group,
  get,
  get_options,
  get_mobile,
  get_instructions,
  chains,
  profile,
  wallet_connectors
};

// src/locales/en_US.json
var connect_wallet2 = {
  label: "Connect Wallet"
};
var intro2 = {
  title: "What is a Wallet?",
  description: "A wallet is used to send, receive, store, and display digital assets. It's also a new way to log in, without needing to create new accounts and passwords on every website.",
  digital_asset: {
    title: "A Home for your Digital Assets",
    description: "Wallets are used to send, receive, store, and display digital assets like Ethereum and NFTs."
  },
  login: {
    title: "A New Way to Log In",
    description: "Instead of creating new accounts and passwords on every website, just connect your wallet."
  },
  get: {
    label: "Get a Wallet"
  },
  learn_more: {
    label: "Learn More"
  }
};
var connect2 = {
  label: "Connect",
  title: "Connect a Wallet",
  new_to_ethereum: {
    description: "New to Ethereum wallets?",
    learn_more: {
      label: "Learn More"
    }
  },
  learn_more: {
    label: "Learn more"
  },
  recent: "Recent",
  status: {
    opening: "Opening %{wallet}...",
    not_installed: "%{wallet} is not installed",
    not_available: "%{wallet} is not available",
    confirm: "Confirm connection in the extension"
  },
  secondary_action: {
    get: {
      description: "Don't have %{wallet}?",
      label: "GET"
    },
    install: {
      label: "INSTALL"
    },
    retry: {
      label: "RETRY"
    }
  },
  walletconnect: {
    description: {
      full: "Need the official WalletConnect modal?",
      compact: "Need the WalletConnect modal?"
    },
    open: {
      label: "OPEN"
    }
  }
};
var connect_scan2 = {
  title: "Scan with %{wallet}",
  fallback_title: "Scan with your phone"
};
var connector_group2 = {
  recommended: "Recommended",
  other: "Other",
  popular: "Popular",
  more: "More",
  others: "Others"
};
var get2 = {
  title: "Get a Wallet",
  action: {
    label: "GET"
  },
  mobile: {
    description: "Mobile Wallet"
  },
  extension: {
    description: "Browser Extension"
  },
  mobile_and_extension: {
    description: "Mobile Wallet and Extension"
  },
  looking_for: {
    title: "Not what you're looking for?",
    mobile: {
      description: "Select a wallet on the main screen to get started with a different wallet provider."
    },
    desktop: {
      compact_description: "Select a wallet on the main screen to get started with a different wallet provider.",
      wide_description: "Select a wallet on the left to get started with a different wallet provider."
    }
  }
};
var get_options2 = {
  title: "Get started with %{wallet}",
  short_title: "Get %{wallet}",
  mobile: {
    title: "%{wallet} for Mobile",
    description: "Use the mobile wallet to explore the world of Ethereum.",
    download: {
      label: "Get the app"
    }
  },
  extension: {
    title: "%{wallet} for %{browser}",
    description: "Access your wallet right from your favorite web browser.",
    download: {
      label: "Add to %{browser}"
    }
  }
};
var get_mobile2 = {
  title: "Install %{wallet}",
  description: "Scan with your phone to download on iOS or Android",
  continue: {
    label: "Continue"
  }
};
var get_instructions2 = {
  mobile: {
    connect: {
      label: "Connect"
    },
    learn_more: {
      label: "Learn More"
    }
  },
  extension: {
    refresh: {
      label: "Refresh"
    },
    learn_more: {
      label: "Learn More"
    }
  }
};
var chains2 = {
  title: "Switch Networks",
  wrong_network: "Wrong network detected, switch or disconnect to continue.",
  confirm: "Confirm in Wallet",
  switching_not_supported: "Your wallet does not support switching networks from %{appName}. Try switching networks from within your wallet instead.",
  switching_not_supported_fallback: "Your wallet does not support switching networks from this app. Try switching networks from within your wallet instead.",
  disconnect: "Disconnect",
  connected: "Connected"
};
var profile2 = {
  disconnect: {
    label: "Disconnect"
  },
  copy_address: {
    label: "Copy Address",
    copied: "Copied!"
  },
  explorer: {
    label: "View more on explorer"
  },
  transactions: {
    description: "%{appName} transactions will appear here...",
    description_fallback: "Your transactions will appear here...",
    recent: {
      title: "Recent Transactions"
    },
    clear: {
      label: "Clear All"
    }
  }
};
var wallet_connectors2 = {
  argent: {
    qr_code: {
      step1: {
        description: "Put Argent on your home screen for faster access to your wallet.",
        title: "Open the Argent app"
      },
      step2: {
        description: "Create a wallet and username, or import an existing wallet.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the Scan QR button"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "We recommend putting Bifrost Wallet on your home screen for quicker access.",
        title: "Open the Bifrost Wallet app"
      },
      step2: {
        description: "Create or import a wallet using your recovery phrase.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the scan button"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "We recommend putting Bitget Wallet on your home screen for quicker access.",
        title: "Open the Bitget Wallet app"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the scan button"
      }
    },
    extension: {
      step1: {
        description: "We recommend pinning Bitget Wallet to your taskbar for quicker access to your wallet.",
        title: "Install the Bitget Wallet extension"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "We recommend pinning Bitski to your taskbar for quicker access to your wallet.",
        title: "Install the Bitski extension"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "We recommend putting Coin98 Wallet on your home screen for faster access to your wallet.",
        title: "Open the Coin98 Wallet app"
      },
      step2: {
        description: "You can easily backup your wallet using our backup feature on your phone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the WalletConnect button"
      }
    },
    extension: {
      step1: {
        description: "Click at the top right of your browser and pin Coin98 Wallet for easy access.",
        title: "Install the Coin98 Wallet extension"
      },
      step2: {
        description: "Create a new wallet or import an existing one.",
        title: "Create or Import a wallet"
      },
      step3: {
        description: "Once you set up Coin98 Wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "We recommend putting Coinbase Wallet on your home screen for quicker access.",
        title: "Open the Coinbase Wallet app"
      },
      step2: {
        description: "You can easily backup your wallet using the cloud backup feature.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the scan button"
      }
    },
    extension: {
      step1: {
        description: "We recommend pinning Coinbase Wallet to your taskbar for quicker access to your wallet.",
        title: "Install the Coinbase Wallet extension"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "We recommend putting Core on your home screen for faster access to your wallet.",
        title: "Open the Core app"
      },
      step2: {
        description: "You can easily backup your wallet using our backup feature on your phone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the WalletConnect button"
      }
    },
    extension: {
      step1: {
        description: "We recommend pinning Core to your taskbar for quicker access to your wallet.",
        title: "Install the Core extension"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "We recommend putting FoxWallet on your home screen for quicker access.",
        title: "Open the FoxWallet app"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the scan button"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "We recommend putting Frontier Wallet on your home screen for quicker access.",
        title: "Open the Frontier Wallet app"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "After you scan, a connection prompt will appear for you to connect your wallet.",
        title: "Tap the scan button"
      }
    },
    extension: {
      step1: {
        description: "We recommend pinning Frontier Wallet to your taskbar for quicker access to your wallet.",
        title: "Install the Frontier Wallet extension"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "Open the imToken app",
        description: "Put imToken app on your home screen for faster access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Create a new wallet or import an existing one."
      },
      step3: {
        title: "Tap Scanner Icon in top right corner",
        description: "Choose New Connection, then scan the QR code and confirm the prompt to connect."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "Open the MetaMask app",
        description: "We recommend putting MetaMask on your home screen for quicker access."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Tap the scan button",
        description: "After you scan, a connection prompt will appear for you to connect your wallet."
      }
    },
    extension: {
      step1: {
        title: "Install the MetaMask extension",
        description: "We recommend pinning MetaMask to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "Open the OKX Wallet app",
        description: "We recommend putting OKX Wallet on your home screen for quicker access."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Tap the scan button",
        description: "After you scan, a connection prompt will appear for you to connect your wallet."
      }
    },
    extension: {
      step1: {
        title: "Install the OKX Wallet extension",
        description: "We recommend pinning OKX Wallet to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Open the Omni app",
        description: "Add Omni to your home screen for faster access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Create a new wallet or import an existing one."
      },
      step3: {
        title: "Tap the QR icon and scan",
        description: "Tap the QR icon on your home screen, scan the code and confirm the prompt to connect."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "Open the TokenPocket app",
        description: "We recommend putting TokenPocket on your home screen for quicker access."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Tap the scan button",
        description: "After you scan, a connection prompt will appear for you to connect your wallet."
      }
    },
    extension: {
      step1: {
        title: "Install the TokenPocket extension",
        description: "We recommend pinning TokenPocket to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Open the Trust Wallet app",
        description: "Put Trust Wallet on your home screen for faster access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Create a new wallet or import an existing one."
      },
      step3: {
        title: "Tap WalletConnect in Settings",
        description: "Choose New Connection, then scan the QR code and confirm the prompt to connect."
      }
    },
    extension: {
      step1: {
        title: "Install the Trust Wallet extension",
        description: "Click at the top right of your browser and pin Trust Wallet for easy access."
      },
      step2: {
        title: "Create or Import a wallet",
        description: "Create a new wallet or import an existing one."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up Trust Wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Open the Uniswap app",
        description: "Add Uniswap Wallet to your home screen for faster access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Create a new wallet or import an existing one."
      },
      step3: {
        title: "Tap the QR icon and scan",
        description: "Tap the QR icon on your homescreen, scan the code and confirm the prompt to connect."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Open the Zerion app",
        description: "We recommend putting Zerion on your home screen for quicker access."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Tap the scan button",
        description: "After you scan, a connection prompt will appear for you to connect your wallet."
      }
    },
    extension: {
      step1: {
        title: "Install the Zerion extension",
        description: "We recommend pinning Zerion to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Open the Rainbow app",
        description: "We recommend putting Rainbow on your home screen for faster access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "You can easily backup your wallet using our backup feature on your phone."
      },
      step3: {
        title: "Tap the scan button",
        description: "After you scan, a connection prompt will appear for you to connect your wallet."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "We recommend pinning Enkrypt Wallet to your taskbar for quicker access to your wallet.",
        title: "Install the Enkrypt Wallet extension"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "We recommend pinning Frame to your taskbar for quicker access to your wallet.",
        title: "Install Frame & the companion extension"
      },
      step2: {
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone.",
        title: "Create or Import a Wallet"
      },
      step3: {
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension.",
        title: "Refresh your browser"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "Install the OneKey Wallet extension",
        description: "We recommend pinning OneKey Wallet to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Install the Phantom extension",
        description: "We recommend pinning Phantom to your taskbar for easier access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret recovery phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Install the Rabby extension",
        description: "We recommend pinning Rabby to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "Install the Core extension",
        description: "We recommend pinning Safeheron to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Install the Taho extension",
        description: "We recommend pinning Taho to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "Install the Talisman extension",
        description: "We recommend pinning Talisman to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import an Ethereum Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your recovery phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "Install the XDEFI Wallet extension",
        description: "We recommend pinning XDEFI Wallet to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  zeal: {
    extension: {
      step1: {
        title: "Install the Zeal extension",
        description: "We recommend pinning Zeal to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  safepal: {
    extension: {
      step1: {
        title: "Install the SafePal Wallet extension",
        description: "Click at the top right of your browser and pin SafePal Wallet for easy access."
      },
      step2: {
        title: "Create or Import a wallet",
        description: "Create a new wallet or import an existing one."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up SafePal Wallet, click below to refresh the browser and load up the extension."
      }
    },
    qr_code: {
      step1: {
        title: "Open the SafePal Wallet app",
        description: "Put SafePal Wallet on your home screen for faster access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Create a new wallet or import an existing one."
      },
      step3: {
        title: "Tap WalletConnect in Settings",
        description: "Choose New Connection, then scan the QR code and confirm the prompt to connect."
      }
    }
  },
  desig: {
    extension: {
      step1: {
        title: "Install the Desig extension",
        description: "We recommend pinning Desig to your taskbar for easier access to your wallet."
      },
      step2: {
        title: "Create a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    }
  },
  subwallet: {
    extension: {
      step1: {
        title: "Install the SubWallet extension",
        description: "We recommend pinning SubWallet to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your recovery phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    },
    qr_code: {
      step1: {
        title: "Open the SubWallet app",
        description: "We recommend putting SubWallet on your home screen for quicker access."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Tap the scan button",
        description: "After you scan, a connection prompt will appear for you to connect your wallet."
      }
    }
  },
  clv: {
    extension: {
      step1: {
        title: "Install the CLV Wallet extension",
        description: "We recommend pinning CLV Wallet to your taskbar for quicker access to your wallet."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Refresh your browser",
        description: "Once you set up your wallet, click below to refresh the browser and load up the extension."
      }
    },
    qr_code: {
      step1: {
        title: "Open the CLV Wallet app",
        description: "We recommend putting CLV Wallet on your home screen for quicker access."
      },
      step2: {
        title: "Create or Import a Wallet",
        description: "Be sure to back up your wallet using a secure method. Never share your secret phrase with anyone."
      },
      step3: {
        title: "Tap the scan button",
        description: "After you scan, a connection prompt will appear for you to connect your wallet."
      }
    }
  },
  okto: {
    qr_code: {
      step1: {
        title: "Open the Okto app",
        description: "Add Okto to your home screen for quick access"
      },
      step2: {
        title: "Create an MPC Wallet",
        description: "Create an account and generate a wallet"
      },
      step3: {
        title: "Tap WalletConnect in Settings",
        description: "Tap the Scan QR icon at the top right and confirm the prompt to connect."
      }
    }
  }
};
var en_US_default = {
  connect_wallet: connect_wallet2,
  intro: intro2,
  connect: connect2,
  connect_scan: connect_scan2,
  connector_group: connector_group2,
  get: get2,
  get_options: get_options2,
  get_mobile: get_mobile2,
  get_instructions: get_instructions2,
  chains: chains2,
  profile: profile2,
  wallet_connectors: wallet_connectors2
};

// src/locales/es_419.json
var connect_wallet3 = {
  label: "Conectar la billetera"
};
var intro3 = {
  title: "\xBFQu\xE9 es una billetera?",
  description: "Una billetera se usa para enviar, recibir, almacenar y mostrar activos digitales. Tambi\xE9n es una nueva forma de iniciar sesi\xF3n, sin necesidad de crear nuevas cuentas y contrase\xF1as en cada sitio web.",
  digital_asset: {
    title: "Un hogar para tus Activos Digitales",
    description: "Las carteras se utilizan para enviar, recibir, almacenar y mostrar activos digitales como Ethereum y NFTs."
  },
  login: {
    title: "Una nueva forma de iniciar sesi\xF3n",
    description: "En lugar de crear nuevas cuentas y contrase\xF1as en cada sitio web, simplemente conecta tu cartera."
  },
  get: {
    label: "Obtener una billetera"
  },
  learn_more: {
    label: "Obtener m\xE1s informaci\xF3n"
  }
};
var connect3 = {
  label: "Conectar",
  title: "Conectar una billetera",
  new_to_ethereum: {
    description: "\xBFEres nuevo en las billeteras Ethereum?",
    learn_more: {
      label: "Obtener m\xE1s informaci\xF3n"
    }
  },
  learn_more: {
    label: "Obtener m\xE1s informaci\xF3n"
  },
  recent: "Reciente",
  status: {
    opening: "Abriendo %{wallet}...",
    not_installed: "%{wallet} no est\xE1 instalado",
    not_available: "%{wallet} no est\xE1 disponible",
    confirm: "Confirma la conexi\xF3n en la extensi\xF3n"
  },
  secondary_action: {
    get: {
      description: "\xBFNo tienes %{wallet}?",
      label: "OBTENER"
    },
    install: {
      label: "INSTALAR"
    },
    retry: {
      label: "REINTENTAR"
    }
  },
  walletconnect: {
    description: {
      full: "\xBFNecesitas el modal oficial de WalletConnect?",
      compact: "\xBFNecesitas el modal de WalletConnect?"
    },
    open: {
      label: "ABRIR"
    }
  }
};
var connect_scan3 = {
  title: "Escanea con %{wallet}",
  fallback_title: "Escanea con tu tel\xE9fono"
};
var connector_group3 = {
  recommended: "Recomendado",
  other: "Otro",
  popular: "Popular",
  more: "M\xE1s",
  others: "Otros"
};
var get3 = {
  title: "Obtener una billetera",
  action: {
    label: "OBTENER"
  },
  mobile: {
    description: "Billetera M\xF3vil"
  },
  extension: {
    description: "Extensi\xF3n de navegador"
  },
  mobile_and_extension: {
    description: "Billetera m\xF3vil y extensi\xF3n"
  },
  looking_for: {
    title: "\xBFNo es lo que est\xE1s buscando?",
    mobile: {
      description: "Seleccione una billetera en la pantalla principal para comenzar con un proveedor de billetera diferente."
    },
    desktop: {
      compact_description: "Seleccione una cartera en la pantalla principal para comenzar con un proveedor de cartera diferente.",
      wide_description: "Seleccione una cartera a la izquierda para comenzar con un proveedor de cartera diferente."
    }
  }
};
var get_options3 = {
  title: "Comienza con %{wallet}",
  short_title: "Obtener %{wallet}",
  mobile: {
    title: "%{wallet} para m\xF3vil",
    description: "Use la billetera m\xF3vil para explorar el mundo de Ethereum.",
    download: {
      label: "Obtener la aplicaci\xF3n"
    }
  },
  extension: {
    title: "%{wallet} para %{browser}",
    description: "Acceda a su billetera directamente desde su navegador web favorito.",
    download: {
      label: "A\xF1adir a %{browser}"
    }
  }
};
var get_mobile3 = {
  title: "Instalar %{wallet}",
  description: "Escanee con su tel\xE9fono para descargar en iOS o Android",
  continue: {
    label: "Continuar"
  }
};
var get_instructions3 = {
  mobile: {
    connect: {
      label: "Conectar"
    },
    learn_more: {
      label: "Obtener m\xE1s informaci\xF3n"
    }
  },
  extension: {
    refresh: {
      label: "Actualizar"
    },
    learn_more: {
      label: "Obtener m\xE1s informaci\xF3n"
    }
  }
};
var chains3 = {
  title: "Cambiar redes",
  wrong_network: "Se detect\xF3 la red incorrecta, cambia o descon\xE9ctate para continuar.",
  confirm: "Confirmar en la cartera",
  switching_not_supported: "Tu cartera no admite cambiar las redes desde %{appName}. Intenta cambiar las redes desde tu cartera.",
  switching_not_supported_fallback: "Su billetera no admite el cambio de redes desde esta aplicaci\xF3n. Intente cambiar de red desde dentro de su billetera en su lugar.",
  disconnect: "Desconectar",
  connected: "Conectado"
};
var profile3 = {
  disconnect: {
    label: "Desconectar"
  },
  copy_address: {
    label: "Copiar direcci\xF3n",
    copied: "\xA1Copiado!"
  },
  explorer: {
    label: "Ver m\xE1s en el explorador"
  },
  transactions: {
    description: "%{appName} transacciones aparecer\xE1n aqu\xED...",
    description_fallback: "Tus transacciones aparecer\xE1n aqu\xED...",
    recent: {
      title: "Transacciones recientes"
    },
    clear: {
      label: "Borrar Todo"
    }
  }
};
var wallet_connectors3 = {
  argent: {
    qr_code: {
      step1: {
        description: "Coloque Argent en su pantalla de inicio para un acceso m\xE1s r\xE1pido a su billetera.",
        title: "Abra la aplicaci\xF3n Argent"
      },
      step2: {
        description: "Cree una billetera y un nombre de usuario, o importe una billetera existente.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 un mensaje de conexi\xF3n para que conecte su billetera.",
        title: "Toque el bot\xF3n Escanear QR"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "Recomendamos poner Bifrost Wallet en su pantalla de inicio para un acceso m\xE1s r\xE1pido.",
        title: "Abra la aplicaci\xF3n Bifrost Wallet"
      },
      step2: {
        description: "Cree o importe una billetera usando su frase de recuperaci\xF3n.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que conecte su billetera.",
        title: "Toque el bot\xF3n de escaneo"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar Bitget Wallet en su pantalla de inicio para un acceso m\xE1s r\xE1pido.",
        title: "Abra la aplicaci\xF3n Bitget Wallet"
      },
      step2: {
        description: "Aseg\xFArese de respaldar su billetera utilizando un m\xE9todo seguro. Nunca comparta su frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que pueda conectar su billetera.",
        title: "Toque el bot\xF3n de escanear"
      }
    },
    extension: {
      step1: {
        description: "Recomendamos anclar Bitget Wallet a su barra de tareas para un acceso m\xE1s r\xE1pido a su billetera.",
        title: "Instale la extensi\xF3n de la Billetera Bitget"
      },
      step2: {
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Una vez que configures tu billetera, haz clic a continuaci\xF3n para refrescar el navegador y cargar la extensi\xF3n.",
        title: "Refrescar tu navegador"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "Recomendamos anclar Bitski a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera.",
        title: "Instala la extensi\xF3n Bitski"
      },
      step2: {
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Una vez que configure su billetera, haga clic abajo para actualizar el navegador y cargar la extensi\xF3n.",
        title: "Actualiza tu navegador"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "Recomendamos poner Coin98 Wallet en la pantalla de inicio para un acceso m\xE1s r\xE1pido a su billetera.",
        title: "Abra la aplicaci\xF3n Coin98 Wallet"
      },
      step2: {
        description: "Puede respaldar f\xE1cilmente su billetera utilizando nuestra funci\xF3n de respaldo en su tel\xE9fono.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que conecte su billetera.",
        title: "Toque el bot\xF3n WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Haga clic en la parte superior derecha de su navegador y fije Coin98 Wallet para un f\xE1cil acceso.",
        title: "Instale la extensi\xF3n Coin98 Wallet"
      },
      step2: {
        description: "Crea una nueva billetera o importa una existente.",
        title: "Crear o Importar una billetera"
      },
      step3: {
        description: "Una vez que configures Coin98 Wallet, haz clic a continuaci\xF3n para refrescar el navegador y cargar la extensi\xF3n.",
        title: "Refresca tu navegador"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "Recomendamos poner Coinbase Wallet en tu pantalla de inicio para un acceso m\xE1s r\xE1pido.",
        title: "Abre la aplicaci\xF3n de la Billetera Coinbase"
      },
      step2: {
        description: "Puedes respaldar tu billetera f\xE1cilmente utilizando la funci\xF3n de respaldo en la nube.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que conectes tu billetera.",
        title: "Pulsa el bot\xF3n de escanear"
      }
    },
    extension: {
      step1: {
        description: "Te recomendamos anclar la Billetera Coinbase a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera.",
        title: "Instala la extensi\xF3n de la Billetera Coinbase"
      },
      step2: {
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Una vez que configure su billetera, haga clic abajo para refrescar el navegador y cargar la extensi\xF3n.",
        title: "Refresca tu navegador"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "Recomendamos poner Core en su pantalla de inicio para un acceso m\xE1s r\xE1pido a su billetera.",
        title: "Abra la aplicaci\xF3n Core"
      },
      step2: {
        description: "Puedes respaldar f\xE1cilmente tu billetera utilizando nuestra funci\xF3n de respaldo en tu tel\xE9fono.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que conectes tu billetera.",
        title: "Toque el bot\xF3n WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Recomendamos fijar Core a tu barra de tareas para acceder m\xE1s r\xE1pido a tu billetera.",
        title: "Instala la extensi\xF3n Core"
      },
      step2: {
        description: "Aseg\xFArate de hacer una copia de seguridad de tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Una vez que configures tu billetera, haz clic a continuaci\xF3n para refrescar el navegador y cargar la extensi\xF3n.",
        title: "Refresca tu navegador"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "Recomendamos poner FoxWallet en tu pantalla de inicio para un acceso m\xE1s r\xE1pido.",
        title: "Abre la aplicaci\xF3n FoxWallet"
      },
      step2: {
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 una solicitud de conexi\xF3n para que conectes tu billetera.",
        title: "Toca el bot\xF3n de escanear"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "Recomendamos poner la Billetera Frontier en tu pantalla principal para un acceso m\xE1s r\xE1pido.",
        title: "Abre la aplicaci\xF3n de la Billetera Frontier"
      },
      step2: {
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Despu\xE9s de escanear, aparecer\xE1 un mensaje para que conectes tu billetera.",
        title: "Haz clic en el bot\xF3n de escaneo"
      }
    },
    extension: {
      step1: {
        description: "Recomendamos anclar la billetera Frontier a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera.",
        title: "Instala la extensi\xF3n de la billetera Frontier"
      },
      step2: {
        description: "Aseg\xFArese de hacer una copia de seguridad de su billetera utilizando un m\xE9todo seguro. Nunca comparta su frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Una vez que configure su billetera, haga clic a continuaci\xF3n para actualizar el navegador y cargar la extensi\xF3n.",
        title: "Actualizar tu navegador"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "Abrir la aplicaci\xF3n imToken",
        description: "Pon la aplicaci\xF3n imToken en tu pantalla de inicio para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Crea una nueva billetera o importa una existente."
      },
      step3: {
        title: "Toca el Icono del Esc\xE1ner en la esquina superior derecha",
        description: "Elija Nueva Conexi\xF3n, luego escanee el c\xF3digo QR y confirme el aviso para conectar."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "Abre la aplicaci\xF3n MetaMask",
        description: "Recomendamos colocar MetaMask en tu pantalla de inicio para un acceso m\xE1s r\xE1pido."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Toca el bot\xF3n de escanear",
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que conectes tu billetera."
      }
    },
    extension: {
      step1: {
        title: "Instala la extensi\xF3n MetaMask",
        description: "Recomendamos anclar MetaMask a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de hacer una copia de seguridad de tu billetera usando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Refresca tu navegador",
        description: "Una vez que configures tu billetera, haz clic abajo para refrescar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "Abre la aplicaci\xF3n OKX Wallet",
        description: "Recomendamos colocar OKX Wallet en tu pantalla de inicio para un acceso m\xE1s r\xE1pido."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de respaldar tu billetera usando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Toca el bot\xF3n de escanear",
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que conectes tu billetera."
      }
    },
    extension: {
      step1: {
        title: "Instala la extensi\xF3n de Billetera OKX",
        description: "Recomendamos anclar la Billetera OKX a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de respaldar tu billetera usando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Refresca tu navegador",
        description: "Una vez que configure su billetera, haga clic abajo para actualizar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Abra la aplicaci\xF3n Omni",
        description: "Agregue Omni a su pantalla de inicio para un acceso m\xE1s r\xE1pido a su billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Crear una nueva billetera o importar una existente."
      },
      step3: {
        title: "Toque el icono de QR y escanee",
        description: "Toca el icono QR en tu pantalla principal, escanea el c\xF3digo y confirma el aviso para conectar."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "Abre la aplicaci\xF3n TokenPocket",
        description: "Recomendamos colocar TokenPocket en tu pantalla principal para un acceso m\xE1s r\xE1pido."
      },
      step2: {
        title: "Crear o importar una Billetera",
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Toca el bot\xF3n de escaneo",
        description: "Despu\xE9s de escanear, aparecer\xE1 una solicitud de conexi\xF3n para que puedas conectar tu billetera."
      }
    },
    extension: {
      step1: {
        title: "Instala la extensi\xF3n TokenPocket",
        description: "Recomendamos anclar TokenPocket a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Actualiza tu navegador",
        description: "Una vez que configures tu billetera, haz clic a continuaci\xF3n para actualizar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Abre la aplicaci\xF3n Trust Wallet",
        description: "Ubica Trust Wallet en tu pantalla de inicio para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Crea una nueva billetera o importa una existente."
      },
      step3: {
        title: "Toca WalletConnect en Configuraciones",
        description: "Elige Nueva Conexi\xF3n, luego escanea el c\xF3digo QR y confirma el aviso para conectar."
      }
    },
    extension: {
      step1: {
        title: "Instala la extensi\xF3n de Trust Wallet",
        description: "Haz clic en la parte superior derecha de tu navegador y fija Trust Wallet para un f\xE1cil acceso."
      },
      step2: {
        title: "Crea o Importa una billetera",
        description: "Crea una nueva billetera o importa una existente."
      },
      step3: {
        title: "Refresca tu navegador",
        description: "Una vez que configures Trust Wallet, haz clic abajo para refrescar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Abre la aplicaci\xF3n Uniswap",
        description: "Agrega la billetera Uniswap a tu pantalla de inicio para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Crea una nueva billetera o importa una existente."
      },
      step3: {
        title: "Toca el icono QR y escanea",
        description: "Toca el icono QR en tu pantalla de inicio, escanea el c\xF3digo y confirma el prompt para conectar."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Abre la aplicaci\xF3n Zerion",
        description: "Recomendamos poner Zerion en tu pantalla de inicio para un acceso m\xE1s r\xE1pido."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de hacer una copia de seguridad de tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Toca el bot\xF3n de escanear",
        description: "Despu\xE9s de escanear, aparecer\xE1 un aviso de conexi\xF3n para que conectes tu billetera."
      }
    },
    extension: {
      step1: {
        title: "Instala la extensi\xF3n Zerion",
        description: "Recomendamos anclar Zerion a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArese de respaldar su billetera usando un m\xE9todo seguro. Nunca comparta su frase secreta con nadie."
      },
      step3: {
        title: "Actualiza tu navegador",
        description: "Una vez que configures tu billetera, haz clic a continuaci\xF3n para actualizar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Abre la aplicaci\xF3n Rainbow",
        description: "Recomendamos poner Rainbow en tu pantalla de inicio para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Puedes respaldar f\xE1cilmente tu billetera usando nuestra funci\xF3n de respaldo en tu tel\xE9fono."
      },
      step3: {
        title: "Toca el bot\xF3n de escanear",
        description: "Despu\xE9s de escanear, aparecer\xE1 una solicitud de conexi\xF3n para que conectes tu billetera."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "Recomendamos anclar la Billetera Enkrypt a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera.",
        title: "Instala la extensi\xF3n de Billetera Enkrypt"
      },
      step2: {
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Una vez que configures tu billetera, haz clic abajo para refrescar el navegador y cargar la extensi\xF3n.",
        title: "Refresca tu navegador"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "Recomendamos anclar Frame a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera.",
        title: "Instala Frame y la extensi\xF3n complementaria"
      },
      step2: {
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie.",
        title: "Crear o Importar una Billetera"
      },
      step3: {
        description: "Una vez que configures tu billetera, haz clic a continuaci\xF3n para refrescar el navegador y cargar la extensi\xF3n.",
        title: "Refresca tu navegador"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "Instale la extensi\xF3n de Billetera OneKey",
        description: "Recomendamos anclar la Billetera OneKey a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArese de respaldar su billetera usando un m\xE9todo seguro. Nunca comparta su frase secreta con nadie."
      },
      step3: {
        title: "Actualiza tu navegador",
        description: "Una vez que configures tu billetera, haz clic a continuaci\xF3n para actualizar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Instala la extensi\xF3n Phantom",
        description: "Recomendamos fijar Phantom a tu barra de tareas para un acceso m\xE1s f\xE1cil a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArese de respaldar su billetera usando un m\xE9todo seguro. Nunca comparta su frase secreta de recuperaci\xF3n con nadie."
      },
      step3: {
        title: "Actualiza tu navegador",
        description: "Una vez que configures tu billetera, haz clic abajo para refrescar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Instala la extensi\xF3n Rabby",
        description: "Recomendamos anclar Rabby a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de hacer una copia de seguridad de tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Actualiza tu navegador",
        description: "Una vez que configures tu billetera, haz clic abajo para actualizar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "Instala la extensi\xF3n Core",
        description: "Recomendamos anclar Safeheron a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Refresca tu navegador",
        description: "Una vez que configures tu billetera, haz clic abajo para refrescar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Instala la extensi\xF3n de Taho",
        description: "Recomendamos anclar Taho a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crea o Importa una Billetera",
        description: "Aseg\xFArate de respaldar tu billetera utilizando un m\xE9todo seguro. Nunca compartas tu frase secreta con nadie."
      },
      step3: {
        title: "Refresca tu navegador",
        description: "Una vez que configures tu billetera, haz clic abajo para refrescar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "Instala la extensi\xF3n de Talisman",
        description: "Recomendamos anclar Talisman a tu barra de tareas para un acceso m\xE1s r\xE1pido a tu billetera."
      },
      step2: {
        title: "Crea o importa una billetera Ethereum",
        description: "Aseg\xFArate de respaldar tu billetera usando un m\xE9todo seguro. Nunca compartas tu frase de recuperaci\xF3n con nadie."
      },
      step3: {
        title: "Recarga tu navegador",
        description: "Una vez que configures tu billetera, haz clic abajo para refrescar el navegador y cargar la extensi\xF3n."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "Instala la extensi\xF3n de la billetera XDEFI",
        description: "Recomendamos anclar XDEFI Wallet a su barra de tareas para un acceso m\xE1s r\xE1pido a su billetera."
      },
      step2: {
        title: "Crear o Importar una Billetera",
        description: "Aseg\xFArese de respaldar su billetera utilizando un m\xE9todo seguro. Nunca comparta su frase secreta con nadie."
      },
      step3: {
        title: "Actualice su navegador",
        description: "Una vez que configure su billetera, haga clic abajo para actualizar el navegador y cargar la extensi\xF3n."
      }
    }
  }
};
var es_419_default = {
  connect_wallet: connect_wallet3,
  intro: intro3,
  connect: connect3,
  connect_scan: connect_scan3,
  connector_group: connector_group3,
  get: get3,
  get_options: get_options3,
  get_mobile: get_mobile3,
  get_instructions: get_instructions3,
  chains: chains3,
  profile: profile3,
  wallet_connectors: wallet_connectors3
};

// src/locales/fr_FR.json
var connect_wallet4 = {
  label: "Connecter le portefeuille"
};
var intro4 = {
  title: "Qu'est-ce qu'un portefeuille?",
  description: "Un portefeuille est utilis\xE9 pour envoyer, recevoir, stocker et afficher des actifs num\xE9riques. C'est aussi une nouvelle fa\xE7on de se connecter, sans avoir besoin de cr\xE9er de nouveaux comptes et mots de passe sur chaque site.",
  digital_asset: {
    title: "Un foyer pour vos actifs num\xE9riques",
    description: "Les portefeuilles sont utilis\xE9s pour envoyer, recevoir, stocker et afficher des actifs num\xE9riques comme Ethereum et les NFTs."
  },
  login: {
    title: "Une nouvelle fa\xE7on de se connecter",
    description: "Au lieu de cr\xE9er de nouveaux comptes et mots de passe sur chaque site Web, connectez simplement votre portefeuille."
  },
  get: {
    label: "Obtenir un portefeuille"
  },
  learn_more: {
    label: "En savoir plus"
  }
};
var connect4 = {
  label: "Connecter",
  title: "Connecter un portefeuille",
  new_to_ethereum: {
    description: "Nouveau aux portefeuilles Ethereum?",
    learn_more: {
      label: "En savoir plus"
    }
  },
  learn_more: {
    label: "En savoir plus"
  },
  recent: "R\xE9cents",
  status: {
    opening: "Ouverture %{wallet}...",
    not_installed: "%{wallet} n'est pas install\xE9",
    not_available: "%{wallet} n'est pas disponible",
    confirm: "Confirmez la connexion dans l'extension"
  },
  secondary_action: {
    get: {
      description: "Vous n'avez pas de %{wallet}?",
      label: "OBTENIR"
    },
    install: {
      label: "INSTALLER"
    },
    retry: {
      label: "R\xC9ESSAYER"
    }
  },
  walletconnect: {
    description: {
      full: "Vous avez besoin du modal officiel de WalletConnect ?",
      compact: "Besoin du modal de WalletConnect ?"
    },
    open: {
      label: "OUVRIR"
    }
  }
};
var connect_scan4 = {
  title: "Scannez avec %{wallet}",
  fallback_title: "Scannez avec votre t\xE9l\xE9phone"
};
var connector_group4 = {
  recommended: "Recommand\xE9",
  other: "Autre",
  popular: "Populaire",
  more: "Plus",
  others: "Autres"
};
var get4 = {
  title: "Obtenez un portefeuille",
  action: {
    label: "OBTENIR"
  },
  mobile: {
    description: "Portefeuille mobile"
  },
  extension: {
    description: "Extension de navigateur"
  },
  mobile_and_extension: {
    description: "Portefeuille mobile et extension"
  },
  looking_for: {
    title: "Ce n'est pas ce que vous cherchez ?",
    mobile: {
      description: "S\xE9lectionnez un portefeuille sur l'\xE9cran principal pour commencer avec un autre fournisseur de portefeuille."
    },
    desktop: {
      compact_description: "S\xE9lectionnez un portefeuille sur l'\xE9cran principal pour commencer avec un autre fournisseur de portefeuille.",
      wide_description: "S\xE9lectionnez un portefeuille sur la gauche pour commencer avec un autre fournisseur de portefeuille."
    }
  }
};
var get_options4 = {
  title: "Commencez avec %{wallet}",
  short_title: "Obtenez %{wallet}",
  mobile: {
    title: "%{wallet} pour mobile",
    description: "Utilisez le portefeuille mobile pour explorer le monde d'Ethereum.",
    download: {
      label: "Obtenez l'application"
    }
  },
  extension: {
    title: "%{wallet} pour %{browser}",
    description: "Acc\xE9dez \xE0 votre portefeuille directement depuis votre navigateur web pr\xE9f\xE9r\xE9.",
    download: {
      label: "Ajouter \xE0 %{browser}"
    }
  }
};
var get_mobile4 = {
  title: "Installer %{wallet}",
  description: "Scannez avec votre t\xE9l\xE9phone pour t\xE9l\xE9charger sur iOS ou Android",
  continue: {
    label: "Continuer"
  }
};
var get_instructions4 = {
  mobile: {
    connect: {
      label: "Connecter"
    },
    learn_more: {
      label: "En savoir plus"
    }
  },
  extension: {
    refresh: {
      label: "Rafra\xEEchir"
    },
    learn_more: {
      label: "En savoir plus"
    }
  }
};
var chains4 = {
  title: "Changer de R\xE9seaux",
  wrong_network: "Mauvais r\xE9seau d\xE9tect\xE9, changez ou d\xE9connectez-vous pour continuer.",
  confirm: "Confirmer dans le portefeuille",
  switching_not_supported: "Votre portefeuille ne supporte pas le changement de r\xE9seaux depuis %{appName}. Essayez de changer de r\xE9seau depuis votre portefeuille.",
  switching_not_supported_fallback: "Votre portefeuille ne prend pas en charge le changement de r\xE9seaux \xE0 partir de cette application. Essayez de changer de r\xE9seau \xE0 partir de votre portefeuille \xE0 la place.",
  disconnect: "D\xE9connecter",
  connected: "Connect\xE9"
};
var profile4 = {
  disconnect: {
    label: "D\xE9connecter"
  },
  copy_address: {
    label: "Copier l'adresse",
    copied: "Copi\xE9 !"
  },
  explorer: {
    label: "Voir plus sur l'explorateur"
  },
  transactions: {
    description: "%{appName} transactions appara\xEEtront ici...",
    description_fallback: "Vos transactions appara\xEEtront ici...",
    recent: {
      title: "Transactions R\xE9centes"
    },
    clear: {
      label: "Tout supprimer"
    }
  }
};
var wallet_connectors4 = {
  argent: {
    qr_code: {
      step1: {
        description: "Mettez Argent sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Ouvrez l'application Argent"
      },
      step2: {
        description: "Cr\xE9ez un portefeuille et un nom d'utilisateur, ou importez un portefeuille existant.",
        title: "Cr\xE9er ou Importer un Portefeuille"
      },
      step3: {
        description: "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
        title: "Appuyez sur le bouton Scan QR"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "Nous vous recommandons de mettre le portefeuille Bifrost sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
        title: "Ouvrez l'application Bifrost Wallet"
      },
      step2: {
        description: "Cr\xE9ez ou importez un portefeuille en utilisant votre phrase de r\xE9cup\xE9ration.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Apr\xE8s votre scan, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
        title: "Appuyez sur le bouton de scan"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "Nous vous recommandons de placer Bitget Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
        title: "Ouvrez l'application Bitget Wallet"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Apr\xE8s le scan, une incitation de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
        title: "Appuyez sur le bouton de scan"
      }
    },
    extension: {
      step1: {
        description: "Nous vous recommandons d'\xE9pingler Bitget Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Installez l'extension de portefeuille Bitget"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
        title: "Cr\xE9ez ou Importez un portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
        title: "Rafra\xEEchissez votre navigateur"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "Nous recommandons d'\xE9pingler Bitski \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Installez l'extension Bitski"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension.",
        title: "Rafra\xEEchissez votre navigateur"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "Nous vous recommandons de placer Coin98 Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Ouvrez l'application Coin98 Wallet"
      },
      step2: {
        description: "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Apr\xE8s que vous ayez scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
        title: "Appuyez sur le bouton WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Cliquez en haut \xE0 droite de votre navigateur et \xE9pinglez Coin98 Wallet pour un acc\xE8s facile.",
        title: "Installez l'extension Coin98 Wallet"
      },
      step2: {
        description: "Cr\xE9ez un nouveau portefeuille ou importez-en un existant.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 Coin98 Wallet, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
        title: "Rafra\xEEchissez votre navigateur"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "Nous recommandons de placer Coinbase Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
        title: "Ouvrez l'application Coinbase Wallet"
      },
      step2: {
        description: "Vous pouvez facilement sauvegarder votre portefeuille en utilisant la fonction de sauvegarde cloud.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Apr\xE8s avoir scann\xE9, une invite de connexion s'affichera pour que vous puissiez connecter votre portefeuille.",
        title: "Appuyez sur le bouton de scan"
      }
    },
    extension: {
      step1: {
        description: "Nous recommandons d'\xE9pingler Coinbase Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Installez l'extension Coinbase Wallet"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xFBre. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
        title: "Actualisez votre navigateur"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "Nous recommandons de placer Core sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Ouvrez l'application Core"
      },
      step2: {
        description: "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
        title: "Appuyez sur le bouton WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Nous recommandons d'\xE9pingler Core \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Installez l'extension Core"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque.",
        title: "Cr\xE9ez ou Importer un Portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension.",
        title: "Rafra\xEEchissez votre navigateur"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "Nous recommandons de mettre FoxWallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
        title: "Ouvrez l'application FoxWallet"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Apr\xE8s avoir scann\xE9, une invitation \xE0 la connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
        title: "Appuyez sur le bouton de scan"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "Nous vous recommandons de placer le portefeuille Frontier sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide.",
        title: "Ouvrez l'application Frontier Wallet"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille.",
        title: "Appuyez sur le bouton de scan"
      }
    },
    extension: {
      step1: {
        description: "Nous recommandons d'\xE9pingler Frontier Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Installez l'extension Frontier Wallet"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
        title: "Cr\xE9ez ou importez un portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension.",
        title: "Rafra\xEEchissez votre navigateur"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application imToken",
        description: "Placez l'application imToken sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9ez ou importez un portefeuille",
        description: "Cr\xE9ez un nouveau portefeuille ou importez-en un existant ."
      },
      step3: {
        title: "Appuyez sur l'ic\xF4ne du scanner dans le coin sup\xE9rieur droit",
        description: "Choisissez Nouvelle Connexion, puis scannez le code QR et confirmez l'invite pour vous connecter."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application MetaMask",
        description: "Nous vous recommandons de mettre MetaMask sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
      },
      step2: {
        title: "Cr\xE9er ou Importer un Portefeuille",
        description: "Veillez \xE0 sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
      },
      step3: {
        title: "Appuyez sur le bouton de scan",
        description: "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
      }
    },
    extension: {
      step1: {
        title: "Installez l\u2019extension de MetaMask",
        description: "Nous recommandons d'\xE9pingler MetaMask \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application OKX Wallet",
        description: "Nous recommandons de mettre OKX Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
      },
      step3: {
        title: "Appuyez sur le bouton de num\xE9risation",
        description: "Apr\xE8s avoir num\xE9ris\xE9, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
      }
    },
    extension: {
      step1: {
        title: "Installez l'extension de portefeuille OKX",
        description: "Nous vous recommandons d'\xE9pingler le portefeuille OKX \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application Omni",
        description: "Ajoutez Omni \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un Portefeuille",
        description: "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
      },
      step3: {
        title: "Touchez l'ic\xF4ne QR et scannez",
        description: "Appuyez sur l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application TokenPocket",
        description: "Nous vous recommandons de mettre TokenPocket sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
      },
      step2: {
        title: "Cr\xE9ez ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille \xE0 l'aide d'une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
      },
      step3: {
        title: "Appuyez sur le bouton de scan",
        description: "Apr\xE8s votre scan, une invite de connexion appara\xEEtra pour vous permettre de connecter votre portefeuille."
      }
    },
    extension: {
      step1: {
        title: "Installez l'extension TokenPocket",
        description: "Nous recommandons d'\xE9pingler TokenPocket \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application Trust Wallet",
        description: "Placez Trust Wallet sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Cr\xE9er un nouveau portefeuille ou en importer un existant."
      },
      step3: {
        title: "Appuyez sur WalletConnect dans les param\xE8tres",
        description: "Choisissez Nouvelle Connexion, puis scannez le code QR et confirmez l'invite pour vous connecter."
      }
    },
    extension: {
      step1: {
        title: "Installez l'extension Trust Wallet",
        description: "Cliquez en haut \xE0 droite de votre navigateur et \xE9pinglez Trust Wallet pour un acc\xE8s facile."
      },
      step2: {
        title: "Cr\xE9er ou importer un portefeuille",
        description: "Cr\xE9er un nouveau portefeuille ou en importer un existant."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 Trust Wallet, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application Uniswap",
        description: "Ajoutez Uniswap Wallet \xE0 votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9ez ou importez un portefeuille",
        description: "Cr\xE9ez un nouveau portefeuille ou importez-en un existant."
      },
      step3: {
        title: "Tapez sur l'ic\xF4ne QR et scannez",
        description: "Touchez l'ic\xF4ne QR sur votre \xE9cran d'accueil, scannez le code et confirmez l'invite pour vous connecter."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Ouvrez l'application Zerion",
        description: "Nous vous recommandons de mettre Zerion sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne."
      },
      step3: {
        title: "Appuyez sur le bouton de scan",
        description: "Une fois que vous avez scann\xE9, une invite de connexion appara\xEEtra pour que vous puissiez connecter votre portefeuille."
      }
    },
    extension: {
      step1: {
        title: "Installer l'extension Zerion",
        description: "Nous recommandons d'\xE9pingler Zerion \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9ez ou Importez un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quiconque."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Ouvre l'application Rainbow",
        description: "Nous vous recommandons de mettre Rainbow sur votre \xE9cran d'accueil pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9ez ou Importez un portefeuille",
        description: "Vous pouvez facilement sauvegarder votre portefeuille en utilisant notre fonction de sauvegarde sur votre t\xE9l\xE9phone."
      },
      step3: {
        title: "Appuyez sur le bouton de scan",
        description: "Apr\xE8s avoir scann\xE9, une invite de connexion appara\xEEtra pour que vous connectiez votre portefeuille."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "Nous vous recommandons d'\xE9pingler Enkrypt Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Installez l'extension Enkrypt Wallet"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quelqu'un.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l\u2019extension.",
        title: "Rafra\xEEchissez votre navigateur"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "Nous vous recommandons d'\xE9pingler Frame \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille.",
        title: "Installez Frame & l'extension compl\xE9mentaire"
      },
      step2: {
        description: "Assurez-vous de sauvegarder votre portefeuille \xE0 l'aide d'une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne.",
        title: "Cr\xE9er ou Importer un portefeuille"
      },
      step3: {
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension.",
        title: "Rafra\xEEchissez votre navigateur"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "Installez l'extension OneKey Wallet",
        description: "Nous vous recommandons d'\xE9pingler OneKey Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec personne."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Installez l'extension Phantom",
        description: "Nous vous recommandons d'\xE9pingler Phantom \xE0 votre barre des t\xE2ches pour un acc\xE8s plus facile \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase de r\xE9cup\xE9ration secr\xE8te avec personne."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Installez l'extension Rabby",
        description: "Nous recommandons d'\xE9pingler Rabby \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
      },
      step3: {
        title: "Actualisez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour actualiser le navigateur et charger l'extension."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "Installez l'extension Core",
        description: "Nous recommandons d'\xE9pingler Safeheron \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quelqu'un."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Installez l'extension Taho",
        description: "Nous vous recommandons d'\xE9pingler Taho \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9ez ou Importez un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec quelqu'un."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "Installez l'extension Talisman",
        description: "Nous vous recommandons d'\xE9pingler Talisman \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou importer un portefeuille Ethereum",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase de r\xE9cup\xE9ration avec personne."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "Installez l'extension du portefeuille XDEFI",
        description: "Nous vous recommandons d'\xE9pingler XDEFI Wallet \xE0 votre barre des t\xE2ches pour un acc\xE8s plus rapide \xE0 votre portefeuille."
      },
      step2: {
        title: "Cr\xE9er ou Importer un portefeuille",
        description: "Assurez-vous de sauvegarder votre portefeuille en utilisant une m\xE9thode s\xE9curis\xE9e. Ne partagez jamais votre phrase secr\xE8te avec qui que ce soit."
      },
      step3: {
        title: "Rafra\xEEchissez votre navigateur",
        description: "Une fois que vous avez configur\xE9 votre portefeuille, cliquez ci-dessous pour rafra\xEEchir le navigateur et charger l'extension."
      }
    }
  }
};
var fr_FR_default = {
  connect_wallet: connect_wallet4,
  intro: intro4,
  connect: connect4,
  connect_scan: connect_scan4,
  connector_group: connector_group4,
  get: get4,
  get_options: get_options4,
  get_mobile: get_mobile4,
  get_instructions: get_instructions4,
  chains: chains4,
  profile: profile4,
  wallet_connectors: wallet_connectors4
};

// src/locales/hi_IN.json
var connect_wallet5 = {
  label: "\u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902"
};
var intro5 = {
  title: "\u0935\u0949\u0932\u0947\u091F \u0915\u094D\u092F\u093E \u0939\u0948?",
  description: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0921\u093F\u091C\u093F\u091F\u0932 \u0938\u0902\u092A\u0924\u094D\u0924\u093F\u092F\u094B\u0902 \u0915\u094B \u092D\u0947\u091C\u0928\u0947, \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0928\u0947, \u0938\u0902\u0917\u094D\u0930\u0939\u093F\u0924 \u0915\u0930\u0928\u0947 \u0914\u0930 \u092A\u094D\u0930\u0926\u0930\u094D\u0936\u093F\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948\u0964 \u092F\u0939 \u090F\u0915 \u0928\u092F\u093E \u0924\u0930\u0940\u0915\u093E \u092D\u0940 \u0939\u0948 \u0932\u0949\u0917 \u0907\u0928 \u0915\u0930\u0928\u0947 \u0915\u093E, \u0939\u0930 \u0935\u0947\u092C\u0938\u093E\u0907\u091F \u092A\u0930 \u0928\u090F \u0916\u093E\u0924\u0947 \u0914\u0930 \u092A\u093E\u0938\u0935\u0930\u094D\u0921 \u092C\u0928\u093E\u0928\u0947 \u0915\u0940 \u091C\u0930\u0942\u0930\u0924 \u0915\u0947 \u092C\u093F\u0928\u093E\u0964",
  digital_asset: {
    title: "\u0905\u092A\u0928\u0947 \u0921\u093F\u091C\u093F\u091F\u0932 \u0938\u0902\u092A\u0924\u094D\u0924\u093F\u092F\u094B\u0902 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0918\u0930",
    description: "\u0935\u0949\u0932\u0947\u091F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 Ethereum \u0914\u0930 NFTs \u091C\u0948\u0938\u0940 \u0921\u093F\u091C\u093F\u091F\u0932 \u0938\u0902\u092A\u0924\u094D\u0924\u093F\u092F\u094B\u0902 \u0915\u094B \u092D\u0947\u091C\u0928\u0947, \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0928\u0947, \u0938\u0902\u0917\u094D\u0930\u0939\u093F\u0924 \u0915\u0930\u0928\u0947 \u0914\u0930 \u092A\u094D\u0930\u0926\u0930\u094D\u0936\u093F\u0924 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0915\u093F\u092F\u093E \u091C\u093E\u0924\u093E \u0939\u0948."
  },
  login: {
    title: "\u0932\u0949\u0917 \u0907\u0928 \u0915\u0930\u0928\u0947 \u0915\u093E \u090F\u0915 \u0928\u092F\u093E \u0924\u0930\u0940\u0915\u093E",
    description: "\u0939\u0930 \u0935\u0947\u092C\u0938\u093E\u0907\u091F \u092A\u0930 \u0928\u090F \u0916\u093E\u0924\u0947 \u0914\u0930 \u092A\u093E\u0938\u0935\u0930\u094D\u0921 \u092C\u0928\u093E\u0928\u0947 \u0915\u0940 \u092C\u091C\u093E\u092F, \u092C\u0938 \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902."
  },
  get: {
    label: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902"
  },
  learn_more: {
    label: "\u0914\u0930 \u091C\u093E\u0928\u0947\u0902"
  }
};
var connect5 = {
  label: "\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902",
  title: "\u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902",
  new_to_ethereum: {
    description: "Ethereum \u0935\u0949\u0932\u0947\u091F\u094D\u0938 \u092E\u0947\u0902 \u0928\u090F \u0939\u0948\u0902?",
    learn_more: {
      label: "\u0914\u0930 \u091C\u093E\u0928\u0947\u0902"
    }
  },
  learn_more: {
    label: "\u0914\u0930 \u091C\u093E\u0928\u0947\u0902\u0964"
  },
  recent: "\u0939\u093E\u0932 \u0939\u0940 \u092E\u0947\u0902",
  status: {
    opening: "%{wallet}\u0916\u094B\u0932 \u0930\u0939\u093E \u0939\u0948...",
    not_installed: "%{wallet} \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0928\u0939\u0940\u0902 \u0939\u0948",
    not_available: "%{wallet} \u0909\u092A\u0932\u092C\u094D\u0927 \u0928\u0939\u0940\u0902 \u0939\u0948",
    confirm: "\u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u092E\u0947\u0902 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902"
  },
  secondary_action: {
    get: {
      description: "\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u0947 \u092A\u093E\u0938 %{wallet}\u0928\u0939\u0940\u0902 \u0939\u0948 ?",
      label: "\u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902"
    },
    install: {
      label: "\u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
    },
    retry: {
      label: "\u092A\u0941\u0928\u0903 \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902"
    }
  },
  walletconnect: {
    description: {
      full: "\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u0906\u0927\u093F\u0915\u093E\u0930\u093F\u0915 WalletConnect \u092E\u094B\u0921\u0932 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0939\u0948?",
      compact: "\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B WalletConnect \u092E\u094B\u0921\u0932 \u0915\u0940 \u0906\u0935\u0936\u094D\u092F\u0915\u0924\u093E \u0939\u0948?"
    },
    open: {
      label: "\u0916\u094B\u0932\u0947\u0902"
    }
  }
};
var connect_scan5 = {
  title: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0935\u093F\u0925 %{wallet}",
  fallback_title: "\u0905\u092A\u0928\u0947 \u092B\u094B\u0928 \u0938\u0947 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902"
};
var connector_group5 = {
  recommended: "\u0905\u0928\u0941\u0936\u0902\u0938\u093F\u0924",
  other: "\u0905\u0928\u094D\u092F",
  popular: "\u0932\u094B\u0915\u092A\u094D\u0930\u093F\u092F",
  more: "\u0905\u0927\u093F\u0915",
  others: "\u0905\u0928\u094D\u092F \u0932\u094B\u0917"
};
var get5 = {
  title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902",
  action: {
    label: "\u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902"
  },
  mobile: {
    description: "\u092E\u094B\u092C\u093E\u0907\u0932 \u0935\u0949\u0932\u0947\u091F"
  },
  extension: {
    description: "\u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928"
  },
  mobile_and_extension: {
    description: "\u092E\u094B\u092C\u093E\u0907\u0932 \u0935\u0949\u0932\u0947\u091F \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928"
  },
  looking_for: {
    title: "\u0915\u094D\u092F\u093E \u0906\u092A\u0915\u094B \u091C\u094B \u091A\u093E\u0939\u093F\u090F \u0935\u0939 \u0928\u0939\u0940\u0902 \u092E\u093F\u0932 \u0930\u0939\u093E \u0939\u0948?",
    mobile: {
      description: "\u092E\u0941\u0916\u094D\u092F \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u090F\u0915 \u092C\u091F\u0941\u0906 \u091A\u0941\u0928\u0947\u0902 \u0924\u093E\u0915\u093F \u0906\u092A \u090F\u0915 \u0905\u0932\u0917 \u092C\u091F\u0941\u0906 \u092A\u094D\u0930\u0926\u093E\u0924\u093E \u0915\u0947 \u0938\u093E\u0925 \u0936\u0941\u0930\u0942 \u0915\u0930 \u0938\u0915\u0947\u0902\u0964"
    },
    desktop: {
      compact_description: "\u092E\u0941\u0916\u094D\u092F \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u090F\u0915 \u092C\u091F\u0941\u0906 \u091A\u0941\u0928\u0947\u0902 \u0924\u093E\u0915\u093F \u0906\u092A \u090F\u0915 \u0905\u0932\u0917 \u092C\u091F\u0941\u0906 \u092A\u094D\u0930\u0926\u093E\u0924\u093E \u0915\u0947 \u0938\u093E\u0925 \u0936\u0941\u0930\u0942 \u0915\u0930 \u0938\u0915\u0947\u0902\u0964",
      wide_description: "\u092C\u093E\u090F\u0902 \u090F\u0915 \u092C\u091F\u0941\u0906 \u091A\u0941\u0928\u0947\u0902 \u0924\u093E\u0915\u093F \u0906\u092A \u090F\u0915 \u0905\u0932\u0917 \u092C\u091F\u0941\u0906 \u092A\u094D\u0930\u0926\u093E\u0924\u093E \u0915\u0947 \u0938\u093E\u0925 \u0936\u0941\u0930\u0942 \u0915\u0930 \u0938\u0915\u0947\u0902\u0964"
    }
  }
};
var get_options5 = {
  title: "%{wallet}\u0915\u0947 \u0938\u093E\u0925 \u0936\u0941\u0930\u0942 \u0915\u0930\u0947\u0902",
  short_title: "%{wallet}\u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902",
  mobile: {
    title: "\u092E\u094B\u092C\u093E\u0907\u0932 \u0915\u0947 \u0932\u093F\u090F %{wallet}",
    description: "\u092E\u094B\u092C\u093E\u0907\u0932 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 Ethereum \u0915\u0940 \u0926\u0941\u0928\u093F\u092F\u093E \u0915\u093E \u0905\u0928\u094D\u0935\u0947\u0937\u0923 \u0915\u0930\u0947\u0902\u0964",
    download: {
      label: "\u0910\u092A \u092A\u094D\u0930\u093E\u092A\u094D\u0924 \u0915\u0930\u0947\u0902"
    }
  },
  extension: {
    title: "%{wallet} \u0915\u0947 \u0932\u093F\u090F %{browser}",
    description: "\u0905\u092A\u0928\u0947 \u092A\u0938\u0902\u0926\u0940\u0926\u093E \u0935\u0947\u092C \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0938\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u092A\u0939\u0941\u0902\u091A\u0947\u0902\u0964",
    download: {
      label: "\u0915\u0930\u0947\u0902 \u091C\u094B\u0921\u093C\u0947\u0902 %{browser}"
    }
  }
};
var get_mobile5 = {
  title: "\u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902 %{wallet}",
  description: "iOS \u092F\u093E Android \u092A\u0930 \u0921\u093E\u0909\u0928\u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u092A\u0928\u0947 \u092B\u094B\u0928 \u0938\u0947 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902",
  continue: {
    label: "\u091C\u093E\u0930\u0940 \u0930\u0916\u0947\u0902"
  }
};
var get_instructions5 = {
  mobile: {
    connect: {
      label: "\u091C\u094B\u0921\u093C\u0947\u0902"
    },
    learn_more: {
      label: "\u0914\u0930 \u091C\u093E\u0928\u0947\u0902"
    }
  },
  extension: {
    refresh: {
      label: "\u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902"
    },
    learn_more: {
      label: "\u0914\u0930 \u091C\u093E\u0928\u0947\u0902"
    }
  }
};
var chains5 = {
  title: "\u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0938\u094D\u0935\u093F\u091A \u0915\u0930\u0947\u0902",
  wrong_network: "\u0917\u0932\u0924 \u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0915\u093E \u092A\u0924\u093E \u091A\u0932\u093E, \u091C\u093E\u0930\u0940 \u0930\u0916\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0938\u094D\u0935\u093F\u091A \u0915\u0930\u0947\u0902 \u092F\u093E \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0947\u0902\u0964",
  confirm: "\u0935\u0949\u0932\u0947\u091F \u092E\u0947\u0902 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902",
  switching_not_supported: "\u0906\u092A\u0915\u093E \u0935\u0949\u0932\u0947\u091F \u0928\u0947\u091F\u0935\u0930\u094D\u0915\u094D\u0938 \u0915\u094B %{appName}\u0938\u0947 \u0938\u094D\u0935\u093F\u091A \u0915\u0930\u0928\u093E \u0938\u092E\u0930\u094D\u0925\u0928 \u0928\u0939\u0940\u0902 \u0915\u0930\u0924\u093E . \u092C\u091C\u093E\u092F \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u092D\u0940\u0924\u0930 \u0938\u0947 \u0928\u0947\u091F\u0935\u0930\u094D\u0915 \u0938\u094D\u0935\u093F\u091A \u0915\u0930\u0928\u0947 \u0915\u093E \u092A\u094D\u0930\u092F\u093E\u0938 \u0915\u0930\u0947\u0902\u0964",
  switching_not_supported_fallback: "\u0906\u092A\u0915\u093E \u0935\u0949\u0932\u0947\u091F \u0907\u0938 \u090F\u092A \u0938\u0947 \u0928\u0947\u091F\u0935\u0930\u094D\u0915\u094D\u0938 \u0938\u094D\u0935\u093F\u091A \u0915\u0930\u0928\u0947 \u0915\u093E \u0938\u092E\u0930\u094D\u0925\u0928 \u0928\u0939\u0940\u0902 \u0915\u0930\u0924\u093E\u0964 \u092C\u091C\u093E\u092F \u0909\u0938\u0915\u0947, \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0926\u094D\u0935\u093E\u0930\u093E \u0928\u0947\u091F\u0935\u0930\u094D\u0915\u094D\u0938 \u0938\u094D\u0935\u093F\u091A \u0915\u0930\u0928\u0947 \u0915\u0940 \u0915\u094B\u0936\u093F\u0936 \u0915\u0930\u0947\u0902\u0964",
  disconnect: "\u0921\u093F\u0915\u0928\u0947\u0915\u094D\u091F",
  connected: "\u0915\u0928\u0947\u0915\u094D\u091F \u0915\u093F\u092F\u093E \u0917\u092F\u093E"
};
var profile5 = {
  disconnect: {
    label: "\u0921\u093F\u0915\u0928\u0947\u0915\u094D\u091F"
  },
  copy_address: {
    label: "\u092A\u0924\u093E \u0915\u0949\u092A\u0940 \u0915\u0930\u0947\u0902",
    copied: "\u0915\u0949\u092A\u0940 \u0915\u0930 \u0926\u093F\u092F\u093E \u0917\u092F\u093E!"
  },
  explorer: {
    label: "\u090F\u0915\u094D\u0938\u092A\u094D\u0932\u094B\u0930\u0930 \u092A\u0930 \u0905\u0927\u093F\u0915 \u0926\u0947\u0916\u0947\u0902"
  },
  transactions: {
    description: "%{appName} \u0932\u0947\u0928 - \u0926\u0947\u0928 \u092F\u0939\u093E\u0902 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0902\u0917\u0947...",
    description_fallback: "\u0906\u092A\u0915\u0947 \u0932\u0947\u0928-\u0926\u0947\u0928 \u092F\u0939\u093E\u0902 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0902\u0917\u0947...",
    recent: {
      title: "\u0939\u093E\u0932 \u0915\u0947 \u0932\u0947\u0928 - \u0926\u0947\u0928"
    },
    clear: {
      label: "\u0938\u092D\u0940 \u0915\u094B \u0939\u091F\u093E\u090F\u0902"
    }
  }
};
var wallet_connectors5 = {
  argent: {
    qr_code: {
      step1: {
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u091C\u0932\u094D\u0926\u0940 \u0938\u0947 \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0906\u092A\u0915\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 Argent \u0921\u093E\u0932\u0947\u0902\u0964",
        title: "Argent \u0910\u092A \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0935\u0949\u0932\u0947\u091F \u0914\u0930 \u0909\u092A\u092F\u094B\u0917\u0915\u0930\u094D\u0924\u093E \u0928\u093E\u092E \u092C\u0928\u093E\u090F\u0902, \u092F\u093E \u092E\u094C\u091C\u0942\u0926\u093E \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u091C\u0948\u0938\u0947 \u0939\u0940 \u0906\u092A \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902\u0917\u0947, \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u0902\u0915\u0947\u0924 \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0917\u093E\u0964",
        title: "QR \u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u0915\u094B \u091F\u0948\u092A \u0915\u0930\u0947\u0902"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "\u0939\u092E \u0906\u092A\u0915\u094B \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F Bifrost Wallet \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0932\u0917\u093E\u090F\u0902, \u0924\u093E\u0915\u093F \u0924\u094D\u0935\u0930\u093F\u0924 \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u094B \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u093F\u092F\u093E \u091C\u093E \u0938\u0915\u0947\u0964",
        title: "Bifrost Wallet \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0905\u092A\u0928\u0947 \u0930\u093F\u0915\u0935\u0930\u0940 \u092B\u093C\u094D\u0930\u0947\u091C\u093C \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0907\u0902\u092A\u094B\u0930\u094D\u091F \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0907\u0902\u092A\u094B\u0930\u094D\u091F \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u0902\u0915\u0947\u0924 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E\u0964",
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u0915\u094B \u091F\u0948\u092A \u0915\u0930\u0947\u0902"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "\u0939\u092E \u0907\u0938\u0947 \u0938\u0941\u091D\u093E\u0935 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 Bitget \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0930\u0916\u0947\u0902 \u0924\u093E\u0915\u093F \u091C\u0932\u094D\u0926\u0940 \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u0930 \u0938\u0915\u0947\u0902\u0964",
        title: "Bitget \u0935\u0949\u0932\u0947\u091F \u090F\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0964 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u092D\u0940 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u093E \u090F\u0915 \u0938\u0902\u0915\u0947\u0924 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E\u0964",
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902"
      }
    },
    extension: {
      step1: {
        description: "\u0939\u092E \u0907\u0938\u0947 \u0938\u0941\u091D\u093E\u0935 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0906\u092A Bitget \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0906\u092A\u0915\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0947\u0902 \u0924\u093E\u0915\u093F \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u091C\u0932\u094D\u0926\u0940 \u092A\u0939\u0941\u0902\u091A \u0938\u0915\u0947\u0902\u0964",
        title: "Bitget Wallet \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0915\u093F\u0938\u0940 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0905\u092A\u0928\u0940 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0915\u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F\u0905\u092A \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u0924\u093E\u0915\u093F \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "\u0939\u092E \u0906\u092A\u0915\u094B \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u091C\u0932\u094D\u0926\u0940 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F Bitski \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "Bitski \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u092C\u0928\u093E \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u0947 \u0917\u094B\u092A\u0928\u0940\u092F \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "\u0939\u092E \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u0947\u091C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 Coin98 \u0935\u0949\u0932\u0947\u091F \u0930\u0916\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "Coin98 \u0935\u0949\u0932\u0947\u091F \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0906\u092A \u0905\u092A\u0928\u0947 \u092B\u094B\u0928 \u092A\u0930 \u0939\u092E\u093E\u0930\u0947 \u092C\u0948\u0915\u0905\u092A \u092B\u0940\u091A\u0930 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0906\u0938\u093E\u0928\u0940 \u0938\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u092A\u094D\u0930\u093E\u0902\u092A\u094D\u091F \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E\u0964",
        title: "WalletConnect \u092C\u091F\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902"
      }
    },
    extension: {
      step1: {
        description: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u0947 \u090A\u092A\u0930\u0940 \u0926\u093E\u090F\u0902 \u0939\u093F\u0938\u094D\u0938\u0947 \u092A\u0930 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u0914\u0930 \u0906\u0938\u093E\u0928\u0940 \u0938\u0947 \u092A\u0939\u0941\u0902\u091A \u0915\u0947 \u0932\u093F\u090F Coin98 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u092A\u093F\u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "Coin98 \u0935\u0949\u0932\u0947\u091F \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0928\u092F\u093E \u092C\u091F\u0941\u0906 \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u092E\u094C\u091C\u0942\u0926\u093E \u0915\u094B \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902\u0964",
        title: "\u090F\u0915 \u092C\u091F\u0941\u0906 \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A Coin98 \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0915\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u0930 \u0915\u094B \u0924\u093E\u091C\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "\u0939\u092E \u0906\u092A\u0915\u094B \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0906\u092A\u0915\u0940 \u092E\u0941\u0916\u094D\u092F \u092C\u093F\u0932\u094D\u0921 \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 Coinbase \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0930\u0916\u0947\u0902 \u091C\u093F\u0938\u0938\u0947 \u0906\u092A\u0915\u0940 \u092A\u0939\u0941\u0902\u091A \u0924\u0947\u091C \u0939\u094B\u0964",
        title: "Coinbase \u0935\u0949\u0932\u0947\u091F \u0910\u092A \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0906\u092A \u092C\u093E\u0926\u0932 \u092C\u0948\u0915\u0905\u092A \u0938\u0941\u0935\u093F\u0927\u093E \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0906\u0938\u093E\u0928\u0940 \u0938\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u091C\u0948\u0938\u0947 \u0939\u0940 \u0906\u092A \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0906\u092A\u0915\u094B \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0938\u0947 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u0902\u0915\u0947\u0924 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E\u0964",
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u0915\u094B \u091B\u0942\u0928\u093E"
      }
    },
    extension: {
      step1: {
        description: "\u0939\u092E\u093E\u0930\u093E \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0939\u0948 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u091C\u0932\u094D\u0926\u0940 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F Coinbase \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092A\u0930 \u092A\u093F\u0928 \u092A\u0930 \u0930\u0916\u0947\u0902\u0964",
        title: "Coinbase \u0935\u0949\u0932\u0947\u091F \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0935\u093F\u0927\u093F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u092C\u091F\u0941\u090F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947\u0928\u093E \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0964 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u092A\u0941\u0928\u0930\u094D\u092A\u094D\u0930\u093E\u092A\u094D\u0924\u093F \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0905\u092A \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u0917\u0940 \u0926\u0947\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902.",
        title: "\u0905\u092A\u0928\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0924\u093E\u091C\u093E \u0915\u0930\u0947\u0902"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "\u0939\u092E \u0906\u092A\u0915\u0940 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u0924\u0947\u091C \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u0947 \u0932\u093F\u090F Core \u0915\u094B \u0906\u092A\u0915\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0921\u093E\u0932\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902.",
        title: "Core \u090F\u092A \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0906\u092A \u0906\u0938\u093E\u0928\u0940 \u0938\u0947 \u0905\u092A\u0928\u0947 \u095E\u094B\u0928 \u092A\u0930 \u0939\u092E\u093E\u0930\u0947 \u092C\u0948\u0915\u0905\u092A \u092B\u0940\u091A\u0930 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0948\u0915\u0905\u092A \u0915\u0930 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902.",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0906\u092A\u0915\u0947 \u0932\u093F\u090F \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u092A\u094D\u0930\u093E\u092E\u094D\u092A\u094D\u091F \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0917\u093E.",
        title: "WalletConnect \u092C\u091F\u0928 \u0915\u094B \u091B\u0942\u0928\u0947 \u0915\u0947 \u0938\u093E\u0925"
      }
    },
    extension: {
      step1: {
        description: "\u0939\u092E \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u0932\u093F\u090F \u0924\u0947\u091C \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u0947 \u0932\u093F\u090F \u0915\u094B\u0930 \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "\u0915\u094B\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u0940 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u0938\u094D\u0925\u093E\u092A\u0928\u093E \u0915\u0930 \u0932\u0947\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u0924\u093E\u0915\u093F \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930 \u0938\u0915\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930 \u0938\u0915\u0947\u0902\u0964",
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "\u0939\u092E FoxWallet \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0928\u0947 \u0915\u0940 \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902 \u0924\u093E\u0915\u093F \u0924\u094D\u0935\u0930\u093F\u0924 \u090F\u0915\u094D\u0938\u0947\u0938 \u092E\u093F\u0932 \u0938\u0915\u0947\u0964",
        title: "FoxWallet \u0910\u092A \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u091C\u092C \u0906\u092A \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902\u0917\u0947, \u0924\u094B \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u0902\u0915\u0947\u0924 \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0917\u093E\u0964",
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "\u0939\u092E\u093E\u0930\u0940 \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0939\u0948 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u092B\u094D\u0930\u0902\u091F\u093F\u092F\u0930 \u0935\u0949\u0932\u0947\u091F \u0930\u0916\u0947\u0902 \u091C\u093F\u0938\u0938\u0947 \u0915\u093F \u0906\u092A\u0915\u094B \u0924\u094D\u0935\u0930\u093F\u0924 \u092A\u0939\u0941\u0902\u091A \u092E\u093F\u0932\u0947\u0964",
        title: "\u092B\u094D\u0930\u0902\u091F\u093F\u092F\u0930 \u0935\u0949\u0932\u0947\u091F \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u091C\u092C \u0906\u092A \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u0902\u0915\u0947\u0924 \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0917\u093E\u0964",
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u0915\u094B \u091F\u0948\u092A \u0915\u0930\u0947\u0902"
      }
    },
    extension: {
      step1: {
        description: "\u0939\u092E \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u0924\u0947\u091C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0902\u091A \u0915\u0947 \u0932\u093F\u090F Frontier Wallet \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "Frontier Wallet \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0907\u0902\u0938\u094D\u091F\u0949\u0932 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0948\u0915\u0905\u092A \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F\u0905\u092A \u0939\u094B\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0930\u093F\u092B\u094D\u0930\u0947\u0936 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0905\u092A\u0928\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0930\u093F\u092B\u094D\u0930\u0947\u0936 \u0915\u0930\u0947\u0902"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "imToken \u0910\u092A \u0916\u094B\u0932\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u0924\u0947\u091C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F imToken \u090F\u092A\u094D\u0932\u0940\u0915\u0947\u0936\u0928 \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0947\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u0928\u092F\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u092E\u094C\u091C\u0942\u0926\u093E \u090F\u0915 \u0915\u094B \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u090A\u092A\u0930\u0940 \u0926\u093E\u090F\u0902 \u0915\u094B\u0928\u0947 \u092E\u0947\u0902 \u0938\u094D\u0915\u0948\u0928\u0930 \u0906\u0907\u0915\u0949\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902",
        description: "\u0928\u092F\u093E \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u091A\u0941\u0928\u0947\u0902, \u092B\u093F\u0930 QR \u0915\u094B\u0921 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u0949\u092E\u094D\u092A\u094D\u091F \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "MetaMask \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u094B MetaMask \u0915\u094B \u0906\u092A\u0915\u0940 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902, \u0907\u0938\u0938\u0947 \u0906\u092A\u0915\u094B \u0924\u094D\u0935\u0930\u093F\u0924 \u092A\u0939\u0941\u0901\u091A \u092E\u093F\u0932\u0947\u0917\u0940\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0907\u092E\u094D\u092A\u094B\u0930\u094D\u091F \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0935\u093F\u0927\u093F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u092C\u091F\u0941\u090F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947\u0928\u093E \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0964 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902",
        description: "\u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u092A\u094D\u0930\u0949\u092E\u094D\u092A\u094D\u091F \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E\u0964"
      }
    },
    extension: {
      step1: {
        title: "MetaMask \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u091C\u0932\u094D\u0926\u0940 \u0938\u0947 \u092A\u0939\u0941\u0901\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F MetaMask \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0928\u093E \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0964 \u0905\u092A\u0928\u0940 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0936\u0947\u092F\u0930 \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0905\u092A \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "OKX Wallet \u0910\u092A \u0916\u094B\u0932\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u094B OKX Wallet \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902, \u091C\u093F\u0938\u0938\u0947 \u0906\u092A \u091C\u0932\u094D\u0926\u0940 \u0938\u0947 \u092A\u0939\u0941\u0902\u091A \u0938\u0915\u0947\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0928\u0947 \u0915\u093E \u092F\u0915\u0940\u0928 \u0915\u0930\u0947\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u0947 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902",
        description: "\u091C\u092C \u0906\u092A \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u0902\u0915\u0947\u0924 \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0917\u093E\u0964"
      }
    },
    extension: {
      step1: {
        title: "OKX \u0935\u0949\u0932\u0947\u091F \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u0947\u091C\u093C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0906\u092A\u0915\u094B OKX \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0905\u092A\u0928\u0947 \u0915\u093E\u0930\u094D\u092F\u092A\u091F\u094D\u091F\u0940 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0928\u0947 \u0915\u093E \u092F\u0915\u0940\u0928 \u0915\u0930\u0947\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u0947 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0905\u092A \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0915\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Omni \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0905\u0927\u093F\u0915 \u091C\u0932\u094D\u0926\u0940 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F Omni \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u091C\u094B\u0921\u093C\u0947\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u0928\u092F\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u092E\u094C\u091C\u0942\u0926\u093E \u090F\u0915 \u0915\u094B \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "QR \u0906\u0907\u0915\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902 \u0914\u0930 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 QR \u0906\u0907\u0915\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902, \u0915\u094B\u0921 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u0949\u092E\u094D\u092A\u094D\u091F \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "TokenPocket \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u094B TokenPocket \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0924\u093E\u0915\u093F \u0906\u092A\u0915\u094B \u0924\u0947\u091C \u090F\u0915\u094D\u0938\u0947\u0938 \u092E\u093F\u0932 \u0938\u0915\u0947\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0901 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0935\u093F\u0927\u093F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u092C\u091F\u0941\u090F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947\u0928\u093E \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0964 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0906\u092A\u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u092A\u094D\u0930\u0949\u092E\u094D\u092A\u094D\u091F \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0917\u093E \u0924\u093E\u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930 \u0938\u0915\u0947\u0902\u0964"
      }
    },
    extension: {
      step1: {
        title: "TokenPocket \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u094D\u0935\u0930\u093F\u0924 \u092A\u0939\u0941\u0902\u091A \u0915\u0947 \u0932\u093F\u090F TokenPocket \u0915\u094B \u0905\u092A\u0928\u0947 taskbar \u092A\u0930 pin \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F\u0905\u092A \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u0924\u093E\u091C\u093C\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930  \u0932\u094B\u0921 \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0905\u092A \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Trust Wallet \u0910\u092A \u0916\u094B\u0932\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u0947\u091C\u093C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F Trust Wallet \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0947\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u0928\u092F\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u092E\u094C\u091C\u0942\u0926\u093E \u0935\u0949\u0932\u0947\u091F \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0938\u0947\u091F\u093F\u0902\u0917\u094D\u0938 \u092E\u0947\u0902 WalletConnect \u0915\u094B \u091F\u0948\u092A \u0915\u0930\u0947\u0902",
        description: "\u0928\u092F\u093E \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u091A\u0941\u0928\u0947\u0902, \u092B\u093F\u0930 QR \u0915\u094B\u0921 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 \u092A\u094D\u0930\u092E\u094D\u092A\u094D\u091F \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902\u0964"
      }
    },
    extension: {
      step1: {
        title: "Trust Wallet \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0907\u0902\u0938\u094D\u091F\u0949\u0932 \u0915\u0930\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u0947 \u090A\u092A\u0930\u0940 \u0926\u093E\u090F\u0902 \u0915\u094B\u0928\u0947 \u092A\u0930 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u0914\u0930 Trust Wallet \u0915\u094B \u0906\u0938\u093E\u0928\u0940 \u0938\u0947 \u092A\u094D\u0930\u0935\u0947\u0936 \u0915\u0947 \u0932\u093F\u090F \u092A\u093F\u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u0928\u092F\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u092E\u094C\u091C\u0942\u0926\u093E \u0935\u0949\u0932\u0947\u091F \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 Trust Wallet \u0938\u0947\u091F \u0905\u092A \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F\u0964"
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Uniswap \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 Uniswap \u0935\u0949\u0932\u0947\u091F \u091C\u094B\u0921\u093C\u0947\u0902, \u0907\u0938\u0938\u0947 \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u0947\u091C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0902\u091A\u0928\u0947 \u0915\u0940 \u0938\u0941\u0935\u093F\u0927\u093E \u0939\u094B\u0917\u0940\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u0928\u092F\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u092E\u094C\u091C\u0942\u0926\u093E \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "QR \u0906\u0907\u0915\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902 \u0914\u0930 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u0939\u094B\u092E\u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 QR \u0906\u0907\u0915\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902, \u0915\u094B\u0921 \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0947\u0902 \u0914\u0930 \u092A\u094D\u0930\u092E\u094D\u092A\u094D\u091F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0940 \u092A\u0941\u0937\u094D\u091F\u093F \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Zerion \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902",
        description: "\u0939\u092E \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0906\u092A Zerion \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0947\u0902, \u0907\u0938\u0938\u0947 \u0924\u0947\u091C\u0940 \u0938\u0947 \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u0930\u0928\u0947 \u092E\u0947\u0902 \u0906\u0938\u093E\u0928\u0940 \u0939\u094B\u0917\u0940\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0935\u093F\u0927\u093F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u092C\u091F\u0941\u090F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947\u0928\u093E \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0964 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u0915\u094B \u091F\u0948\u092A \u0915\u0930\u0947\u0902",
        description: "\u0906\u092A \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0928\u0947 \u0915\u0947 \u092C\u093E\u0926, \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u092A\u094D\u0930\u094B\u092E\u094D\u092A\u094D\u091F \u0906\u092A\u0915\u0947 \u092C\u091F\u0941\u090F \u0915\u094B \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u092A\u094D\u0930\u0915\u091F \u0939\u094B\u0917\u093E\u0964"
      }
    },
    extension: {
      step1: {
        title: "Zerion \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E\u093E\u0930\u0940 \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0939\u0948 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u091C\u0932\u094D\u0926\u0940 \u092A\u0939\u0941\u0901\u091A\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F Zerion \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0935\u093F\u0927\u093F \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F \u0915\u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u0938\u094D\u0925\u093E\u092A\u0928\u093E \u0915\u0930 \u0932\u0947\u0902, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Rainbow \u0910\u092A \u0915\u094B \u0916\u094B\u0932\u0947\u0902",
        description: "\u0939\u092E \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u0924\u0947\u091C \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u0947 \u0932\u093F\u090F Rainbow \u0915\u094B \u0905\u092A\u0928\u0947 \u0939\u094B\u092E \u0938\u094D\u0915\u094D\u0930\u0940\u0928 \u092A\u0930 \u0930\u0916\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0906\u092A \u0905\u092A\u0928\u0947 \u092B\u093C\u094B\u0928 \u092A\u0930 \u0939\u092E\u093E\u0930\u0947 \u092C\u0948\u0915\u0905\u092A \u092B\u0940\u091A\u0930 \u0915\u093E \u0909\u092A\u092F\u094B\u0917 \u0915\u0930\u0915\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0906\u0938\u093E\u0928\u0940 \u0938\u0947 \u0932\u0947 \u0938\u0915\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step3: {
        title: "\u0938\u094D\u0915\u0948\u0928 \u092C\u091F\u0928 \u092A\u0930 \u091F\u0948\u092A \u0915\u0930\u0947\u0902",
        description: "\u091C\u092C \u0906\u092A \u0938\u094D\u0915\u0948\u0928 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0906\u092A\u0915\u0940 \u0935\u0949\u0932\u0947\u091F \u0938\u0947 \u0915\u0928\u0947\u0915\u094D\u091F \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u090F\u0915 \u0915\u0928\u0947\u0915\u094D\u0936\u0928 \u0938\u0902\u0915\u0947\u0924 \u0926\u093F\u0916\u093E\u0908 \u0926\u0947\u0917\u093E\u0964"
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "\u0939\u092E \u0905\u092A\u0928\u0940 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u0947\u091C\u093C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F Enkrypt \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "Enkrypt \u0935\u0949\u0932\u0947\u091F \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0940 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0964 \u0905\u092A\u0928\u0940 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u0940 \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0915\u0930 \u0932\u0947\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F\u0964",
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "\u0939\u092E \u0905\u092A\u0928\u0940 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u0947\u091C\u093C\u0940 \u0938\u0947 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F Frame \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964",
        title: "Frame \u0914\u0930 \u0938\u093E\u0925\u0940 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902"
      },
      step2: {
        description: "\u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0928\u093E \u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0905\u092A\u0928\u0940 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902"
      },
      step3: {
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u0938\u0947\u091F\u0905\u092A \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0915\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964",
        title: "\u0905\u092A\u0928\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "OneKey Wallet \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u094B \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u0924\u0947\u091C \u090F\u0915\u094D\u0938\u0947\u0938 \u0915\u0947 \u0932\u093F\u090F OneKey Wallet \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u092D\u0940 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0905\u092A \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "\u092B\u0948\u0902\u091F\u092E \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0947 \u0906\u0938\u093E\u0928 \u0909\u092A\u092F\u094B\u0917 \u0915\u0947 \u0932\u093F\u090F \u092B\u0948\u0902\u091F\u092E \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u0938\u0942\u0932\u0940 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u092D\u0940 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0915\u0930 \u0932\u0947\u0902, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u0917\u0940 \u0926\u0947\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Rabby \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u094B \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u091C\u0932\u094D\u0926\u0940 \u0938\u0947 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F Rabby \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u093E \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u093E \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0905\u092A \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "\u0915\u094B\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u094B \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902 \u0915\u093F \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u091C\u0932\u094D\u0926\u0940 \u0938\u0947 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F Safeheron \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step2: {
        title: "\u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0948\u0915\u0905\u092A \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u0947 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u094B \u0938\u0947\u091F \u0905\u092A \u0915\u0930\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902 \u0924\u093E\u0915\u093F \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "\u0924\u093E\u0939\u094B \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u0947 \u0935\u0949\u0932\u0947\u091F \u0924\u0915 \u0924\u094D\u0935\u0930\u093F\u0924 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F \u0924\u093E\u0939\u094B \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0901 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0938\u0941\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0915\u0930\u0947\u0902 \u0915\u093F \u0906\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0905\u092A\u0928\u093E \u0935\u0949\u0932\u0947\u091F \u092C\u0948\u0915\u0905\u092A \u0915\u0930 \u0930\u0939\u0947 \u0939\u0948\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0905\u092A\u0928\u0947 \u0917\u0941\u092A\u094D\u0924 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u092C\u091F\u0941\u0906 \u0938\u0947\u091F \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0915\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "\u0924\u093E\u0932\u093F\u0938\u092E\u093E\u0928 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u0947 \u092C\u091F\u0941\u090F \u0915\u0947 \u0924\u094D\u0935\u0930\u093F\u0924 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F \u0924\u093E\u0932\u093F\u0938\u092E\u093E\u0928 \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u093F\u092B\u093E\u0930\u093F\u0936 \u0915\u0930\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0908\u0925\u0947\u0930\u093F\u092F\u092E \u092C\u091F\u0941\u090F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0905\u092A\u0928\u0947 \u092C\u091F\u0941\u090F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u090F\u0915 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0928\u0947 \u0915\u093E \u0927\u094D\u092F\u093E\u0928 \u0930\u0916\u0947\u0902\u0964 \u0915\u092D\u0940 \u092D\u0940 \u0905\u092A\u0928\u0940 \u0935\u0938\u0942\u0932\u0940 \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0938\u093E\u091D\u093E \u0928 \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A \u0905\u092A\u0928\u093E \u092C\u091F\u0941\u0906 \u0938\u0947\u091F \u0915\u0930 \u0932\u0947\u0924\u0947 \u0939\u0948\u0902, \u0924\u094B \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0915\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "XDEFI \u0935\u0949\u0932\u0947\u091F \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0938\u094D\u0925\u093E\u092A\u093F\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0939\u092E \u0906\u092A\u0915\u0940 \u0935\u0949\u0932\u0947\u091F \u0915\u0940 \u091C\u0932\u094D\u0926\u0940 \u0938\u0947 \u092A\u0939\u0941\u0901\u091A \u0915\u0947 \u0932\u093F\u090F XDEFI Wallet \u0915\u094B \u0905\u092A\u0928\u0947 \u091F\u093E\u0938\u094D\u0915\u092C\u093E\u0930 \u092E\u0947\u0902 \u092A\u093F\u0928 \u0915\u0930\u0928\u0947 \u0915\u0940 \u0938\u0932\u093E\u0939 \u0926\u0947\u0924\u0947 \u0939\u0948\u0902\u0964"
      },
      step2: {
        title: "\u090F\u0915 \u0935\u0949\u0932\u0947\u091F \u092C\u0928\u093E\u090F\u0902 \u092F\u093E \u0906\u092F\u093E\u0924 \u0915\u0930\u0947\u0902",
        description: "\u0928\u093F\u0936\u094D\u091A\u093F\u0924 \u0930\u0942\u092A \u0938\u0947 \u0905\u092A\u0928\u0947 \u0935\u0949\u0932\u0947\u091F \u0915\u093E \u092C\u0948\u0915\u0905\u092A \u0915\u093F\u0938\u0940 \u0938\u0941\u0930\u0915\u094D\u0937\u093F\u0924 \u0924\u0930\u0940\u0915\u0947 \u0938\u0947 \u0932\u0947\u0902\u0964 \u0905\u092A\u0928\u0940 \u0917\u094B\u092A\u0928\u0940\u092F \u0935\u093E\u0915\u094D\u092F\u093E\u0902\u0936 \u0915\u094B \u0915\u093F\u0938\u0940 \u0915\u0947 \u0938\u093E\u0925 \u0936\u0947\u092F\u0930 \u0928\u093E \u0915\u0930\u0947\u0902\u0964"
      },
      step3: {
        title: "\u0905\u092A\u0928\u0947 \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0947\u0902",
        description: "\u090F\u0915 \u092C\u093E\u0930 \u091C\u092C \u0906\u092A\u0928\u0947 \u0905\u092A\u0928\u0940 \u0935\u0949\u0932\u0947\u091F \u0938\u0947\u091F \u0905\u092A \u0915\u0930 \u0932\u0940 \u0939\u094B, \u0924\u094B \u092C\u094D\u0930\u093E\u0909\u091C\u093C\u0930 \u0915\u094B \u0924\u093E\u091C\u093C\u093E \u0915\u0930\u0928\u0947 \u0914\u0930 \u090F\u0915\u094D\u0938\u091F\u0947\u0902\u0936\u0928 \u0915\u094B \u0932\u094B\u0921 \u0915\u0930\u0928\u0947 \u0915\u0947 \u0932\u093F\u090F \u0928\u0940\u091A\u0947 \u0915\u094D\u0932\u093F\u0915 \u0915\u0930\u0947\u0902\u0964"
      }
    }
  }
};
var hi_IN_default = {
  connect_wallet: connect_wallet5,
  intro: intro5,
  connect: connect5,
  connect_scan: connect_scan5,
  connector_group: connector_group5,
  get: get5,
  get_options: get_options5,
  get_mobile: get_mobile5,
  get_instructions: get_instructions5,
  chains: chains5,
  profile: profile5,
  wallet_connectors: wallet_connectors5
};

// src/locales/id_ID.json
var connect_wallet6 = {
  label: "Hubungkan Dompet"
};
var intro6 = {
  title: "Apa itu Dompet?",
  description: "Sebuah dompet digunakan untuk mengirim, menerima, menyimpan, dan menampilkan aset digital. Ini juga cara baru untuk masuk, tanpa perlu membuat akun dan kata sandi baru di setiap situs web.",
  digital_asset: {
    title: "Sebuah Rumah untuk Aset Digital Anda",
    description: "Dompet digunakan untuk mengirim, menerima, menyimpan, dan menampilkan aset digital seperti Ethereum dan NFTs."
  },
  login: {
    title: "Cara Baru untuk Masuk",
    description: "Alih-alih membuat akun dan kata sandi baru di setiap situs web, cukup hubungkan dompet Anda."
  },
  get: {
    label: "Dapatkan Dompet"
  },
  learn_more: {
    label: "Pelajari lebih lanjut"
  }
};
var connect6 = {
  label: "Hubungkan",
  title: "Hubungkan Dompet",
  new_to_ethereum: {
    description: "Baru dalam dompet Ethereum?",
    learn_more: {
      label: "Pelajari lebih lanjut"
    }
  },
  learn_more: {
    label: "Pelajari lebih lanjut"
  },
  recent: "Terkini",
  status: {
    opening: "Membuka %{wallet}...",
    not_installed: "%{wallet} tidak terpasang",
    not_available: "%{wallet} tidak tersedia",
    confirm: "Konfirmasikan koneksi di ekstensi"
  },
  secondary_action: {
    get: {
      description: "Tidak memiliki %{wallet}?",
      label: "DAPATKAN"
    },
    install: {
      label: "PASANG"
    },
    retry: {
      label: "COBA LAGI"
    }
  },
  walletconnect: {
    description: {
      full: "Perlu modal resmi WalletConnect?",
      compact: "Perlu modal WalletConnect?"
    },
    open: {
      label: "BUKA"
    }
  }
};
var connect_scan6 = {
  title: "Pindai dengan %{wallet}",
  fallback_title: "Pindai dengan ponsel Anda"
};
var connector_group6 = {
  recommended: "Direkomendasikan",
  other: "Lainnya",
  popular: "Populer",
  more: "Lebih Banyak",
  others: "Lainnya"
};
var get6 = {
  title: "Dapatkan Dompet",
  action: {
    label: "DAPATKAN"
  },
  mobile: {
    description: "Dompet Mobile"
  },
  extension: {
    description: "Ekstensi Browser"
  },
  mobile_and_extension: {
    description: "Dompet Mobile dan Ekstensi"
  },
  looking_for: {
    title: "Bukan yang Anda cari?",
    mobile: {
      description: "Pilih dompet di layar utama untuk memulai dengan penyedia dompet yang berbeda."
    },
    desktop: {
      compact_description: "Pilih dompet di layar utama untuk memulai dengan penyedia dompet yang berbeda.",
      wide_description: "Pilih dompet di sebelah kiri untuk memulai dengan penyedia dompet yang berbeda."
    }
  }
};
var get_options6 = {
  title: "Mulai dengan %{wallet}",
  short_title: "Dapatkan %{wallet}",
  mobile: {
    title: "%{wallet} untuk Mobile",
    description: "Gunakan dompet mobile untuk menjelajahi dunia Ethereum.",
    download: {
      label: "Dapatkan aplikasinya"
    }
  },
  extension: {
    title: "%{wallet} untuk %{browser}",
    description: "Akses dompet Anda langsung dari browser web favorit Anda.",
    download: {
      label: "Tambahkan ke %{browser}"
    }
  }
};
var get_mobile6 = {
  title: "Instal %{wallet}",
  description: "Pindai dengan ponsel Anda untuk mengunduh di iOS atau Android",
  continue: {
    label: "Lanjutkan"
  }
};
var get_instructions6 = {
  mobile: {
    connect: {
      label: "Hubungkan"
    },
    learn_more: {
      label: "Pelajari lebih lanjut"
    }
  },
  extension: {
    refresh: {
      label: "Segarkan"
    },
    learn_more: {
      label: "Pelajari lebih lanjut"
    }
  }
};
var chains6 = {
  title: "Alihkan Jaringan",
  wrong_network: "Jaringan yang salah terdeteksi, alihkan atau diskonek untuk melanjutkan.",
  confirm: "Konfirmasi di Dompet",
  switching_not_supported: "Dompet Anda tidak mendukung pengalihan jaringan dari %{appName}. Coba alihkan jaringan dari dalam dompet Anda.",
  switching_not_supported_fallback: "Wallet Anda tidak mendukung penggantian jaringan dari aplikasi ini. Cobalah ganti jaringan dari dalam wallet Anda.",
  disconnect: "Putuskan koneksi",
  connected: "Terkoneksi"
};
var profile6 = {
  disconnect: {
    label: "Putuskan koneksi"
  },
  copy_address: {
    label: "Salin Alamat",
    copied: "Tersalin!"
  },
  explorer: {
    label: "Lihat lebih banyak di penjelajah"
  },
  transactions: {
    description: "%{appName} transaksi akan muncul di sini...",
    description_fallback: "Transaksi Anda akan muncul di sini...",
    recent: {
      title: "Transaksi Terbaru"
    },
    clear: {
      label: "Hapus Semua"
    }
  }
};
var wallet_connectors6 = {
  argent: {
    qr_code: {
      step1: {
        description: "Letakkan Argent di layar utama Anda untuk akses lebih cepat ke dompet Anda.",
        title: "Buka aplikasi Argent"
      },
      step2: {
        description: "Buat dompet dan nama pengguna, atau impor dompet yang ada.",
        title: "Buat atau Impor Dompet"
      },
      step3: {
        description: "Setelah Anda memindai, akan muncul petunjuk koneksi untuk Anda menghubungkan dompet Anda.",
        title: "Tekan tombol Scan QR"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "Kami merekomendasikan untuk menempatkan Bifrost Wallet di layar utama anda untuk akses yang lebih cepat.",
        title: "Buka aplikasi Bifrost Wallet"
      },
      step2: {
        description: "Buat atau impor sebuah dompet menggunakan frasa pemulihan Anda.",
        title: "Buat atau Impor sebuah Wallet"
      },
      step3: {
        description: "Setelah Anda memindai, sebuah pesan akan muncul untuk menghubungkan dompet Anda.",
        title: "Tekan tombol scan"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "Kami menyarankan untuk meletakkan Bitget Wallet di layar depan Anda untuk akses yang lebih cepat.",
        title: "Buka aplikasi Bitget Wallet"
      },
      step2: {
        description: "Pastikan untuk mencadangkan wallet Anda menggunakan metode yang aman. Jangan pernah berbagi frasa rahasia Anda dengan siapa pun.",
        title: "Buat atau Impor Wallet"
      },
      step3: {
        description: "Setelah Anda pindai, akan muncul petunjuk untuk menghubungkan wallet Anda.",
        title: "Tekan tombol pindai"
      }
    },
    extension: {
      step1: {
        description: "Kami menyarankan untuk memasang Bitget Wallet ke taskbar Anda untuk akses yang lebih cepat ke wallet Anda.",
        title: "Instal ekstensi Dompet Bitget"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frasa rahasia Anda kepada siapa pun.",
        title: "Buat atau Impor Dompet"
      },
      step3: {
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "Kami merekomendasikan untuk memasang Bitski ke taskbar Anda untuk akses dompet Anda yang lebih cepat.",
        title: "Pasang ekstensi Bitski"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah berbagi frasa rahasia Anda dengan siapa pun.",
        title: "Buat atau Impor Dompet"
      },
      step3: {
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "Kami merekomendasikan untuk menaruh Coin98 Wallet di layar utama Anda untuk akses wallet Anda lebih cepat.",
        title: "Buka aplikasi Coin98 Wallet"
      },
      step2: {
        description: "Anda dapat dengan mudah mencadangkan wallet Anda menggunakan fitur cadangan kami di telepon Anda.",
        title: "Buat atau Impor Wallet"
      },
      step3: {
        description: "Setelah Anda melakukan pemindaian, akan muncul prompt koneksi untuk Anda menghubungkan wallet Anda.",
        title: "Ketuk tombol WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Klik di pojok kanan atas browser Anda dan sematkan Coin98 Wallet untuk akses mudah.",
        title: "Pasang ekstensi Coin98 Wallet"
      },
      step2: {
        description: "Buat dompet baru atau impor yang sudah ada.",
        title: "Buat atau Impor sebuah dompet"
      },
      step3: {
        description: "Setelah Anda menyiapkan Coin98 Wallet, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "Kami merekomendasikan memasang Coinbase Wallet di layar utama Anda untuk akses yang lebih cepat.",
        title: "Buka aplikasi Coinbase Wallet"
      },
      step2: {
        description: "Anda dapat dengan mudah mencadangkan dompet Anda menggunakan fitur cadangan awan.",
        title: "Buat atau Impor sebuah Dompet"
      },
      step3: {
        description: "Setelah Anda memindai, akan muncul sebuah petunjuk koneksi untuk Anda menyambungkan dompet Anda.",
        title: "Ketuk tombol pindai"
      }
    },
    extension: {
      step1: {
        description: "Kami merekomendasikan untuk menempel Coinbase Wallet ke taskbar Anda untuk akses lebih cepat ke dompet Anda.",
        title: "Instal ekstensi Coinbase Wallet"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase pemulihan rahasia Anda kepada siapa pun.",
        title: "Buat atau Import Wallet"
      },
      step3: {
        description: "Setelah Anda menyiapkan wallet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "Kami merekomendasikan untuk meletakkan Core di layar utama Anda untuk akses lebih cepat ke wallet Anda.",
        title: "Buka aplikasi Core"
      },
      step2: {
        description: "Anda dapat dengan mudah mencadangkan wallet Anda dengan menggunakan fitur cadangan kami di telepon Anda.",
        title: "Buat atau Import Wallet"
      },
      step3: {
        description: "Setelah Anda memindai, akan muncul petunjuk koneksi untuk Anda menyambungkan wallet Anda.",
        title: "Ketuk tombol WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Kami merekomendasikan untuk menempelkan Core pada taskbar Anda untuk akses ke dompet Anda lebih cepat.",
        title: "Pasang ekstensi Core"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase rahasia Anda kepada siapa pun.",
        title: "Buat atau Impor Dompet"
      },
      step3: {
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "Kami merekomendasikan untuk menaruh FoxWallet pada layar utama Anda untuk akses lebih cepat.",
        title: "Buka aplikasi FoxWallet"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase rahasia Anda kepada siapa pun.",
        title: "Buat atau Impor Wallet"
      },
      step3: {
        description: "Setelah Anda memindai, prompt koneksi akan muncul untuk Anda hubungkan dompet Anda.",
        title: "Ketuk tombol pindai"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "Kami merekomendasikan untuk meletakkan Frontier Wallet di layar awal Anda untuk akses yang lebih cepat.",
        title: "Buka aplikasi Frontier Wallet"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase rahasia Anda kepada siapa pun.",
        title: "Buat atau Impor Wallet"
      },
      step3: {
        description: "Setelah Anda memindai, prompt koneksi akan muncul untuk Anda menghubungkan dompet Anda.",
        title: "Ketuk tombol pindai"
      }
    },
    extension: {
      step1: {
        description: "Kami menyarankan menempelkan Frontier Wallet ke taskbar Anda untuk akses yang lebih cepat ke dompet Anda.",
        title: "Instal ekstensi Frontier Wallet"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah berbagi frasa rahasia Anda dengan siapa pun.",
        title: "Buat atau Impor Dompet"
      },
      step3: {
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "Buka aplikasi imToken",
        description: "Letakkan aplikasi imToken di layar utama Anda untuk akses yang lebih cepat ke dompet Anda."
      },
      step2: {
        title: "Buat atau Impor Dompet",
        description: "Buat dompet baru atau impor yang sudah ada."
      },
      step3: {
        title: "Ketuk Ikon Scanner di pojok kanan atas",
        description: "Pilih Koneksi Baru, lalu pindai kode QR dan konfirmasi petunjuk untuk terhubung."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "Buka aplikasi MetaMask",
        description: "Kami merekomendasikan untuk meletakkan MetaMask di layar beranda Anda untuk akses yang lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Dompet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Ketuk tombol pindai",
        description: "Setelah Anda memindai, petunjuk koneksi akan muncul untuk Anda menyambungkan dompet Anda."
      }
    },
    extension: {
      step1: {
        title: "Pasang ekstensi MetaMask",
        description: "Kami menyarankan untuk memasang MetaMask pada taskbar Anda untuk akses wallet lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Pastikan untuk mencadangkan wallet Anda menggunakan metode yang aman. Jangan pernah membagikan frase rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda menyiapkan wallet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "Buka aplikasi OKX Wallet",
        description: "Kami menyarankan untuk menaruh OKX Wallet di layar utama Anda untuk akses lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frasa rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Ketuk tombol scan",
        description: "Setelah Anda memindai, prompt koneksi akan muncul untuk Anda hubungkan dompet Anda."
      }
    },
    extension: {
      step1: {
        title: "Instal ekstensi OKX Wallet",
        description: "Kami menyarankan untuk menempelkan OKX Wallet ke taskbar Anda untuk akses lebih cepat ke dompet Anda."
      },
      step2: {
        title: "Buat atau Impor Dompet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frasa rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda mengatur wallet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Buka aplikasi Omni",
        description: "Tambahkan Omni ke layar utama Anda untuk akses yang lebih cepat ke wallet Anda."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Buat wallet baru atau impor yang sudah ada."
      },
      step3: {
        title: "Ketuk ikon QR dan scan",
        description: "Ketuk ikon QR di layar utama Anda, pindai kode dan konfirmasi petunjuk untuk terhubung."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "Buka aplikasi TokenPocket",
        description: "Kami sarankan meletakkan TokenPocket di layar utama Anda untuk akses yang lebih cepat."
      },
      step2: {
        title: "Buat atau impor Dompet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase pemulihan rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Ketuk tombol pindai",
        description: "Setelah Anda memindai, Indikasi sambungan akan muncul untuk Anda menghubungkan dompet Anda."
      }
    },
    extension: {
      step1: {
        title: "Instal ekstensi TokenPocket",
        description: "Kami merekomendasikan penambatan TokenPocket ke taskbar Anda untuk akses dompet Anda lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagi frasa rahasia Anda dengan siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda mengatur dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Buka aplikasi Trust Wallet",
        description: "Pasang Trust Wallet di layar utama Anda untuk akses dompet Anda lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Buat dompet baru atau impor yang sudah ada."
      },
      step3: {
        title: "Ketuk WalletConnect di Pengaturan",
        description: "Pilih Koneksi Baru, kemudian pindai kode QR dan konfirmasi perintah untuk terhubung."
      }
    },
    extension: {
      step1: {
        title: "Instal ekstensi Trust Wallet",
        description: "Klik di pojok kanan atas browser Anda dan sematkan Trust Wallet untuk akses mudah."
      },
      step2: {
        title: "Buat atau Impor dompet",
        description: "Buat dompet baru atau impor yang sudah ada."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda mengatur Trust Wallet, klik di bawah untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Buka aplikasi Uniswap",
        description: "Tambahkan Uniswap Wallet ke layar utama Anda untuk akses ke wallet Anda lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Buat wallet baru atau impor yang sudah ada."
      },
      step3: {
        title: "Ketuk ikon QR dan pindai",
        description: "Ketuk ikon QR di layar utama Anda, pindai kode dan konfirmasi prompt untuk terhubung."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Buka aplikasi Zerion",
        description: "Kami merekomendasikan untuk meletakkan Zerion di layar utama Anda untuk akses lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Dompet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase pemulihan rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Ketuk tombol scan",
        description: "Setelah Anda scan, muncul prompt koneksi untuk Anda menghubungkan dompet Anda."
      }
    },
    extension: {
      step1: {
        title: "Instal ekstensi Zerion",
        description: "Kami menyarankan untuk menempelkan Zerion ke taskbar Anda untuk akses lebih cepat ke dompet Anda."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Pastikan untuk mencadangkan wallet Anda menggunakan metode yang aman. Jangan pernah berbagi frasa rahasia Anda dengan siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda mengatur wallet Anda, klik di bawah untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Buka aplikasi Rainbow",
        description: "Kami menyarankan menempatkan Rainbow di layar home Anda untuk akses yang lebih cepat ke wallet Anda."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Anda dapat dengan mudah mencadangkan wallet Anda menggunakan fitur cadangan kami di telepon Anda."
      },
      step3: {
        title: "Tekan tombol scan",
        description: "Setelah Anda memindai, akan muncul pesan untuk menghubungkan dompet Anda."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "Kami menyarankan untuk memasang Enkrypt Wallet ke taskbar Anda untuk akses dompet yang lebih cepat.",
        title: "Instal ekstensi Enkrypt Wallet"
      },
      step2: {
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah berbagi frase rahasia Anda dengan siapa pun.",
        title: "Buat atau Impor Dompet"
      },
      step3: {
        description: "Setelah Anda menyiapkan dompet, klik di bawah ini untuk memuat ulang peramban dan meload ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "Kami menyarankan untuk memasang Frame ke taskbar Anda untuk akses dompet yang lebih cepat.",
        title: "Instal Frame & ekstensi pendamping"
      },
      step2: {
        description: "Pastikan untuk mencadangkan wallet Anda menggunakan metode yang aman. Jangan pernah membagikan frase rahasia Anda kepada siapa pun.",
        title: "Buat atau Impor Wallet"
      },
      step3: {
        description: "Setelah Anda menyetel wallet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi.",
        title: "Segarkan browser Anda"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "Instal ekstensi OneKey Wallet",
        description: "Kami menyarankan untuk menempelkan OneKey Wallet ke taskbar Anda untuk akses wallet yang lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Instal ekstensi Phantom",
        description: "Kami menyarankan untuk mem-pin Phantom ke taskbar Anda untuk akses dompet yang lebih mudah."
      },
      step2: {
        title: "Buat atau Impor Dompet",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah membagikan frase pemulihan rahasia Anda kepada siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Instal ekstensi Rabby",
        description: "Kami merekomendasikan menempelkan Rabby ke taskbar Anda untuk akses lebih cepat ke wallet Anda."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Pastikan untuk mencadangkan wallet Anda dengan metode yang aman. Jangan pernah berbagi frase rahasia Anda dengan siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda menyiapkan wallet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "Instal ekstensi Core",
        description: "Kami merekomendasikan menempelkan Safeheron ke taskbar Anda untuk akses lebih cepat ke wallet Anda."
      },
      step2: {
        title: "Buat atau Impor Wallet",
        description: "Pastikan untuk mencadangkan dompet Anda dengan metode yang aman. Jangan pernah berbagi frasa rahasia Anda dengan siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda mengatur dompet Anda, klik di bawah untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Instal ekstensi Taho",
        description: "Kami merekomendasikan pengepinan Taho ke taskbar Anda untuk akses yang lebih cepat ke dompet Anda."
      },
      step2: {
        title: "Buat atau Impor Dompet",
        description: "Pastikan untuk mencadangkan dompet Anda dengan metode yang aman. Jangan pernah berbagi frasa rahasia Anda dengan siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "Instal ekstensi Talisman",
        description: "Kami merekomendasikan menempelkan Talisman ke taskbar Anda untuk akses dompet Anda lebih cepat."
      },
      step2: {
        title: "Buat atau Impor Dompet Ethereum",
        description: "Pastikan untuk mencadangkan dompet Anda menggunakan metode yang aman. Jangan pernah berbagi frase pemulihan Anda dengan siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "Instal ekstensi Dompet XDEFI",
        description: "Kami merekomendasikan menempelkan XDEFI Wallet ke taskbar Anda untuk akses lebih cepat ke dompet Anda."
      },
      step2: {
        title: "Buat atau Impor Dompet",
        description: "Pastikan untuk mencadangkan dompet Anda dengan metode yang aman. Jangan pernah berbagi frase rahasia Anda dengan siapa pun."
      },
      step3: {
        title: "Segarkan browser Anda",
        description: "Setelah Anda menyiapkan dompet Anda, klik di bawah ini untuk menyegarkan browser dan memuat ekstensi."
      }
    }
  }
};
var id_ID_default = {
  connect_wallet: connect_wallet6,
  intro: intro6,
  connect: connect6,
  connect_scan: connect_scan6,
  connector_group: connector_group6,
  get: get6,
  get_options: get_options6,
  get_mobile: get_mobile6,
  get_instructions: get_instructions6,
  chains: chains6,
  profile: profile6,
  wallet_connectors: wallet_connectors6
};

// src/locales/ja_JP.json
var connect_wallet7 = {
  label: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B"
};
var intro7 = {
  title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u306F\u4F55\u3067\u3059\u304B\uFF1F",
  description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3001\u30C7\u30B8\u30BF\u30EB\u30A2\u30BB\u30C3\u30C8\u3092\u9001\u4FE1\u3001\u53D7\u4FE1\u3001\u4FDD\u5B58\u3001\u8868\u793A\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002\u307E\u305F\u3001\u5404\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u65B0\u305F\u306A\u30A2\u30AB\u30A6\u30F3\u30C8\u3084\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4F5C\u6210\u3059\u308B\u5FC5\u8981\u306A\u304F\u3001\u30ED\u30B0\u30A4\u30F3\u3059\u308B\u65B0\u3057\u3044\u65B9\u6CD5\u3067\u3082\u3042\u308A\u307E\u3059\u3002",
  digital_asset: {
    title: "\u3042\u306A\u305F\u306E\u30C7\u30B8\u30BF\u30EB\u8CC7\u7523\u306E\u305F\u3081\u306E\u5BB6",
    description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3001Ethereum\u3084NFT\u306E\u3088\u3046\u306A\u30C7\u30B8\u30BF\u30EB\u8CC7\u7523\u3092\u9001\u4FE1\u3001\u53D7\u4FE1\u3001\u4FDD\u5B58\u3001\u8868\u793A\u3059\u308B\u305F\u3081\u306B\u4F7F\u7528\u3055\u308C\u307E\u3059\u3002"
  },
  login: {
    title: "\u65B0\u3057\u3044\u30ED\u30B0\u30A4\u30F3\u65B9\u6CD5",
    description: "\u3059\u3079\u3066\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u65B0\u3057\u3044\u30A2\u30AB\u30A6\u30F3\u30C8\u3068\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u4F5C\u6210\u3059\u308B\u4EE3\u308F\u308A\u306B\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3057\u307E\u3059\u3002"
  },
  get: {
    label: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u53D6\u5F97\u3059\u308B"
  },
  learn_more: {
    label: "\u8A73\u3057\u304F\u306F\u3053\u3061\u3089"
  }
};
var connect7 = {
  label: "\u63A5\u7D9A",
  title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B",
  new_to_ethereum: {
    description: "Ethereum\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u304C\u521D\u3081\u3066\u3067\u3059\u304B\uFF1F",
    learn_more: {
      label: "\u8A73\u3057\u304F\u306F\u3053\u3061\u3089"
    }
  },
  learn_more: {
    label: "\u8A73\u3057\u304F\u306F\u3053\u3061\u3089"
  },
  recent: "\u6700\u8FD1",
  status: {
    opening: "%{wallet}\u3092\u958B\u3044\u3066\u3044\u307E\u3059...",
    not_installed: "%{wallet} \u306F\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3055\u308C\u3066\u3044\u307E\u305B\u3093",
    not_available: "%{wallet} \u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093",
    confirm: "\u30A8\u30AF\u30B9\u30C6\u30F3\u30B7\u30E7\u30F3\u3067\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044"
  },
  secondary_action: {
    get: {
      description: "%{wallet}\u304C\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
      label: "\u53D6\u5F97"
    },
    install: {
      label: "\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB"
    },
    retry: {
      label: "\u518D\u8A66\u884C"
    }
  },
  walletconnect: {
    description: {
      full: "\u516C\u5F0F\u306EWalletConnect\u30E2\u30FC\u30C0\u30EB\u304C\u5FC5\u8981\u3067\u3059\u304B\uFF1F",
      compact: "WalletConnect\u30E2\u30FC\u30C0\u30EB\u304C\u5FC5\u8981\u3067\u3059\u304B\uFF1F"
    },
    open: {
      label: "\u958B\u304F"
    }
  }
};
var connect_scan7 = {
  title: "%{wallet}\u3067\u30B9\u30AD\u30E3\u30F3",
  fallback_title: "\u643A\u5E2F\u96FB\u8A71\u3067\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u304F\u3060\u3055\u3044"
};
var connector_group7 = {
  recommended: "\u63A8\u5968",
  other: "\u305D\u306E\u4ED6",
  popular: "\u4EBA\u6C17",
  more: "\u3082\u3063\u3068",
  others: "\u305D\u306E\u4ED6"
};
var get7 = {
  title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u53D6\u5F97",
  action: {
    label: "\u53D6\u5F97"
  },
  mobile: {
    description: "\u30E2\u30D0\u30A4\u30EB\u30A6\u30A9\u30EC\u30C3\u30C8"
  },
  extension: {
    description: "\u30D6\u30E9\u30A6\u30B6\u62E1\u5F35"
  },
  mobile_and_extension: {
    description: "\u30E2\u30D0\u30A4\u30EB\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u62E1\u5F35\u6A5F\u80FD"
  },
  looking_for: {
    title: "\u304A\u63A2\u3057\u306E\u3082\u306E\u3067\u306F\u3042\u308A\u307E\u305B\u3093\u304B\uFF1F",
    mobile: {
      description: "\u30E1\u30A4\u30F3\u753B\u9762\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3001\u7570\u306A\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3067\u59CB\u3081\u3066\u304F\u3060\u3055\u3044\u3002"
    },
    desktop: {
      compact_description: "\u30E1\u30A4\u30F3\u753B\u9762\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3001\u7570\u306A\u308B\u30A6\u30A9\u30EC\u30C3\u30C8\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3067\u59CB\u3081\u3066\u304F\u3060\u3055\u3044\u3002",
      wide_description: "\u5DE6\u5074\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u9078\u629E\u3057\u3066\u3001\u5225\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u30D7\u30ED\u30D0\u30A4\u30C0\u30FC\u3067\u59CB\u3081\u3066\u304F\u3060\u3055\u3044\u3002"
    }
  }
};
var get_options7 = {
  title: "%{wallet}\u3067\u59CB\u3081\u308B",
  short_title: "%{wallet}\u3092\u53D6\u5F97\u3059\u308B",
  mobile: {
    title: "\u30E2\u30D0\u30A4\u30EB\u7528 %{wallet}",
    description: "\u30E2\u30D0\u30A4\u30EB\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A4\u30FC\u30B5\u30EA\u30A2\u30E0\u306E\u4E16\u754C\u3092\u63A2\u7D22\u3057\u307E\u3059\u3002",
    download: {
      label: "\u30A2\u30D7\u30EA\u3092\u53D6\u5F97"
    }
  },
  extension: {
    title: "%{wallet} for %{browser}",
    description: "\u304A\u597D\u304D\u306A\u30A6\u30A7\u30D6\u30D6\u30E9\u30A6\u30B6\u304B\u3089\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u76F4\u63A5\u30A2\u30AF\u30BB\u30B9\u3057\u307E\u3059\u3002",
    download: {
      label: "%{browser}\u306B\u8FFD\u52A0"
    }
  }
};
var get_mobile7 = {
  title: "%{wallet}\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
  description: "iOS\u307E\u305F\u306FAndroid\u3067\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9\u3059\u308B\u305F\u3081\u306B\u96FB\u8A71\u3067\u30B9\u30AD\u30E3\u30F3",
  continue: {
    label: "\u7D9A\u884C"
  }
};
var get_instructions7 = {
  mobile: {
    connect: {
      label: "\u63A5\u7D9A"
    },
    learn_more: {
      label: "\u8A73\u3057\u304F\u306F\u3053\u3061\u3089"
    }
  },
  extension: {
    refresh: {
      label: "\u66F4\u65B0"
    },
    learn_more: {
      label: "\u8A73\u3057\u304F\u306F\u3053\u3061\u3089"
    }
  }
};
var chains7 = {
  title: "\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5207\u308A\u66FF\u3048\u308B",
  wrong_network: "\u8AA4\u3063\u305F\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u304C\u691C\u51FA\u3055\u308C\u307E\u3057\u305F\u3001\u7D9A\u884C\u3059\u308B\u306B\u306F\u5207\u308A\u66FF\u3048\u308B\u304B\u5207\u65AD\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  confirm: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3067\u78BA\u8A8D\u3059\u308B",
  switching_not_supported: "\u3042\u306A\u305F\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F %{appName}\u304B\u3089\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u3067\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5207\u308A\u66FF\u3048\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
  switching_not_supported_fallback: "\u3042\u306A\u305F\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u3001\u3053\u306E\u30A2\u30D7\u30EA\u304B\u3089\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5207\u308A\u66FF\u3048\u308B\u3053\u3068\u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u307E\u305B\u3093\u3002\u4EE3\u308F\u308A\u306B\u30A6\u30A9\u30EC\u30C3\u30C8\u5185\u304B\u3089\u30CD\u30C3\u30C8\u30EF\u30FC\u30AF\u3092\u5207\u308A\u66FF\u3048\u3066\u307F\u3066\u304F\u3060\u3055\u3044\u3002",
  disconnect: "\u5207\u65AD\u3059\u308B",
  connected: "\u63A5\u7D9A\u3057\u307E\u3057\u305F"
};
var profile7 = {
  disconnect: {
    label: "\u5207\u65AD\u3059\u308B"
  },
  copy_address: {
    label: "\u30A2\u30C9\u30EC\u30B9\u3092\u30B3\u30D4\u30FC\u3059\u308B",
    copied: "\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\uFF01"
  },
  explorer: {
    label: "\u30A8\u30AF\u30B9\u30D7\u30ED\u30FC\u30E9\u30FC\u3067\u8A73\u3057\u304F\u898B\u308B"
  },
  transactions: {
    description: "%{appName} \u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u304C\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059...",
    description_fallback: "\u3042\u306A\u305F\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3\u306F\u3053\u3053\u306B\u8868\u793A\u3055\u308C\u307E\u3059...",
    recent: {
      title: "\u6700\u8FD1\u306E\u30C8\u30E9\u30F3\u30B6\u30AF\u30B7\u30E7\u30F3"
    },
    clear: {
      label: "\u3059\u3079\u3066\u30AF\u30EA\u30A2"
    }
  }
};
var wallet_connectors7 = {
  argent: {
    qr_code: {
      step1: {
        description: "\u3088\u308A\u901F\u304F\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u305F\u3081\u306B\u3001Argent\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u3044\u3066\u304F\u3060\u3055\u3044\u3002",
        title: "Argent\u30A2\u30D7\u30EA\u3092\u958B\u304F"
      },
      step2: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3068\u30E6\u30FC\u30B6\u30FC\u30CD\u30FC\u30E0\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "\u300CQR\u3092\u30B9\u30AD\u30E3\u30F3\u300D\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "\u3088\u308A\u901F\u304F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3001Bifrost Wallet\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Bifrost Wallet\u30A2\u30D7\u30EA\u3092\u958B\u304D\u307E\u3059"
      },
      step2: {
        description: "\u30EA\u30AB\u30D0\u30EA\u30FC\u30D5\u30EC\u30FC\u30BA\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "\u300C\u30B9\u30AD\u30E3\u30F3\u300D\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "\u3088\u308A\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001\u30DB\u30FC\u30E0\u753B\u9762\u306BBitget Wallet\u3092\u914D\u7F6E\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Bitget Wallet\u30A2\u30D7\u30EA\u3092\u958B\u304F"
      },
      step2: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306F\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3059\u308B"
      }
    },
    extension: {
      step1: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u3088\u308A\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306BBitget Wallet\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Bitget Wallet\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059"
      },
      step2: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059"
      },
      step3: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u7D20\u65E9\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001Bitski\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Bitski\u30A8\u30AF\u30B9\u30C6\u30F3\u30B7\u30E7\u30F3\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B"
      },
      step2: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u30D5\u30EC\u30FC\u30BA\u306F\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B"
      },
      step3: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u30A8\u30AF\u30B9\u30C6\u30F3\u30B7\u30E7\u30F3\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "Coin98\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304F\u3053\u3068\u3067\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u9AD8\u901F\u5316\u3055\u308C\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Coin98\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30D7\u30EA\u3092\u958B\u304D\u307E\u3059"
      },
      step2: {
        description: "\u96FB\u8A71\u306E\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u7C21\u5358\u306B\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u63A5\u7D9A\u3092\u4FC3\u3059\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "WalletConnect\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059"
      }
    },
    extension: {
      step1: {
        description: "\u30D6\u30E9\u30A6\u30B6\u306E\u53F3\u4E0A\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u3001Coin98\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D4\u30F3\u7559\u3081\u3057\u3066\u7C21\u5358\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002",
        title: "Coin98\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059"
      },
      step2: {
        description: "\u65B0\u3057\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u3082\u306E\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B"
      },
      step3: {
        description: "Coin98\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3057\u305F\u3089\u3001\u4E0B\u306E\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "\u3088\u308A\u7D20\u65E9\u304F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3001Coinbase\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DB\u30FC\u30E0\u30B9\u30AF\u30EA\u30FC\u30F3\u306B\u7F6E\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Coinbase Wallet\u30A2\u30D7\u30EA\u3092\u958B\u304F"
      },
      step2: {
        description: "\u30AF\u30E9\u30A6\u30C9\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u7C21\u5358\u306B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3067\u304D\u307E\u3059\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3059\u308B"
      }
    },
    extension: {
      step1: {
        description: "\u30BF\u30B9\u30AF\u30D0\u30FC\u306BCoinbase Wallet\u3092\u30D4\u30F3\u7559\u3081\u3057\u3066\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306B\u3088\u308A\u65E9\u304F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u63A8\u5968\u3057\u307E\u3059\u3002",
        title: "Coinbase Wallet\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B"
      },
      step2: {
        description: "\u5FC5\u305A\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u306B\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u3001\u30B3\u30A2\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u8A2D\u5B9A\u3059\u308B\u3053\u3068\u3092\u63A8\u5968\u3057\u307E\u3059\u3002",
        title: "Core\u30A2\u30D7\u30EA\u3092\u958B\u304F"
      },
      step2: {
        description: "\u96FB\u8A71\u306E\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u6A5F\u80FD\u3092\u4F7F\u3063\u3066\u3001\u7C21\u5358\u306B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3067\u304D\u307E\u3059\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u3088\u3046\u306B\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "WalletConnect\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3059\u308B"
      }
    },
    extension: {
      step1: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u3088\u308A\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001\u30BF\u30B9\u30AF\u30D0\u30FC\u306BCore\u3092\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Core\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B"
      },
      step2: {
        description: "\u30BB\u30AD\u30E5\u30A2\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B"
      },
      step3: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "\u3088\u308A\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001\u30DB\u30FC\u30E0\u753B\u9762\u306BFoxWallet\u3092\u7F6E\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "FoxWallet\u30A2\u30D7\u30EA\u3092\u958B\u304F"
      },
      step2: {
        description: "\u30BB\u30AD\u30E5\u30A2\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u306F\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u3057\u305F\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "Frontier\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304F\u3053\u3068\u3067\u3001\u3088\u308A\u65E9\u304F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002",
        title: "Frontier\u30A6\u30A9\u30EC\u30C3\u30C8\u30A2\u30D7\u30EA\u3092\u958B\u304D\u307E\u3059"
      },
      step2: {
        description: "\u30BB\u30AD\u30E5\u30A2\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u306F\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u306B\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u63A5\u7D9A\u3092\u4FC3\u3059\u30E1\u30C3\u30BB\u30FC\u30B8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002",
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059"
      }
    },
    extension: {
      step1: {
        description: "\u3088\u308A\u8FC5\u901F\u306A\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u53EF\u80FD\u306B\u3059\u308B\u305F\u3081\u306B\u3001\u30D5\u30ED\u30F3\u30C6\u30A3\u30A2\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u63A8\u5968\u3057\u307E\u3059\u3002",
        title: "\u30D5\u30ED\u30F3\u30C6\u30A3\u30A2\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059"
      },
      step2: {
        description: "\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u306F\u6C7A\u3057\u3066\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3066\u62E1\u5F35\u6A5F\u80FD\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "imToken\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u901F\u304F\u3059\u308B\u305F\u3081\u306B\u3001imToken\u30A2\u30D7\u30EA\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u3044\u3066\u304F\u3060\u3055\u3044\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u65B0\u3057\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u3082\u306E\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002"
      },
      step3: {
        title: "\u53F3\u4E0A\u9685\u306E\u30B9\u30AD\u30E3\u30CA\u30FC\u30A2\u30A4\u30B3\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059",
        description: "\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u9078\u629E\u3057\u3001QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u78BA\u8A8D\u3057\u63A5\u7D9A\u3057\u307E\u3059\u3002"
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "MetaMask\u30A2\u30D7\u30EA\u3092\u958B\u304D\u307E\u3059",
        description: "\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001MetaMask\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059",
        description: "\u5FC5\u305A\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u56DE\u5FA9\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u306B\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059",
        description: "\u30B9\u30AD\u30E3\u30F3\u3059\u308B\u3068\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
      }
    },
    extension: {
      step1: {
        title: "MetaMask\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u3088\u308A\u901F\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001MetaMask\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3001\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3057\u305F\u5F8C\u306F\u3001\u4E0B\u306E\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u30A8\u30AF\u30B9\u30C6\u30F3\u30B7\u30E7\u30F3\u3092\u8AAD\u307F\u8FBC\u3093\u3067\u304F\u3060\u3055\u3044\u3002"
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "OKX Wallet\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "OKX Wallet\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u914D\u7F6E\u3057\u3066\u3001\u3088\u308A\u65E9\u304F\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u30BB\u30AD\u30E5\u30A2\u306A\u65B9\u6CD5\u3092\u4F7F\u3063\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u30D5\u30EC\u30FC\u30BA\u306F\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3059\u308B",
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
      }
    },
    extension: {
      step1: {
        title: "OKX\u30A6\u30A9\u30EC\u30C3\u30C8\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u3001OKX\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u6B62\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B",
        description: "\u30BB\u30AD\u30E5\u30A2\u306A\u65B9\u6CD5\u3092\u4F7F\u3063\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u30D5\u30EC\u30FC\u30BA\u306F\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3057\u305F\u3089\u3001\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u30EA\u30D5\u30EC\u30C3\u30B7\u30E5\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002"
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Omni\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "Omni\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u8FFD\u52A0\u3057\u3066\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u65E9\u3081\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u65B0\u3057\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u3082\u306E\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002"
      },
      step3: {
        title: "QR\u30A2\u30A4\u30B3\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u30B9\u30AD\u30E3\u30F3",
        description: "\u30DB\u30FC\u30E0\u753B\u9762\u306EQR\u30A2\u30A4\u30B3\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3001\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u78BA\u8A8D\u3057\u3066\u63A5\u7D9A\u3057\u307E\u3059\u3002"
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "TokenPocket\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "\u3088\u308A\u901F\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001TokenPocket\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B",
        description: "\u5FC5\u305A\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u56DE\u5FA9\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u306B\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3059\u308B",
        description: "\u30B9\u30AD\u30E3\u30F3\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
      }
    },
    extension: {
      step1: {
        title: "TokenPocket\u30A8\u30AF\u30B9\u30C6\u30F3\u30B7\u30E7\u30F3\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u3088\u308A\u65E9\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001TokenPocket\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u30D5\u30EC\u30FC\u30BA\u3092\u6C7A\u3057\u3066\u4ED6\u306E\u4EBA\u3068\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002"
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Trust Wallet\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u9AD8\u901F\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001Trust Wallet\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304D\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u65B0\u3057\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u3082\u306E\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002"
      },
      step3: {
        title: "\u8A2D\u5B9A\u3067WalletConnect\u3092\u30BF\u30C3\u30D7\u3057\u307E\u3059",
        description: "\u65B0\u3057\u3044\u63A5\u7D9A\u3092\u9078\u629E\u3057\u3001QR\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u3001\u30D7\u30ED\u30F3\u30D7\u30C8\u3067\u63A5\u7D9A\u3092\u78BA\u8A8D\u3057\u307E\u3059\u3002"
      }
    },
    extension: {
      step1: {
        title: "Trust Wallet\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u307E\u3059",
        description: "\u30D6\u30E9\u30A6\u30B6\u306E\u53F3\u4E0A\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3001Trust Wallet\u3092\u30D4\u30F3\u7559\u3081\u3057\u3066\u7C21\u5358\u306B\u30A2\u30AF\u30BB\u30B9\u3067\u304D\u308B\u3088\u3046\u306B\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059",
        description: "\u65B0\u3057\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u3082\u306E\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "Trust Wallet\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002"
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Uniswap\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "Uniswap\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u8FFD\u52A0\u3057\u3066\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u9AD8\u901F\u5316\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B",
        description: "\u65B0\u3057\u3044\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u65E2\u5B58\u306E\u3082\u306E\u3092\u30A4\u30F3\u30DD\u30FC\u30C8\u3057\u307E\u3059\u3002"
      },
      step3: {
        title: "QR\u30A2\u30A4\u30B3\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3066\u30B9\u30AD\u30E3\u30F3\u3059\u308B",
        description: "\u30DB\u30FC\u30E0\u753B\u9762\u306EQR\u30A2\u30A4\u30B3\u30F3\u3092\u30BF\u30C3\u30D7\u3057\u3001\u30B3\u30FC\u30C9\u3092\u30B9\u30AD\u30E3\u30F3\u3057\u3066\u30D7\u30ED\u30F3\u30D7\u30C8\u3092\u78BA\u8A8D\u3057\u3066\u63A5\u7D9A\u3057\u307E\u3059\u3002"
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Zerion\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "\u3088\u308A\u901F\u304F\u30A2\u30AF\u30BB\u30B9\u3059\u308B\u305F\u3081\u306B\u3001Zerion\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304F\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B",
        description: "\u5FC5\u305A\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u56DE\u5FA9\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u306B\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u62BC\u3059",
        description: "\u30B9\u30AD\u30E3\u30F3\u3057\u305F\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
      }
    },
    extension: {
      step1: {
        title: "Zerion\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u7D20\u65E9\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u3001Zerion\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30BB\u30AD\u30E5\u30A2\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30BB\u30C3\u30C8\u30A2\u30C3\u30D7\u3057\u305F\u3089\u3001\u4E0B\u306E\u30DC\u30BF\u30F3\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002"
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Rainbow\u30A2\u30D7\u30EA\u3092\u958B\u304F",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u65E9\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001Rainbow\u3092\u30DB\u30FC\u30E0\u753B\u9762\u306B\u7F6E\u304F\u3053\u3068\u3092\u304A\u3059\u3059\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u96FB\u8A71\u306E\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u6A5F\u80FD\u3092\u4F7F\u7528\u3057\u3066\u3001\u7C21\u5358\u306B\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
      },
      step3: {
        title: "\u30B9\u30AD\u30E3\u30F3\u30DC\u30BF\u30F3\u3092\u30BF\u30C3\u30D7\u3059\u308B",
        description: "\u30B9\u30AD\u30E3\u30F3\u3057\u305F\u5F8C\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u63A5\u7D9A\u3059\u308B\u305F\u3081\u306E\u63A5\u7D9A\u30D7\u30ED\u30F3\u30D7\u30C8\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002"
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u3088\u308A\u65E9\u304F\u3059\u308B\u305F\u3081\u3001\u30BF\u30B9\u30AF\u30D0\u30FC\u306BEnkrypt Wallet\u3092\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u63A8\u5968\u3057\u307E\u3059\u3002",
        title: "Enkrypt Wallet\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3057\u3066\u304F\u3060\u3055\u3044"
      },
      step2: {
        description: "\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3092\u5FC5\u305A\u53D6\u308A\u3001\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B"
      },
      step3: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u3088\u308A\u65E9\u304F\u3059\u308B\u305F\u3081\u3001\u30BF\u30B9\u30AF\u30D0\u30FC\u306BFrame\u3092\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u63A8\u5968\u3057\u307E\u3059\u3002",
        title: "Frame\u3068\u305D\u306E\u4ED8\u5C5E\u306E\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB"
      },
      step2: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002",
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3001\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8"
      },
      step3: {
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4E0B\u306E\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002",
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "OneKey Wallet\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u7D20\u65E9\u304F\u884C\u3046\u305F\u3081\u3001OneKey Wallet\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3001\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u8A2D\u5B9A\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002"
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Phantom\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u5BB9\u6613\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u3001Phantom\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u63A8\u5968\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B",
        description: "\u5B89\u5168\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u56DE\u5FA9\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u30A8\u30AF\u30B9\u30C6\u30F3\u30B7\u30E7\u30F3\u3092\u8AAD\u307F\u8FBC\u307F\u307E\u3059\u3002"
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Rabby\u30A8\u30AF\u30B9\u30C6\u30F3\u30B7\u30E7\u30F3\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u7D20\u65E9\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u3001\u30BF\u30B9\u30AF\u30D0\u30FC\u306BRabby\u3092\u30D4\u30F3\u6B62\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u30BB\u30AD\u30E5\u30A2\u306A\u65B9\u6CD5\u3092\u4F7F\u7528\u3057\u3066\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002"
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "\u30B3\u30A2\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u7D20\u65E9\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u3001\u30BF\u30B9\u30AF\u30D0\u30FC\u306BSafeheron\u3092\u30D4\u30F3\u6B62\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u78BA\u5B9F\u306B\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u306F\u6C7A\u3057\u3066\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002"
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Taho\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u3088\u308A\u8FC5\u901F\u306A\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u3001Taho\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B",
        description: "\u78BA\u5B9F\u306B\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u306F\u6C7A\u3057\u3066\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002"
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "Talisman\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u3088\u308A\u65E9\u3044\u30A2\u30AF\u30BB\u30B9\u306E\u305F\u3081\u306B\u3001Talisman\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "Ethereum\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u4F5C\u6210\u3059\u308B\u304B\u3001\u30A4\u30F3\u30DD\u30FC\u30C8\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304A\u304F\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u30EA\u30AB\u30D0\u30EA\u30FC\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u307E\u3059\u3002"
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "XDEFI Wallet\u62E1\u5F35\u6A5F\u80FD\u3092\u30A4\u30F3\u30B9\u30C8\u30FC\u30EB\u3059\u308B",
        description: "XDEFI Wallet\u3092\u30BF\u30B9\u30AF\u30D0\u30FC\u306B\u30D4\u30F3\u7559\u3081\u3059\u308B\u3053\u3068\u3067\u3001\u30A6\u30A9\u30EC\u30C3\u30C8\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u304C\u901F\u304F\u306A\u308B\u3053\u3068\u3092\u304A\u52E7\u3081\u3057\u307E\u3059\u3002"
      },
      step2: {
        title: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u4F5C\u6210\u307E\u305F\u306F\u30A4\u30F3\u30DD\u30FC\u30C8",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u3092\u5B89\u5168\u306A\u65B9\u6CD5\u3067\u30D0\u30C3\u30AF\u30A2\u30C3\u30D7\u3057\u3066\u304F\u3060\u3055\u3044\u3002\u79D8\u5BC6\u306E\u30D5\u30EC\u30FC\u30BA\u3092\u8AB0\u3068\u3082\u5171\u6709\u3057\u306A\u3044\u3067\u304F\u3060\u3055\u3044\u3002"
      },
      step3: {
        title: "\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3059\u308B",
        description: "\u30A6\u30A9\u30EC\u30C3\u30C8\u306E\u8A2D\u5B9A\u304C\u5B8C\u4E86\u3057\u305F\u3089\u3001\u4EE5\u4E0B\u3092\u30AF\u30EA\u30C3\u30AF\u3057\u3066\u30D6\u30E9\u30A6\u30B6\u3092\u66F4\u65B0\u3057\u3001\u62E1\u5F35\u6A5F\u80FD\u3092\u30ED\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
      }
    }
  }
};
var ja_JP_default = {
  connect_wallet: connect_wallet7,
  intro: intro7,
  connect: connect7,
  connect_scan: connect_scan7,
  connector_group: connector_group7,
  get: get7,
  get_options: get_options7,
  get_mobile: get_mobile7,
  get_instructions: get_instructions7,
  chains: chains7,
  profile: profile7,
  wallet_connectors: wallet_connectors7
};

// src/locales/ko_KR.json
var connect_wallet8 = {
  label: "\uC9C0\uAC11 \uC5F0\uACB0"
};
var intro8 = {
  title: "\uC9C0\uAC11\uC774\uB780 \uBB34\uC5C7\uC778\uAC00\uC694?",
  description: "\uC9C0\uAC11\uC740 \uB514\uC9C0\uD138 \uC790\uC0B0\uC744 \uBCF4\uB0B4\uACE0, \uBC1B\uACE0, \uC800\uC7A5\uD558\uACE0, \uD45C\uC2DC\uD558\uB294 \uB370 \uC0AC\uC6A9\uB429\uB2C8\uB2E4. \uB610\uD55C, \uBAA8\uB4E0 \uC6F9 \uC0AC\uC774\uD2B8\uC5D0\uC11C \uC0C8 \uACC4\uC815\uACFC \uBE44\uBC00\uBC88\uD638\uB97C \uC0DD\uC131\uD560 \uD544\uC694 \uC5C6\uC774 \uB85C\uADF8\uC778\uD558\uB294 \uC0C8\uB85C\uC6B4 \uBC29\uBC95\uC785\uB2C8\uB2E4.",
  digital_asset: {
    title: "\uB2F9\uC2E0\uC758 \uB514\uC9C0\uD138 \uC790\uC0B0\uC744 \uC704\uD55C \uC9D1",
    description: "\uC9C0\uAC11\uC740 \uC774\uB354\uB9AC\uC6C0 \uBC0F NFT\uC640 \uAC19\uC740 \uB514\uC9C0\uD138 \uC790\uC0B0\uC744 \uBCF4\uB0B4\uACE0, \uBC1B\uACE0, \uC800\uC7A5\uD558\uACE0, \uD45C\uC2DC\uD558\uB294\uB370 \uC0AC\uC6A9\uB429\uB2C8\uB2E4."
  },
  login: {
    title: "\uC0C8\uB85C\uC6B4 \uB85C\uADF8\uC778 \uBC29\uC2DD",
    description: "\uBAA8\uB4E0 \uC6F9\uC0AC\uC774\uD2B8\uC5D0\uC11C \uC0C8 \uACC4\uC815\uACFC \uBE44\uBC00\uBC88\uD638\uB97C \uC0DD\uC131\uD558\uB294 \uB300\uC2E0, \uB2F9\uC2E0\uC758 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uAE30\uB9CC \uD558\uBA74 \uB429\uB2C8\uB2E4."
  },
  get: {
    label: "\uC9C0\uAC11 \uAC00\uC838\uC624\uAE30"
  },
  learn_more: {
    label: "\uB354 \uC54C\uC544\uBCF4\uAE30"
  }
};
var connect8 = {
  label: "\uC5F0\uACB0",
  title: "\uC9C0\uAC11 \uC5F0\uACB0",
  new_to_ethereum: {
    description: "\uC774\uB354\uB9AC\uC6C0 \uC9C0\uAC11\uC5D0 \uCC98\uC74C \uC811\uD558\uC2DC\uB098\uC694?",
    learn_more: {
      label: "\uB354 \uC54C\uC544\uBCF4\uAE30"
    }
  },
  learn_more: {
    label: "\uB354 \uC54C\uC544\uBCF4\uAE30"
  },
  recent: "\uCD5C\uADFC",
  status: {
    opening: "%{wallet}\uC5F4\uAE30 ...",
    not_installed: "%{wallet} \uAC00 \uC124\uCE58\uB418\uC5B4 \uC788\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
    not_available: "%{wallet} \uB97C \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4",
    confirm: "\uD655\uC7A5\uAE30\uB2A5\uC5D0\uC11C \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uC138\uC694"
  },
  secondary_action: {
    get: {
      description: "%{wallet}\uAC00 \uC5C6\uB098\uC694?",
      label: "GET"
    },
    install: {
      label: "\uC124\uCE58"
    },
    retry: {
      label: "\uB2E4\uC2DC \uC2DC\uB3C4"
    }
  },
  walletconnect: {
    description: {
      full: "\uACF5\uC2DD WalletConnect \uBAA8\uB2EC\uC774 \uD544\uC694\uD55C\uAC00\uC694?",
      compact: "WalletConnect \uBAA8\uB2EC\uC774 \uD544\uC694\uD55C\uAC00\uC694?"
    },
    open: {
      label: "\uC5F4\uAE30"
    }
  }
};
var connect_scan8 = {
  title: "%{wallet}\uB85C \uC2A4\uCE94\uD558\uAE30",
  fallback_title: "\uD734\uB300\uD3F0\uC73C\uB85C \uC2A4\uCE94\uD558\uAE30"
};
var connector_group8 = {
  recommended: "\uCD94\uCC9C",
  other: "\uAE30\uD0C0",
  popular: "\uC778\uAE30",
  more: "\uB354 \uBCF4\uAE30",
  others: "\uB2E4\uB978 \uC0AC\uD56D\uB4E4"
};
var get8 = {
  title: "\uC6D4\uB81B \uBC1B\uAE30",
  action: {
    label: "\uBC1B\uAE30"
  },
  mobile: {
    description: "\uBAA8\uBC14\uC77C \uC6D4\uB81B"
  },
  extension: {
    description: "\uBE0C\uB77C\uC6B0\uC800 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8"
  },
  mobile_and_extension: {
    description: "\uBAA8\uBC14\uC77C \uC9C0\uAC11 \uBC0F \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8"
  },
  looking_for: {
    title: "\uCC3E\uACE0 \uACC4\uC2E0 \uAC83\uC774 \uC544\uB2CC\uAC00\uC694?",
    mobile: {
      description: "\uBA54\uC778 \uD654\uBA74\uC5D0\uC11C \uB2E4\uB978 \uC9C0\uAC11 \uC81C\uACF5\uC790\uB97C \uC0AC\uC6A9\uD558\uAE30 \uC704\uD574 \uC9C0\uAC11\uC744 \uC120\uD0DD\uD558\uC138\uC694."
    },
    desktop: {
      compact_description: "\uBA54\uC778 \uD654\uBA74\uC5D0\uC11C \uB2E4\uB978 \uC9C0\uAC11 \uC81C\uACF5\uC790\uB97C \uC0AC\uC6A9\uD558\uAE30 \uC704\uD574 \uC9C0\uAC11\uC744 \uC120\uD0DD\uD558\uC138\uC694.",
      wide_description: "\uC67C\uCABD\uC5D0\uC11C \uC9C0\uAC11\uC744 \uC120\uD0DD\uD558\uC5EC \uB2E4\uB978 \uC9C0\uAC11 \uC81C\uACF5\uC790\uB97C \uC0AC\uC6A9\uD558\uAE30 \uC2DC\uC791\uD558\uC138\uC694."
    }
  }
};
var get_options8 = {
  title: "%{wallet}\uB85C \uC2DC\uC791\uD558\uC2ED\uC2DC\uC624",
  short_title: "%{wallet}\uC5BB\uAE30",
  mobile: {
    title: "\uBAA8\uBC14\uC77C\uC6A9 %{wallet}",
    description: "\uBAA8\uBC14\uC77C \uC9C0\uAC11\uC73C\uB85C \uC774\uB354\uB9AC\uC6C0 \uC138\uACC4\uB97C \uD0D0\uD5D8\uD558\uC138\uC694.",
    download: {
      label: "\uC571 \uBC1B\uAE30"
    }
  },
  extension: {
    title: "%{browser}\uC6A9 %{wallet}",
    description: "\uAC00\uC7A5 \uC88B\uC544\uD558\uB294 \uC6F9 \uBE0C\uB77C\uC6B0\uC800\uC5D0\uC11C \uBC14\uB85C \uC9C0\uAC11\uC5D0 \uC811\uADFC\uD558\uC138\uC694.",
    download: {
      label: "\uCD94\uAC00\uD558\uAE30 %{browser}"
    }
  }
};
var get_mobile8 = {
  title: "\uC124\uCE58\uD558\uAE30 %{wallet}",
  description: "iOS \uB610\uB294 Android\uC5D0\uC11C \uB2E4\uC6B4\uB85C\uB4DC\uD558\uAE30 \uC704\uD574 \uD734\uB300\uD3F0\uC73C\uB85C \uC2A4\uCE94\uD558\uC138\uC694",
  continue: {
    label: "\uACC4\uC18D"
  }
};
var get_instructions8 = {
  mobile: {
    connect: {
      label: "\uC5F0\uACB0"
    },
    learn_more: {
      label: "\uB354 \uC54C\uC544\uBCF4\uAE30"
    }
  },
  extension: {
    refresh: {
      label: "\uC0C8\uB85C\uACE0\uCE68"
    },
    learn_more: {
      label: "\uB354 \uC54C\uC544\uBCF4\uAE30"
    }
  }
};
var chains8 = {
  title: "\uB124\uD2B8\uC6CC\uD06C \uC804\uD658",
  wrong_network: "\uC798\uBABB\uB41C \uB124\uD2B8\uC6CC\uD06C\uB97C \uD0D0\uC9C0\uD588\uC2B5\uB2C8\uB2E4, \uACC4\uC18D\uD558\uB824\uBA74 \uC804\uD658\uD558\uAC70\uB098 \uC5F0\uACB0\uC744 \uD574\uC81C\uD558\uC138\uC694.",
  confirm: "\uC9C0\uAC11\uC5D0\uC11C \uC2B9\uC778",
  switching_not_supported: "\uC9C0\uAC11\uC5D0\uC11C %{appName}\uB124\uD2B8\uC6CC\uD06C\uB97C \uC804\uD658\uD558\uB294 \uAC83\uC740 \uC9C0\uC6D0\uB418\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB300\uC2E0 \uC9C0\uAC11 \uB0B4\uC5D0\uC11C \uB124\uD2B8\uC6CC\uD06C\uB97C \uC804\uD658\uD574 \uBCF4\uC138\uC694.",
  switching_not_supported_fallback: "\uB2F9\uC2E0\uC758 \uC9C0\uAC11\uC740 \uC774 \uC571\uC5D0\uC11C \uB124\uD2B8\uC6CC\uD06C\uB97C \uBC14\uAFB8\uB294 \uAC83\uC744 \uC9C0\uC6D0\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4. \uB300\uC2E0 \uC9C0\uAC11 \uB0B4\uC5D0\uC11C \uB124\uD2B8\uC6CC\uD06C\uB97C \uBCC0\uACBD\uD574 \uBCF4\uC2ED\uC2DC\uC624.",
  disconnect: "\uC5F0\uACB0 \uD574\uC81C",
  connected: "\uC5F0\uACB0\uB428"
};
var profile8 = {
  disconnect: {
    label: "\uC5F0\uACB0 \uD574\uC81C"
  },
  copy_address: {
    label: "\uC8FC\uC18C \uBCF5\uC0AC",
    copied: "\uBCF5\uC0AC\uB428!"
  },
  explorer: {
    label: "\uD0D0\uC0C9\uAE30\uC5D0\uC11C \uB354 \uBCF4\uAE30"
  },
  transactions: {
    description: "%{appName} \uAC70\uB798\uAC00 \uC5EC\uAE30\uC5D0 \uB098\uD0C0\uB0A9\uB2C8\uB2E4...",
    description_fallback: "\uC5EC\uAE30\uC5D0 \uD2B8\uB79C\uC7AD\uC158\uC774 \uD45C\uC2DC\uB429\uB2C8\uB2E4...",
    recent: {
      title: "\uCD5C\uADFC \uAC70\uB798 \uB0B4\uC5ED"
    },
    clear: {
      label: "\uBAA8\uB450 \uC9C0\uC6B0\uAE30"
    }
  }
};
var wallet_connectors8 = {
  argent: {
    qr_code: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uB824\uBA74 Argent\uB97C \uD648 \uD654\uBA74\uC5D0 \uB193\uC73C\uC2ED\uC2DC\uC624.",
        title: "Argent \uC571\uC744 \uC5F4\uAE30"
      },
      step2: {
        description: "\uC9C0\uAC11\uACFC \uC0AC\uC6A9\uC790 \uC774\uB984\uC744 \uC0DD\uC131\uD558\uAC70\uB098 \uAE30\uC874\uC758 \uC9C0\uAC11\uC744 \uAC00\uC838\uC635\uB2C8\uB2E4.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94 \uD6C4\uC5D0 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uAE30 \uC704\uD55C \uC5F0\uACB0 \uC694\uCCAD\uC774 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
        title: "QR \uCF54\uB4DC \uC2A4\uCE94 \uBC84\uD2BC\uC744 \uB204\uB974\uAE30"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "\uB354 \uBE60\uB978 \uC811\uADFC\uC744 \uC704\uD574 \uD648 \uD654\uBA74\uC5D0 Bifrost Wallet\uC744 \uB193\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Bifrost \uC9C0\uAC11 \uC571\uC744 \uC5F4\uC5B4\uC8FC\uC138\uC694"
      },
      step2: {
        description: "\uBCF5\uAD6C \uBB38\uAD6C\uB97C \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uC0DD\uC131\uD558\uAC70\uB098 \uAC00\uC838\uC635\uB2C8\uB2E4.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94 \uD6C4 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uB098\uD0C0\uB098\uACE0 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uB204\uB985\uB2C8\uB2E4"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "\uB354 \uBE60\uB978 \uC811\uADFC\uC744 \uC704\uD574 Bitget \uC9C0\uAC11\uC744 \uD648 \uD654\uBA74\uC5D0 \uB450\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Bitget \uC9C0\uAC11 \uC571\uC744 \uC5F4\uC2ED\uC2DC\uC624"
      },
      step2: {
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uBE44\uBC00 \uAD6C\uBB38\uC744 \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94 \uD6C4, \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uC5F0\uACB0 \uC694\uCCAD \uBA54\uC2DC\uC9C0\uAC00 \uB098\uD0C0\uB0A9\uB2C8\uB2E4.",
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uB204\uB974\uC2ED\uC2DC\uC624"
      }
    },
    extension: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uAE30 \uC704\uD574 Bitget Wallet\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Bitget Wallet \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC138\uC694"
      },
      step2: {
        description: "\uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC9C0\uAC11 \uC124\uC815\uC744 \uB9C8\uCE5C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC138\uC694.",
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uC138\uC694"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uAE30 \uC704\uD574 Bitski\uB97C \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Bitski \uD655\uC7A5 \uAE30\uB2A5\uC744 \uC124\uCE58\uD569\uB2C8\uB2E4"
      },
      step2: {
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.",
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC138\uC694.",
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uC138\uC694"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uAE30 \uC704\uD574 Coin98 Wallet\uC744 \uD648 \uD654\uBA74\uC5D0 \uB450\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Coin98 Wallet \uC571\uC744 \uC5F4\uAE30"
      },
      step2: {
        description: "\uD734\uB300\uD3F0\uC5D0\uC11C \uBC31\uC5C5 \uAE30\uB2A5\uC744 \uC774\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uC27D\uAC8C \uBC31\uC5C5\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94\uD55C \uD6C4 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uB098\uD0C0\uB098 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB3C4\uB85D \uD569\uB2C8\uB2E4.",
        title: "WalletConnect \uBC84\uD2BC\uC744 \uB204\uB974\uC2ED\uC2DC\uC624"
      }
    },
    extension: {
      step1: {
        description: "\uBE0C\uB77C\uC6B0\uC800 \uC624\uB978\uCABD \uC0C1\uB2E8\uC744 \uD074\uB9AD\uD558\uACE0 \uC27D\uAC8C \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB3C4\uB85D Coin98 Wallet\uC744 \uACE0\uC815\uD558\uC2ED\uC2DC\uC624.",
        title: "Coin98 Wallet \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC2ED\uC2DC\uC624"
      },
      step2: {
        description: "\uC0C8\uB85C\uC6B4 \uC9C0\uAC11\uC744 \uB9CC\uB4E4\uAC70\uB098 \uAE30\uC874\uC758 \uC9C0\uAC11\uC744 \uAC00\uC838\uC635\uB2C8\uB2E4.",
        title: "\uC9C0\uAC11\uC744 \uB9CC\uB4E4\uAC70\uB098 \uAC00\uC838\uC635\uB2C8\uB2E4"
      },
      step3: {
        description: "Coin98 Wallet\uC744 \uC124\uC815\uD558\uBA74 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624.",
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uC2ED\uC2DC\uC624"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "\uB354 \uBE60\uB978 \uC561\uC138\uC2A4\uB97C \uC704\uD574 Coinbase Wallet\uC744 \uD648 \uD654\uBA74\uC5D0 \uB450\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Coinbase Wallet \uC571\uC744 \uC5FD\uB2C8\uB2E4"
      },
      step2: {
        description: "\uD074\uB77C\uC6B0\uB4DC \uBC31\uC5C5 \uAE30\uB2A5\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uC27D\uAC8C \uBC31\uC5C5\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94\uD55C \uD6C4\uC5D0 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uB098\uD0C0\uB0A9\uB2C8\uB2E4.",
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uD0ED\uD558\uC138\uC694"
      }
    },
    extension: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D Coinbase Wallet\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Coinbase Wallet \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC138\uC694"
      },
      step2: {
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uBE44\uBC00 \uBB38\uAD6C\uB294 \uC808\uB300\uB85C \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.",
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624.",
        title: "\uBE0C\uB77C\uC6B0\uC800 \uC0C8\uB85C \uACE0\uCE68"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB3C4\uB85D Core\uB97C \uD648 \uD654\uBA74\uC5D0 \uB450\uB294 \uAC83\uC744 \uCD94\uCC9C\uB4DC\uB9BD\uB2C8\uB2E4.",
        title: "Core \uC571 \uC5F4\uAE30"
      },
      step2: {
        description: "\uD734\uB300\uD3F0\uC5D0\uC11C \uC6B0\uB9AC\uC758 \uBC31\uC5C5 \uAE30\uB2A5\uC744 \uC774\uC6A9\uD574 \uC9C0\uAC11\uC744 \uC27D\uAC8C \uBC31\uC5C5\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94 \uD55C \uD6C4\uC5D0\uB294 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uC5F0\uACB0 \uC694\uCCAD\uC774 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
        title: "WalletConnect \uBC84\uD2BC\uC744 \uB204\uB974\uC138\uC694"
      }
    },
    extension: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uAE30 \uC704\uD574 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 Core\uB97C \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Core \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC2ED\uC2DC\uC624"
      },
      step2: {
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD574\uC57C \uD569\uB2C8\uB2E4. \uC808\uB300\uB85C \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.",
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624.",
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uC138\uC694"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "FoxWallet\uC744 \uD648 \uD654\uBA74\uC5D0 \uB193\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4. \uC774\uB807\uAC8C \uD558\uBA74 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        title: "FoxWallet \uC571\uC744 \uC5F4\uC5B4\uC8FC\uC138\uC694"
      },
      step2: {
        description: "\uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.",
        title: "\uC9C0\uAC11\uC744 \uC0DD\uC131\uD558\uAC70\uB098 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94 \uD6C4, \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uB204\uB974\uC138\uC694"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "Frontier Wallet\uC744 \uD648 \uD654\uBA74\uC5D0 \uB193\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4. \uC774\uB807\uAC8C \uD558\uBA74 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4.",
        title: "Frontier Wallet \uC571\uC744 \uC5F4\uC5B4\uC8FC\uC138\uC694"
      },
      step2: {
        description: "\uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD574\uC57C \uD569\uB2C8\uB2E4. \uBE44\uBC00 \uAD6C\uBB38\uC744 \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC2A4\uCE94 \uD6C4\uC5D0 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uD45C\uC2DC\uB429\uB2C8\uB2E4.",
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uB204\uB974\uC138\uC694"
      }
    },
    extension: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4 \uD560 \uC218 \uC788\uB3C4\uB85D Frontier Wallet\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4.",
        title: "Frontier Wallet \uD655\uC7A5 \uAE30\uB2A5 \uC124\uCE58"
      },
      step2: {
        description: "\uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD574\uC57C \uD569\uB2C8\uB2E4. \uBE44\uBC00 \uAD6C\uBB38\uC744 \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4\uC5D0 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624.",
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE69\uB2C8\uB2E4"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "imToken \uC571\uC744 \uC5F0\uB2E4",
        description: "\uB2F9\uC2E0\uC758 \uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD558\uAE30 \uC704\uD574 imToken \uC571\uC744 \uD648 \uD654\uBA74\uC5D0 \uB461\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11\uC744 \uB9CC\uB4E4\uAC70\uB098 \uBD88\uB7EC\uC635\uB2C8\uB2E4",
        description: "\uC0C8 \uC9C0\uAC11\uC744 \uC0DD\uC131\uD558\uAC70\uB098 \uAE30\uC874\uC758 \uAC83\uC744 \uAC00\uC838\uC635\uB2C8\uB2E4."
      },
      step3: {
        title: "\uC624\uB978\uCABD \uC0C1\uB2E8\uC758 \uC2A4\uCE90\uB108 \uC544\uC774\uCF58\uC744 \uB204\uB985\uB2C8\uB2E4",
        description: "\uC0C8 \uC5F0\uACB0\uC744 \uC120\uD0DD\uD558\uACE0 QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD55C \uB4A4, \uC5F0\uACB0\uD558\uB824\uB294 \uD504\uB86C\uD504\uD2B8\uB97C \uD655\uC778\uD569\uB2C8\uB2E4."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "MetaMask \uC571\uC744 \uC5FD\uB2C8\uB2E4",
        description: "\uBE60\uB978 \uC561\uC138\uC2A4\uB97C \uC704\uD574 MetaMask\uB97C \uD648 \uD654\uBA74\uC5D0 \uB450\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uB2F9\uC2E0\uC758 \uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD558\uB294 \uAC83\uC744 \uC78A\uC9C0 \uB9C8\uC138\uC694. \uC808\uB300\uB85C \uBE44\uBC00 \uAD6C\uC808\uC744 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694."
      },
      step3: {
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uB204\uB985\uB2C8\uB2E4",
        description: "\uC2A4\uCE94\uD55C \uD6C4\uC5D0 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uB098\uD0C0\uB0A9\uB2C8\uB2E4."
      }
    },
    extension: {
      step1: {
        title: "MetaMask \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC138\uC694",
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC811\uADFC\uD558\uAE30 \uC704\uD574 MetaMask\uB97C \uC791\uC5C5\uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC138\uC694. \uACB0\uCF54 \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uC138\uC694",
        description: "\uC9C0\uAC11 \uC124\uC815\uC744 \uB9C8\uCE5C \uD6C4\uC5D0\uB294 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC138\uC694."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "OKX Wallet \uC571\uC744 \uC5F4\uAE30",
        description: "\uB354 \uBE60\uB978 \uC811\uADFC\uC744 \uC704\uD574 OKX \uC9C0\uAC11\uC744 \uD648 \uD654\uBA74\uC5D0 \uB450\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uBD88\uB7EC\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300 \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694."
      },
      step3: {
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uD0ED\uD558\uC138\uC694",
        description: "\uC2A4\uCE94 \uD6C4 \uC5F0\uACB0 \uC694\uCCAD\uC774 \uB098\uD0C0\uB098\uBA70, \uC774\uB97C \uD1B5\uD574 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
      }
    },
    extension: {
      step1: {
        title: "OKX \uC9C0\uAC11 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8 \uC124\uCE58\uD558\uAE30",
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D OKX \uC9C0\uAC11\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uBD88\uB7EC\uC624\uAE30",
        description: "\uB2F9\uC2E0\uC758 \uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD574\uC57C \uD569\uB2C8\uB2E4. \uBE44\uBC00 \uBB38\uAD6C\uB97C \uC808\uB300\uB85C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uC138\uC694",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4, \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uAE30\uB2A5\uC744 \uB85C\uB4DC\uD558\uAE30 \uC704\uD574 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC138\uC694."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Omni \uC571\uC744 \uC5F4\uAE30",
        description: "\uB354 \uBE60\uB978 \uC561\uC138\uC2A4\uB97C \uC704\uD574 Omni\uB97C \uD648 \uC2A4\uD06C\uB9B0\uC5D0 \uCD94\uAC00\uD558\uC138\uC694."
      },
      step2: {
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC0C8\uB85C\uC6B4 \uC9C0\uAC11\uC744 \uB9CC\uB4E4\uAC70\uB098 \uAE30\uC874\uC758 \uD558\uB098\uB97C \uAC00\uC838\uC635\uB2C8\uB2E4."
      },
      step3: {
        title: "QR \uC544\uC774\uCF58\uC744 \uD0ED\uD558\uACE0 \uC2A4\uCE94\uD558\uAE30",
        description: "\uD648 \uD654\uBA74\uC758 QR \uC544\uC774\uCF58\uC744 \uD0ED\uD558\uACE0, \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uACE0 \uD504\uB86C\uD504\uD2B8\uB97C \uD655\uC778\uD558\uC5EC \uC5F0\uACB0\uD558\uC138\uC694."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "TokenPocket \uC571\uC744 \uC5F4\uC5B4\uC8FC\uC138\uC694",
        description: "\uBE60\uB978 \uC811\uADFC\uC744 \uC704\uD574 \uD648 \uD654\uBA74\uC5D0 TokenPocket\uC744 \uCD94\uAC00\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC138\uC694. \uC808\uB300\uB85C \uB204\uAD6C\uC5D0\uAC8C\uB3C4 \uBE44\uBC00 \uBB38\uAD6C\uB97C \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694."
      },
      step3: {
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uD0ED\uD558\uC138\uC694",
        description: "\uC2A4\uCE94 \uD6C4\uC5D0 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uD504\uB86C\uD504\uD2B8\uAC00 \uD45C\uC2DC\uB429\uB2C8\uB2E4."
      }
    },
    extension: {
      step1: {
        title: "TokenPocket \uD655\uC7A5 \uAE30\uB2A5\uC744 \uC124\uCE58\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC811\uADFC\uD558\uAE30 \uC704\uD574 TokenPocket\uB97C \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC138\uC694. \uC808\uB300\uB85C \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800 \uC0C8\uB85C \uACE0\uCE68",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD558\uBA74 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uAE30\uB2A5\uC744 \uB85C\uB4DC\uD569\uB2C8\uB2E4."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Trust Wallet \uC571\uC744 \uC5F4\uAE30",
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC811\uADFC\uD558\uAE30 \uC704\uD574 Trust Wallet\uC744 \uD648 \uC2A4\uD06C\uB9B0\uC5D0 \uB450\uC2ED\uC2DC\uC624."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC0C8\uB85C\uC6B4 \uC9C0\uAC11\uC744 \uC0DD\uC131\uD558\uAC70\uB098 \uAE30\uC874\uC758 \uAC83\uC744 \uAC00\uC838\uC624\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uC124\uC815\uC5D0\uC11C WalletConnect\uB97C \uD0ED\uD558\uC2ED\uC2DC\uC624",
        description: "\uC0C8 \uC5F0\uACB0\uC744 \uC120\uD0DD\uD55C \uB2E4\uC74C QR \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uACE0, \uC5F0\uACB0\uC744 \uD655\uC778\uD558\uB294 \uD504\uB86C\uD504\uD2B8\uB97C \uD655\uC778\uD558\uC2ED\uC2DC\uC624."
      }
    },
    extension: {
      step1: {
        title: "Trust Wallet \uD655\uC7A5 \uAE30\uB2A5\uC744 \uC124\uCE58\uD558\uC2ED\uC2DC\uC624",
        description: "\uBE0C\uB77C\uC6B0\uC800\uC758 \uC624\uB978\uCABD \uC0C1\uB2E8\uC744 \uD074\uB9AD\uD558\uACE0 Trust Wallet\uC744 \uACE0\uC815\uD558\uC5EC \uC27D\uAC8C \uC811\uADFC\uD558\uC2ED\uC2DC\uC624."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC0C8\uB85C\uC6B4 \uC9C0\uAC11\uC744 \uC0DD\uC131\uD558\uAC70\uB098 \uAE30\uC874\uC758 \uAC83\uC744 \uAC00\uC838\uC624\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uC138\uC694",
        description: "Trust Wallet\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD569\uB2C8\uB2E4."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Uniswap \uC571\uC744 \uC5FD\uB2C8\uB2E4",
        description: "Uniswap Wallet\uC744 \uD648 \uD654\uBA74\uC5D0 \uCD94\uAC00\uD558\uC5EC \uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uC138\uC694."
      },
      step2: {
        title: "\uC9C0\uAC11\uC744 \uB9CC\uB4E4\uAC70\uB098 \uAC00\uC838\uC624\uAE30",
        description: "\uC0C8 \uC9C0\uAC11\uC744 \uC0DD\uC131\uD558\uAC70\uB098 \uAE30\uC874\uC758 \uAC83\uC744 \uAC00\uC838\uC635\uB2C8\uB2E4."
      },
      step3: {
        title: "QR \uC544\uC774\uCF58\uC744 \uB204\uB974\uACE0 \uC2A4\uCE94\uD558\uAE30",
        description: "\uD648\uD654\uBA74\uC758 QR \uC544\uC774\uCF58\uC744 \uB204\uB974\uACE0 \uCF54\uB4DC\uB97C \uC2A4\uCE94\uD558\uACE0 \uD504\uB86C\uD504\uD2B8\uB97C \uD655\uC778\uD558\uC5EC \uC5F0\uACB0\uD558\uC138\uC694."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Zerion \uC571\uC744 \uC5FD\uB2C8\uB2E4",
        description: "\uB354 \uBE60\uB978 \uC811\uADFC\uC744 \uC704\uD574 Zerion\uC744 \uD648 \uD654\uBA74\uC5D0 \uB450\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uBE44\uBC00 \uAD6C\uC808\uC744 \uB204\uAD70\uAC00\uC640 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uD0ED\uD558\uC2ED\uC2DC\uC624",
        description: "\uC2A4\uCE94 \uD6C4 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uB098\uD0C0\uB098 \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uC2ED\uC2DC\uC624."
      }
    },
    extension: {
      step1: {
        title: "Zerion \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D Zerion\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC138\uC694. \uBE44\uBC00 \uAD6C\uBB38\uC744 \uC808\uB300\uB85C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uC138\uC694",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC138\uC694."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Rainbow \uC571 \uC5F4\uAE30",
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD558\uAE30 \uC704\uD574 \uD648 \uD654\uBA74\uC5D0 Rainbow\uB97C \uB450\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uD734\uB300\uD3F0\uC5D0 \uC788\uB294 \uBC31\uC5C5 \uAE30\uB2A5\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uC27D\uAC8C \uBC31\uC5C5\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."
      },
      step3: {
        title: "\uC2A4\uCE94 \uBC84\uD2BC\uC744 \uB204\uB974\uC138\uC694",
        description: "\uC2A4\uCE94 \uD6C4, \uC9C0\uAC11\uC744 \uC5F0\uACB0\uD558\uB77C\uB294 \uC5F0\uACB0 \uD504\uB86C\uD504\uD2B8\uAC00 \uB098\uD0C0\uB0A9\uB2C8\uB2E4."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD558\uAE30 \uC704\uD574 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 Enkrypt Wallet\uB97C \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4.",
        title: "Enkrypt Wallet \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC138\uC694"
      },
      step2: {
        description: "\uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4\uC5D0\uB294 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC138\uC694.",
        title: "\uBE0C\uB77C\uC6B0\uC800 \uC0C8\uB85C \uACE0\uCE68"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D Frame\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4.",
        title: "Frame \uBC0F \uB3D9\uBC18 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8 \uC124\uCE58"
      },
      step2: {
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uBE44\uBC00 \uAD6C\uBB38\uC744 \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC138\uC694.",
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30"
      },
      step3: {
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4\uC5D0\uB294 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC138\uC694.",
        title: "\uBE0C\uB77C\uC6B0\uC800 \uC0C8\uB85C \uACE0\uCE68"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "OneKey Wallet \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC138\uC694",
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D OneKey Wallet\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uBD88\uB7EC\uC624\uAE30",
        description: "\uC9C0\uAC11\uC744 \uC548\uC804\uD55C \uBC29\uBC95\uC73C\uB85C \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Phantom \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC138\uC694",
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uC27D\uAC8C \uC811\uADFC\uD560 \uC218 \uC788\uB3C4\uB85D Phantom\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uBD88\uB7EC\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uB204\uAD6C\uC640\uB3C4 \uBE44\uBC00 \uBCF5\uAD6C \uAD6C\uBB38\uC744 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uAE30\uB2A5\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Rabby \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uC124\uCE58\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD560 \uC218 \uC788\uB3C4\uB85D Rabby\uB97C \uC791\uC5C5\uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uC808\uB300\uB85C \uB204\uAD6C\uC640\uB3C4 \uBE44\uBC00 \uAD6C\uBB38\uC744 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11 \uC124\uC815\uC744 \uC644\uB8CC\uD558\uBA74 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD569\uB2C8\uB2E4."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "\uCF54\uC5B4 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8 \uC124\uCE58",
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uAE30 \uC704\uD574 Safeheron\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uB9CC\uB4E4\uAE30 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uBE44\uBC00 \uBB38\uAD6C\uB97C \uC808\uB300 \uB2E4\uB978 \uC0AC\uB78C\uACFC \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800 \uC0C8\uB85C \uACE0\uCE68",
        description: "\uC9C0\uAC11 \uC124\uC815\uC744 \uC644\uB8CC\uD558\uBA74 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD569\uB2C8\uB2E4."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Taho \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8 \uC124\uCE58",
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uAE30 \uC704\uD574 Taho\uB97C \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uACB0\uCF54 \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB204\uAD70\uAC00\uC640 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE58\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "\uD0C8\uB9AC\uC2A4\uB9CC \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8 \uC124\uCE58",
        description: "\uC9C0\uAC11\uC5D0 \uB354 \uBE60\uB974\uAC8C \uC811\uADFC\uD558\uAE30 \uC704\uD574 Talisman\uC744 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC774\uB354\uB9AC\uC6C0 \uC9C0\uAC11 \uC0DD\uC131 \uB610\uB294 \uAC00\uC838\uC624\uAE30",
        description: "\uBC18\uB4DC\uC2DC \uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uBCF5\uAD6C \uBB38\uAD6C\uB97C \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815 \uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uAE30\uB2A5\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "XDEFI \uC9C0\uAC11 \uD655\uC7A5 \uAE30\uB2A5\uC744 \uC124\uCE58\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC5D0 \uBE60\uB974\uAC8C \uC561\uC138\uC2A4\uD558\uAE30 \uC704\uD574 \uC791\uC5C5 \uD45C\uC2DC\uC904\uC5D0 XDEFI Wallet\uC744 \uACE0\uC815\uD558\uB294 \uAC83\uC744 \uAD8C\uC7A5\uD569\uB2C8\uB2E4."
      },
      step2: {
        title: "\uC9C0\uAC11\uC744 \uB9CC\uB4E4\uAC70\uB098 \uAC00\uC838\uC624\uAE30",
        description: "\uBC18\uB4DC\uC2DC \uC548\uC804\uD55C \uBC29\uBC95\uC744 \uC0AC\uC6A9\uD558\uC5EC \uC9C0\uAC11\uC744 \uBC31\uC5C5\uD558\uC2ED\uC2DC\uC624. \uBE44\uBC00 \uBB38\uAD6C\uB97C \uB204\uAD6C\uC640\uB3C4 \uACF5\uC720\uD558\uC9C0 \uB9C8\uC2ED\uC2DC\uC624."
      },
      step3: {
        title: "\uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C \uACE0\uCE68\uD558\uC2ED\uC2DC\uC624",
        description: "\uC9C0\uAC11\uC744 \uC124\uC815\uD55C \uD6C4 \uC544\uB798\uB97C \uD074\uB9AD\uD558\uC5EC \uBE0C\uB77C\uC6B0\uC800\uB97C \uC0C8\uB85C\uACE0\uCE68\uD558\uACE0 \uD655\uC7A5 \uD504\uB85C\uADF8\uB7A8\uC744 \uB85C\uB4DC\uD558\uC2ED\uC2DC\uC624."
      }
    }
  }
};
var ko_KR_default = {
  connect_wallet: connect_wallet8,
  intro: intro8,
  connect: connect8,
  connect_scan: connect_scan8,
  connector_group: connector_group8,
  get: get8,
  get_options: get_options8,
  get_mobile: get_mobile8,
  get_instructions: get_instructions8,
  chains: chains8,
  profile: profile8,
  wallet_connectors: wallet_connectors8
};

// src/locales/pt_BR.json
var connect_wallet9 = {
  label: "Conectar Carteira"
};
var intro9 = {
  title: "O que \xE9 uma Carteira?",
  description: "Uma carteira \xE9 usada para enviar, receber, armazenar e exibir ativos digitais. Tamb\xE9m \xE9 uma nova forma de se conectar, sem precisar criar novas contas e senhas em todo site.",
  digital_asset: {
    title: "Um lar para seus ativos digitais",
    description: "Carteiras s\xE3o usadas para enviar, receber, armazenar e exibir ativos digitais como Ethereum e NFTs."
  },
  login: {
    title: "Uma nova maneira de fazer login",
    description: "Em vez de criar novas contas e senhas em todos os sites, basta conectar sua carteira."
  },
  get: {
    label: "Obter uma Carteira"
  },
  learn_more: {
    label: "Saiba mais"
  }
};
var connect9 = {
  label: "Conectar",
  title: "Conectar uma Carteira",
  new_to_ethereum: {
    description: "Novo nas carteiras Ethereum?",
    learn_more: {
      label: "Saiba mais"
    }
  },
  learn_more: {
    label: "Saiba mais"
  },
  recent: "Recente",
  status: {
    opening: "Abrindo %{wallet}...",
    not_installed: "%{wallet} n\xE3o est\xE1 instalado",
    not_available: "%{wallet} n\xE3o est\xE1 dispon\xEDvel",
    confirm: "Confirme a conex\xE3o na extens\xE3o"
  },
  secondary_action: {
    get: {
      description: "N\xE3o tem %{wallet}?",
      label: "OBTER"
    },
    install: {
      label: "INSTALAR"
    },
    retry: {
      label: "TENTAR DE NOVO"
    }
  },
  walletconnect: {
    description: {
      full: "Precisa do modal oficial do WalletConnect?",
      compact: "Precisa do modal WalletConnect?"
    },
    open: {
      label: "ABRIR"
    }
  }
};
var connect_scan9 = {
  title: "Digitalize com %{wallet}",
  fallback_title: "Digitalize com o seu telefone"
};
var connector_group9 = {
  recommended: "Recomendado",
  other: "Outro",
  popular: "Popular",
  more: "Mais",
  others: "Outros"
};
var get9 = {
  title: "Obter uma Carteira",
  action: {
    label: "OBTER"
  },
  mobile: {
    description: "Carteira M\xF3vel"
  },
  extension: {
    description: "Extens\xE3o do Navegador"
  },
  mobile_and_extension: {
    description: "Carteira M\xF3vel e Extens\xE3o"
  },
  looking_for: {
    title: "N\xE3o \xE9 o que voc\xEA est\xE1 procurando?",
    mobile: {
      description: "Selecione uma carteira na tela principal para come\xE7ar com um provedor de carteira diferente."
    },
    desktop: {
      compact_description: "Selecione uma carteira na tela principal para come\xE7ar com um provedor de carteira diferente.",
      wide_description: "Selecione uma carteira \xE0 esquerda para come\xE7ar com um provedor de carteira diferente."
    }
  }
};
var get_options9 = {
  title: "Comece com %{wallet}",
  short_title: "Obtenha %{wallet}",
  mobile: {
    title: "%{wallet} para M\xF3vel",
    description: "Use a carteira m\xF3vel para explorar o mundo do Ethereum.",
    download: {
      label: "Baixe o aplicativo"
    }
  },
  extension: {
    title: "%{wallet} para %{browser}",
    description: "Acesse sua carteira diretamente do seu navegador web favorito.",
    download: {
      label: "Adicionar ao %{browser}"
    }
  }
};
var get_mobile9 = {
  title: "Instale %{wallet}",
  description: "Escaneie com seu celular para baixar no iOS ou Android",
  continue: {
    label: "Continuar"
  }
};
var get_instructions9 = {
  mobile: {
    connect: {
      label: "Conectar"
    },
    learn_more: {
      label: "Saiba mais"
    }
  },
  extension: {
    refresh: {
      label: "Atualizar"
    },
    learn_more: {
      label: "Saiba mais"
    }
  }
};
var chains9 = {
  title: "Mudar Redes",
  wrong_network: "Rede errada detectada, mude ou desconecte para continuar.",
  confirm: "Confirme na Carteira",
  switching_not_supported: "Sua carteira n\xE3o suporta a mudan\xE7a de redes de %{appName}. Tente mudar de redes dentro da sua carteira.",
  switching_not_supported_fallback: "Sua carteira n\xE3o suporta a troca de redes a partir deste aplicativo. Tente trocar de rede dentro de sua carteira.",
  disconnect: "Desconectar",
  connected: "Conectado"
};
var profile9 = {
  disconnect: {
    label: "Desconectar"
  },
  copy_address: {
    label: "Copiar Endere\xE7o",
    copied: "Copiado!"
  },
  explorer: {
    label: "Veja mais no explorador"
  },
  transactions: {
    description: "%{appName} transa\xE7\xF5es aparecer\xE3o aqui...",
    description_fallback: "Suas transa\xE7\xF5es aparecer\xE3o aqui...",
    recent: {
      title: "Transa\xE7\xF5es Recentes"
    },
    clear: {
      label: "Limpar Tudo"
    }
  }
};
var wallet_connectors9 = {
  argent: {
    qr_code: {
      step1: {
        description: "Coloque o Argent na tela inicial para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Abra o aplicativo Argent"
      },
      step2: {
        description: "Crie uma carteira e nome de usu\xE1rio, ou importe uma carteira existente.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois que voc\xEA escanear, um prompt de conex\xE3o aparecer\xE1 para voc\xEA conectar sua carteira.",
        title: "Toque no bot\xE3o Scan QR"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar a Bifrost Wallet na sua tela inicial para um acesso mais r\xE1pido.",
        title: "Abra o aplicativo Bifrost Wallet"
      },
      step2: {
        description: "Crie ou importe uma carteira usando sua frase de recupera\xE7\xE3o.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Ap\xF3s voc\xEA escanear, um prompt de conex\xE3o aparecer\xE1 para voc\xEA conectar sua carteira.",
        title: "Toque no bot\xE3o de escanear"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar a Bitget Wallet na sua tela inicial para um acesso mais r\xE1pido.",
        title: "Abra o aplicativo Bitget Wallet"
      },
      step2: {
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de escanear, um prompt de conex\xE3o aparecer\xE1 para voc\xEA conectar sua carteira.",
        title: "Toque no bot\xE3o de escaneamento"
      }
    },
    extension: {
      step1: {
        description: "Recomendamos fixar a Bitget Wallet na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Instale a extens\xE3o da Carteira Bitget"
      },
      step2: {
        description: "Certifique-se de fazer o backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize seu navegador"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "Recomendamos fixar o Bitski na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Instale a extens\xE3o Bitski"
      },
      step2: {
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize seu navegador"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar a Carteira Coin98 na tela inicial para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Abra o aplicativo Carteira Coin98"
      },
      step2: {
        description: "Voc\xEA pode facilmente fazer backup de sua carteira usando nosso recurso de backup em seu telefone.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de escanear, uma solicita\xE7\xE3o de conex\xE3o aparecer\xE1 para voc\xEA conectar sua carteira.",
        title: "Toque no bot\xE3o WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Clique no canto superior direito do seu navegador e fixe a Carteira Coin98 para f\xE1cil acesso.",
        title: "Instale a extens\xE3o da Carteira Coin98"
      },
      step2: {
        description: "Crie uma nova carteira ou importe uma existente.",
        title: "Criar ou Importar uma carteira"
      },
      step3: {
        description: "Depois de configurar a Carteira Coin98, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize seu navegador"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar a Carteira Coinbase na tela inicial para um acesso mais r\xE1pido.",
        title: "Abra o aplicativo Coinbase Wallet"
      },
      step2: {
        description: "Voc\xEA pode fazer backup da sua carteira facilmente usando o recurso de backup na nuvem.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de escanear, um prompt de conex\xE3o aparecer\xE1 para que voc\xEA conecte sua carteira.",
        title: "Toque no bot\xE3o de escanear"
      }
    },
    extension: {
      step1: {
        description: "Recomendamos fixar o Coinbase Wallet na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Instale a extens\xE3o Coinbase Wallet"
      },
      step2: {
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Uma vez que voc\xEA configurou sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize seu navegador"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar o Core na tela inicial para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Abra o aplicativo Core"
      },
      step2: {
        description: "Voc\xEA pode facilmente salvar sua carteira usando nosso recurso de backup no seu celular.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de escanear, um prompt de conex\xE3o aparecer\xE1 para voc\xEA conectar sua carteira.",
        title: "Toque no bot\xE3o WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "Recomendamos fixar o Core na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Instale a extens\xE3o Core"
      },
      step2: {
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize seu navegador"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar o FoxWallet na tela inicial para um acesso mais r\xE1pido.",
        title: "Abra o aplicativo FoxWallet"
      },
      step2: {
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de escanear, uma solicita\xE7\xE3o de conex\xE3o aparecer\xE1 para voc\xEA conectar sua carteira.",
        title: "Toque no bot\xE3o de escaneamento"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "Recomendamos colocar o Frontier Wallet na tela inicial para um acesso mais r\xE1pido.",
        title: "Abra o aplicativo Frontier Wallet"
      },
      step2: {
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de escanear, aparecer\xE1 um prompt de conex\xE3o para voc\xEA conectar sua carteira.",
        title: "Toque no bot\xE3o de varredura"
      }
    },
    extension: {
      step1: {
        description: "Recomendamos fixar a Carteira Frontier na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Instale a extens\xE3o da Carteira Frontier"
      },
      step2: {
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize seu navegador"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo imToken",
        description: "Coloque o aplicativo imToken na tela inicial para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Crie uma nova carteira ou importe uma existente."
      },
      step3: {
        title: "Toque no \xEDcone do Scanner no canto superior direito",
        description: "Escolha Nova Conex\xE3o, em seguida, escaneie o c\xF3digo QR e confirme o prompt para conectar."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo MetaMask",
        description: "Recomendamos colocar o MetaMask na tela inicial para um acesso mais r\xE1pido."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Toque no bot\xE3o escanear",
        description: "Depois de escanear, aparecer\xE1 um prompt de conex\xE3o para voc\xEA conectar sua carteira."
      }
    },
    extension: {
      step1: {
        title: "Instale a extens\xE3o MetaMask",
        description: "Recomendamos fixar o MetaMask na barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize o seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo da Carteira OKX",
        description: "Recomendamos colocar a Carteira OKX na tela inicial para um acesso mais r\xE1pido."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer o backup da sua carteira utilizando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Toque no bot\xE3o de digitaliza\xE7\xE3o",
        description: "Depois de escanear, aparecer\xE1 um prompt de conex\xE3o para voc\xEA conectar sua carteira."
      }
    },
    extension: {
      step1: {
        title: "Instale a extens\xE3o OKX Wallet",
        description: "Recomendamos fixar a OKX Wallet na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer o backup da sua carteira utilizando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize o seu navegador",
        description: "Uma vez que voc\xEA configurou sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo Omni",
        description: "Adicione o Omni \xE0 sua tela inicial para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Crie uma nova carteira ou importe uma existente."
      },
      step3: {
        title: "Toque no \xEDcone do QR e escaneie",
        description: "Toque no \xEDcone QR na tela inicial, escaneie o c\xF3digo e confirme o prompt para conectar."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo TokenPocket",
        description: "Recomendamos colocar o TokenPocket na tela inicial para um acesso mais r\xE1pido."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Toque no bot\xE3o de digitaliza\xE7\xE3o",
        description: "Depois de escanear, aparecer\xE1 um prompt de conex\xE3o para voc\xEA conectar sua carteira."
      }
    },
    extension: {
      step1: {
        title: "Instale a extens\xE3o TokenPocket",
        description: "Recomendamos fixar o TokenPocket em sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Uma vez que voc\xEA configurou sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo Trust Wallet",
        description: "Coloque o Trust Wallet na tela inicial para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Crie uma nova carteira ou importe uma existente."
      },
      step3: {
        title: "Toque em WalletConnect nas Configura\xE7\xF5es",
        description: "Escolha Nova Conex\xE3o, depois escaneie o QR code e confirme o prompt para se conectar."
      }
    },
    extension: {
      step1: {
        title: "Instale a extens\xE3o Trust Wallet",
        description: "Clique no canto superior direito do seu navegador e marque Trust Wallet para f\xE1cil acesso."
      },
      step2: {
        title: "Crie ou Importe uma carteira",
        description: "Crie uma nova carteira ou importe uma existente."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Depois que configurar a Trust Wallet, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo Uniswap",
        description: "Adicione a Carteira Uniswap \xE0 sua tela inicial para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Crie uma nova carteira ou importe uma existente."
      },
      step3: {
        title: "Toque no \xEDcone QR e escaneie",
        description: "Toque no \xEDcone QR na sua tela inicial, escaneie o c\xF3digo e confirme o prompt para conectar."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo Zerion",
        description: "Recomendamos colocar o Zerion na sua tela inicial para um acesso mais r\xE1pido."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Toque no bot\xE3o de digitaliza\xE7\xE3o",
        description: "Depois de digitalizar, um prompt de conex\xE3o aparecer\xE1 para que voc\xEA possa conectar sua carteira."
      }
    },
    extension: {
      step1: {
        title: "Instale a extens\xE3o Zerion",
        description: "Recomendamos fixar o Zerion na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Abra o aplicativo Rainbow",
        description: "Recomendamos colocar o Rainbow na tela inicial para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Voc\xEA pode facilmente fazer backup da sua carteira usando nosso recurso de backup no seu telefone."
      },
      step3: {
        title: "Toque no bot\xE3o de digitalizar",
        description: "Depois de escanear, uma solicita\xE7\xE3o de conex\xE3o aparecer\xE1 para voc\xEA conectar sua carteira."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "Recomendamos fixar a Carteira Enkrypt na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Instale a extens\xE3o da Carteira Enkrypt"
      },
      step2: {
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize o seu navegador"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "Recomendamos fixar o Frame na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira.",
        title: "Instale o Frame e a extens\xE3o complementar"
      },
      step2: {
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m.",
        title: "Criar ou Importar uma Carteira"
      },
      step3: {
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o.",
        title: "Atualize seu navegador"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "Instale a extens\xE3o OneKey Wallet",
        description: "Recomendamos fixar a OneKey Wallet na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Uma vez que voc\xEA configurou sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Instale a extens\xE3o Phantom",
        description: "Recomendamos fixar o Phantom na sua barra de tarefas para facilitar o acesso \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta de recupera\xE7\xE3o com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Instale a extens\xE3o Rabby",
        description: "Recomendamos fixar Rabby na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "Instale a extens\xE3o Core",
        description: "Recomendamos fixar Safeheron na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer o backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Instale a extens\xE3o Taho",
        description: "Recomendamos fixar o Taho na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer o backup da sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "Instale a extens\xE3o Talisman",
        description: "Recomendamos fixar o Talisman na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Crie ou Importe uma Carteira Ethereum",
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase de recupera\xE7\xE3o com ningu\xE9m."
      },
      step3: {
        title: "Atualize o seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "Instale a extens\xE3o XDEFI Wallet",
        description: "Recomendamos fixar a Carteira XDEFI na sua barra de tarefas para um acesso mais r\xE1pido \xE0 sua carteira."
      },
      step2: {
        title: "Criar ou Importar uma Carteira",
        description: "Certifique-se de fazer backup de sua carteira usando um m\xE9todo seguro. Nunca compartilhe sua frase secreta com ningu\xE9m."
      },
      step3: {
        title: "Atualize seu navegador",
        description: "Depois de configurar sua carteira, clique abaixo para atualizar o navegador e carregar a extens\xE3o."
      }
    }
  }
};
var pt_BR_default = {
  connect_wallet: connect_wallet9,
  intro: intro9,
  connect: connect9,
  connect_scan: connect_scan9,
  connector_group: connector_group9,
  get: get9,
  get_options: get_options9,
  get_mobile: get_mobile9,
  get_instructions: get_instructions9,
  chains: chains9,
  profile: profile9,
  wallet_connectors: wallet_connectors9
};

// src/locales/ru_RU.json
var connect_wallet10 = {
  label: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
};
var intro10 = {
  title: "\u0427\u0442\u043E \u0442\u0430\u043A\u043E\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A?",
  description: "\u041A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0446\u0438\u0444\u0440\u043E\u0432\u044B\u0445 \u0430\u043A\u0442\u0438\u0432\u043E\u0432. \u042D\u0442\u043E \u0442\u0430\u043A\u0436\u0435 \u043D\u043E\u0432\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443, \u0431\u0435\u0437 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043D\u043E\u0432\u044B\u0445 \u0443\u0447\u0435\u0442\u043D\u044B\u0445 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u0438 \u043F\u0430\u0440\u043E\u043B\u0435\u0439 \u043D\u0430 \u043A\u0430\u0436\u0434\u043E\u043C \u0441\u0430\u0439\u0442\u0435.",
  digital_asset: {
    title: "\u0414\u043E\u043C \u0434\u043B\u044F \u0432\u0430\u0448\u0438\u0445 \u0446\u0438\u0444\u0440\u043E\u0432\u044B\u0445 \u0430\u043A\u0442\u0438\u0432\u043E\u0432",
    description: "\u041A\u043E\u0448\u0435\u043B\u044C\u043A\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0434\u043B\u044F \u043E\u0442\u043F\u0440\u0430\u0432\u043A\u0438, \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F, \u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0438 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0446\u0438\u0444\u0440\u043E\u0432\u044B\u0445 \u0430\u043A\u0442\u0438\u0432\u043E\u0432, \u0442\u0430\u043A\u0438\u0445 \u043A\u0430\u043A Ethereum \u0438 NFT."
  },
  login: {
    title: "\u041D\u043E\u0432\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u0432\u0445\u043E\u0434\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0443",
    description: "\u0412\u043C\u0435\u0441\u0442\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043D\u043E\u0432\u044B\u0445 \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u043E\u0432 \u0438 \u043F\u0430\u0440\u043E\u043B\u0435\u0439 \u043D\u0430 \u043A\u0430\u0436\u0434\u043E\u043C \u0441\u0430\u0439\u0442\u0435, \u043F\u0440\u043E\u0441\u0442\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A."
  },
  get: {
    label: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
  },
  learn_more: {
    label: "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435"
  }
};
var connect10 = {
  label: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
  title: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
  new_to_ethereum: {
    description: "\u0412\u043F\u0435\u0440\u0432\u044B\u0435 \u0441\u0442\u043E\u043B\u043A\u043D\u0443\u043B\u0438\u0441\u044C \u0441 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430\u043C\u0438 Ethereum?",
    learn_more: {
      label: "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435"
    }
  },
  learn_more: {
    label: "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435"
  },
  recent: "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435",
  status: {
    opening: "\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0435\u0442\u0441\u044F %{wallet}...",
    not_installed: "%{wallet} \u043D\u0435 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D",
    not_available: "%{wallet} \u043D\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D",
    confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0438"
  },
  secondary_action: {
    get: {
      description: "\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 %{wallet}?",
      label: "\u041F\u041E\u041B\u0423\u0427\u0418\u0422\u042C"
    },
    install: {
      label: "\u0423\u0421\u0422\u0410\u041D\u041E\u0412\u0418\u0422\u042C"
    },
    retry: {
      label: "\u041F\u041E\u0412\u0422\u041E\u0420\u0418\u0422\u042C"
    }
  },
  walletconnect: {
    description: {
      full: "\u041D\u0443\u0436\u0435\u043D \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043C\u043E\u0434\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u043A\u043D\u043E WalletConnect?",
      compact: "\u041D\u0443\u0436\u0435\u043D \u043C\u043E\u0434\u0430\u043B\u044C\u043D\u044B\u0439 \u043E\u043A\u043D\u043E WalletConnect?"
    },
    open: {
      label: "\u041E\u0422\u041A\u0420\u042B\u0422\u042C"
    }
  }
};
var connect_scan10 = {
  title: "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E %{wallet}",
  fallback_title: "\u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0430"
};
var connector_group10 = {
  recommended: "\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C\u044B\u0435",
  other: "\u0414\u0440\u0443\u0433\u0438\u0435",
  popular: "\u041F\u043E\u043F\u0443\u043B\u044F\u0440\u043D\u044B\u0435",
  more: "\u0411\u043E\u043B\u044C\u0448\u0435",
  others: "\u0414\u0440\u0443\u0433\u0438\u0435"
};
var get10 = {
  title: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
  action: {
    label: "\u041F\u041E\u041B\u0423\u0427\u0418\u0422\u042C"
  },
  mobile: {
    description: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
  },
  extension: {
    description: "\u0420\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430"
  },
  mobile_and_extension: {
    description: "\u041C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435"
  },
  looking_for: {
    title: "\u041D\u0435 \u0442\u043E, \u0447\u0442\u043E \u0432\u044B \u0438\u0449\u0435\u0442\u0435?",
    mobile: {
      description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u043C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430."
    },
    desktop: {
      compact_description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u043C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
      wide_description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0441\u043B\u0435\u0432\u0430, \u0447\u0442\u043E\u0431\u044B \u043D\u0430\u0447\u0430\u0442\u044C \u0440\u0430\u0431\u043E\u0442\u0443 \u0441 \u0434\u0440\u0443\u0433\u0438\u043C \u043F\u0440\u043E\u0432\u0430\u0439\u0434\u0435\u0440\u043E\u043C \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430."
    }
  }
};
var get_options10 = {
  title: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0441 %{wallet}",
  short_title: "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C %{wallet}",
  mobile: {
    title: "%{wallet} \u0434\u043B\u044F \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0445",
    description: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u043C\u043E\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0434\u043B\u044F \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u044F \u043C\u0438\u0440\u0430 Ethereum.",
    download: {
      label: "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435"
    }
  },
  extension: {
    title: "%{wallet} \u0434\u043B\u044F %{browser}",
    description: "\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443 \u043F\u0440\u044F\u043C\u043E \u0438\u0437 \u0432\u0430\u0448\u0435\u0433\u043E \u043B\u044E\u0431\u0438\u043C\u043E\u0433\u043E \u0432\u0435\u0431-\u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430.",
    download: {
      label: "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 %{browser}"
    }
  }
};
var get_mobile10 = {
  title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C %{wallet}",
  description: "\u041E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u043D\u0430 \u0441\u0432\u043E\u0435\u043C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435 \u0434\u043B\u044F \u0441\u043A\u0430\u0447\u0438\u0432\u0430\u043D\u0438\u044F \u043D\u0430 iOS \u0438\u043B\u0438 Android",
  continue: {
    label: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C"
  }
};
var get_instructions10 = {
  mobile: {
    connect: {
      label: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C"
    },
    learn_more: {
      label: "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435"
    }
  },
  extension: {
    refresh: {
      label: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C"
    },
    learn_more: {
      label: "\u0423\u0437\u043D\u0430\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435"
    }
  }
};
var chains10 = {
  title: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0441\u0435\u0442\u0438",
  wrong_network: "\u041E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u0430 \u043D\u0435\u0432\u0435\u0440\u043D\u0430\u044F \u0441\u0435\u0442\u044C, \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u0441\u044C \u0438\u043B\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u0441\u044C \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F.",
  confirm: "\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0432 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0435",
  switching_not_supported: "\u0412\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0441\u0435\u0442\u0435\u0439 \u0441 %{appName}. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0441\u0435\u0442\u0438 \u0438\u0437 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
  switching_not_supported_fallback: "\u0412\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0441\u0435\u0442\u0435\u0439 \u0438\u0437 \u044D\u0442\u043E\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0441\u0435\u0442\u0438 \u0438\u0437 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
  disconnect: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C",
  connected: "\u041F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E"
};
var profile10 = {
  disconnect: {
    label: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C"
  },
  copy_address: {
    label: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441",
    copied: "\u0421\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u043E!"
  },
  explorer: {
    label: "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u0432 \u044D\u043A\u0441\u043F\u043B\u043E\u0440\u0435\u0440\u0435"
  },
  transactions: {
    description: "%{appName} \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0437\u0434\u0435\u0441\u044C...",
    description_fallback: "\u0412\u0430\u0448\u0438 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u0437\u0434\u0435\u0441\u044C...",
    recent: {
      title: "\u041D\u0435\u0434\u0430\u0432\u043D\u0438\u0435 \u0442\u0440\u0430\u043D\u0437\u0430\u043A\u0446\u0438\u0438"
    },
    clear: {
      label: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C \u0432\u0441\u0435"
    }
  }
};
var wallet_connectors10 = {
  argent: {
    qr_code: {
      step1: {
        description: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 Argent \u043D\u0430 \u0434\u043E\u043C\u0430\u0448\u043D\u0438\u0439 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Argent"
      },
      step2: {
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438 \u0438\u043C\u044F \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0421\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C QR"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A Bifrost \u043D\u0430 \u0432\u0430\u0448 \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Bifrost Wallet"
      },
      step2: {
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0432\u0430\u0448\u0443 \u0444\u0440\u0430\u0437\u0443 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C Bitget Wallet \u043D\u0430 \u0432\u0430\u0448 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Bitget Wallet"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"
      }
    },
    extension: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Bitget Wallet \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Bitget Wallet"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0434\u0451\u0436\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C Bitski \u043A \u0432\u0430\u0448\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Bitski"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E \u043A\u0430\u043A \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C Coin98 Wallet \u043D\u0430 \u0432\u0430\u0448 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Coin98 Wallet"
      },
      step2: {
        description: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043B\u0435\u0433\u043A\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u043D\u0430\u0448\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u044E \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0433\u043E \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043B\u044F \u0432\u0430\u0441 \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0432 \u0432\u0435\u0440\u0445\u043D\u0435\u043C \u043F\u0440\u0430\u0432\u043E\u043C \u0443\u0433\u043B\u0443 \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0438 \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u0435 Coin98 Wallet \u0434\u043B\u044F \u0443\u0434\u043E\u0431\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Coin98 Wallet"
      },
      step2: {
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E \u043A\u0430\u043A \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u041A\u043E\u0448\u0435\u043B\u0435\u043A Coin98, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C Coinbase Wallet \u043D\u0430 \u0432\u0430\u0448 \u044D\u043A\u0440\u0430\u043D \u043D\u0430\u0447\u0430\u043B\u0430 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Coinbase Wallet"
      },
      step2: {
        description: "\u0412\u044B \u043B\u0435\u0433\u043A\u043E \u043C\u043E\u0436\u0435\u0442\u0435 \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u0444\u0443\u043D\u043A\u0446\u0438\u044E \u043E\u0431\u043B\u0430\u0447\u043D\u043E\u0433\u043E \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0433\u043E \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"
      }
    },
    extension: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Coinbase Wallet \u043D\u0430 \u0432\u0430\u0448\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Coinbase Wallet"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C Core \u043D\u0430 \u0432\u0430\u0448 \u044D\u043A\u0440\u0430\u043D \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u0434\u043B\u044F \u0443\u0441\u043A\u043E\u0440\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Core"
      },
      step2: {
        description: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043B\u0435\u0433\u043A\u043E \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044F \u043D\u0430\u0448\u0443 \u0444\u0443\u043D\u043A\u0446\u0438\u044E \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0433\u043E \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435, \u0447\u0442\u043E\u0431\u044B \u0432\u044B \u043C\u043E\u0433\u043B\u0438 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Core \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Core"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0432\u0430\u0448\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C FoxWallet \u043D\u0430 \u0432\u0430\u0448 \u044D\u043A\u0440\u0430\u043D \u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u044D\u043A\u0440\u0430\u043D\u0430 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 FoxWallet"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0435 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C Frontier Wallet \u043D\u0430 \u044D\u043A\u0440\u0430\u043D \u0432\u0430\u0448\u0435\u0433\u043E \u0441\u043C\u0430\u0440\u0442\u0444\u043E\u043D\u0430 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430.",
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Frontier Wallet"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0435 \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430.",
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"
      }
    },
    extension: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A Frontier \u043A \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 Frontier"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0441\u0432\u043E\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 imToken",
        description: "\u041F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 imToken \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0438\u043A\u043E\u043D\u043A\u0443 \u0441\u043A\u0430\u043D\u0435\u0440\u0430 \u0432 \u0432\u0435\u0440\u0445\u043D\u0435\u043C \u043F\u0440\u0430\u0432\u043E\u043C \u0443\u0433\u043B\u0443",
        description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u041D\u043E\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435, \u0437\u0430\u0442\u0435\u043C \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 MetaMask",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C MetaMask \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u043A\u043E\u043F\u0438\u044E \u0441\u0432\u043E\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0434\u0435\u0436\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C \u0431\u044B \u0442\u043E \u043D\u0438 \u0431\u044B\u043B\u043E."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430."
      }
    },
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 MetaMask",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C MetaMask \u043D\u0430 \u0432\u0430\u0448\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u0449\u0435\u043B\u043A\u043D\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 OKX",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A OKX \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430."
      }
    },
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 OKX",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C OKX Wallet \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Omni",
        description: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 Omni \u043D\u0430 \u0441\u0432\u043E\u0439 \u0434\u043E\u043C\u0430\u0448\u043D\u0438\u0439 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0438\u043A\u043E\u043D\u043A\u0443 QR \u0438 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435",
        description: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0438\u043A\u043E\u043D\u043A\u0443 QR \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0434\u043E\u043C\u0430\u0448\u043D\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0435, \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0434 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0443, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C\u0441\u044F."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 TokenPocket",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C TokenPocket \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0434\u043E\u043C\u0430\u0448\u043D\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0435 \u0434\u043B\u044F \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u043F\u0440\u0438 \u043F\u043E\u043C\u043E\u0449\u0438 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0438\u043C \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u043A\u043E\u0434\u043E\u043C \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u043F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0430 \u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0434\u043B\u044F \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430."
      }
    },
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 TokenPocket",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C TokenPocket \u043D\u0430 \u0432\u0430\u0448\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E \u043A\u0430\u043A \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Trust Wallet",
        description: "\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u0435 Trust Wallet \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0434\u043E\u043C\u0430\u0448\u043D\u0435\u043C \u044D\u043A\u0440\u0430\u043D\u0435 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 WalletConnect \u0432 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u0445",
        description: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u041D\u043E\u0432\u043E\u0435 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u0438\u0435, \u0437\u0430\u0442\u0435\u043C \u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 QR-\u043A\u043E\u0434 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435."
      }
    },
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Trust Wallet",
        description: "\u041A\u043B\u0438\u043A\u043D\u0438\u0442\u0435 \u0432 \u043F\u0440\u0430\u0432\u043E\u043C \u0432\u0435\u0440\u0445\u043D\u0435\u043C \u0443\u0433\u043B\u0443 \u0432\u0430\u0448\u0435\u0433\u043E \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430 \u0438 \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u0435 Trust Wallet \u0434\u043B\u044F \u043B\u0435\u0433\u043A\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 Trust Wallet, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Uniswap",
        description: "\u0414\u043E\u0431\u0430\u0432\u044C\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A Uniswap \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u044B\u0439 \u044D\u043A\u0440\u0430\u043D \u0434\u043B\u044F \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043D\u043E\u0432\u044B\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0438\u043A\u043E\u043D\u043A\u0443 QR \u0438 \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435",
        description: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0438\u043A\u043E\u043D\u043A\u0443 QR \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435, \u043E\u0442\u0441\u043A\u0430\u043D\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0434 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Zerion",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C Zerion \u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u043C \u044D\u043A\u0440\u0430\u043D\u0435 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0432\u0430\u043C \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u043E \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A."
      }
    },
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Zerion",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C Zerion \u043A \u0432\u0430\u0448\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u044F\u0441\u044C \u0441\u0432\u043E\u0438\u043C \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u043F\u0430\u0440\u043E\u043B\u0435\u043C \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "\u041E\u0442\u043A\u0440\u043E\u0439\u0442\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435 Rainbow",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u043E\u043C\u0435\u0441\u0442\u0438\u0442\u044C Rainbow \u043D\u0430 \u0432\u0430\u0448 \u044D\u043A\u0440\u0430\u043D \u0433\u043B\u0430\u0432\u043D\u043E\u0433\u043E \u043C\u0435\u043D\u044E \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043B\u0435\u0433\u043A\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043D\u0430\u0448\u0435\u0439 \u0444\u0443\u043D\u043A\u0446\u0438\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u043E\u0433\u043E \u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0435."
      },
      step3: {
        title: "\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043A\u043D\u043E\u043F\u043A\u0443 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u044F\u0432\u0438\u0442\u0441\u044F \u0437\u0430\u043F\u0440\u043E\u0441 \u043D\u0430 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Enkrypt Wallet \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Enkrypt Wallet"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Frame \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443.",
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 Frame \u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435"
      },
      step2: {
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E.",
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A"
      },
      step3: {
        description: "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E \u043A\u0430\u043A \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435.",
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 OneKey Wallet",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C OneKey Wallet \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Phantom",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Phantom \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0443\u0434\u043E\u0431\u043D\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E \u043A\u0430\u043A \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Rabby",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Rabby \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C \u0431\u044B \u0442\u043E \u043D\u0438 \u0431\u044B\u043B\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C SafeHeron \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0432\u0430\u0448 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Taho",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Taho \u043D\u0430 \u0432\u0430\u0448\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\u043C \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 Talisman",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C Talisman \u043D\u0430 \u0432\u0430\u0448\u0435\u0439 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u0443\u0439\u0442\u0435 \u043A\u043E\u0448\u0435\u043B\u0435\u043A Ethereum",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0432\u0430\u0448\u0435\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u0435 \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 XDEFI",
        description: "\u041C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u0437\u0430\u043A\u0440\u0435\u043F\u0438\u0442\u044C XDEFI Wallet \u043D\u0430 \u043F\u0430\u043D\u0435\u043B\u0438 \u0437\u0430\u0434\u0430\u0447 \u0434\u043B\u044F \u0431\u043E\u043B\u0435\u0435 \u0431\u044B\u0441\u0442\u0440\u043E\u0433\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0443."
      },
      step2: {
        title: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u043B\u0438 \u0418\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0448\u0435\u043B\u0435\u043A",
        description: "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u0443\u044E \u043A\u043E\u043F\u0438\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043E\u0448\u0435\u043B\u044C\u043A\u0430 \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u043C\u0435\u0442\u043E\u0434\u0430. \u041D\u0438\u043A\u043E\u0433\u0434\u0430 \u043D\u0435 \u0434\u0435\u043B\u0438\u0442\u0435\u0441\u044C \u0441\u0432\u043E\u0435\u0439 \u0441\u0435\u043A\u0440\u0435\u0442\u043D\u043E\u0439 \u0444\u0440\u0430\u0437\u043E\u0439 \u0441 \u043A\u0435\u043C-\u043B\u0438\u0431\u043E."
      },
      step3: {
        title: "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u0435 \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440",
        description: "\u041F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u0432\u044B \u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u0435 \u0441\u0432\u043E\u0439 \u043A\u043E\u0448\u0435\u043B\u0435\u043A, \u043D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0438\u0436\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u0435."
      }
    }
  }
};
var ru_RU_default = {
  connect_wallet: connect_wallet10,
  intro: intro10,
  connect: connect10,
  connect_scan: connect_scan10,
  connector_group: connector_group10,
  get: get10,
  get_options: get_options10,
  get_mobile: get_mobile10,
  get_instructions: get_instructions10,
  chains: chains10,
  profile: profile10,
  wallet_connectors: wallet_connectors10
};

// src/locales/th_TH.json
var connect_wallet11 = {
  label: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
};
var intro11 = {
  title: "\u0E2D\u0E30\u0E44\u0E23\u0E04\u0E37\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19?",
  description: "\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E43\u0E0A\u0E49\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E48\u0E07, \u0E23\u0E31\u0E1A, \u0E40\u0E01\u0E47\u0E1A, \u0E41\u0E25\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25 \u0E21\u0E31\u0E19\u0E22\u0E31\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E27\u0E34\u0E18\u0E35\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A, \u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E08\u0E33\u0E40\u0E1B\u0E47\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E41\u0E25\u0E30\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E17\u0E38\u0E01\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C.",
  digital_asset: {
    title: "\u0E1A\u0E49\u0E32\u0E19\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E2A\u0E34\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
    description: "\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E16\u0E39\u0E01\u0E43\u0E0A\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E48\u0E07, \u0E23\u0E31\u0E1A, \u0E40\u0E01\u0E47\u0E1A, \u0E41\u0E2A\u0E14\u0E07\u0E2A\u0E34\u0E19\u0E17\u0E23\u0E31\u0E1E\u0E22\u0E4C\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25 \u0E40\u0E0A\u0E48\u0E19 Ethereum \u0E41\u0E25\u0E30 NFTs."
  },
  login: {
    title: "\u0E27\u0E34\u0E18\u0E35\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E30\u0E1A\u0E1A",
    description: "\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48\u0E08\u0E30\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1A\u0E31\u0E0D\u0E0A\u0E35\u0E41\u0E25\u0E30\u0E23\u0E2B\u0E31\u0E2A\u0E1C\u0E48\u0E32\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E43\u0E19\u0E17\u0E38\u0E01\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C, \u0E41\u0E04\u0E48\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13."
  },
  get: {
    label: "\u0E23\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
  },
  learn_more: {
    label: "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21"
  }
};
var connect11 = {
  label: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
  title: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
  new_to_ethereum: {
    description: "\u0E43\u0E2B\u0E21\u0E48\u0E01\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32 Ethereum \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
    learn_more: {
      label: "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21"
    }
  },
  learn_more: {
    label: "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21"
  },
  recent: "\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14",
  status: {
    opening: "\u0E01\u0E33\u0E25\u0E31\u0E07\u0E40\u0E1B\u0E34\u0E14 %{wallet}...",
    not_installed: "%{wallet} \u0E44\u0E21\u0E48\u0E44\u0E14\u0E49\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07",
    not_available: "%{wallet} \u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E43\u0E0A\u0E49\u0E44\u0E14\u0E49",
    confirm: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
  },
  secondary_action: {
    get: {
      description: "\u0E44\u0E21\u0E48\u0E21\u0E35 %{wallet}?",
      label: "\u0E23\u0E31\u0E1A"
    },
    install: {
      label: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07"
    },
    retry: {
      label: "\u0E25\u0E2D\u0E07\u0E43\u0E2B\u0E21\u0E48"
    }
  },
  walletconnect: {
    description: {
      full: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23 modal \u0E2D\u0E22\u0E48\u0E32\u0E07\u0E40\u0E1B\u0E47\u0E19\u0E17\u0E32\u0E07\u0E01\u0E32\u0E23\u0E08\u0E32\u0E01 WalletConnect \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
      compact: "\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23 modal \u0E08\u0E32\u0E01 WalletConnect \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?"
    },
    open: {
      label: "\u0E40\u0E1B\u0E34\u0E14"
    }
  }
};
var connect_scan11 = {
  title: "\u0E2A\u0E41\u0E01\u0E19\u0E14\u0E49\u0E27\u0E22 %{wallet}",
  fallback_title: "\u0E2A\u0E41\u0E01\u0E19\u0E14\u0E49\u0E27\u0E22\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
};
var connector_group11 = {
  recommended: "\u0E41\u0E19\u0E30\u0E19\u0E33",
  other: "\u0E2D\u0E37\u0E48\u0E19 \u0E46",
  popular: "\u0E22\u0E2D\u0E14\u0E19\u0E34\u0E22\u0E21",
  more: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21",
  others: "\u0E2D\u0E37\u0E48\u0E19 \u0E46"
};
var get11 = {
  title: "\u0E23\u0E31\u0E1A Wallet",
  action: {
    label: "\u0E23\u0E31\u0E1A"
  },
  mobile: {
    description: "Wallet \u0E1A\u0E19\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D"
  },
  extension: {
    description: "\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22\u0E1A\u0E23\u0E32\u0E27\u0E40\u0E0B\u0E2D\u0E23\u0E4C"
  },
  mobile_and_extension: {
    description: "\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D\u0E41\u0E25\u0E30\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
  },
  looking_for: {
    title: "\u0E44\u0E21\u0E48\u0E43\u0E0A\u0E48\u0E2A\u0E34\u0E48\u0E07\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E01\u0E33\u0E25\u0E31\u0E07\u0E2B\u0E32\u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E21\u0E48?",
    mobile: {
      description: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07\u0E01\u0E31\u0E19"
    },
    desktop: {
      compact_description: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07\u0E01\u0E31\u0E19",
      wide_description: "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E17\u0E32\u0E07\u0E0B\u0E49\u0E32\u0E22\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E41\u0E15\u0E01\u0E15\u0E48\u0E32\u0E07\u0E01\u0E31\u0E19"
    }
  }
};
var get_options11 = {
  title: "\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E01\u0E31\u0E1A %{wallet}",
  short_title: "\u0E23\u0E31\u0E1A %{wallet}",
  mobile: {
    title: "%{wallet} \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D",
    description: "\u0E43\u0E0A\u0E49\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E23\u0E30\u0E1A\u0E1A\u0E21\u0E37\u0E2D\u0E16\u0E37\u0E2D\u0E43\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E27\u0E08\u0E42\u0E25\u0E01\u0E02\u0E2D\u0E07 Ethereum.",
    download: {
      label: "\u0E23\u0E31\u0E1A\u0E41\u0E2D\u0E1B"
    }
  },
  extension: {
    title: "%{wallet} \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A %{browser}",
    description: "\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E15\u0E23\u0E07\u0E08\u0E32\u0E01\u0E1A\u0E23\u0E32\u0E27\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E0A\u0E37\u0E48\u0E19\u0E0A\u0E2D\u0E1A.",
    download: {
      label: "\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E44\u0E1B\u0E22\u0E31\u0E07 %{browser}"
    }
  }
};
var get_mobile11 = {
  title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07 %{wallet}",
  description: "\u0E2A\u0E41\u0E01\u0E19\u0E14\u0E49\u0E27\u0E22\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E1A\u0E19 iOS \u0E2B\u0E23\u0E37\u0E2D Android",
  continue: {
    label: "\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D"
  }
};
var get_instructions11 = {
  mobile: {
    connect: {
      label: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
    },
    learn_more: {
      label: "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21"
    }
  },
  extension: {
    refresh: {
      label: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A"
    },
    learn_more: {
      label: "\u0E40\u0E23\u0E35\u0E22\u0E19\u0E23\u0E39\u0E49\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21"
    }
  }
};
var chains11 = {
  title: "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22",
  wrong_network: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E1E\u0E1A\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E2A\u0E25\u0E31\u0E1A\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23\u0E15\u0E48\u0E2D.",
  confirm: "\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E43\u0E19 Wallet",
  switching_not_supported: "\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E08\u0E32\u0E01 %{appName}\u0E25\u0E2D\u0E07\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E08\u0E32\u0E01\u0E20\u0E32\u0E22\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E17\u0E19",
  switching_not_supported_fallback: "\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E21\u0E48\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E01\u0E32\u0E23\u0E2A\u0E25\u0E31\u0E1A\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E08\u0E32\u0E01\u0E41\u0E2D\u0E1B\u0E19\u0E35\u0E49 \u0E25\u0E2D\u0E07\u0E2A\u0E25\u0E31\u0E1A\u0E40\u0E04\u0E23\u0E37\u0E2D\u0E02\u0E48\u0E32\u0E22\u0E08\u0E32\u0E01\u0E20\u0E32\u0E22\u0E43\u0E19\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E17\u0E19",
  disconnect: "\u0E15\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D",
  connected: "\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E41\u0E25\u0E49\u0E27"
};
var profile11 = {
  disconnect: {
    label: "\u0E15\u0E31\u0E14\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
  },
  copy_address: {
    label: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48",
    copied: "\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27!"
  },
  explorer: {
    label: "\u0E14\u0E39\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E15\u0E34\u0E21\u0E1A\u0E19 explorer"
  },
  transactions: {
    description: "%{appName} \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0E\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48...",
    description_fallback: "\u0E01\u0E32\u0E23\u0E17\u0E33\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0E\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48...",
    recent: {
      title: "\u0E18\u0E38\u0E23\u0E01\u0E23\u0E23\u0E21\u0E25\u0E48\u0E32\u0E2A\u0E38\u0E14"
    },
    clear: {
      label: "\u0E25\u0E1A\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14"
    }
  }
};
var wallet_connectors11 = {
  argent: {
    qr_code: {
      step1: {
        description: "\u0E27\u0E32\u0E07 Argent \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B Argent"
      },
      step2: {
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E41\u0E25\u0E30\u0E0A\u0E37\u0E48\u0E2D\u0E1C\u0E39\u0E49\u0E43\u0E0A\u0E49\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19 \u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E04\u0E38\u0E48\u0E21\u0E38\u0E48\u0E07\u0E2A\u0E41\u0E01\u0E19 QR"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E27\u0E32\u0E07 Bifrost Wallet \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1E\u0E2F Bifrost Wallet"
      },
      step2: {
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E14\u0E49\u0E27\u0E22 recovery phrase \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27\u0E22\u0E34\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E27\u0E32\u0E07 Bitget Wallet \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E01\u0E32\u0E23\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E17\u0E35\u0E48\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19.",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1E Bitget Wallet"
      },
      step2: {
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E19\u0E2D\u0E19\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23\u0E40\u0E1B\u0E47\u0E19\u0E2D\u0E31\u0E19\u0E02\u0E32\u0E14.",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19 \u0E08\u0E30\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E02\u0E36\u0E49\u0E19\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.",
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19"
      }
    },
    extension: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 Bitget Wallet \u0E44\u0E27\u0E49\u0E1A\u0E19\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21 Bitget Wallet"
      },
      step2: {
        description: "\u0E42\u0E1B\u0E23\u0E14\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E43\u0E14\u0E46",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27\u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E17\u0E33\u0E1B\u0E31\u0E01 Bitski \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E44\u0E14\u0E49\u0E42\u0E14\u0E22\u0E44\u0E21\u0E48\u0E15\u0E49\u0E2D\u0E07\u0E23\u0E2D",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Bitski"
      },
      step2: {
        description: "\u0E04\u0E27\u0E23\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E04\u0E33\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E43\u0E04\u0E23\u0E17\u0E23\u0E32\u0E1A",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E27\u0E32\u0E07 Coin98 Wallet \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19.",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1E Coin98 Wallet"
      },
      step2: {
        description: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E46 \u0E14\u0E49\u0E27\u0E22\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E19\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19 \u0E08\u0E30\u0E21\u0E35\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E02\u0E36\u0E49\u0E19\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13.",
        title: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E1B\u0E38\u0E48\u0E21 WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E14\u0E49\u0E32\u0E19\u0E1A\u0E19\u0E02\u0E27\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E1B\u0E31\u0E01 Coin98 Wallet \u0E44\u0E27\u0E49\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22.",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Coin98 Wallet"
      },
      step2: {
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27.",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 Coin98 Wallet \u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22\u0E02\u0E36\u0E49\u0E19\u0E21\u0E32.",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E27\u0E32\u0E07 Coinbase Wallet \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19.",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B Coinbase Wallet"
      },
      step2: {
        description: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E46 \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E01\u0E32\u0E23\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E14\u0E49\u0E27\u0E22\u0E04\u0E25\u0E32\u0E27\u0E14\u0E4C",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E2D\u0E49\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19"
      }
    },
    extension: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E22\u0E31\u0E14 Coinbase Wallet \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Coinbase Wallet"
      },
      step2: {
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23\u0E40\u0E25\u0E22",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E23\u0E35\u0E22\u0E01\u0E14\u0E39\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E43\u0E2B\u0E21\u0E48\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E27\u0E32\u0E07 Core \u0E25\u0E07\u0E2A\u0E19\u0E32\u0E21\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B\u0E40\u0E04\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E21\u0E37\u0E2D\u0E0A\u0E48\u0E27\u0E22\u0E2D\u0E35\u0E40\u0E01\u0E34\u0E23\u0E4C\u0E19"
      },
      step2: {
        description: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E46 \u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E1A\u0E19\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21 WalletConnect"
      }
    },
    extension: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 Core \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Core"
      },
      step2: {
        description: "\u0E42\u0E1B\u0E23\u0E14\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E27\u0E32\u0E07 FoxWallet \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B FoxWallet"
      },
      step2: {
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E17\u0E35\u0E48\u0E08\u0E30\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E08\u0E07\u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E23\u0E39\u0E49",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19 \u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E17\u0E35\u0E48\u0E41\u0E2A\u0E14\u0E07\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E27\u0E32\u0E07 Frontier Wallet \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B Frontier Wallet"
      },
      step2: {
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C"
      },
      step3: {
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19"
      }
    },
    extension: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01\u0E2B\u0E21\u0E38\u0E14 Frontier Wallet \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21 Frontier Wallet"
      },
      step2: {
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1E imToken",
        description: "\u0E43\u0E2A\u0E48\u0E41\u0E2D\u0E1E imToken \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19."
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E44\u0E2D\u0E04\u0E2D\u0E19\u0E2A\u0E41\u0E01\u0E19\u0E40\u0E19\u0E2D\u0E23\u0E4C\u0E43\u0E19\u0E21\u0E38\u0E21\u0E1A\u0E19\u0E02\u0E27\u0E32",
        description: "\u0E40\u0E25\u0E37\u0E2D\u0E01 New Connection, \u0E41\u0E25\u0E49\u0E27\u0E2A\u0E41\u0E01\u0E19 QR code \u0E41\u0E25\u0E30\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E23\u0E31\u0E1A\u0E23\u0E2D\u0E07\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B MetaMask",
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E27\u0E32\u0E07 MetaMask \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet",
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E27\u0E48\u0E32\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19",
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E01\u0E32\u0E23\u0E2A\u0E41\u0E01\u0E19, \u0E08\u0E30\u0E1B\u0E23\u0E32\u0E01\u0E0F\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    },
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 MetaMask",
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 MetaMask \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E19\u0E48\u0E19\u0E2D\u0E19\u0E43\u0E2B\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23\u0E40\u0E25\u0E22"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1E OKX Wallet",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E27\u0E32\u0E07 OKX Wallet \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet",
        description: "\u0E08\u0E07\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E04\u0E19\u0E2D\u0E37\u0E48\u0E19"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19",
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19 \u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    },
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21 OKX Wallet",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E22\u0E36\u0E14 OKX Wallet \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet",
        description: "\u0E42\u0E1B\u0E23\u0E14\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E43\u0E04\u0E23\u0E17\u0E23\u0E32\u0E1A"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B Omni",
        description: "\u0E40\u0E1E\u0E34\u0E48\u0E21 Omni \u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E41\u0E23\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C",
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E44\u0E2D\u0E04\u0E2D\u0E19 QR \u0E41\u0E25\u0E49\u0E27\u0E2A\u0E41\u0E01\u0E19",
        description: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E44\u0E2D\u0E04\u0E2D\u0E19 QR \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13, \u0E2A\u0E41\u0E01\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E25\u0E30\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B TokenPocket",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E27\u0E32\u0E07 TokenPocket \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E19\u0E49\u0E32\u0E41\u0E23\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19."
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E27\u0E48\u0E32\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E17\u0E23\u0E32\u0E1A\u0E43\u0E19\u0E17\u0E32\u0E07\u0E43\u0E14\u0E17\u0E32\u0E07\u0E2B\u0E19\u0E36\u0E48\u0E07."
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19",
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E08\u0E30\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E23\u0E35\u0E22\u0E01\u0E43\u0E2B\u0E49\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E31\u0E1A\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    },
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 TokenPocket",
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 TokenPocket \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E17\u0E33\u0E01\u0E32\u0E23\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E14\u0E49\u0E27\u0E22\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E1A\u0E23\u0E32\u0E27\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E1A\u0E23\u0E32\u0E27\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1E Trust Wallet",
        description: "\u0E27\u0E32\u0E07 Trust Wallet \u0E17\u0E35\u0E48\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet",
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07 wallet \u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 wallet \u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30 WalletConnect \u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32",
        description: "\u0E40\u0E25\u0E37\u0E2D\u0E01 New Connection \u0E08\u0E32\u0E01\u0E19\u0E31\u0E49\u0E19\u0E2A\u0E41\u0E01\u0E19 QR code \u0E41\u0E25\u0E30\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E41\u0E08\u0E49\u0E07\u0E40\u0E15\u0E37\u0E2D\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
      }
    },
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Trust Wallet",
        description: "\u0E04\u0E25\u0E34\u0E01\u0E17\u0E35\u0E48\u0E21\u0E38\u0E21\u0E1A\u0E19\u0E02\u0E27\u0E32\u0E02\u0E2D\u0E07\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E30\u0E1B\u0E31\u0E01 Trust Wallet \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 wallet",
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07 wallet \u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 wallet \u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 Trust Wallet \u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22\u0E02\u0E36\u0E49\u0E19\u0E21\u0E32"
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B Uniswap",
        description: "\u0E40\u0E1E\u0E34\u0E48\u0E21 Uniswap Wallet \u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet",
        description: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E43\u0E2B\u0E21\u0E48\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E17\u0E35\u0E48\u0E21\u0E35\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E44\u0E2D\u0E04\u0E2D\u0E19 QR \u0E41\u0E25\u0E30\u0E2A\u0E41\u0E01\u0E19",
        description: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E44\u0E2D\u0E04\u0E2D\u0E19 QR \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13 \u0E2A\u0E41\u0E01\u0E19\u0E23\u0E2B\u0E31\u0E2A\u0E41\u0E25\u0E30\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D"
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B Zerion",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E27\u0E32\u0E07 Zerion \u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet",
        description: "\u0E25\u0E2D\u0E07\u0E17\u0E33\u0E2A\u0E33\u0E40\u0E19\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25 wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E27\u0E49\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E2D\u0E37\u0E48\u0E19"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E17\u0E35\u0E48\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19",
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E2A\u0E41\u0E01\u0E19 \u0E08\u0E30\u0E21\u0E35\u0E2B\u0E19\u0E49\u0E32\u0E15\u0E48\u0E32\u0E07\u0E41\u0E2A\u0E14\u0E07\u0E04\u0E33\u0E2A\u0E31\u0E48\u0E07\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    },
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Zerion",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E15\u0E34\u0E14 Zerion \u0E1A\u0E19\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E43\u0E04\u0E23\u0E17\u0E23\u0E32\u0E1A\u0E04\u0E23\u0E31\u0E1A"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "\u0E40\u0E1B\u0E34\u0E14\u0E41\u0E2D\u0E1B Rainbow",
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E27\u0E32\u0E07 Rainbow \u0E2D\u0E22\u0E39\u0E48\u0E1A\u0E19\u0E2B\u0E19\u0E49\u0E32\u0E08\u0E2D\u0E2B\u0E25\u0E31\u0E01\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E31\u0E1A\u0E1C\u0E34\u0E14\u0E0A\u0E2D\u0E1A\u0E08\u0E32\u0E01\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C",
        description: "\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E46 \u0E14\u0E49\u0E27\u0E22\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E19\u0E42\u0E17\u0E23\u0E28\u0E31\u0E1E\u0E17\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      },
      step3: {
        title: "\u0E41\u0E15\u0E30\u0E1B\u0E38\u0E48\u0E21\u0E2A\u0E41\u0E01\u0E19",
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E2A\u0E41\u0E01\u0E19\u0E41\u0E25\u0E49\u0E27 \u0E08\u0E30\u0E41\u0E2A\u0E14\u0E07\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E02\u0E2D\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 Enkrypt Wallet \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E17\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Enkrypt Wallet"
      },
      step2: {
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2B\u0E49\u0E32\u0E21\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A browser \u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E36\u0E49\u0E19 extension",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A browser \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E2B\u0E21\u0E38\u0E19 Frame \u0E44\u0E27\u0E49\u0E1A\u0E19 taskbar \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07 wallet \u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19",
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07 Frame \u0E41\u0E25\u0E30 extension \u0E17\u0E35\u0E48\u0E40\u0E1B\u0E47\u0E19\u0E04\u0E39\u0E48"
      },
      step2: {
        description: "\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E27\u0E48\u0E32\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07 wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23",
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32 Wallet"
      },
      step3: {
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32 wallet \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A browser \u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E02\u0E36\u0E49\u0E19 extension",
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A browser \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21 OneKey Wallet",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E01\u0E32\u0E23\u0E1B\u0E31\u0E01 OneKey Wallet \u0E44\u0E27\u0E49\u0E1A\u0E19\u0E41\u0E17\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E2D\u0E22\u0E48\u0E32\u0E25\u0E37\u0E21\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E43\u0E04\u0E23"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21"
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21 Phantom",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E01\u0E32\u0E23\u0E1B\u0E31\u0E01 Phantom \u0E44\u0E27\u0E49\u0E1A\u0E19\u0E41\u0E17\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E44\u0E14\u0E49\u0E07\u0E48\u0E32\u0E22\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E43\u0E14 \u0E46"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E40\u0E23\u0E35\u0E22\u0E1A\u0E23\u0E49\u0E2D\u0E22\u0E41\u0E25\u0E49\u0E27, \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Rabby",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 Rabby \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E23\u0E27\u0E14\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19."
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E02\u0E49\u0E2D\u0E04\u0E27\u0E32\u0E21\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E1A\u0E38\u0E04\u0E04\u0E25\u0E2D\u0E37\u0E48\u0E19"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Core",
        description: "\u0E40\u0E23\u0E32\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 Safeheron \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E2D\u0E22\u0E48\u0E32\u0E25\u0E37\u0E21\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E1C\u0E39\u0E49\u0E2D\u0E37\u0E48\u0E19\u0E17\u0E23\u0E32\u0E1A"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Taho",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 Taho \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E42\u0E1B\u0E23\u0E14\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E41\u0E0A\u0E23\u0E4C\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E04\u0E25\u0E31\u0E1A\u0E04\u0E38\u0E13\u0E01\u0E31\u0E1A\u0E1C\u0E39\u0E49\u0E2D\u0E37\u0E48\u0E19"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 Talisman",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E1B\u0E31\u0E01 Talisman \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19 Ethereum",
        description: "\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E27\u0E25\u0E35\u0E01\u0E32\u0E23\u0E01\u0E39\u0E49\u0E04\u0E37\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E43\u0E04\u0E23\u0E17\u0E23\u0E32\u0E1A\u0E40\u0E14\u0E47\u0E14\u0E02\u0E32\u0E14"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22"
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22 XDEFI Wallet",
        description: "\u0E40\u0E23\u0E32\u0E41\u0E19\u0E30\u0E19\u0E33\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E15\u0E23\u0E32 XDEFI Wallet \u0E44\u0E27\u0E49\u0E17\u0E35\u0E48\u0E41\u0E16\u0E1A\u0E07\u0E32\u0E19\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E02\u0E49\u0E32\u0E16\u0E36\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19"
      },
      step2: {
        title: "\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2B\u0E23\u0E37\u0E2D\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19",
        description: "\u0E43\u0E2B\u0E49\u0E41\u0E19\u0E48\u0E43\u0E08\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E44\u0E14\u0E49\u0E2A\u0E33\u0E23\u0E2D\u0E07\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E40\u0E07\u0E34\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E42\u0E14\u0E22\u0E43\u0E0A\u0E49\u0E27\u0E34\u0E18\u0E35\u0E17\u0E35\u0E48\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E2D\u0E22\u0E48\u0E32\u0E40\u0E1B\u0E34\u0E14\u0E40\u0E1C\u0E22\u0E27\u0E25\u0E35\u0E25\u0E31\u0E1A\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E2B\u0E49\u0E43\u0E04\u0E23\u0E17\u0E23\u0E32\u0E1A\u0E40\u0E14\u0E47\u0E14\u0E02\u0E32\u0E14"
      },
      step3: {
        title: "\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13",
        description: "\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E17\u0E35\u0E48\u0E04\u0E38\u0E13\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E23\u0E30\u0E40\u0E1B\u0E4B\u0E32\u0E2A\u0E15\u0E32\u0E07\u0E04\u0E4C\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E41\u0E25\u0E49\u0E27 \u0E04\u0E25\u0E34\u0E01\u0E14\u0E49\u0E32\u0E19\u0E25\u0E48\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E35\u0E40\u0E1F\u0E23\u0E0A\u0E1A\u0E23\u0E32\u0E27\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E25\u0E30\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E40\u0E2A\u0E23\u0E34\u0E21."
      }
    }
  }
};
var th_TH_default = {
  connect_wallet: connect_wallet11,
  intro: intro11,
  connect: connect11,
  connect_scan: connect_scan11,
  connector_group: connector_group11,
  get: get11,
  get_options: get_options11,
  get_mobile: get_mobile11,
  get_instructions: get_instructions11,
  chains: chains11,
  profile: profile11,
  wallet_connectors: wallet_connectors11
};

// src/locales/tr_TR.json
var connect_wallet12 = {
  label: "C\xFCzdan\u0131 Ba\u011Fla"
};
var intro12 = {
  title: "C\xFCzdan nedir?",
  description: "Bir c\xFCzdan, dijital varl\u0131klar\u0131 g\xF6ndermek, almak, saklamak ve g\xF6r\xFCnt\xFClemek i\xE7in kullan\u0131l\u0131r. Ayn\u0131 zamanda her web sitesinde yeni hesaplar ve \u015Fifreler olu\u015Fturman\u0131za gerek kalmadan oturum a\xE7man\u0131n yeni bir yoludur.",
  digital_asset: {
    title: "Dijital Varl\u0131klar\u0131n\u0131z \u0130\xE7in Bir Ev",
    description: "C\xFCzdanlar, Ethereum ve NFT'ler gibi dijital varl\u0131klar\u0131 g\xF6ndermek, almak, depolamak ve g\xF6r\xFCnt\xFClemek i\xE7in kullan\u0131l\u0131r."
  },
  login: {
    title: "Yeni Bir Giri\u015F Yolu",
    description: "Her web sitesinde yeni hesap ve parolalar olu\u015Fturmak yerine, sadece c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flay\u0131n."
  },
  get: {
    label: "Bir C\xFCzdan Edinin"
  },
  learn_more: {
    label: "Daha fazla bilgi edinin"
  }
};
var connect12 = {
  label: "Ba\u011Flan",
  title: "Bir C\xFCzdan\u0131 Ba\u011Fla",
  new_to_ethereum: {
    description: "Ethereum c\xFCzdanlar\u0131na yeni misiniz?",
    learn_more: {
      label: "Daha fazla bilgi edinin"
    }
  },
  learn_more: {
    label: "Daha fazla bilgi edinin"
  },
  recent: "Son",
  status: {
    opening: "%{wallet}a\xE7\u0131l\u0131yor...",
    not_installed: "%{wallet} y\xFCkl\xFC de\u011Fil",
    not_available: "%{wallet} kullan\u0131labilir de\u011Fil",
    confirm: "Ba\u011Flant\u0131y\u0131 eklentide onaylay\u0131n"
  },
  secondary_action: {
    get: {
      description: "%{wallet}yok mu?",
      label: "AL"
    },
    install: {
      label: "Y\xDCKLE"
    },
    retry: {
      label: "YEN\u0130DEN DENE"
    }
  },
  walletconnect: {
    description: {
      full: "Resmi WalletConnect modal\u0131na m\u0131 ihtiyac\u0131n\u0131z var?",
      compact: "WalletConnect modal\u0131na m\u0131 ihtiyac\u0131n\u0131z var?"
    },
    open: {
      label: "A\xC7"
    }
  }
};
var connect_scan12 = {
  title: "%{wallet}ile tarama yap\u0131n",
  fallback_title: "Telefonunuzla tarama yap\u0131n"
};
var connector_group12 = {
  recommended: "Tavsiye Edilen",
  other: "Di\u011Fer",
  popular: "Pop\xFCler",
  more: "Daha Fazla",
  others: "Di\u011Ferleri"
};
var get12 = {
  title: "Bir C\xFCzdan Edinin",
  action: {
    label: "AL"
  },
  mobile: {
    description: "Mobil C\xFCzdan"
  },
  extension: {
    description: "Taray\u0131c\u0131 Eklentisi"
  },
  mobile_and_extension: {
    description: "Mobil C\xFCzdan ve Eklenti"
  },
  looking_for: {
    title: "Arad\u0131\u011F\u0131n\u0131z \u015Fey bu de\u011Fil mi?",
    mobile: {
      description: "Ana ekranda ba\u015Fka bir c\xFCzdan sa\u011Flay\u0131c\u0131s\u0131yla ba\u015Flamak i\xE7in bir c\xFCzdan se\xE7in."
    },
    desktop: {
      compact_description: "Ana ekranda ba\u015Fka bir c\xFCzdan sa\u011Flay\u0131c\u0131s\u0131yla ba\u015Flamak i\xE7in bir c\xFCzdan se\xE7in.",
      wide_description: "Ba\u015Fka bir c\xFCzdan sa\u011Flay\u0131c\u0131s\u0131yla ba\u015Flamak i\xE7in sol tarafta bir c\xFCzdan se\xE7in."
    }
  }
};
var get_options12 = {
  title: "%{wallet}ile ba\u015Flay\u0131n",
  short_title: "%{wallet}Edinin",
  mobile: {
    title: "%{wallet} Mobil \u0130\xE7in",
    description: "Mobil c\xFCzdan\u0131 kullanarak Ethereum d\xFCnyas\u0131n\u0131 ke\u015Ffedin.",
    download: {
      label: "Uygulamay\u0131 al\u0131n"
    }
  },
  extension: {
    title: "%{wallet} i\xE7in %{browser}",
    description: "C\xFCzdan\u0131n\u0131za favori web taray\u0131c\u0131n\u0131zdan do\u011Frudan eri\u015Fin.",
    download: {
      label: "%{browser}'e ekle"
    }
  }
};
var get_mobile12 = {
  title: "%{wallet}'i y\xFCkleyin",
  description: "iOS veya Android'de indirmek i\xE7in telefonunuzla taray\u0131n",
  continue: {
    label: "Devam et"
  }
};
var get_instructions12 = {
  mobile: {
    connect: {
      label: "Ba\u011Flan"
    },
    learn_more: {
      label: "Daha fazla bilgi edinin"
    }
  },
  extension: {
    refresh: {
      label: "Yenile"
    },
    learn_more: {
      label: "Daha fazla bilgi edinin"
    }
  }
};
var chains12 = {
  title: "A\u011Flar\u0131 De\u011Fi\u015Ftir",
  wrong_network: "Yanl\u0131\u015F a\u011F alg\u0131land\u0131, devam etmek i\xE7in ba\u011Flant\u0131y\u0131 kesin veya de\u011Fi\u015Ftirin.",
  confirm: "C\xFCzdan\u0131nda Onayla",
  switching_not_supported: "C\xFCzdan\u0131n\u0131z %{appName}. a\u011Flar\u0131 de\u011Fi\u015Ftirmeyi desteklemiyor. Bunun yerine c\xFCzdan\u0131n\u0131zdan a\u011Flar\u0131 de\u011Fi\u015Ftirmeyi deneyin.",
  switching_not_supported_fallback: "C\xFCzdan\u0131n\u0131z bu uygulamadan a\u011Flar\u0131 de\u011Fi\u015Ftirmeyi desteklemiyor. Bunun yerine c\xFCzdan\u0131n\u0131zdaki a\u011Flar\u0131 de\u011Fi\u015Ftirmeyi deneyin.",
  disconnect: "Ba\u011Flant\u0131y\u0131 Kes",
  connected: "Ba\u011Fl\u0131"
};
var profile12 = {
  disconnect: {
    label: "Ba\u011Flant\u0131y\u0131 Kes"
  },
  copy_address: {
    label: "Adresi Kopyala",
    copied: "Kopyaland\u0131!"
  },
  explorer: {
    label: "Explorer \xFCzerinde daha fazlas\u0131n\u0131 g\xF6r\xFCn"
  },
  transactions: {
    description: "%{appName} i\u015Flem burada g\xF6r\xFCnecek...",
    description_fallback: "\u0130\u015Flemleriniz burada g\xF6r\xFCnecek...",
    recent: {
      title: "Son \u0130\u015Flemler"
    },
    clear: {
      label: "Hepsini Temizle"
    }
  }
};
var wallet_connectors12 = {
  argent: {
    qr_code: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Argent'i ana ekran\u0131n\u0131za koyun.",
        title: "Argent uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "Bir c\xFCzdan ve kullan\u0131c\u0131 ad\u0131 olu\u015Fturun veya mevcut bir c\xFCzdan\u0131 i\xE7e aktar\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar"
      },
      step3: {
        description: "Tarad\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi g\xF6r\xFCnecektir.",
        title: "QR taray\u0131c\u0131 d\xFC\u011Fmesine dokunun"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in Bifrost C\xFCzdan'\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz.",
        title: "Bifrost C\xFCzdan uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "Kurtarma ifadenizle bir c\xFCzdan olu\u015Fturun veya i\xE7e aktar\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar"
      },
      step3: {
        description: "Tarama i\u015Flemi sonras\u0131nda, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi g\xF6z\xFCkecektir.",
        title: "Taray\u0131c\u0131 d\xFC\u011Fmesine dokunun"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in Bitget C\xFCzdan\u0131n\u0131z\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz.",
        title: "Bitget C\xFCzdan uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedeklemeye emin olun. Gizli ifadenizi asla kimseyle payla\u015Fmay\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar"
      },
      step3: {
        description: "Tarama yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi g\xF6r\xFCnecektir.",
        title: "Tarama d\xFC\u011Fmesine dokunun"
      }
    },
    extension: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Bitget C\xFCzdan\u0131n\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz.",
        title: "Bitget C\xFCzdan eklentisini y\xFCkleyin"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedeklemekten emin olun. Gizli ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n.",
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n"
      },
      step3: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, a\u015Fa\u011F\u0131ya t\u0131klay\u0131n ve taray\u0131c\u0131y\u0131 yenileyin ve eklentiyi y\xFCkleyin.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Bitski'yi g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz.",
        title: "Bitski eklentisini y\xFCkleyin"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli ifadenizi kimseyle payla\u015Fmay\u0131n.",
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n"
      },
      step3: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Coin98 C\xFCzdan\u0131n\u0131z\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz.",
        title: "Coin98 C\xFCzdan uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "Telefonunuzdaki yedekleme \xF6zelli\u011Fimizi kullanarak c\xFCzdan\u0131n\u0131z\u0131 kolayca yedekleyebilirsiniz.",
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar"
      },
      step3: {
        description: "Tarama i\u015Flemi yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi g\xF6r\xFCnecektir.",
        title: "C\xFCzdanBa\u011Flant\u0131s\u0131 d\xFC\u011Fmesine dokunun"
      }
    },
    extension: {
      step1: {
        description: "Taray\u0131c\u0131n\u0131z\u0131n sa\u011F \xFCst k\xF6\u015Fesinde t\u0131klay\u0131n ve Coin98 C\xFCzdan\u0131n\u0131z\u0131 kolay eri\u015Fim i\xE7in sabitleyin.",
        title: "Coin98 C\xFCzdan eklentisini y\xFCkleyin"
      },
      step2: {
        description: "Yeni bir c\xFCzdan olu\u015Fturun veya mevcut birini i\xE7e aktar\u0131n.",
        title: "Bir c\xFCzdan olu\u015Fturun veya i\xE7e aktar\u0131n"
      },
      step3: {
        description: "Coin98 C\xFCzdan'\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "Coinbase C\xFCzdan'\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz, b\xF6ylece daha h\u0131zl\u0131 eri\u015Fim sa\u011Flan\u0131r.",
        title: "Coinbase Wallet uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 bulut yedekleme \xF6zelli\u011Fini kullanarak kolayca yedekleyebilirsiniz.",
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n"
      },
      step3: {
        description: "Tarama yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flaman\u0131z i\xE7in bir ba\u011Flant\u0131 istemi belirecektir.",
        title: "Tarama d\xFC\u011Fmesine dokunun"
      }
    },
    extension: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Coinbase Wallet'\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz.",
        title: "Coinbase Wallet uzant\u0131s\u0131n\u0131 y\xFCkleyin"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekleyin. Gizli ifadenizi asla ba\u015Fkalar\u0131yla payla\u015Fmay\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar"
      },
      step3: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Core'u ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz.",
        title: "Core uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131n yede\u011Fini telefonunuzda bulunan yedekleme \xF6zelli\u011Fimizi kullanarak kolayca alabilirsiniz.",
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar"
      },
      step3: {
        description: "Tarama yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak \xFCzere bir ba\u011Flant\u0131 istemi g\xF6r\xFCnecektir.",
        title: "WalletConnect d\xFC\u011Fmesine dokunun"
      }
    },
    extension: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Core'u g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz.",
        title: "Core eklentisini y\xFCkleyin"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedeklemeye dikkat edin. Gizli ifadenizi asla kimseyle payla\u015Fmay\u0131n.",
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n"
      },
      step3: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, a\u015Fa\u011F\u0131ya t\u0131klayarak taray\u0131c\u0131y\u0131 yenileyin ve eklentiyi y\xFCkleyin.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in FoxWallet'\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz.",
        title: "FoxWallet uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli ifadenizi asla kimseyle payla\u015Fmay\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar"
      },
      step3: {
        description: "Tarama yapt\u0131ktan sonra c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flaman\u0131z i\xE7in bir ba\u011Flant\u0131 istemi belirecektir.",
        title: "Tarama d\xFC\u011Fmesine dokunun"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in Frontier C\xFCzdan\u0131n\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz.",
        title: "Frontier C\xFCzdan uygulamas\u0131n\u0131 a\xE7\u0131n"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli ifadenizi asla kimseyle payla\u015Fmay\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar"
      },
      step3: {
        description: "Taramadan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi g\xF6r\xFCnecektir.",
        title: "Tarama d\xFC\u011Fmesine dokunun"
      }
    },
    extension: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Frontier C\xFCzdan\u0131n\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz.",
        title: "Frontier C\xFCzdan eklentisini y\xFCkleyin"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar"
      },
      step3: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemeye ve eklentiyi y\xFCklemeye ba\u015Flamak i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 Yenileyin"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "imToken uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in imToken uygulamas\u0131n\u0131 ana ekran\u0131n\u0131za koyun."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar",
        description: "Yeni bir c\xFCzdan olu\u015Fturun veya mevcut bir c\xFCzdan\u0131 i\xE7e aktar\u0131n."
      },
      step3: {
        title: "Sa\u011F \xFCst k\xF6\u015Fede Taray\u0131c\u0131 Simgesine dokunun",
        description: "Yeni Ba\u011Flant\u0131'y\u0131 se\xE7in, ard\u0131ndan QR kodunu taray\u0131n ve ba\u011Flant\u0131y\u0131 onaylamak i\xE7in istemi onaylay\u0131n."
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "MetaMask uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in MetaMask'\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekleyin. Gizli kurtarma ifadenizi asla ba\u015Fkalar\u0131yla payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Tarama d\xFC\u011Fmesine dokunun",
        description: "Taramay\u0131 yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi belirecektir."
      }
    },
    extension: {
      step1: {
        title: "MetaMask eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in MetaMask'i g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 Yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "OKX Wallet uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in OKX Wallet'\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli c\xFCmlenizi asla kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Tarama d\xFC\u011Fmesine dokunun",
        description: "Tarama yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flama istemi g\xF6r\xFCnecektir."
      }
    },
    extension: {
      step1: {
        title: "OKX C\xFCzdan eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in OKX C\xFCzdan'\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli c\xFCmlenizi asla kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "Omni uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Omni'yi ana ekran\u0131n\u0131za ekleyin."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun ya da \u0130\xE7e Aktar\u0131n",
        description: "Yeni bir c\xFCzdan olu\u015Fturun veya mevcut birini i\xE7e aktar\u0131n."
      },
      step3: {
        title: "QR simgesine dokunun ve taray\u0131n",
        description: "Ana ekran\u0131n\u0131zdaki QR simgesine dokunun, kodu taray\u0131n ve ba\u011Flanmak i\xE7in istemi onaylay\u0131n."
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "TokenPocket uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in TokenPocket'\u0131 ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya C\xFCzdan\u0131 \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekleyin. Gizli ifadenizi asla ba\u015Fkalar\u0131yla payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Tarama d\xFC\u011Fmesine dokunun",
        description: "Taramay\u0131 yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi belirecektir."
      }
    },
    extension: {
      step1: {
        title: "TokenPocket eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in TokenPocket'i g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli c\xFCmlenizi asla ba\u015Fkalar\u0131yla payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemekte ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "Trust Wallet uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Trust Wallet'\u0131 ana ekran\u0131n\u0131za koyun."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya C\xFCzdan\u0131 \u0130\xE7e Aktar",
        description: "Yeni bir c\xFCzdan olu\u015Fturun veya mevcut bir tane i\xE7e aktar\u0131n."
      },
      step3: {
        title: "Ayarlar'da WalletConnect'e dokunun",
        description: "Yeni Ba\u011Flant\u0131'y\u0131 se\xE7in, ard\u0131ndan QR kodunu taray\u0131n ve ba\u011Flanmak i\xE7in istemi onaylay\u0131n."
      }
    },
    extension: {
      step1: {
        title: "Trust Wallet eklentisini y\xFCkleyin",
        description: "Taray\u0131c\u0131n\u0131z\u0131n sa\u011F \xFCst k\xF6\u015Fesine t\u0131klay\u0131n ve kolay eri\u015Fim i\xE7in Trust Wallet'i sabitleyin."
      },
      step2: {
        title: "Bir c\xFCzdan olu\u015Fturun veya i\xE7e aktar\u0131n",
        description: "Yeni bir c\xFCzdan olu\u015Fturun veya mevcut bir tane i\xE7e aktar\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "Trust Wallet'\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "Uniswap uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Uniswap C\xFCzdan\u0131n\u0131z\u0131 ana ekran\u0131n\u0131za ekleyin."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar",
        description: "Yeni bir c\xFCzdan olu\u015Fturun veya mevcut birini i\xE7e aktar\u0131n."
      },
      step3: {
        title: "QR ikonuna dokunun ve tarama yap\u0131n",
        description: "Ana ekran\u0131n\u0131zdaki QR simgesine dokunun, kodu taray\u0131n ve ba\u011Flanmay\u0131 onaylamak i\xE7in istemi kabul edin."
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "Zerion uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "Daha h\u0131zl\u0131 eri\u015Fim i\xE7in Zerion'un ana ekran\u0131n\u0131za konumland\u0131rman\u0131z\u0131 \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekleyin. Gizli ifadenizi asla ba\u015Fkalar\u0131yla payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Tarama d\xFC\u011Fmesine bas\u0131n",
        description: "Taramadan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flamak i\xE7in bir ba\u011Flant\u0131 istemi belirecektir."
      }
    },
    extension: {
      step1: {
        title: "Zerion eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Zerion'u g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedeklemeye emin olun. Gizli ifadenizi asla ba\u015Fkalar\u0131yla payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "Rainbow uygulamas\u0131n\u0131 a\xE7\u0131n",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Rainbow'u ana ekran\u0131n\u0131za koyman\u0131z\u0131 \xF6neririz."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar",
        description: "Telefonunuzdaki yedekleme \xF6zelli\u011Fimizi kullanarak c\xFCzdan\u0131n\u0131z\u0131 kolayca yedekleyebilirsiniz."
      },
      step3: {
        title: "Tarama d\xFC\u011Fmesine dokunun",
        description: "Tarama yapt\u0131ktan sonra, c\xFCzdan\u0131n\u0131z\u0131 ba\u011Flaman\u0131z i\xE7in bir ba\u011Flant\u0131 istemi belirecektir."
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim sa\u011Flamak i\xE7in Enkrypt C\xFCzdan'\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz.",
        title: "Enkrypt C\xFCzdan eklentisini y\xFCkleyin"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n.",
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n"
      },
      step3: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim sa\u011Flamak i\xE7in Frame'\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz.",
        title: "Frame ve e\u015Flik eden uzant\u0131y\u0131 y\xFCkleyin"
      },
      step2: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli ifadenizi asla ba\u015Fkas\u0131yla payla\u015Fmay\u0131n.",
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar"
      },
      step3: {
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve uzant\u0131y\u0131 y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n.",
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "OneKey Wallet uzant\u0131s\u0131n\u0131 y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in OneKey Wallet'\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli ifadenizi kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "Phantom eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha kolay eri\u015Fim sa\u011Flamak i\xE7in Phantom'u g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntem kullanarak yedekledi\u011Finizden emin olun. Gizli kurtarma ifadenizi kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "Rabby eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Rabby'yi g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli ifadenizi asla ba\u015Fkalar\u0131yla payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 kurduktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131daki d\xFC\u011Fmeye t\u0131klay\u0131n."
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "Core eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Safeheron'u g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "C\xFCzdan Olu\u015Ftur veya \u0130\xE7e Aktar",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "Taho uzant\u0131s\u0131n\u0131 y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Taho'yu g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "Talisman eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in Talisman'\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "Ethereum C\xFCzdan\u0131 Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Kurtarma ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "XDEFI C\xFCzdan eklentisini y\xFCkleyin",
        description: "C\xFCzdan\u0131n\u0131za daha h\u0131zl\u0131 eri\u015Fim i\xE7in XDEFI Wallet'\u0131 g\xF6rev \xE7ubu\u011Funuza sabitlemenizi \xF6neririz."
      },
      step2: {
        title: "Bir C\xFCzdan Olu\u015Fturun veya \u0130\xE7e Aktar\u0131n",
        description: "C\xFCzdan\u0131n\u0131z\u0131 g\xFCvenli bir y\xF6ntemle yedekledi\u011Finizden emin olun. Gizli ifadenizi hi\xE7 kimseyle payla\u015Fmay\u0131n."
      },
      step3: {
        title: "Taray\u0131c\u0131n\u0131z\u0131 yenileyin",
        description: "C\xFCzdan\u0131n\u0131z\u0131 ayarlad\u0131ktan sonra, taray\u0131c\u0131y\u0131 yenilemek ve eklentiyi y\xFCklemek i\xE7in a\u015Fa\u011F\u0131ya t\u0131klay\u0131n."
      }
    }
  }
};
var tr_TR_default = {
  connect_wallet: connect_wallet12,
  intro: intro12,
  connect: connect12,
  connect_scan: connect_scan12,
  connector_group: connector_group12,
  get: get12,
  get_options: get_options12,
  get_mobile: get_mobile12,
  get_instructions: get_instructions12,
  chains: chains12,
  profile: profile12,
  wallet_connectors: wallet_connectors12
};

// src/locales/zh_CN.json
var connect_wallet13 = {
  label: "\u8FDE\u63A5\u94B1\u5305"
};
var intro13 = {
  title: "\u4EC0\u4E48\u662F\u94B1\u5305\uFF1F",
  description: "\u94B1\u5305\u7528\u4E8E\u53D1\u9001\u3001\u63A5\u6536\u3001\u5B58\u50A8\u548C\u663E\u793A\u6570\u5B57\u8D44\u4EA7\u3002\u5B83\u4E5F\u662F\u4E00\u79CD\u65B0\u578B\u7684\u767B\u5F55\u65B9\u5F0F\uFF0C\u65E0\u9700\u5728\u6BCF\u4E2A\u7F51\u7AD9\u4E0A\u521B\u5EFA\u65B0\u8D26\u6237\u548C\u5BC6\u7801\u3002",
  digital_asset: {
    title: "\u60A8\u7684\u6570\u5B57\u8D44\u4EA7\u4E4B\u5BB6",
    description: "\u94B1\u5305\u7528\u4E8E\u53D1\u9001\u3001\u63A5\u6536\u3001\u5B58\u50A8\u548C\u663E\u793A\u50CF\u4EE5\u592A\u574A\u548CNFT\u8FD9\u6837\u7684\u6570\u5B57\u8D44\u4EA7\u3002"
  },
  login: {
    title: "\u4E00\u79CD\u65B0\u7684\u767B\u5F55\u65B9\u5F0F",
    description: "\u800C\u4E0D\u662F\u5728\u6BCF\u4E2A\u7F51\u7AD9\u4E0A\u521B\u5EFA\u65B0\u7684\u8D26\u6237\u548C\u5BC6\u7801\uFF0C\u53EA\u9700\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002"
  },
  get: {
    label: "\u83B7\u53D6\u94B1\u5305"
  },
  learn_more: {
    label: "\u4E86\u89E3\u66F4\u591A"
  }
};
var connect13 = {
  label: "\u8FDE\u63A5",
  title: "\u8FDE\u63A5\u94B1\u5305",
  new_to_ethereum: {
    description: "\u5BF9\u4EE5\u592A\u574A\u94B1\u5305\u4E0D\u719F\u6089\uFF1F",
    learn_more: {
      label: "\u4E86\u89E3\u66F4\u591A"
    }
  },
  learn_more: {
    label: "\u4E86\u89E3\u66F4\u591A"
  },
  recent: "\u8FD1\u671F",
  status: {
    opening: "\u6B63\u5728\u6253\u5F00 %{wallet}...",
    not_installed: "%{wallet} \u5C1A\u672A\u5B89\u88C5",
    not_available: "%{wallet} \u4E0D\u53EF\u7528",
    confirm: "\u5728\u6269\u5C55\u4E2D\u786E\u8BA4\u8FDE\u63A5"
  },
  secondary_action: {
    get: {
      description: "\u6CA1\u6709 %{wallet}\u5417\uFF1F",
      label: "\u83B7\u53D6"
    },
    install: {
      label: "\u5B89\u88C5"
    },
    retry: {
      label: "\u91CD\u8BD5"
    }
  },
  walletconnect: {
    description: {
      full: "\u9700\u8981\u5B98\u65B9\u7684 WalletConnect \u5F39\u7A97\u5417\uFF1F",
      compact: "\u9700\u8981 WalletConnect \u5F39\u7A97\u5417\uFF1F"
    },
    open: {
      label: "\u6253\u5F00"
    }
  }
};
var connect_scan13 = {
  title: "\u4F7F\u7528 %{wallet}\u626B\u63CF",
  fallback_title: "\u4F7F\u7528\u60A8\u7684\u624B\u673A\u626B\u63CF"
};
var connector_group13 = {
  recommended: "\u63A8\u8350",
  other: "\u5176\u4ED6",
  popular: "\u6D41\u884C",
  more: "\u66F4\u591A",
  others: "\u5176\u4ED6\u7684"
};
var get13 = {
  title: "\u83B7\u53D6\u4E00\u4E2A\u94B1\u5305",
  action: {
    label: "\u83B7\u53D6"
  },
  mobile: {
    description: "\u79FB\u52A8\u94B1\u5305"
  },
  extension: {
    description: "\u6D4F\u89C8\u5668\u6269\u5C55"
  },
  mobile_and_extension: {
    description: "\u79FB\u52A8\u94B1\u5305\u548C\u6269\u5C55"
  },
  looking_for: {
    title: "\u4E0D\u662F\u4F60\u8981\u627E\u7684\u5417\uFF1F",
    mobile: {
      description: "\u5728\u4E3B\u5C4F\u5E55\u4E0A\u9009\u62E9\u4E00\u4E2A\u94B1\u5305\uFF0C\u4EE5\u5F00\u59CB\u4F7F\u7528\u4E0D\u540C\u7684\u94B1\u5305\u63D0\u4F9B\u5546\u3002"
    },
    desktop: {
      compact_description: "\u5728\u4E3B\u5C4F\u5E55\u4E0A\u9009\u62E9\u4E00\u4E2A\u94B1\u5305\uFF0C\u4EE5\u5F00\u59CB\u4F7F\u7528\u4E0D\u540C\u7684\u94B1\u5305\u63D0\u4F9B\u5546\u3002",
      wide_description: "\u5728\u5DE6\u4FA7\u9009\u62E9\u4E00\u4E2A\u94B1\u5305\uFF0C\u4EE5\u5F00\u59CB\u4F7F\u7528\u4E0D\u540C\u7684\u94B1\u5305\u63D0\u4F9B\u5546\u3002"
    }
  }
};
var get_options13 = {
  title: "\u5F00\u59CB\u4F7F\u7528 %{wallet}",
  short_title: "\u83B7\u53D6 %{wallet}",
  mobile: {
    title: "%{wallet} \u7528\u4E8E\u79FB\u52A8",
    description: "\u4F7F\u7528\u79FB\u52A8\u94B1\u5305\u63A2\u7D22\u4EE5\u592A\u574A\u7684\u4E16\u754C\u3002",
    download: {
      label: "\u83B7\u53D6\u5E94\u7528"
    }
  },
  extension: {
    title: "%{wallet} \u4E3A %{browser}",
    description: "\u4ECE\u60A8\u6700\u559C\u6B22\u7684\u7F51\u7EDC\u6D4F\u89C8\u5668\u76F4\u63A5\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
    download: {
      label: "\u6DFB\u52A0\u5230 %{browser}"
    }
  }
};
var get_mobile13 = {
  title: "\u5B89\u88C5 %{wallet}",
  description: "\u7528\u624B\u673A\u626B\u63CF\u4E0B\u8F7D iOS \u6216 Android",
  continue: {
    label: "\u7EE7\u7EED"
  }
};
var get_instructions13 = {
  mobile: {
    connect: {
      label: "\u8FDE\u63A5"
    },
    learn_more: {
      label: "\u4E86\u89E3\u66F4\u591A"
    }
  },
  extension: {
    refresh: {
      label: "\u5237\u65B0"
    },
    learn_more: {
      label: "\u4E86\u89E3\u66F4\u591A"
    }
  }
};
var chains13 = {
  title: "\u5207\u6362\u7F51\u7EDC",
  wrong_network: "\u68C0\u6D4B\u5230\u9519\u8BEF\u7684\u7F51\u7EDC\uFF0C\u8BF7\u5207\u6362\u6216\u65AD\u5F00\u8FDE\u63A5\u4EE5\u7EE7\u7EED\u3002",
  confirm: "\u5728\u94B1\u5305\u4E2D\u786E\u8BA4",
  switching_not_supported: "\u60A8\u7684\u94B1\u5305\u4E0D\u652F\u6301\u4ECE %{appName}\u5207\u6362\u7F51\u7EDC\u3002\u8BF7\u5C1D\u8BD5\u4ECE\u60A8\u7684\u94B1\u5305\u5185\u90E8\u5207\u6362\u7F51\u7EDC\u3002",
  switching_not_supported_fallback: "\u60A8\u7684\u94B1\u5305\u4E0D\u652F\u6301\u4ECE\u6B64\u5E94\u7528\u5207\u6362\u7F51\u7EDC\u3002\u5C1D\u8BD5\u4ECE\u60A8\u7684\u94B1\u5305\u5185\u5207\u6362\u7F51\u7EDC\u3002",
  disconnect: "\u65AD\u5F00\u8FDE\u63A5",
  connected: "\u5DF2\u8FDE\u63A5"
};
var profile13 = {
  disconnect: {
    label: "\u65AD\u5F00\u8FDE\u63A5"
  },
  copy_address: {
    label: "\u590D\u5236\u5730\u5740",
    copied: "\u5DF2\u590D\u5236\uFF01"
  },
  explorer: {
    label: "\u5728\u6D4F\u89C8\u5668\u4E0A\u67E5\u770B\u66F4\u591A"
  },
  transactions: {
    description: "%{appName} \u4EA4\u6613\u5C06\u4F1A\u51FA\u73B0\u5728\u8FD9\u91CC...",
    description_fallback: "\u60A8\u7684\u4EA4\u6613\u5C06\u4F1A\u51FA\u73B0\u5728\u8FD9\u91CC...",
    recent: {
      title: "\u6700\u8FD1\u4EA4\u6613"
    },
    clear: {
      label: "\u6E05\u9664\u5168\u90E8"
    }
  }
};
var wallet_connectors13 = {
  argent: {
    qr_code: {
      step1: {
        description: "\u5C06 Argent \u653E\u5230\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u6253\u5F00 Argent \u5E94\u7528"
      },
      step2: {
        description: "\u521B\u5EFA\u94B1\u5305\u548C\u7528\u6237\u540D\uFF0C\u6216\u5BFC\u5165\u73B0\u6709\u94B1\u5305\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u5728\u60A8\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u4F9B\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FB\u626B\u63CF\u4E8C\u7EF4\u7801\u6309\u94AE"
      }
    }
  },
  bifrost: {
    qr_code: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06Bifrost Wallet\u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u3002",
        title: "\u6253\u5F00 Bifrost Wallet \u5E94\u7528"
      },
      step2: {
        description: "\u4F7F\u7528\u6062\u590D\u77ED\u8BED\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u5728\u60A8\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u4F9B\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE"
      }
    }
  },
  bitget: {
    qr_code: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06Bitget\u94B1\u5305\u6DFB\u52A0\u5230\u4E3B\u5C4F\u5E55\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u3002",
        title: "\u6253\u5F00Bitget\u94B1\u5305\u5E94\u7528\u7A0B\u5E8F"
      },
      step2: {
        description: "\u52A1\u5FC5\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u51B3\u4E0D\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u4E00\u4E2A\u8FDE\u63A5\u63D0\u793A\uFF0C\u4F9B\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE"
      }
    },
    extension: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06Bitget\u94B1\u5305\u56FA\u5B9A\u5728\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u5B89\u88C5Bitget Wallet\u6269\u5C55"
      },
      step2: {
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u5F0F\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u7EDD\u4E0D\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u8BBE\u7F6E\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002",
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  bitski: {
    extension: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06Bitski\u56FA\u5B9A\u5728\u4EFB\u52A1\u680F\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u5B89\u88C5Bitski\u6269\u5C55"
      },
      step2: {
        description: "\u8BF7\u786E\u4FDD\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u7EDD\u4E0D\u4E0E\u4EFB\u4F55\u4EBA\u5171\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u8BBE\u7F6E\u5B8C\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002",
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  coin98: {
    qr_code: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06Coin98\u94B1\u5305\u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u6253\u5F00Coin98\u94B1\u5305\u5E94\u7528\u7A0B\u5E8F"
      },
      step2: {
        description: "\u60A8\u53EF\u4EE5\u4F7F\u7528\u6211\u4EEC\u7684\u624B\u673A\u4E0A\u7684\u5907\u4EFD\u529F\u80FD\u8F7B\u677E\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u4E00\u4E2A\u8FDE\u63A5\u63D0\u793A\uFF0C\u8BA9\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FBWalletConnect\u6309\u94AE"
      }
    },
    extension: {
      step1: {
        description: "\u70B9\u51FB\u6D4F\u89C8\u5668\u53F3\u4E0A\u89D2\u5E76\u56FA\u5B9ACoin98\u94B1\u5305\uFF0C\u4EE5\u4FBF\u8F7B\u677E\u8BBF\u95EE\u3002",
        title: "\u5B89\u88C5Coin98\u94B1\u5305\u6269\u5C55"
      },
      step2: {
        description: "\u521B\u5EFA\u65B0\u94B1\u5305\u6216\u5BFC\u5165\u73B0\u6709\u94B1\u5305\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305\u3002"
      },
      step3: {
        description: "\u8BBE\u7F6E\u5B8C\u6210Coin98 \u94B1\u5305\u540E\uFF0C\u5355\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002",
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  coinbase: {
    qr_code: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u628ACoinbase\u94B1\u5305\u653E\u5230\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u3002",
        title: "\u6253\u5F00Coinbase\u94B1\u5305\u5E94\u7528"
      },
      step2: {
        description: "\u60A8\u53EF\u4EE5\u8F7B\u677E\u5730\u4F7F\u7528\u4E91\u5907\u4EFD\u529F\u80FD\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u4F9B\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE"
      }
    },
    extension: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06Coinbase\u94B1\u5305\u56FA\u5B9A\u5728\u4EFB\u52A1\u680F\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u5B89\u88C5Coinbase\u94B1\u5305\u6269\u5C55"
      },
      step2: {
        description: "\u52A1\u5FC5\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u8BBE\u7F6E\u597D\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002",
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  core: {
    qr_code: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06Core\u6DFB\u52A0\u5230\u4E3B\u5C4F\u5E55\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u6253\u5F00Core\u5E94\u7528\u7A0B\u5E8F"
      },
      step2: {
        description: "\u60A8\u53EF\u4EE5\u4F7F\u7528\u6211\u4EEC\u7684\u624B\u673A\u5907\u4EFD\u529F\u80FD\u8F7B\u677E\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u8BA9\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FBWalletConnect\u6309\u94AE"
      }
    },
    extension: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Core \u56FA\u5B9A\u5230\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u5B89\u88C5 Core \u6269\u5C55"
      },
      step2: {
        description: "\u4E00\u5B9A\u8981\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u8BBE\u7F6E\u597D\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002",
        title: "\u5237\u65B0\u4F60\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  fox: {
    qr_code: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06 FoxWallet \u653E\u5230\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u7684\u8BBF\u95EE\u3002",
        title: "\u6253\u5F00 FoxWallet \u5E94\u7528"
      },
      step2: {
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5171\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u8BA9\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE"
      }
    }
  },
  frontier: {
    qr_code: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Frontier \u94B1\u5305\u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u3002",
        title: "\u6253\u5F00 Frontier \u94B1\u5305\u5E94\u7528"
      },
      step2: {
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5171\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u8BA9\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE"
      }
    },
    extension: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u60A8\u5C06Frontier\u94B1\u5305\u56FA\u5B9A\u5230\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u5B89\u88C5Frontier\u94B1\u5305\u6269\u5C55"
      },
      step2: {
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u8BBE\u7F6E\u5B8C\u6210\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002",
        title: "\u5237\u65B0\u4F60\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  im_token: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00imToken\u5E94\u7528",
        description: "\u5C06imToken\u5E94\u7528\u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u521B\u5EFA\u65B0\u94B1\u5305\u6216\u5BFC\u5165\u5DF2\u6709\u7684\u94B1\u5305\u3002"
      },
      step3: {
        title: "\u70B9\u51FB\u53F3\u4E0A\u89D2\u7684\u626B\u63CF\u56FE\u6807",
        description: "\u9009\u62E9\u65B0\u8FDE\u63A5\uFF0C\u7136\u540E\u626B\u63CF\u4E8C\u7EF4\u7801\u5E76\u786E\u8BA4\u63D0\u793A\u4EE5\u8FDB\u884C\u8FDE\u63A5\u3002"
      }
    }
  },
  metamask: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00 MetaMask \u5E94\u7528",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 MetaMask \u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u4F60\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE",
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u4EE5\u4FBF\u4F60\u8FDE\u63A5\u4F60\u7684\u94B1\u5305\u3002"
      }
    },
    extension: {
      step1: {
        title: "\u5B89\u88C5 MetaMask \u6269\u5C55",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06MetaMask\u56FA\u5B9A\u5728\u60A8\u7684\u4EFB\u52A1\u680F\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u8BF7\u52A1\u5FC5\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u4E00\u65E6\u60A8\u8BBE\u7F6E\u597D\u60A8\u7684\u94B1\u5305\uFF0C\u70B9\u51FB\u4E0B\u9762\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002"
      }
    }
  },
  okx: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00OKX\u94B1\u5305\u5E94\u7528\u7A0B\u5E8F",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06OKX\u94B1\u5305\u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u52A1\u5FC5\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5343\u4E07\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE",
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u4E00\u4E2A\u8FDE\u63A5\u63D0\u793A\uFF0C\u8BA9\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002"
      }
    },
    extension: {
      step1: {
        title: "\u5B89\u88C5 OKX \u94B1\u5305\u6269\u5C55",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 OKX \u94B1\u5305\u56FA\u5B9A\u5230\u60A8\u7684\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u52A1\u5FC5\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5343\u4E07\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u4E00\u65E6\u4F60\u8BBE\u7F6E\u597D\u4F60\u7684\u94B1\u5305\uFF0C\u70B9\u51FB\u4E0B\u65B9\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002"
      }
    }
  },
  omni: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00Omni\u5E94\u7528",
        description: "\u5C06Omni\u6DFB\u52A0\u5230\u4F60\u7684\u4E3B\u5C4F\u5E55\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u4F60\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u521B\u5EFA\u65B0\u7684\u94B1\u5305\u6216\u5BFC\u5165\u73B0\u6709\u7684\u94B1\u5305\u3002"
      },
      step3: {
        title: "\u70B9\u51FBQR\u56FE\u6807\u5E76\u626B\u63CF",
        description: "\u70B9\u51FB\u9996\u9875\u7684\u4E8C\u7EF4\u7801\u56FE\u6807\uFF0C\u626B\u63CF\u4EE3\u7801\u5E76\u786E\u8BA4\u63D0\u793A\u4EE5\u8FDE\u63A5\u3002"
      }
    }
  },
  token_pocket: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00TokenPocket\u5E94\u7528",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06TokenPocket\u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\u4EE5\u4FBF\u66F4\u5FEB\u7684\u8BBF\u95EE\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u4E00\u5B9A\u8981\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE",
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u4F9B\u60A8\u8FDE\u63A5\u94B1\u5305\u3002"
      }
    },
    extension: {
      step1: {
        title: "\u5B89\u88C5TokenPocket\u6269\u5C55",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06TokenPocket\u56FA\u5B9A\u5230\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u4E00\u4E2A\u94B1\u5305",
        description: "\u4E00\u5B9A\u8981\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u7EDD\u5BF9\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6E\u597D\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u9762\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002"
      }
    }
  },
  trust: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00Trust Wallet\u5E94\u7528",
        description: "\u5C06Trust Wallet\u653E\u5728\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u4E00\u4E2A\u94B1\u5305",
        description: "\u521B\u5EFA\u65B0\u7684\u94B1\u5305\u6216\u5BFC\u5165\u73B0\u6709\u7684\u94B1\u5305\u3002"
      },
      step3: {
        title: "\u5728\u8BBE\u7F6E\u4E2D\u70B9\u51FBWalletConnect",
        description: "\u9009\u62E9\u65B0\u7684\u8FDE\u63A5\uFF0C\u7136\u540E\u626B\u63CF\u4E8C\u7EF4\u7801\u5E76\u786E\u8BA4\u63D0\u793A\u4EE5\u8FDB\u884C\u8FDE\u63A5\u3002"
      }
    },
    extension: {
      step1: {
        title: "\u5B89\u88C5Trust Wallet\u6269\u5C55\u7A0B\u5E8F",
        description: "\u5728\u6D4F\u89C8\u5668\u7684\u53F3\u4E0A\u89D2\u70B9\u51FB\u5E76\u56FA\u5B9ATrust Wallet\u4EE5\u4FBF\u4E8E\u8BBF\u95EE\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u521B\u5EFA\u65B0\u7684\u94B1\u5305\u6216\u5BFC\u5165\u73B0\u6709\u7684\u94B1\u5305\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6ETrust Wallet\u540E\uFF0C\u70B9\u51FB\u4E0B\u9762\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  uniswap: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00Uniswap\u5E94\u7528",
        description: "\u5C06Uniswap\u94B1\u5305\u6DFB\u52A0\u5230\u60A8\u7684\u4E3B\u5C4F\u5E55\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u521B\u5EFA\u65B0\u94B1\u5305\u6216\u5BFC\u5165\u73B0\u6709\u94B1\u5305\u3002"
      },
      step3: {
        title: "\u70B9\u51FBQR\u56FE\u6807\u5E76\u626B\u63CF",
        description: "\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\u70B9\u51FBQR\u56FE\u6807\uFF0C\u626B\u63CF\u4EE3\u7801\u5E76\u786E\u8BA4\u63D0\u793A\u4EE5\u8FDB\u884C\u8FDE\u63A5\u3002"
      }
    }
  },
  zerion: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00Zerion\u5E94\u7528",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06Zerion\u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u5F0F\u5907\u4EFD\u4F60\u7684\u94B1\u5305\u3002\u7EDD\u5BF9\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u4F60\u7684\u79C1\u4EBA\u5BC6\u8BED\u3002"
      },
      step3: {
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE",
        description: "\u4F60\u626B\u63CF\u540E\uFF0C\u4F1A\u51FA\u73B0\u4E00\u4E2A\u8FDE\u63A5\u63D0\u793A\u8BA9\u4F60\u8FDE\u63A5\u4F60\u7684\u94B1\u5305\u3002"
      }
    },
    extension: {
      step1: {
        title: "\u5B89\u88C5 Zerion \u6269\u5C55",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Zerion \u56FA\u5B9A\u5728\u4F60\u7684\u4EFB\u52A1\u680F\u4EE5\u4FBF\u66F4\u5FEB\u8BBF\u95EE\u4F60\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u4F60\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u4F60\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6E\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u9762\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  rainbow: {
    qr_code: {
      step1: {
        title: "\u6253\u5F00 Rainbow \u5E94\u7528",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Rainbow \u653E\u5728\u60A8\u7684\u4E3B\u5C4F\u5E55\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u60A8\u53EF\u4EE5\u4F7F\u7528\u6211\u4EEC\u7684\u5907\u4EFD\u529F\u80FD\u5728\u60A8\u7684\u624B\u673A\u4E0A\u8F7B\u677E\u5907\u4EFD\u4F60\u7684\u94B1\u5305\u3002"
      },
      step3: {
        title: "\u70B9\u51FB\u626B\u63CF\u6309\u94AE",
        description: "\u626B\u63CF\u540E\uFF0C\u5C06\u51FA\u73B0\u8FDE\u63A5\u63D0\u793A\uFF0C\u8BA9\u60A8\u8FDE\u63A5\u60A8\u7684\u94B1\u5305\u3002"
      }
    }
  },
  enkrypt: {
    extension: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06Enkrypt Wallet\u56FA\u5B9A\u5230\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u5B89\u88C5Enkrypt Wallet\u6269\u5C55"
      },
      step2: {
        description: "\u8BF7\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u94B1\u5305\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u8BBE\u7F6E\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u9762\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002",
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  frame: {
    extension: {
      step1: {
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06Frame\u56FA\u5B9A\u5230\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002",
        title: "\u5B89\u88C5Frame\u53CA\u5176\u914D\u5957\u6269\u5C55"
      },
      step2: {
        description: "\u52A1\u5FC5\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u51B3\u4E0D\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002",
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305"
      },
      step3: {
        description: "\u8BBE\u7F6E\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u3002",
        title: "\u5237\u65B0\u4F60\u7684\u6D4F\u89C8\u5668"
      }
    }
  },
  one_key: {
    extension: {
      step1: {
        title: "\u5B89\u88C5OneKey Wallet\u6269\u5C55",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06OneKey Wallet\u56FA\u5B9A\u5230\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6E\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  phantom: {
    extension: {
      step1: {
        title: "\u5B89\u88C5 Phantom \u6269\u5C55\u7A0B\u5E8F",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Phantom \u56FA\u5B9A\u5230\u60A8\u7684\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5BB9\u6613\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u6062\u590D\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6E\u597D\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  rabby: {
    extension: {
      step1: {
        title: "\u5B89\u88C5 Rabby \u6269\u5C55\u7A0B\u5E8F",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Rabby \u56FA\u5B9A\u5728\u60A8\u7684\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u4E00\u5B9A\u8981\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u5BC6\u94A5\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u4E00\u65E6\u60A8\u8BBE\u7F6E\u597D\u60A8\u7684\u94B1\u5305\uFF0C\u70B9\u51FB\u4EE5\u4E0B\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  safeheron: {
    extension: {
      step1: {
        title: "\u5B89\u88C5 Core \u6269\u5C55",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Safeheron \u56FA\u5B9A\u5728\u60A8\u7684\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6E\u597D\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  taho: {
    extension: {
      step1: {
        title: "\u5B89\u88C5Taho\u6269\u5C55\u7A0B\u5E8F",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06Taho\u56FA\u5B9A\u5728\u60A8\u7684\u4EFB\u52A1\u680F\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u5207\u52FF\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6E\u597D\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  talisman: {
    extension: {
      step1: {
        title: "\u5B89\u88C5 Talisman \u6269\u5C55\u7A0B\u5E8F",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06 Talisman \u56FA\u5B9A\u5728\u4EFB\u52A1\u680F\u4E0A\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u4EE5\u592A\u574A\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5206\u4EAB\u60A8\u7684\u6062\u590D\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u8BBE\u7F6E\u597D\u60A8\u7684\u94B1\u5305\u540E\uFF0C\u70B9\u51FB\u4E0B\u65B9\u4EE5\u5237\u65B0\u6D4F\u89C8\u5668\u5E76\u52A0\u8F7D\u6269\u5C55\u7A0B\u5E8F\u3002"
      }
    }
  },
  xdefi: {
    extension: {
      step1: {
        title: "\u5B89\u88C5 XDEFI \u94B1\u5305\u6269\u5C55\u7A0B\u5E8F",
        description: "\u6211\u4EEC\u5EFA\u8BAE\u5C06XDEFI\u94B1\u5305\u56FA\u5B9A\u5230\u60A8\u7684\u4EFB\u52A1\u680F\uFF0C\u4EE5\u4FBF\u66F4\u5FEB\u5730\u8BBF\u95EE\u60A8\u7684\u94B1\u5305\u3002"
      },
      step2: {
        title: "\u521B\u5EFA\u6216\u5BFC\u5165\u94B1\u5305",
        description: "\u786E\u4FDD\u4F7F\u7528\u5B89\u5168\u7684\u65B9\u6CD5\u5907\u4EFD\u60A8\u7684\u94B1\u5305\u3002\u6C38\u8FDC\u4E0D\u8981\u4E0E\u4EFB\u4F55\u4EBA\u5171\u4EAB\u60A8\u7684\u79D8\u5BC6\u77ED\u8BED\u3002"
      },
      step3: {
        title: "\u5237\u65B0\u60A8\u7684\u6D4F\u89C8\u5668",
        description: "\u4E00\u65E6\u4F60\u8BBE\u7F6E\u597D\u4F60\u7684\u94B1\u5305\uFF0C\u70B9\u51FB\u4E0B\u9762\u5237\u65B0\u6D4F\u89C8\u5668\u548C\u52A0\u8F7D\u6269\u5C55\u3002"
      }
    }
  }
};
var zh_CN_default = {
  connect_wallet: connect_wallet13,
  intro: intro13,
  connect: connect13,
  connect_scan: connect_scan13,
  connector_group: connector_group13,
  get: get13,
  get_options: get_options13,
  get_mobile: get_mobile13,
  get_instructions: get_instructions13,
  chains: chains13,
  profile: profile13,
  wallet_connectors: wallet_connectors13
};

// src/locales/index.ts
var i18n = new I18n({
  "ar": ar_AR_default,
  "ar-AR": ar_AR_default,
  "en": en_US_default,
  "en-US": en_US_default,
  "es": es_419_default,
  "es-419": es_419_default,
  "fr": fr_FR_default,
  "fr-FR": fr_FR_default,
  "hi": hi_IN_default,
  "hi-IN": hi_IN_default,
  "id": id_ID_default,
  "id-ID": id_ID_default,
  "ja": ja_JP_default,
  "ja-JP": ja_JP_default,
  "ko": ko_KR_default,
  "ko-KR": ko_KR_default,
  "pt": pt_BR_default,
  "pt-BR": pt_BR_default,
  "ru": ru_RU_default,
  "ru-RU": ru_RU_default,
  "th": th_TH_default,
  "th-TH": th_TH_default,
  "tr": tr_TR_default,
  "tr-TR": tr_TR_default,
  "zh": zh_CN_default,
  "zh-CN": zh_CN_default
});
i18n.defaultLocale = "en-US";
i18n.locale = "en-US";
i18n.enableFallback = true;

// src/utils/locale.ts
var detectedBrowserLocale = () => {
  var _a;
  if (typeof window !== "undefined" && typeof navigator !== "undefined") {
    if ((_a = navigator.languages) == null ? void 0 : _a.length) {
      return navigator.languages[0];
    }
    if (navigator.language) {
      return navigator.language;
    }
  }
};

// src/components/RainbowKitProvider/I18nContext.tsx
var I18nContext = createContext3(i18n);
var I18nProvider = ({ children, locale }) => {
  const browserLocale = useMemo4(() => detectedBrowserLocale(), []);
  const i18n2 = useMemo4(() => {
    if (locale) {
      i18n.locale = locale;
    } else if (!locale && browserLocale) {
      i18n.locale = browserLocale;
    }
    return i18n;
  }, [locale, browserLocale]);
  return /* @__PURE__ */ React9.createElement(I18nContext.Provider, {
    value: i18n2
  }, children);
};

// src/components/RainbowKitProvider/RainbowKitChainContext.tsx
import React10, { createContext as createContext4, useContext as useContext3, useMemo as useMemo5 } from "react";

// src/utils/isNotNullish.ts
function isNotNullish(value) {
  return value != null;
}

// src/components/RainbowKitProvider/provideRainbowKitChains.ts
var arbitrumIcon = {
  iconBackground: "#96bedc",
  iconUrl: async () => (await import("./arbitrum-LYDBJZP3.js")).default
};
var avalancheIcon = {
  iconBackground: "#e84141",
  iconUrl: async () => (await import("./avalanche-TFPKP544.js")).default
};
var baseIcon = {
  iconBackground: "#0052ff",
  iconUrl: async () => (await import("./base-3MIUIYGA.js")).default
};
var bscIcon = {
  iconBackground: "#ebac0e",
  iconUrl: async () => (await import("./bsc-S2GSW6VX.js")).default
};
var cronosIcon = {
  iconBackground: "#002D74",
  iconUrl: async () => (await import("./cronos-DQKKIEX7.js")).default
};
var ethereumIcon = {
  iconBackground: "#484c50",
  iconUrl: async () => (await import("./ethereum-4FY57XJF.js")).default
};
var hardhatIcon = {
  iconBackground: "#f9f7ec",
  iconUrl: async () => (await import("./hardhat-ARRFHFKB.js")).default
};
var optimismIcon = {
  iconBackground: "#ff5a57",
  iconUrl: async () => (await import("./optimism-UUP5Y7TB.js")).default
};
var polygonIcon = {
  iconBackground: "#9f71ec",
  iconUrl: async () => (await import("./polygon-Z4QITDL7.js")).default
};
var zoraIcon = {
  iconBackground: "#000000",
  iconUrl: async () => (await import("./zora-KVO7WIOK.js")).default
};
var zkSyncIcon = {
  iconBackground: "#f9f7ec",
  iconUrl: async () => (await import("./zkSync-XRUC4ZHO.js")).default
};
var chainMetadataByName = {
  arbitrum: { chainId: 42161, name: "Arbitrum", ...arbitrumIcon },
  arbitrumGoerli: { chainId: 421613, ...arbitrumIcon },
  avalanche: { chainId: 43114, ...avalancheIcon },
  avalancheFuji: { chainId: 43113, ...avalancheIcon },
  base: { chainId: 8453, name: "Base", ...baseIcon },
  baseGoerli: { chainId: 84531, ...baseIcon },
  bsc: { chainId: 56, name: "BSC", ...bscIcon },
  bscTestnet: { chainId: 97, ...bscIcon },
  cronos: { chainId: 25, ...cronosIcon },
  cronosTestnet: { chainId: 338, ...cronosIcon },
  goerli: { chainId: 5, ...ethereumIcon },
  hardhat: { chainId: 31337, ...hardhatIcon },
  holesky: { chainId: 17e3, ...ethereumIcon },
  kovan: { chainId: 42, ...ethereumIcon },
  localhost: { chainId: 1337, ...ethereumIcon },
  mainnet: { chainId: 1, name: "Ethereum", ...ethereumIcon },
  optimism: { chainId: 10, name: "Optimism", ...optimismIcon },
  optimismGoerli: { chainId: 420, ...optimismIcon },
  optimismKovan: { chainId: 69, ...optimismIcon },
  polygon: { chainId: 137, name: "Polygon", ...polygonIcon },
  polygonMumbai: { chainId: 80001, ...polygonIcon },
  rinkeby: { chainId: 4, ...ethereumIcon },
  ropsten: { chainId: 3, ...ethereumIcon },
  sepolia: { chainId: 11155111, ...ethereumIcon },
  zora: { chainId: 7777777, name: "Zora", ...zoraIcon },
  zoraTestnet: { chainId: 999, ...zoraIcon },
  zkSync: { chainId: 324, name: "zkSync", ...zkSyncIcon },
  zkSyncTestnet: { chainId: 280, ...zkSyncIcon }
};
var chainMetadataById = Object.fromEntries(Object.values(chainMetadataByName).filter(isNotNullish).map(({ chainId, ...metadata }) => [chainId, metadata]));
var provideRainbowKitChains = (chains14) => chains14.map((chain) => {
  var _a, _b, _c, _d;
  const defaultMetadata = (_a = chainMetadataById[chain.id]) != null ? _a : {};
  return {
    ...chain,
    name: (_b = defaultMetadata.name) != null ? _b : chain.name,
    iconUrl: (_c = chain.iconUrl) != null ? _c : defaultMetadata.iconUrl,
    iconBackground: (_d = chain.iconBackground) != null ? _d : defaultMetadata.iconBackground
  };
});

// src/components/RainbowKitProvider/RainbowKitChainContext.tsx
var RainbowKitChainContext = createContext4({
  chains: []
});
function RainbowKitChainProvider({
  chains: chains14,
  children,
  initialChain
}) {
  return /* @__PURE__ */ React10.createElement(RainbowKitChainContext.Provider, {
    value: useMemo5(() => ({
      chains: provideRainbowKitChains(chains14),
      initialChainId: typeof initialChain === "number" ? initialChain : initialChain == null ? void 0 : initialChain.id
    }), [chains14, initialChain])
  }, children);
}
var useRainbowKitChains = () => useContext3(RainbowKitChainContext).chains;
var useInitialChainId = () => useContext3(RainbowKitChainContext).initialChainId;
var useRainbowKitChainsById = () => {
  const rainbowkitChains = useRainbowKitChains();
  return useMemo5(() => {
    const rainbowkitChainsById = {};
    rainbowkitChains.forEach((rkChain) => {
      rainbowkitChainsById[rkChain.id] = rkChain;
    });
    return rainbowkitChainsById;
  }, [rainbowkitChains]);
};

// src/components/ConnectButton/ConnectButtonRenderer.tsx
import React55, { useContext as useContext17 } from "react";
import { useAccount as useAccount11, useBalance as useBalance2, useNetwork as useNetwork7 } from "wagmi";

// src/hooks/useIsMounted.ts
import { useEffect as useEffect4, useReducer as useReducer3 } from "react";
var useIsMounted = () => {
  const [mounted, setMounted] = useReducer3(() => true, false);
  useEffect4(setMounted, [setMounted]);
  return mounted;
};

// src/hooks/useMainnetEnsAvatar.ts
import { useEnsAvatar } from "wagmi";

// src/hooks/useMainnet.ts
import { usePublicClient } from "wagmi";
import { mainnet } from "wagmi/chains";
function useMainnet() {
  const chainId = mainnet.id;
  const provider = usePublicClient();
  const chains14 = Array.isArray(provider.chains) ? provider.chains : [];
  const enabled = chains14 == null ? void 0 : chains14.some((chain) => (chain == null ? void 0 : chain.id) === chainId);
  return { chainId, enabled };
}

// src/hooks/useMainnetEnsAvatar.ts
function useMainnetEnsAvatar(name) {
  const { chainId, enabled } = useMainnet();
  const { data: ensAvatar } = useEnsAvatar({
    chainId,
    enabled,
    name
  });
  return ensAvatar;
}

// src/hooks/useMainnetEnsName.ts
import { useEnsName } from "wagmi";
function useMainnetEnsName(address) {
  const { chainId, enabled } = useMainnet();
  const { data: ensName } = useEnsName({
    address,
    chainId,
    enabled
  });
  return ensName;
}

// src/transactions/useRecentTransactions.ts
import { useEffect as useEffect6, useState as useState3 } from "react";
import { useAccount as useAccount4 } from "wagmi";

// src/hooks/useChainId.ts
import { useNetwork } from "wagmi";
function useChainId() {
  var _a;
  const { chain: activeChain } = useNetwork();
  return (_a = activeChain == null ? void 0 : activeChain.id) != null ? _a : null;
}

// src/transactions/TransactionStoreContext.tsx
import React11, { createContext as createContext5, useContext as useContext4, useEffect as useEffect5, useState as useState2 } from "react";
import { useAccount as useAccount3, usePublicClient as usePublicClient2 } from "wagmi";

// src/transactions/transactionStore.ts
var storageKey = "rk-transactions";
function safeParseJsonData(string) {
  try {
    const value = string ? JSON.parse(string) : {};
    return typeof value === "object" ? value : {};
  } catch {
    return {};
  }
}
function loadData() {
  return safeParseJsonData(typeof localStorage !== "undefined" ? localStorage.getItem(storageKey) : null);
}
var transactionHashRegex = /^0x([A-Fa-f0-9]{64})$/;
function validateTransaction(transaction) {
  const errors = [];
  if (!transactionHashRegex.test(transaction.hash)) {
    errors.push("Invalid transaction hash");
  }
  if (typeof transaction.description !== "string") {
    errors.push("Transaction must have a description");
  }
  if (typeof transaction.confirmations !== "undefined" && (!Number.isInteger(transaction.confirmations) || transaction.confirmations < 1)) {
    errors.push("Transaction confirmations must be a positiver integer");
  }
  return errors;
}
function createTransactionStore({
  provider: initialProvider
}) {
  let data = loadData();
  let provider = initialProvider;
  const listeners = /* @__PURE__ */ new Set();
  const transactionRequestCache = /* @__PURE__ */ new Map();
  function setProvider(newProvider) {
    provider = newProvider;
  }
  function getTransactions(account, chainId) {
    var _a, _b;
    return (_b = (_a = data[account]) == null ? void 0 : _a[chainId]) != null ? _b : [];
  }
  function addTransaction(account, chainId, transaction) {
    const errors = validateTransaction(transaction);
    if (errors.length > 0) {
      throw new Error(["Unable to add transaction", ...errors].join("\n"));
    }
    updateTransactions(account, chainId, (transactions) => {
      return [
        { ...transaction, status: "pending" },
        ...transactions.filter(({ hash }) => {
          return hash !== transaction.hash;
        })
      ];
    });
  }
  function clearTransactions(account, chainId) {
    updateTransactions(account, chainId, () => {
      return [];
    });
  }
  function setTransactionStatus(account, chainId, hash, status) {
    updateTransactions(account, chainId, (transactions) => {
      return transactions.map((transaction) => transaction.hash === hash ? { ...transaction, status } : transaction);
    });
  }
  async function waitForPendingTransactions(account, chainId) {
    await Promise.all(getTransactions(account, chainId).filter((transaction) => transaction.status === "pending").map(async (transaction) => {
      const { confirmations, hash } = transaction;
      const existingRequest = transactionRequestCache.get(hash);
      if (existingRequest) {
        return await existingRequest;
      }
      const requestPromise = provider.waitForTransactionReceipt({ confirmations, hash }).then(({ status }) => {
        transactionRequestCache.delete(hash);
        if (status === void 0) {
          return;
        }
        setTransactionStatus(account, chainId, hash, status === 0 || status === "reverted" ? "failed" : "confirmed");
      });
      transactionRequestCache.set(hash, requestPromise);
      return await requestPromise;
    }));
  }
  function updateTransactions(account, chainId, updateFn) {
    var _a, _b;
    data = loadData();
    data[account] = (_a = data[account]) != null ? _a : {};
    let completedTransactionCount = 0;
    const MAX_COMPLETED_TRANSACTIONS = 10;
    const transactions = updateFn((_b = data[account][chainId]) != null ? _b : []).filter(({ status }) => {
      return status === "pending" ? true : completedTransactionCount++ <= MAX_COMPLETED_TRANSACTIONS;
    });
    data[account][chainId] = transactions.length > 0 ? transactions : void 0;
    persistData();
    notifyListeners();
    waitForPendingTransactions(account, chainId);
  }
  function persistData() {
    localStorage.setItem(storageKey, JSON.stringify(data));
  }
  function notifyListeners() {
    listeners.forEach((listener) => listener());
  }
  function onChange(fn) {
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }
  return {
    addTransaction,
    clearTransactions,
    getTransactions,
    onChange,
    setProvider,
    waitForPendingTransactions
  };
}

// src/transactions/TransactionStoreContext.tsx
var storeSingleton;
var TransactionStoreContext = createContext5(null);
function TransactionStoreProvider({
  children
}) {
  const provider = usePublicClient2();
  const { address } = useAccount3();
  const chainId = useChainId();
  const [store] = useState2(() => storeSingleton != null ? storeSingleton : storeSingleton = createTransactionStore({ provider }));
  useEffect5(() => {
    store.setProvider(provider);
  }, [store, provider]);
  useEffect5(() => {
    if (address && chainId) {
      store.waitForPendingTransactions(address, chainId);
    }
  }, [store, address, chainId]);
  return /* @__PURE__ */ React11.createElement(TransactionStoreContext.Provider, {
    value: store
  }, children);
}
function useTransactionStore() {
  const store = useContext4(TransactionStoreContext);
  if (!store) {
    throw new Error("Transaction hooks must be used within RainbowKitProvider");
  }
  return store;
}

// src/transactions/useRecentTransactions.ts
function useRecentTransactions() {
  const store = useTransactionStore();
  const { address } = useAccount4();
  const chainId = useChainId();
  const [transactions, setTransactions] = useState3(() => store && address && chainId ? store.getTransactions(address, chainId) : []);
  useEffect6(() => {
    if (store && address && chainId) {
      setTransactions(store.getTransactions(address, chainId));
      return store.onChange(() => {
        setTransactions(store.getTransactions(address, chainId));
      });
    }
  }, [store, address, chainId]);
  return transactions;
}

// src/components/RainbowKitProvider/ModalContext.tsx
import React54, {
  createContext as createContext11,
  useCallback as useCallback9,
  useContext as useContext16,
  useMemo as useMemo7,
  useState as useState10
} from "react";
import { useAccount as useAccount10, useNetwork as useNetwork6 } from "wagmi";

// src/components/AccountModal/AccountModal.tsx
import React34 from "react";
import { useAccount as useAccount9, useBalance, useDisconnect } from "wagmi";

// src/components/Dialog/Dialog.tsx
import React22, {
  useCallback as useCallback5,
  useEffect as useEffect11,
  useState as useState5
} from "react";
import { createPortal } from "react-dom";
import { RemoveScroll } from "react-remove-scroll";

// src/components/RainbowKitProvider/RainbowKitProvider.tsx
import React20, { createContext as createContext10, useContext as useContext5 } from "react";
import { useAccount as useAccount6 } from "wagmi";

// src/css/cssObjectFromTheme.ts
import { assignInlineVars } from "@vanilla-extract/dynamic";
var resolveThemeVars = (theme) => typeof theme === "function" ? theme() : theme;
function cssObjectFromTheme(theme, { extends: baseTheme } = {}) {
  const resolvedThemeVars = {
    ...assignInlineVars(themeVars, resolveThemeVars(theme))
  };
  if (!baseTheme) {
    return resolvedThemeVars;
  }
  const resolvedBaseThemeVars = assignInlineVars(themeVars, resolveThemeVars(baseTheme));
  const filteredVars = Object.fromEntries(Object.entries(resolvedThemeVars).filter(([varName, value]) => value !== resolvedBaseThemeVars[varName]));
  return filteredVars;
}

// src/css/cssStringFromTheme.ts
function cssStringFromTheme(theme, options = {}) {
  return Object.entries(cssObjectFromTheme(theme, options)).map(([key, value]) => `${key}:${value.replace(/[:;{}</>]/g, "")};`).join("");
}

// src/hooks/useWindowSize.ts
import { useEffect as useEffect7, useState as useState4 } from "react";
var useWindowSize = () => {
  const [windowSize, setWindowSize] = useState4({
    height: void 0,
    width: void 0
  });
  useEffect7(() => {
    function handleResize() {
      setWindowSize({
        height: window.innerHeight,
        width: window.innerWidth
      });
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
};

// src/components/RainbowKitProvider/AppContext.ts
import { createContext as createContext6 } from "react";
var defaultAppInfo = {
  appName: void 0,
  disclaimer: void 0,
  learnMoreUrl: "https://learn.rainbow.me/understanding-web3?utm_source=rainbowkit&utm_campaign=learnmore"
};
var AppContext = createContext6(defaultAppInfo);

// src/components/RainbowKitProvider/CoolModeContext.ts
import { createContext as createContext7 } from "react";
var CoolModeContext = createContext7(false);

// src/components/RainbowKitProvider/ModalSizeContext.ts
import { createContext as createContext8 } from "react";
var ModalSizeOptions = {
  COMPACT: "compact",
  WIDE: "wide"
};
var ModalSizeContext = createContext8(ModalSizeOptions.WIDE);

// src/components/RainbowKitProvider/ShowRecentTransactionsContext.ts
import { createContext as createContext9 } from "react";
var ShowRecentTransactionsContext = createContext9(false);

// src/components/RainbowKitProvider/useFingerprint.ts
import { useCallback, useEffect as useEffect8 } from "react";
var storageKey2 = "rk-version";
function setRainbowKitVersion({ version }) {
  localStorage.setItem(storageKey2, version);
}
function useFingerprint() {
  const fingerprint = useCallback(() => {
    setRainbowKitVersion({ version: "1.1.3" });
  }, []);
  useEffect8(() => {
    fingerprint();
  }, [fingerprint]);
}

// src/components/RainbowKitProvider/usePreloadImages.ts
import { useCallback as useCallback3, useEffect as useEffect9 } from "react";

// src/wallets/useWalletConnectors.ts
import { useConnect } from "wagmi";

// src/utils/flatten.ts
function flatten(array) {
  const flattenedItems = [];
  for (const items of array) {
    flattenedItems.push(...items);
  }
  return flattenedItems;
}

// src/utils/indexBy.ts
function indexBy(items, getKey) {
  const indexedItems = {};
  items.forEach((item) => {
    const key = getKey(item);
    if (!key) {
      return;
    }
    indexedItems[key] = item;
  });
  return indexedItems;
}

// src/utils/browsers.ts
function isSafari() {
  return typeof navigator !== "undefined" && /Version\/([0-9._]+).*Safari/.test(navigator.userAgent);
}
function isArc() {
  return typeof document !== "undefined" && getComputedStyle(document.body).getPropertyValue("--arc-palette-focus") !== "";
}
function getBrowser() {
  var _a;
  if (typeof navigator === "undefined")
    return "Browser" /* Browser */;
  const ua = navigator.userAgent.toLowerCase();
  if ((_a = navigator.brave) == null ? void 0 : _a.isBrave)
    return "Brave" /* Brave */;
  else if (ua.indexOf("edg/") > -1)
    return "Edge" /* Edge */;
  else if (ua.indexOf("op") > -1)
    return "Opera" /* Opera */;
  else if (isArc())
    return "Arc" /* Arc */;
  else if (ua.indexOf("chrome") > -1)
    return "Chrome" /* Chrome */;
  else if (ua.indexOf("firefox") > -1)
    return "Firefox" /* Firefox */;
  else if (isSafari())
    return "Safari" /* Safari */;
  return "Browser" /* Browser */;
}

// src/wallets/downloadUrls.ts
var getExtensionDownloadUrl = (wallet) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const browser = getBrowser();
  return (_l = {
    ["Arc" /* Arc */]: (_a = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _a.chrome,
    ["Brave" /* Brave */]: (_b = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _b.chrome,
    ["Chrome" /* Chrome */]: (_c = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _c.chrome,
    ["Edge" /* Edge */]: ((_d = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _d.edge) || ((_e = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _e.chrome),
    ["Firefox" /* Firefox */]: (_f = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _f.firefox,
    ["Opera" /* Opera */]: ((_g = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _g.opera) || ((_h = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _h.chrome),
    ["Safari" /* Safari */]: (_i = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _i.safari,
    ["Browser" /* Browser */]: (_j = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _j.browserExtension
  }[browser]) != null ? _l : (_k = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _k.browserExtension;
};
var getMobileDownloadUrl = (wallet) => {
  var _a, _b, _c, _d;
  const ios = isIOS();
  return (_d = ios ? (_a = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _a.ios : (_b = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _b.android) != null ? _d : (_c = wallet == null ? void 0 : wallet.downloadUrls) == null ? void 0 : _c.mobile;
};

// src/wallets/recentWalletIds.ts
var storageKey3 = "rk-recent";
function safeParseJsonArray(string) {
  try {
    const value = string ? JSON.parse(string) : [];
    return Array.isArray(value) ? value : [];
  } catch {
    return [];
  }
}
function getRecentWalletIds() {
  return typeof localStorage !== "undefined" ? safeParseJsonArray(localStorage.getItem(storageKey3)) : [];
}
function dedupe(array) {
  return [...new Set(array)];
}
function addRecentWalletId(walletId) {
  const newValue = dedupe([walletId, ...getRecentWalletIds()]);
  localStorage.setItem(storageKey3, JSON.stringify(newValue));
}

// src/wallets/useWalletConnectors.ts
function useWalletConnectors() {
  const rainbowKitChains = useRainbowKitChains();
  const intialChainId = useInitialChainId();
  const { connectAsync, connectors: defaultConnectors_untyped } = useConnect();
  const defaultConnectors = defaultConnectors_untyped;
  async function connectWallet(walletId, connector) {
    var _a, _b, _c;
    const walletChainId = await connector.getChainId();
    const result = await connectAsync({
      chainId: (_c = intialChainId != null ? intialChainId : (_a = rainbowKitChains.find(({ id }) => id === walletChainId)) == null ? void 0 : _a.id) != null ? _c : (_b = rainbowKitChains[0]) == null ? void 0 : _b.id,
      connector
    });
    if (result) {
      addRecentWalletId(walletId);
    }
    return result;
  }
  async function connectToWalletConnectModal(walletId, walletConnectModalConnector) {
    try {
      return await connectWallet(walletId, walletConnectModalConnector);
    } catch (err) {
      const isUserRejection = err.name === "UserRejectedRequestError" || err.message === "Connection request reset. Please try again.";
      if (!isUserRejection) {
        throw err;
      }
    }
  }
  const walletInstances = flatten(defaultConnectors.map((connector) => {
    var _a;
    return (_a = connector._wallets) != null ? _a : [];
  })).sort((a, b) => a.index - b.index);
  const walletInstanceById = indexBy(walletInstances, (walletInstance) => walletInstance.id);
  const MAX_RECENT_WALLETS = 3;
  const recentWallets = getRecentWalletIds().map((walletId) => walletInstanceById[walletId]).filter(isNotNullish).slice(0, MAX_RECENT_WALLETS);
  const groupedWallets = [
    ...recentWallets,
    ...walletInstances.filter((walletInstance) => !recentWallets.includes(walletInstance))
  ];
  const walletConnectors = [];
  groupedWallets.forEach((wallet) => {
    var _a;
    if (!wallet) {
      return;
    }
    const recent = recentWallets.includes(wallet);
    walletConnectors.push({
      ...wallet,
      connect: () => wallet.connector.showQrModal ? connectToWalletConnectModal(wallet.id, wallet.connector) : connectWallet(wallet.id, wallet.connector),
      extensionDownloadUrl: getExtensionDownloadUrl(wallet),
      groupName: wallet.groupName,
      mobileDownloadUrl: getMobileDownloadUrl(wallet),
      onConnecting: (fn) => wallet.connector.on("message", ({ type }) => type === "connecting" ? fn() : void 0),
      ready: ((_a = wallet.installed) != null ? _a : true) && wallet.connector.ready,
      recent,
      showWalletConnectModal: wallet.walletConnectModalConnector ? () => connectToWalletConnectModal(wallet.id, wallet.walletConnectModalConnector) : void 0
    });
  });
  return walletConnectors;
}

// src/components/Icons/Assets.tsx
import React13 from "react";
var src = async () => (await import("./assets-26YY4GVD.js")).default;
var preloadAssetsIcon = () => loadImages(src);
var AssetsIcon = () => /* @__PURE__ */ React13.createElement(AsyncImage, {
  background: "#d0d5de",
  borderRadius: "10",
  height: "48",
  src,
  width: "48"
});

// src/components/Icons/Login.tsx
import React14 from "react";
var src2 = async () => (await import("./login-ZSMM5UYL.js")).default;
var preloadLoginIcon = () => loadImages(src2);
var LoginIcon = () => /* @__PURE__ */ React14.createElement(AsyncImage, {
  background: "#d0d5de",
  borderRadius: "10",
  height: "48",
  src: src2,
  width: "48"
});

// src/components/SignIn/SignIn.tsx
import React19, { useCallback as useCallback2, useRef as useRef2 } from "react";
import { UserRejectedRequestError } from "viem";
import { useAccount as useAccount5, useNetwork as useNetwork2, useSignMessage } from "wagmi";

// src/components/Button/ActionButton.tsx
import React16 from "react";

// src/components/Text/Text.tsx
import React15 from "react";
var Text = React15.forwardRef(({
  as = "div",
  children,
  className,
  color,
  display,
  font = "body",
  id,
  size = "16",
  style,
  tabIndex,
  textAlign = "inherit",
  weight = "regular",
  testId
}, ref) => {
  return /* @__PURE__ */ React15.createElement(Box, {
    as,
    className,
    color,
    display,
    fontFamily: font,
    fontSize: size,
    fontWeight: weight,
    id,
    ref,
    style,
    tabIndex,
    textAlign,
    testId
  }, children);
});
Text.displayName = "Text";

// src/components/Button/ActionButton.tsx
var sizeVariants = {
  large: {
    fontSize: "16",
    paddingX: "24",
    paddingY: "10"
  },
  medium: {
    fontSize: "14",
    height: "28",
    paddingX: "12",
    paddingY: "4"
  },
  small: {
    fontSize: "14",
    paddingX: "10",
    paddingY: "5"
  }
};
function ActionButton({
  disabled = false,
  href,
  label,
  onClick,
  rel = "noreferrer noopener",
  size = "medium",
  target = "_blank",
  testId,
  type = "primary"
}) {
  const isPrimary = type === "primary";
  const isNotLarge = size !== "large";
  const mobile = isMobile();
  const background = !disabled ? isPrimary ? "accentColor" : isNotLarge ? "actionButtonSecondaryBackground" : null : "actionButtonSecondaryBackground";
  const { fontSize, height, paddingX, paddingY } = sizeVariants[size];
  const hasBorder = !mobile || !isNotLarge;
  return /* @__PURE__ */ React16.createElement(Box, {
    ...href ? !disabled ? { as: "a", href, rel, target } : {} : { as: "button", type: "button" },
    onClick: !disabled ? onClick : void 0,
    ...hasBorder ? {
      borderColor: mobile && !isNotLarge && !isPrimary ? "actionButtonBorderMobile" : "actionButtonBorder",
      borderStyle: "solid",
      borderWidth: "1"
    } : {},
    borderRadius: "actionButton",
    className: !disabled && touchableStyles({ active: "shrinkSm", hover: "grow" }),
    display: "block",
    paddingX,
    paddingY,
    style: { willChange: "transform" },
    testId,
    textAlign: "center",
    transition: "transform",
    ...background ? { background } : {},
    ...height ? { height } : {}
  }, /* @__PURE__ */ React16.createElement(Text, {
    color: !disabled ? isPrimary ? "accentColorForeground" : "accentColor" : "modalTextSecondary",
    size: fontSize,
    weight: "bold"
  }, label));
}

// src/components/CloseButton/CloseButton.tsx
import React18 from "react";

// src/components/Icons/Close.tsx
import React17 from "react";
var CloseIcon = () => {
  return isMobile() ? /* @__PURE__ */ React17.createElement("svg", {
    "aria-hidden": true,
    fill: "none",
    height: "11.5",
    viewBox: "0 0 11.5 11.5",
    width: "11.5",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React17.createElement("path", {
    d: "M2.13388 0.366117C1.64573 -0.122039 0.854272 -0.122039 0.366117 0.366117C-0.122039 0.854272 -0.122039 1.64573 0.366117 2.13388L3.98223 5.75L0.366117 9.36612C-0.122039 9.85427 -0.122039 10.6457 0.366117 11.1339C0.854272 11.622 1.64573 11.622 2.13388 11.1339L5.75 7.51777L9.36612 11.1339C9.85427 11.622 10.6457 11.622 11.1339 11.1339C11.622 10.6457 11.622 9.85427 11.1339 9.36612L7.51777 5.75L11.1339 2.13388C11.622 1.64573 11.622 0.854272 11.1339 0.366117C10.6457 -0.122039 9.85427 -0.122039 9.36612 0.366117L5.75 3.98223L2.13388 0.366117Z",
    fill: "currentColor"
  })) : /* @__PURE__ */ React17.createElement("svg", {
    "aria-hidden": true,
    fill: "none",
    height: "10",
    viewBox: "0 0 10 10",
    width: "10",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React17.createElement("path", {
    d: "M1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L3.58579 5L0.292893 8.29289C-0.0976311 8.68342 -0.0976311 9.31658 0.292893 9.70711C0.683417 10.0976 1.31658 10.0976 1.70711 9.70711L5 6.41421L8.29289 9.70711C8.68342 10.0976 9.31658 10.0976 9.70711 9.70711C10.0976 9.31658 10.0976 8.68342 9.70711 8.29289L6.41421 5L9.70711 1.70711C10.0976 1.31658 10.0976 0.683417 9.70711 0.292893C9.31658 -0.0976311 8.68342 -0.0976311 8.29289 0.292893L5 3.58579L1.70711 0.292893Z",
    fill: "currentColor"
  }));
};

// src/components/CloseButton/CloseButton.tsx
var CloseButton = ({
  "aria-label": ariaLabel = "Close",
  onClose
}) => {
  const mobile = isMobile();
  return /* @__PURE__ */ React18.createElement(Box, {
    alignItems: "center",
    "aria-label": ariaLabel,
    as: "button",
    background: "closeButtonBackground",
    borderColor: "actionButtonBorder",
    borderRadius: "full",
    borderStyle: "solid",
    borderWidth: mobile ? "0" : "1",
    className: touchableStyles({ active: "shrinkSm", hover: "growLg" }),
    color: "closeButton",
    display: "flex",
    height: mobile ? "30" : "28",
    justifyContent: "center",
    onClick: onClose,
    style: { willChange: "transform" },
    transition: "default",
    type: "button",
    width: mobile ? "30" : "28"
  }, /* @__PURE__ */ React18.createElement(CloseIcon, null));
};

// src/components/SignIn/SignIn.tsx
var signInIcon = async () => (await import("./sign-FZVB2CS6.js")).default;
function SignIn({ onClose }) {
  const [{ status, ...state }, setState] = React19.useState({ status: "idle" });
  const authAdapter = useAuthenticationAdapter();
  const getNonce = useCallback2(async () => {
    try {
      const nonce = await authAdapter.getNonce();
      setState((x) => ({ ...x, nonce }));
    } catch {
      setState((x) => ({
        ...x,
        errorMessage: "Error preparing message, please retry!",
        status: "idle"
      }));
    }
  }, [authAdapter]);
  const onceRef = useRef2(false);
  React19.useEffect(() => {
    if (onceRef.current)
      return;
    onceRef.current = true;
    getNonce();
  }, [getNonce]);
  const mobile = isMobile();
  const { address } = useAccount5();
  const { chain: activeChain } = useNetwork2();
  const { signMessageAsync } = useSignMessage();
  const signIn = async () => {
    try {
      const chainId = activeChain == null ? void 0 : activeChain.id;
      const { nonce } = state;
      if (!address || !chainId || !nonce) {
        return;
      }
      setState((x) => ({
        ...x,
        errorMessage: void 0,
        status: "signing"
      }));
      const message = authAdapter.createMessage({ address, chainId, nonce });
      let signature;
      try {
        signature = await signMessageAsync({
          message: authAdapter.getMessageBody({ message })
        });
      } catch (error) {
        if (error instanceof UserRejectedRequestError) {
          return setState((x) => ({
            ...x,
            status: "idle"
          }));
        }
        return setState((x) => ({
          ...x,
          errorMessage: "Error signing message, please retry!",
          status: "idle"
        }));
      }
      setState((x) => ({ ...x, status: "verifying" }));
      try {
        const verified = await authAdapter.verify({ message, signature });
        if (verified) {
          return;
        } else {
          throw new Error();
        }
      } catch {
        return setState((x) => ({
          ...x,
          errorMessage: "Error verifying signature, please retry!",
          status: "idle"
        }));
      }
    } catch {
      setState({
        errorMessage: "Oops, something went wrong!",
        status: "idle"
      });
    }
  };
  return /* @__PURE__ */ React19.createElement(Box, {
    position: "relative"
  }, /* @__PURE__ */ React19.createElement(Box, {
    display: "flex",
    paddingRight: "16",
    paddingTop: "16",
    position: "absolute",
    right: "0"
  }, /* @__PURE__ */ React19.createElement(CloseButton, {
    onClose
  })), /* @__PURE__ */ React19.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "32" : "24",
    padding: "24",
    paddingX: "18",
    style: { paddingTop: mobile ? "60px" : "36px" }
  }, /* @__PURE__ */ React19.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "6" : "4",
    style: { maxWidth: mobile ? 320 : 280 }
  }, /* @__PURE__ */ React19.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "32" : "16"
  }, /* @__PURE__ */ React19.createElement(AsyncImage, {
    height: 40,
    src: signInIcon,
    width: 40
  }), /* @__PURE__ */ React19.createElement(Text, {
    color: "modalText",
    size: mobile ? "20" : "18",
    textAlign: "center",
    weight: "heavy"
  }, "Verify your account")), /* @__PURE__ */ React19.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "16" : "12"
  }, /* @__PURE__ */ React19.createElement(Text, {
    color: "modalTextSecondary",
    size: mobile ? "16" : "14",
    textAlign: "center"
  }, "To finish connecting, you must sign a message in your wallet to verify that you are the owner of this account."), status === "idle" && state.errorMessage ? /* @__PURE__ */ React19.createElement(Text, {
    color: "error",
    size: mobile ? "16" : "14",
    textAlign: "center",
    weight: "bold"
  }, state.errorMessage) : null)), /* @__PURE__ */ React19.createElement(Box, {
    alignItems: !mobile ? "center" : void 0,
    display: "flex",
    flexDirection: "column",
    gap: "8",
    width: "full"
  }, /* @__PURE__ */ React19.createElement(ActionButton, {
    disabled: !state.nonce || status === "signing" || status === "verifying",
    label: !state.nonce ? "Preparing message..." : status === "signing" ? "Waiting for signature..." : status === "verifying" ? "Verifying signature..." : "Send message",
    onClick: signIn,
    size: mobile ? "large" : "medium",
    testId: "auth-message-button"
  }), mobile ? /* @__PURE__ */ React19.createElement(ActionButton, {
    label: "Cancel",
    onClick: onClose,
    size: "large",
    type: "secondary"
  }) : /* @__PURE__ */ React19.createElement(Box, {
    as: "button",
    borderRadius: "full",
    className: touchableStyles({ active: "shrink", hover: "grow" }),
    display: "block",
    onClick: onClose,
    paddingX: "10",
    paddingY: "5",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ React19.createElement(Text, {
    color: "closeButton",
    size: mobile ? "16" : "14",
    weight: "bold"
  }, "Cancel")))));
}

// src/components/RainbowKitProvider/usePreloadImages.ts
function usePreloadImages() {
  const rainbowKitChains = useRainbowKitChains();
  const walletConnectors = useWalletConnectors();
  const isUnauthenticated = useAuthenticationStatus() === "unauthenticated";
  const preloadImages = useCallback3(() => {
    loadImages(...walletConnectors.map((wallet) => wallet.iconUrl), ...rainbowKitChains.map((chain) => chain.iconUrl).filter(isNotNullish));
    if (!isMobile()) {
      preloadAssetsIcon();
      preloadLoginIcon();
    }
    if (isUnauthenticated) {
      loadImages(signInIcon);
    }
  }, [walletConnectors, rainbowKitChains, isUnauthenticated]);
  useEffect9(() => {
    preloadImages();
  }, [preloadImages]);
}

// src/components/RainbowKitProvider/walletConnectDeepLink.ts
var storageKey4 = "WALLETCONNECT_DEEPLINK_CHOICE";
function setWalletConnectDeepLink({
  mobileUri,
  name
}) {
  localStorage.setItem(storageKey4, JSON.stringify({
    href: mobileUri.split("?")[0],
    name
  }));
}
function clearWalletConnectDeepLink() {
  localStorage.removeItem(storageKey4);
}

// src/components/RainbowKitProvider/RainbowKitProvider.tsx
var ThemeIdContext = createContext10(void 0);
var attr = "data-rk";
var createThemeRootProps = (id) => ({ [attr]: id || "" });
var createThemeRootSelector = (id) => {
  if (id && !/^[a-zA-Z0-9_]+$/.test(id)) {
    throw new Error(`Invalid ID: ${id}`);
  }
  return id ? `[${attr}="${id}"]` : `[${attr}]`;
};
var useThemeRootProps = () => {
  const id = useContext5(ThemeIdContext);
  return createThemeRootProps(id);
};
var defaultTheme = lightTheme();
function RainbowKitProvider({
  appInfo,
  avatar,
  chains: chains14,
  children,
  coolMode = false,
  id,
  initialChain,
  locale,
  modalSize = ModalSizeOptions.WIDE,
  showRecentTransactions = false,
  theme = defaultTheme
}) {
  usePreloadImages();
  useFingerprint();
  useAccount6({ onDisconnect: clearWalletConnectDeepLink });
  if (typeof theme === "function") {
    throw new Error('A theme function was provided to the "theme" prop instead of a theme object. You must execute this function to get the resulting theme object.');
  }
  const selector = createThemeRootSelector(id);
  const appContext = {
    ...defaultAppInfo,
    ...appInfo
  };
  const avatarContext = avatar != null ? avatar : defaultAvatar;
  const { width } = useWindowSize();
  const isSmallScreen = width && width < largeScreenMinWidth;
  return /* @__PURE__ */ React20.createElement(RainbowKitChainProvider, {
    chains: chains14,
    initialChain
  }, /* @__PURE__ */ React20.createElement(I18nProvider, {
    locale
  }, /* @__PURE__ */ React20.createElement(CoolModeContext.Provider, {
    value: coolMode
  }, /* @__PURE__ */ React20.createElement(ModalSizeContext.Provider, {
    value: isSmallScreen ? ModalSizeOptions.COMPACT : modalSize
  }, /* @__PURE__ */ React20.createElement(ShowRecentTransactionsContext.Provider, {
    value: showRecentTransactions
  }, /* @__PURE__ */ React20.createElement(TransactionStoreProvider, null, /* @__PURE__ */ React20.createElement(AvatarContext.Provider, {
    value: avatarContext
  }, /* @__PURE__ */ React20.createElement(AppContext.Provider, {
    value: appContext
  }, /* @__PURE__ */ React20.createElement(ThemeIdContext.Provider, {
    value: id
  }, /* @__PURE__ */ React20.createElement(ModalProvider, null, theme ? /* @__PURE__ */ React20.createElement("div", {
    ...createThemeRootProps(id)
  }, /* @__PURE__ */ React20.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: [
        `${selector}{${cssStringFromTheme("lightMode" in theme ? theme.lightMode : theme)}}`,
        "darkMode" in theme ? `@media(prefers-color-scheme:dark){${selector}{${cssStringFromTheme(theme.darkMode, { extends: theme.lightMode })}}}` : null
      ].join("")
    }
  }), children) : children))))))))));
}

// src/components/Dialog/Dialog.css.ts
var content = "_9pm4ki5 ju367va ju367v10 ju367v8m";
var overlay = "_9pm4ki3 ju367v9b ju367vax ju367va ju367v2l ju367v8l";

// src/components/Dialog/FocusTrap.tsx
import React21, { useCallback as useCallback4, useEffect as useEffect10, useRef as useRef3 } from "react";
var moveFocusWithin = (element2, position) => {
  const focusableElements = element2.querySelectorAll("button:not(:disabled), a[href]");
  if (focusableElements.length === 0)
    return;
  focusableElements[position === "end" ? focusableElements.length - 1 : 0].focus();
};
function FocusTrap(props) {
  const contentRef = useRef3(null);
  useEffect10(() => {
    const previouslyActiveElement = document.activeElement;
    return () => {
      var _a;
      (_a = previouslyActiveElement.focus) == null ? void 0 : _a.call(previouslyActiveElement);
    };
  }, []);
  useEffect10(() => {
    if (contentRef.current) {
      const elementToFocus = contentRef.current.querySelector("[data-auto-focus]");
      if (elementToFocus) {
        elementToFocus.focus();
      } else {
        contentRef.current.focus();
      }
    }
  }, [contentRef]);
  return /* @__PURE__ */ React21.createElement(React21.Fragment, null, /* @__PURE__ */ React21.createElement("div", {
    onFocus: useCallback4(() => contentRef.current && moveFocusWithin(contentRef.current, "end"), []),
    tabIndex: 0
  }), /* @__PURE__ */ React21.createElement("div", {
    ref: contentRef,
    style: { outline: "none" },
    tabIndex: -1,
    ...props
  }), /* @__PURE__ */ React21.createElement("div", {
    onFocus: useCallback4(() => contentRef.current && moveFocusWithin(contentRef.current, "start"), []),
    tabIndex: 0
  }));
}

// src/components/Dialog/Dialog.tsx
var stopPropagation = (event) => event.stopPropagation();
function Dialog({ children, onClose, open, titleId }) {
  useEffect11(() => {
    const handleEscape = (event) => open && event.key === "Escape" && onClose();
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [open, onClose]);
  const [bodyScrollable, setBodyScrollable] = useState5(true);
  useEffect11(() => {
    setBodyScrollable(getComputedStyle(window.document.body).overflow !== "hidden");
  }, []);
  const handleBackdropClick = useCallback5(() => onClose(), [onClose]);
  const themeRootProps = useThemeRootProps();
  const mobile = isMobile();
  return /* @__PURE__ */ React22.createElement(React22.Fragment, null, open ? createPortal(/* @__PURE__ */ React22.createElement(RemoveScroll, {
    enabled: bodyScrollable
  }, /* @__PURE__ */ React22.createElement(Box, {
    ...themeRootProps
  }, /* @__PURE__ */ React22.createElement(Box, {
    ...themeRootProps,
    alignItems: mobile ? "flex-end" : "center",
    "aria-labelledby": titleId,
    "aria-modal": true,
    className: overlay,
    onClick: handleBackdropClick,
    position: "fixed",
    role: "dialog"
  }, /* @__PURE__ */ React22.createElement(FocusTrap, {
    className: content,
    onClick: stopPropagation,
    role: "document"
  }, children)))), document.body) : null);
}

// src/components/Dialog/DialogContent.tsx
import React23, { useContext as useContext6 } from "react";

// src/components/Dialog/DialogContent.css.ts
var bottomSheetOverrides = "_1ckjpok7";
var dialogContent = "_1ckjpok1 ju367vb0 ju367vdl ju367vp ju367vt ju367vv ju367vef ju367va ju367v10 ju367v67 ju367v8m";
var dialogContentCompactMode = "_1ckjpok4 _1ckjpok1 ju367vb0 ju367vdl ju367vp ju367vt ju367vv ju367vef ju367va ju367v10 ju367v67 ju367v8m";
var dialogContentMobile = "_1ckjpok6 ju367vq";
var dialogContentWideDesktop = "_1ckjpok3 _1ckjpok1 ju367vb0 ju367vdl ju367vp ju367vt ju367vv ju367vef ju367va ju367v10 ju367v67 ju367v8m";
var dialogContentWideMobile = "_1ckjpok2 _1ckjpok1 ju367vb0 ju367vdl ju367vp ju367vt ju367vv ju367vef ju367va ju367v10 ju367v67 ju367v8m";

// src/components/Dialog/DialogContent.tsx
function DialogContent({
  bottomSheetOnMobile = false,
  children,
  marginTop,
  padding = "16",
  paddingBottom,
  wide = false
}) {
  const mobile = isMobile();
  const modalSize = useContext6(ModalSizeContext);
  const compactModeEnabled = modalSize === ModalSizeOptions.COMPACT;
  return /* @__PURE__ */ React23.createElement(Box, {
    marginTop
  }, /* @__PURE__ */ React23.createElement(Box, {
    className: [
      wide ? mobile ? dialogContentWideMobile : compactModeEnabled ? dialogContentCompactMode : dialogContentWideDesktop : dialogContent,
      mobile ? dialogContentMobile : null,
      mobile && bottomSheetOnMobile ? bottomSheetOverrides : null
    ].join(" ")
  }, /* @__PURE__ */ React23.createElement(Box, {
    padding,
    paddingBottom: paddingBottom != null ? paddingBottom : padding
  }, children)));
}

// src/components/ProfileDetails/ProfileDetails.tsx
import React33, { useCallback as useCallback7, useContext as useContext8, useEffect as useEffect12, useState as useState6 } from "react";

// src/components/ConnectButton/abbreviateETHBalance.ts
var units = ["k", "m", "b", "t"];
function toPrecision(number, precision = 1) {
  return number.toString().replace(new RegExp(`(.+\\.\\d{${precision}})\\d+`), "$1").replace(/(\.[1-9]*)0+$/, "$1").replace(/\.$/, "");
}
function abbreviateETHBalance(number) {
  if (number < 1)
    return toPrecision(number, 3);
  if (number < 10 ** 2)
    return toPrecision(number, 2);
  if (number < 10 ** 4)
    return new Intl.NumberFormat().format(parseFloat(toPrecision(number, 1)));
  const decimalsDivisor = 10 ** 1;
  let result = String(number);
  for (let i = units.length - 1; i >= 0; i--) {
    const size = 10 ** ((i + 1) * 3);
    if (size <= number) {
      number = number * decimalsDivisor / size / decimalsDivisor;
      result = toPrecision(number, 1) + units[i];
      break;
    }
  }
  return result;
}

// src/components/ConnectButton/formatAddress.ts
function formatAddress(address) {
  const leadingChars = 4;
  const trailingChars = 4;
  return address.length < leadingChars + trailingChars ? address : `${address.substring(0, leadingChars)}\u2026${address.substring(address.length - trailingChars)}`;
}

// src/components/ConnectButton/formatENS.ts
function formatENS(name) {
  const parts = name.split(".");
  const last = parts.pop();
  if (parts.join(".").length > 24) {
    return `${parts.join(".").substring(0, 24)}...`;
  }
  return `${parts.join(".")}.${last}`;
}

// src/components/Icons/Copied.tsx
import React24 from "react";
var CopiedIcon = () => /* @__PURE__ */ React24.createElement("svg", {
  fill: "none",
  height: "13",
  viewBox: "0 0 13 13",
  width: "13",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React24.createElement("path", {
  d: "M4.94568 12.2646C5.41052 12.2646 5.77283 12.0869 6.01892 11.7109L12.39 1.96973C12.5677 1.69629 12.6429 1.44336 12.6429 1.2041C12.6429 0.561523 12.1644 0.0966797 11.5082 0.0966797C11.057 0.0966797 10.7767 0.260742 10.5033 0.691406L4.9115 9.50977L2.07458 5.98926C1.82166 5.68848 1.54822 5.55176 1.16541 5.55176C0.502319 5.55176 0.0238037 6.02344 0.0238037 6.66602C0.0238037 6.95312 0.112671 7.20605 0.358765 7.48633L3.88611 11.7588C4.18005 12.1074 4.50818 12.2646 4.94568 12.2646Z",
  fill: "currentColor"
}));

// src/components/Icons/Copy.tsx
import React25 from "react";
var CopyIcon = () => /* @__PURE__ */ React25.createElement("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 17 16",
  width: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React25.createElement("path", {
  d: "M3.04236 12.3027H4.18396V13.3008C4.18396 14.8525 5.03845 15.7002 6.59705 15.7002H13.6244C15.183 15.7002 16.0375 14.8525 16.0375 13.3008V6.24609C16.0375 4.69434 15.183 3.84668 13.6244 3.84668H12.4828V2.8418C12.4828 1.29688 11.6283 0.442383 10.0697 0.442383H3.04236C1.48376 0.442383 0.629272 1.29004 0.629272 2.8418V9.90332C0.629272 11.4551 1.48376 12.3027 3.04236 12.3027ZM3.23376 10.5391C2.68689 10.5391 2.39294 10.2656 2.39294 9.68457V3.06055C2.39294 2.47949 2.68689 2.21289 3.23376 2.21289H9.8783C10.4252 2.21289 10.7191 2.47949 10.7191 3.06055V3.84668H6.59705C5.03845 3.84668 4.18396 4.69434 4.18396 6.24609V10.5391H3.23376ZM6.78845 13.9365C6.24158 13.9365 5.94763 13.6699 5.94763 13.0889V6.45801C5.94763 5.87695 6.24158 5.61035 6.78845 5.61035H13.433C13.9799 5.61035 14.2738 5.87695 14.2738 6.45801V13.0889C14.2738 13.6699 13.9799 13.9365 13.433 13.9365H6.78845Z",
  fill: "currentColor"
}));

// src/components/Icons/Disconnect.tsx
import React26 from "react";
var DisconnectIcon = () => /* @__PURE__ */ React26.createElement("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 18 16",
  width: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React26.createElement("path", {
  d: "M2.67834 15.5908H9.99963C11.5514 15.5908 12.399 14.7432 12.399 13.1777V10.2656H10.6354V12.9863C10.6354 13.5332 10.3688 13.8271 9.78772 13.8271H2.89026C2.3092 13.8271 2.0426 13.5332 2.0426 12.9863V3.15625C2.0426 2.60254 2.3092 2.30859 2.89026 2.30859H9.78772C10.3688 2.30859 10.6354 2.60254 10.6354 3.15625V5.89746H12.399V2.95801C12.399 1.39941 11.5514 0.544922 9.99963 0.544922H2.67834C1.12659 0.544922 0.278931 1.39941 0.278931 2.95801V13.1777C0.278931 14.7432 1.12659 15.5908 2.67834 15.5908ZM7.43616 8.85059H14.0875L15.0924 8.78906L14.566 9.14453L13.6842 9.96484C13.5406 10.1016 13.4586 10.2861 13.4586 10.4844C13.4586 10.8398 13.7321 11.168 14.1217 11.168C14.3199 11.168 14.4635 11.0928 14.6002 10.9561L16.7809 8.68652C16.986 8.48145 17.0543 8.27637 17.0543 8.06445C17.0543 7.85254 16.986 7.64746 16.7809 7.43555L14.6002 5.17285C14.4635 5.03613 14.3199 4.9541 14.1217 4.9541C13.7321 4.9541 13.4586 5.27539 13.4586 5.6377C13.4586 5.83594 13.5406 6.02734 13.6842 6.15723L14.566 6.98438L15.0924 7.33984L14.0875 7.27148H7.43616C7.01917 7.27148 6.65686 7.62012 6.65686 8.06445C6.65686 8.50195 7.01917 8.85059 7.43616 8.85059Z",
  fill: "currentColor"
}));

// src/components/Txs/TxList.tsx
import React31, { useContext as useContext7 } from "react";
import { useNetwork as useNetwork4 } from "wagmi";

// src/transactions/useClearRecentTransactions.ts
import { useCallback as useCallback6 } from "react";
import { useAccount as useAccount7 } from "wagmi";
function useClearRecentTransactions() {
  const store = useTransactionStore();
  const { address } = useAccount7();
  const chainId = useChainId();
  return useCallback6(() => {
    if (!address || !chainId) {
      throw new Error("No address or chain ID found");
    }
    store.clearTransactions(address, chainId);
  }, [store, address, chainId]);
}

// src/utils/chainToExplorerUrl.ts
var chainToExplorerUrl = (chain) => {
  var _a, _b;
  return (_b = (_a = chain == null ? void 0 : chain.blockExplorers) == null ? void 0 : _a.default) == null ? void 0 : _b.url;
};

// src/components/Icons/ExternalLink.tsx
import React27 from "react";
var ExternalLinkIcon = () => /* @__PURE__ */ React27.createElement("svg", {
  fill: "none",
  height: "19",
  viewBox: "0 0 20 19",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React27.createElement("path", {
  d: "M10 18.9443C15.0977 18.9443 19.2812 14.752 19.2812 9.6543C19.2812 4.56543 15.0889 0.373047 10 0.373047C4.90234 0.373047 0.71875 4.56543 0.71875 9.6543C0.71875 14.752 4.91113 18.9443 10 18.9443ZM10 16.6328C6.1416 16.6328 3.03906 13.5215 3.03906 9.6543C3.03906 5.7959 6.13281 2.68457 10 2.68457C13.8584 2.68457 16.9697 5.7959 16.9697 9.6543C16.9785 13.5215 13.8672 16.6328 10 16.6328ZM12.7158 12.1416C13.2432 12.1416 13.5684 11.7549 13.5684 11.1836V7.19336C13.5684 6.44629 13.1377 6.05957 12.417 6.05957H8.40918C7.8291 6.05957 7.45117 6.38477 7.45117 6.91211C7.45117 7.43945 7.8291 7.77344 8.40918 7.77344H9.69238L10.7207 7.63281L9.53418 8.67871L6.73047 11.4912C6.53711 11.6758 6.41406 11.9395 6.41406 12.2031C6.41406 12.7832 6.85352 13.1699 7.39844 13.1699C7.68848 13.1699 7.92578 13.0732 8.1543 12.8623L10.9316 10.0762L11.9775 8.89844L11.8545 9.98828V11.1836C11.8545 11.7725 12.1885 12.1416 12.7158 12.1416Z",
  fill: "currentColor"
}));

// src/components/Txs/TxItem.tsx
import React30 from "react";
import { useNetwork as useNetwork3 } from "wagmi";

// src/components/Icons/Cancel.tsx
import React28 from "react";
var CancelIcon = () => /* @__PURE__ */ React28.createElement("svg", {
  fill: "none",
  height: "19",
  viewBox: "0 0 20 19",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React28.createElement("path", {
  d: "M10 18.9443C15.0977 18.9443 19.2812 14.752 19.2812 9.6543C19.2812 4.56543 15.0889 0.373047 10 0.373047C4.90234 0.373047 0.71875 4.56543 0.71875 9.6543C0.71875 14.752 4.91113 18.9443 10 18.9443ZM10 16.6328C6.1416 16.6328 3.03906 13.5215 3.03906 9.6543C3.03906 5.7959 6.13281 2.68457 10 2.68457C13.8584 2.68457 16.9697 5.7959 16.9697 9.6543C16.9785 13.5215 13.8672 16.6328 10 16.6328ZM7.29297 13.3018C7.58301 13.3018 7.81152 13.2139 7.99609 13.0205L10 11.0166L12.0127 13.0205C12.1973 13.2051 12.4258 13.3018 12.707 13.3018C13.2432 13.3018 13.6562 12.8887 13.6562 12.3525C13.6562 12.0977 13.5508 11.8691 13.3662 11.6934L11.3535 9.67188L13.375 7.6416C13.5596 7.44824 13.6562 7.22852 13.6562 6.98242C13.6562 6.44629 13.2432 6.0332 12.7158 6.0332C12.4346 6.0332 12.2148 6.12109 12.0215 6.31445L10 8.32715L7.9873 6.32324C7.80273 6.12988 7.58301 6.04199 7.29297 6.04199C6.76562 6.04199 6.35254 6.45508 6.35254 6.99121C6.35254 7.2373 6.44922 7.46582 6.63379 7.6416L8.65527 9.67188L6.63379 11.6934C6.44922 11.8691 6.35254 12.1064 6.35254 12.3525C6.35254 12.8887 6.76562 13.3018 7.29297 13.3018Z",
  fill: "currentColor"
}));

// src/components/Icons/Success.tsx
import React29 from "react";
var SuccessIcon = () => /* @__PURE__ */ React29.createElement("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React29.createElement("path", {
  d: "M10 19.4443C15.0977 19.4443 19.2812 15.252 19.2812 10.1543C19.2812 5.06543 15.0889 0.873047 10 0.873047C4.90234 0.873047 0.71875 5.06543 0.71875 10.1543C0.71875 15.252 4.91113 19.4443 10 19.4443ZM10 17.1328C6.1416 17.1328 3.03906 14.0215 3.03906 10.1543C3.03906 6.2959 6.13281 3.18457 10 3.18457C13.8584 3.18457 16.9697 6.2959 16.9697 10.1543C16.9785 14.0215 13.8672 17.1328 10 17.1328ZM9.07715 14.3379C9.4375 14.3379 9.7627 14.1533 9.97363 13.8369L13.7441 8.00977C13.8848 7.79883 13.9814 7.5791 13.9814 7.36816C13.9814 6.84961 13.5244 6.48926 13.0322 6.48926C12.707 6.48926 12.4258 6.66504 12.2148 7.0166L9.05957 12.0967L7.5918 10.2949C7.37207 10.0225 7.13477 9.9082 6.84473 9.9082C6.33496 9.9082 5.92188 10.3125 5.92188 10.8223C5.92188 11.0684 6.00098 11.2793 6.18555 11.5078L8.1543 13.8545C8.40918 14.1709 8.70801 14.3379 9.07715 14.3379Z",
  fill: "currentColor"
}));

// src/components/Txs/TxItem.tsx
var getTxStatusIcon = (status) => {
  switch (status) {
    case "pending":
      return SpinnerIcon;
    case "confirmed":
      return SuccessIcon;
    case "failed":
      return CancelIcon;
    default:
      return SpinnerIcon;
  }
};
function TxItem({ tx }) {
  const mobile = isMobile();
  const Icon = getTxStatusIcon(tx.status);
  const color = tx.status === "failed" ? "error" : "accentColor";
  const { chain: activeChain } = useNetwork3();
  const confirmationStatus = tx.status === "confirmed" ? "Confirmed" : tx.status === "failed" ? "Failed" : "Pending";
  const explorerLink = chainToExplorerUrl(activeChain);
  return /* @__PURE__ */ React30.createElement(React30.Fragment, null, /* @__PURE__ */ React30.createElement(Box, {
    ...explorerLink ? {
      as: "a",
      background: { hover: "profileForeground" },
      borderRadius: "menuButton",
      className: touchableStyles({ active: "shrink" }),
      href: `${explorerLink}/tx/${tx.hash}`,
      rel: "noreferrer noopener",
      target: "_blank",
      transition: "default"
    } : {},
    color: "modalText",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "8",
    width: "full"
  }, /* @__PURE__ */ React30.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: mobile ? "16" : "14"
  }, /* @__PURE__ */ React30.createElement(Box, {
    color
  }, /* @__PURE__ */ React30.createElement(Icon, null)), /* @__PURE__ */ React30.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "3" : "1"
  }, /* @__PURE__ */ React30.createElement(Box, null, /* @__PURE__ */ React30.createElement(Text, {
    color: "modalText",
    font: "body",
    size: mobile ? "16" : "14",
    weight: "bold"
  }, tx == null ? void 0 : tx.description)), /* @__PURE__ */ React30.createElement(Box, null, /* @__PURE__ */ React30.createElement(Text, {
    color: tx.status === "pending" ? "modalTextSecondary" : color,
    font: "body",
    size: "14",
    weight: mobile ? "medium" : "regular"
  }, confirmationStatus)))), explorerLink && /* @__PURE__ */ React30.createElement(Box, {
    alignItems: "center",
    color: "modalTextDim",
    display: "flex"
  }, /* @__PURE__ */ React30.createElement(ExternalLinkIcon, null))));
}

// src/components/Txs/TxList.tsx
var NUMBER_OF_VISIBLE_TXS = 3;
function TxList({ address }) {
  const recentTransactions = useRecentTransactions();
  const clearRecentTransactions = useClearRecentTransactions();
  const { chain: activeChain } = useNetwork4();
  const explorerLink = chainToExplorerUrl(activeChain);
  const visibleTxs = recentTransactions.slice(0, NUMBER_OF_VISIBLE_TXS);
  const hasTransactions = visibleTxs.length > 0;
  const mobile = isMobile();
  const { appName } = useContext7(AppContext);
  const i18n2 = useContext7(I18nContext);
  return /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "10",
    paddingBottom: "2",
    paddingTop: "16",
    paddingX: mobile ? "8" : "18"
  }, hasTransactions && /* @__PURE__ */ React31.createElement(Box, {
    paddingBottom: mobile ? "4" : "0",
    paddingTop: "8",
    paddingX: mobile ? "12" : "6"
  }, /* @__PURE__ */ React31.createElement(Box, {
    display: "flex",
    justifyContent: "space-between"
  }, /* @__PURE__ */ React31.createElement(Text, {
    color: "modalTextSecondary",
    size: mobile ? "16" : "14",
    weight: "semibold"
  }, i18n2.t("profile.transactions.recent.title")), /* @__PURE__ */ React31.createElement(Box, {
    style: {
      marginBottom: -6,
      marginLeft: -10,
      marginRight: -10,
      marginTop: -6
    }
  }, /* @__PURE__ */ React31.createElement(Box, {
    as: "button",
    background: {
      hover: "profileForeground"
    },
    borderRadius: "actionButton",
    className: touchableStyles({ active: "shrink" }),
    onClick: clearRecentTransactions,
    paddingX: mobile ? "8" : "12",
    paddingY: mobile ? "4" : "5",
    transition: "default",
    type: "button"
  }, /* @__PURE__ */ React31.createElement(Text, {
    color: "modalTextSecondary",
    size: mobile ? "16" : "14",
    weight: "semibold"
  }, i18n2.t("profile.transactions.clear.label")))))), /* @__PURE__ */ React31.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, hasTransactions ? visibleTxs.map((tx) => /* @__PURE__ */ React31.createElement(TxItem, {
    key: tx.hash,
    tx
  })) : /* @__PURE__ */ React31.createElement(React31.Fragment, null, /* @__PURE__ */ React31.createElement(Box, {
    padding: mobile ? "12" : "8"
  }, /* @__PURE__ */ React31.createElement(Text, {
    color: "modalTextDim",
    size: mobile ? "16" : "14",
    weight: mobile ? "medium" : "bold"
  }, appName ? i18n2.t("profile.transactions.description", {
    appName
  }) : i18n2.t("profile.transactions.description_fallback"))), mobile && /* @__PURE__ */ React31.createElement(Box, {
    background: "generalBorderDim",
    height: "1",
    marginX: "12",
    marginY: "8"
  })))), explorerLink && /* @__PURE__ */ React31.createElement(Box, {
    paddingBottom: "18",
    paddingX: mobile ? "8" : "18"
  }, /* @__PURE__ */ React31.createElement(Box, {
    alignItems: "center",
    as: "a",
    background: { hover: "profileForeground" },
    borderRadius: "menuButton",
    className: touchableStyles({ active: "shrink" }),
    color: "modalTextDim",
    display: "flex",
    flexDirection: "row",
    href: `${explorerLink}/address/${address}`,
    justifyContent: "space-between",
    paddingX: "8",
    paddingY: "12",
    rel: "noreferrer noopener",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default",
    width: "full",
    ...mobile ? { paddingLeft: "12" } : {}
  }, /* @__PURE__ */ React31.createElement(Text, {
    color: "modalText",
    font: "body",
    size: mobile ? "16" : "14",
    weight: mobile ? "semibold" : "bold"
  }, i18n2.t("profile.explorer.label")), /* @__PURE__ */ React31.createElement(ExternalLinkIcon, null))));
}

// src/components/ProfileDetails/ProfileDetailsAction.tsx
import React32 from "react";
function ProfileDetailsAction({
  action,
  icon,
  label,
  testId,
  url
}) {
  const mobile = isMobile();
  return /* @__PURE__ */ React32.createElement(Box, {
    ...url ? { as: "a", href: url, rel: "noreferrer noopener", target: "_blank" } : { as: "button", type: "button" },
    background: {
      base: "profileAction",
      ...!mobile ? { hover: "profileActionHover" } : {}
    },
    borderRadius: "menuButton",
    boxShadow: "profileDetailsAction",
    className: touchableStyles({
      active: "shrinkSm",
      hover: !mobile ? "grow" : void 0
    }),
    display: "flex",
    onClick: action,
    padding: mobile ? "6" : "8",
    style: { willChange: "transform" },
    testId,
    transition: "default",
    width: "full"
  }, /* @__PURE__ */ React32.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "1",
    justifyContent: "center",
    paddingTop: "2",
    width: "full"
  }, /* @__PURE__ */ React32.createElement(Box, {
    color: "modalText",
    height: "max"
  }, icon), /* @__PURE__ */ React32.createElement(Box, null, /* @__PURE__ */ React32.createElement(Text, {
    color: "modalText",
    size: mobile ? "12" : "13",
    weight: "semibold"
  }, label))));
}

// src/components/ProfileDetails/ProfileDetails.tsx
function ProfileDetails({
  address,
  balanceData,
  ensAvatar,
  ensName,
  onClose,
  onDisconnect
}) {
  const showRecentTransactions = useContext8(ShowRecentTransactionsContext);
  const [copiedAddress, setCopiedAddress] = useState6(false);
  const i18n2 = useContext8(I18nContext);
  const copyAddressAction = useCallback7(() => {
    if (address) {
      navigator.clipboard.writeText(address);
      setCopiedAddress(true);
    }
  }, [address]);
  useEffect12(() => {
    if (copiedAddress) {
      const timer = setTimeout(() => {
        setCopiedAddress(false);
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [copiedAddress]);
  if (!address) {
    return null;
  }
  const accountName = ensName ? formatENS(ensName) : formatAddress(address);
  const ethBalance = balanceData == null ? void 0 : balanceData.formatted;
  const displayBalance = ethBalance ? abbreviateETHBalance(parseFloat(ethBalance)) : void 0;
  const titleId = "rk_profile_title";
  const mobile = isMobile();
  return /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, /* @__PURE__ */ React33.createElement(Box, {
    background: "profileForeground",
    padding: "16"
  }, /* @__PURE__ */ React33.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "16" : "12",
    justifyContent: "center",
    margin: "8",
    style: { textAlign: "center" }
  }, /* @__PURE__ */ React33.createElement(Box, {
    style: {
      position: "absolute",
      right: 16,
      top: 16,
      willChange: "transform"
    }
  }, /* @__PURE__ */ React33.createElement(CloseButton, {
    onClose
  })), " ", /* @__PURE__ */ React33.createElement(Box, {
    marginTop: mobile ? "24" : "0"
  }, /* @__PURE__ */ React33.createElement(Avatar, {
    address,
    imageUrl: ensAvatar,
    size: mobile ? 82 : 74
  })), /* @__PURE__ */ React33.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "4" : "0",
    textAlign: "center"
  }, /* @__PURE__ */ React33.createElement(Box, {
    textAlign: "center"
  }, /* @__PURE__ */ React33.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: mobile ? "20" : "18",
    weight: "heavy"
  }, accountName)), balanceData && /* @__PURE__ */ React33.createElement(Box, {
    textAlign: "center"
  }, /* @__PURE__ */ React33.createElement(Text, {
    as: "h1",
    color: "modalTextSecondary",
    id: titleId,
    size: mobile ? "16" : "14",
    weight: "semibold"
  }, displayBalance, " ", balanceData.symbol)))), /* @__PURE__ */ React33.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    gap: "8",
    margin: "2",
    marginTop: "16"
  }, /* @__PURE__ */ React33.createElement(ProfileDetailsAction, {
    action: copyAddressAction,
    icon: copiedAddress ? /* @__PURE__ */ React33.createElement(CopiedIcon, null) : /* @__PURE__ */ React33.createElement(CopyIcon, null),
    label: copiedAddress ? i18n2.t("profile.copy_address.copied") : i18n2.t("profile.copy_address.label")
  }), /* @__PURE__ */ React33.createElement(ProfileDetailsAction, {
    action: onDisconnect,
    icon: /* @__PURE__ */ React33.createElement(DisconnectIcon, null),
    label: i18n2.t("profile.disconnect.label"),
    testId: "disconnect-button"
  }))), showRecentTransactions && /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(Box, {
    background: "generalBorder",
    height: "1",
    marginTop: "-1"
  }), /* @__PURE__ */ React33.createElement(Box, null, /* @__PURE__ */ React33.createElement(TxList, {
    address
  })))));
}

// src/components/AccountModal/AccountModal.tsx
function AccountModal({ onClose, open }) {
  const { address } = useAccount9();
  const { data: balanceData } = useBalance({ address });
  const ensName = useMainnetEnsName(address);
  const ensAvatar = useMainnetEnsAvatar(ensName);
  const { disconnect } = useDisconnect();
  if (!address) {
    return null;
  }
  const titleId = "rk_account_modal_title";
  return /* @__PURE__ */ React34.createElement(React34.Fragment, null, address && /* @__PURE__ */ React34.createElement(Dialog, {
    onClose,
    open,
    titleId
  }, /* @__PURE__ */ React34.createElement(DialogContent, {
    bottomSheetOnMobile: true,
    padding: "0"
  }, /* @__PURE__ */ React34.createElement(ProfileDetails, {
    address,
    balanceData,
    ensAvatar,
    ensName,
    onClose,
    onDisconnect: disconnect
  }))));
}

// src/components/ChainModal/ChainModal.tsx
import React37, { Fragment, useContext as useContext9 } from "react";
import { useDisconnect as useDisconnect2, useNetwork as useNetwork5, useSwitchNetwork } from "wagmi";

// src/components/Icons/DisconnectSq.tsx
import React35 from "react";
var DisconnectSqIcon = ({ size }) => /* @__PURE__ */ React35.createElement("svg", {
  fill: "none",
  height: size,
  viewBox: "0 0 28 28",
  width: size,
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React35.createElement("path", {
  d: "M6.742 22.195h8.367c1.774 0 2.743-.968 2.743-2.758V16.11h-2.016v3.11c0 .625-.305.96-.969.96H6.984c-.664 0-.968-.335-.968-.96V7.984c0-.632.304-.968.968-.968h7.883c.664 0 .969.336.969.968v3.133h2.016v-3.36c0-1.78-.97-2.757-2.743-2.757H6.742C4.97 5 4 5.977 4 7.758v11.68c0 1.789.969 2.757 2.742 2.757Zm5.438-7.703h7.601l1.149-.07-.602.406-1.008.938a.816.816 0 0 0-.258.593c0 .407.313.782.758.782.227 0 .39-.086.547-.243l2.492-2.593c.235-.235.313-.47.313-.711 0-.242-.078-.477-.313-.719l-2.492-2.586c-.156-.156-.32-.25-.547-.25-.445 0-.758.367-.758.781 0 .227.094.446.258.594l1.008.945.602.407-1.149-.079H12.18a.904.904 0 0 0 0 1.805Z",
  fill: "currentColor"
}));

// src/components/MenuButton/MenuButton.tsx
import React36 from "react";

// src/components/MenuButton/MenuButton.css.ts
var unsetBackgroundOnHover = "v9horb0";

// src/components/MenuButton/MenuButton.tsx
var MenuButton = React36.forwardRef(({
  children,
  currentlySelected = false,
  onClick,
  testId,
  ...urlProps
}, ref) => {
  const mobile = isMobile();
  return /* @__PURE__ */ React36.createElement(Box, {
    as: "button",
    borderRadius: "menuButton",
    disabled: currentlySelected,
    display: "flex",
    onClick,
    ref,
    testId,
    type: "button"
  }, /* @__PURE__ */ React36.createElement(Box, {
    borderRadius: "menuButton",
    className: [
      mobile ? unsetBackgroundOnHover : void 0,
      !currentlySelected && touchableStyles({ active: "shrink" })
    ],
    padding: mobile ? "8" : "6",
    transition: "default",
    width: "full",
    ...currentlySelected ? {
      background: "accentColor",
      borderColor: "selectedOptionBorder",
      borderStyle: "solid",
      borderWidth: "1",
      boxShadow: "selectedOption",
      color: "accentColorForeground"
    } : {
      background: { hover: "menuItemBackground" },
      color: "modalText",
      transition: "default"
    },
    ...urlProps
  }, children));
});
MenuButton.displayName = "MenuButton";

// src/components/ChainModal/ChainModal.css.ts
var DesktopScrollClassName = "_18dqw9x0";
var MobileScrollClassName = "_18dqw9x1";

// src/components/ChainModal/ChainModal.tsx
function ChainModal({ onClose, open }) {
  var _a;
  const { chain: activeChain } = useNetwork5();
  const { chains: chains14, pendingChainId, reset, switchNetwork } = useSwitchNetwork({
    onSettled: () => {
      reset();
      onClose();
    }
  });
  const i18n2 = useContext9(I18nContext);
  const { disconnect } = useDisconnect2();
  const titleId = "rk_chain_modal_title";
  const mobile = isMobile();
  const unsupportedChain = (_a = activeChain == null ? void 0 : activeChain.unsupported) != null ? _a : false;
  const chainIconSize = mobile ? "36" : "28";
  const { appName } = useContext9(AppContext);
  const rainbowkitChains = useRainbowKitChains();
  if (!activeChain || !(activeChain == null ? void 0 : activeChain.id)) {
    return null;
  }
  return /* @__PURE__ */ React37.createElement(Dialog, {
    onClose,
    open,
    titleId
  }, /* @__PURE__ */ React37.createElement(DialogContent, {
    bottomSheetOnMobile: true,
    paddingBottom: "0"
  }, /* @__PURE__ */ React37.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "14"
  }, /* @__PURE__ */ React37.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, mobile && /* @__PURE__ */ React37.createElement(Box, {
    width: "30"
  }), /* @__PURE__ */ React37.createElement(Box, {
    paddingBottom: "0",
    paddingLeft: "8",
    paddingTop: "4"
  }, /* @__PURE__ */ React37.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: mobile ? "20" : "18",
    weight: "heavy"
  }, i18n2.t("chains.title"))), /* @__PURE__ */ React37.createElement(CloseButton, {
    onClose
  })), unsupportedChain && /* @__PURE__ */ React37.createElement(Box, {
    marginX: "8",
    textAlign: mobile ? "center" : "left"
  }, /* @__PURE__ */ React37.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, i18n2.t("chains.wrong_network"))), /* @__PURE__ */ React37.createElement(Box, {
    className: mobile ? MobileScrollClassName : DesktopScrollClassName,
    display: "flex",
    flexDirection: "column",
    gap: "4",
    padding: "2",
    paddingBottom: "16"
  }, switchNetwork ? rainbowkitChains.map(({ iconBackground, iconUrl, id, name }, idx) => {
    const chain = chains14.find((c) => c.id === id);
    if (!chain)
      return null;
    const isCurrentChain = chain.id === (activeChain == null ? void 0 : activeChain.id);
    const switching = !isCurrentChain && chain.id === pendingChainId;
    return /* @__PURE__ */ React37.createElement(Fragment, {
      key: chain.id
    }, /* @__PURE__ */ React37.createElement(MenuButton, {
      currentlySelected: isCurrentChain,
      onClick: isCurrentChain ? void 0 : () => switchNetwork(chain.id),
      testId: `chain-option-${chain.id}`
    }, /* @__PURE__ */ React37.createElement(Box, {
      fontFamily: "body",
      fontSize: "16",
      fontWeight: "bold"
    }, /* @__PURE__ */ React37.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }, /* @__PURE__ */ React37.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "4",
      height: chainIconSize
    }, iconUrl && /* @__PURE__ */ React37.createElement(Box, {
      height: "full",
      marginRight: "8"
    }, /* @__PURE__ */ React37.createElement(AsyncImage, {
      alt: name != null ? name : chain.name,
      background: iconBackground,
      borderRadius: "full",
      height: chainIconSize,
      src: iconUrl,
      width: chainIconSize,
      testId: `chain-option-${chain.id}-icon`
    })), /* @__PURE__ */ React37.createElement("div", null, name != null ? name : chain.name)), isCurrentChain && /* @__PURE__ */ React37.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      marginRight: "6"
    }, /* @__PURE__ */ React37.createElement(Text, {
      color: "accentColorForeground",
      size: "14",
      weight: "medium"
    }, i18n2.t("chains.connected")), /* @__PURE__ */ React37.createElement(Box, {
      background: "connectionIndicator",
      borderColor: "selectedOptionBorder",
      borderRadius: "full",
      borderStyle: "solid",
      borderWidth: "1",
      height: "8",
      marginLeft: "8",
      width: "8"
    })), switching && /* @__PURE__ */ React37.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      marginRight: "6"
    }, /* @__PURE__ */ React37.createElement(Text, {
      color: "modalText",
      size: "14",
      weight: "medium"
    }, i18n2.t("chains.confirm")), /* @__PURE__ */ React37.createElement(Box, {
      background: "standby",
      borderRadius: "full",
      height: "8",
      marginLeft: "8",
      width: "8"
    }))))), mobile && idx < rainbowkitChains.length - 1 && /* @__PURE__ */ React37.createElement(Box, {
      background: "generalBorderDim",
      height: "1",
      marginX: "8"
    }));
  }) : /* @__PURE__ */ React37.createElement(Box, {
    background: "generalBorder",
    borderRadius: "menuButton",
    paddingX: "18",
    paddingY: "12"
  }, /* @__PURE__ */ React37.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "medium"
  }, appName ? i18n2.t("chains.switching_not_supported", {
    appName
  }) : i18n2.t("chains.switching_not_supported_fallback"))), unsupportedChain && /* @__PURE__ */ React37.createElement(React37.Fragment, null, /* @__PURE__ */ React37.createElement(Box, {
    background: "generalBorderDim",
    height: "1",
    marginX: "8"
  }), /* @__PURE__ */ React37.createElement(MenuButton, {
    onClick: () => disconnect(),
    testId: "chain-option-disconnect"
  }, /* @__PURE__ */ React37.createElement(Box, {
    color: "error",
    fontFamily: "body",
    fontSize: "16",
    fontWeight: "bold"
  }, /* @__PURE__ */ React37.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, /* @__PURE__ */ React37.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "4",
    height: chainIconSize
  }, /* @__PURE__ */ React37.createElement(Box, {
    alignItems: "center",
    color: "error",
    height: chainIconSize,
    justifyContent: "center",
    marginRight: "8"
  }, /* @__PURE__ */ React37.createElement(DisconnectSqIcon, {
    size: Number(chainIconSize)
  })), /* @__PURE__ */ React37.createElement("div", null, i18n2.t("chains.disconnect")))))))))));
}

// src/components/ConnectModal/ConnectModal.tsx
import React53 from "react";
import { useDisconnect as useDisconnect3 } from "wagmi";

// src/components/ConnectOptions/ConnectOptions.tsx
import React52 from "react";

// src/components/ConnectOptions/DesktopOptions.tsx
import React50, { Fragment as Fragment2, useContext as useContext14, useEffect as useEffect15, useState as useState8 } from "react";

// src/utils/groupBy.ts
function groupBy(items, getKey) {
  const groupedItems = {};
  items.forEach((item) => {
    const key = getKey(item);
    if (!key) {
      return;
    }
    if (!groupedItems[key]) {
      groupedItems[key] = [];
    }
    groupedItems[key].push(item);
  });
  return groupedItems;
}

// src/components/ConnectModal/ConnectModalIntro.tsx
import React40, { useContext as useContext10 } from "react";

// src/components/Disclaimer/DisclaimerLink.tsx
import React38 from "react";
var DisclaimerLink = ({
  children,
  href
}) => {
  return /* @__PURE__ */ React38.createElement(Box, {
    as: "a",
    color: "accentColor",
    href,
    rel: "noreferrer",
    target: "_blank"
  }, children);
};

// src/components/Disclaimer/DisclaimerText.tsx
import React39 from "react";
var DisclaimerText = ({ children }) => {
  return /* @__PURE__ */ React39.createElement(Text, {
    color: "modalTextSecondary",
    size: "12",
    weight: "medium"
  }, children);
};

// src/components/ConnectModal/ConnectModalIntro.tsx
function ConnectModalIntro({
  compactModeEnabled = false,
  getWallet
}) {
  const { disclaimer: Disclaimer, learnMoreUrl } = useContext10(AppContext);
  const i18n2 = useContext10(I18nContext);
  return /* @__PURE__ */ React40.createElement(React40.Fragment, null, /* @__PURE__ */ React40.createElement(Box, {
    alignItems: "center",
    color: "accentColor",
    display: "flex",
    flexDirection: "column",
    height: "full",
    justifyContent: "space-around"
  }, /* @__PURE__ */ React40.createElement(Box, {
    marginBottom: "10"
  }, !compactModeEnabled && /* @__PURE__ */ React40.createElement(Text, {
    color: "modalText",
    size: "18",
    weight: "heavy"
  }, i18n2.t("intro.title"))), /* @__PURE__ */ React40.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "32",
    justifyContent: "center",
    marginY: "20",
    style: { maxWidth: 312 }
  }, /* @__PURE__ */ React40.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "16"
  }, /* @__PURE__ */ React40.createElement(Box, {
    borderRadius: "6",
    height: "48",
    minWidth: "48",
    width: "48"
  }, /* @__PURE__ */ React40.createElement(AssetsIcon, null)), /* @__PURE__ */ React40.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, /* @__PURE__ */ React40.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, i18n2.t("intro.digital_asset.title")), /* @__PURE__ */ React40.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, i18n2.t("intro.digital_asset.description")))), /* @__PURE__ */ React40.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "16"
  }, /* @__PURE__ */ React40.createElement(Box, {
    borderRadius: "6",
    height: "48",
    minWidth: "48",
    width: "48"
  }, /* @__PURE__ */ React40.createElement(LoginIcon, null)), /* @__PURE__ */ React40.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, /* @__PURE__ */ React40.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, i18n2.t("intro.login.title")), /* @__PURE__ */ React40.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, i18n2.t("intro.login.description"))))), /* @__PURE__ */ React40.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    margin: "10"
  }, /* @__PURE__ */ React40.createElement(ActionButton, {
    label: i18n2.t("intro.get.label"),
    onClick: getWallet
  }), /* @__PURE__ */ React40.createElement(Box, {
    as: "a",
    className: touchableStyles({ active: "shrink", hover: "grow" }),
    display: "block",
    href: learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ React40.createElement(Text, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, i18n2.t("intro.learn_more.label")))), Disclaimer && !compactModeEnabled && /* @__PURE__ */ React40.createElement(Box, {
    marginBottom: "8",
    marginTop: "12",
    textAlign: "center"
  }, /* @__PURE__ */ React40.createElement(Disclaimer, {
    Link: DisclaimerLink,
    Text: DisclaimerText
  }))));
}

// src/components/Icons/Back.tsx
import React41 from "react";
var BackIcon = () => /* @__PURE__ */ React41.createElement("svg", {
  fill: "none",
  height: "17",
  viewBox: "0 0 11 17",
  width: "11",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React41.createElement("path", {
  d: "M0.99707 8.6543C0.99707 9.08496 1.15527 9.44531 1.51562 9.79688L8.16016 16.3096C8.43262 16.5732 8.74902 16.7051 9.13574 16.7051C9.90918 16.7051 10.5508 16.0811 10.5508 15.3076C10.5508 14.9121 10.3838 14.5605 10.0938 14.2705L4.30176 8.64551L10.0938 3.0293C10.3838 2.74805 10.5508 2.3877 10.5508 2.00098C10.5508 1.23633 9.90918 0.603516 9.13574 0.603516C8.74902 0.603516 8.43262 0.735352 8.16016 0.999023L1.51562 7.51172C1.15527 7.85449 1.00586 8.21484 0.99707 8.6543Z",
  fill: "currentColor"
}));

// src/components/InfoButton/InfoButton.tsx
import React43 from "react";

// src/components/Icons/Info.tsx
import React42 from "react";
var InfoIcon = () => /* @__PURE__ */ React42.createElement("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 8 12",
  width: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, /* @__PURE__ */ React42.createElement("path", {
  d: "M3.64258 7.99609C4.19336 7.99609 4.5625 7.73828 4.68555 7.24609C4.69141 7.21094 4.70312 7.16406 4.70898 7.13477C4.80859 6.60742 5.05469 6.35547 6.04492 5.76367C7.14648 5.10156 7.67969 4.3457 7.67969 3.24414C7.67969 1.39844 6.17383 0.255859 3.95898 0.255859C2.32422 0.255859 1.05859 0.894531 0.548828 1.86719C0.396484 2.14844 0.320312 2.44727 0.320312 2.74023C0.314453 3.37305 0.742188 3.79492 1.42188 3.79492C1.91406 3.79492 2.33594 3.54883 2.53516 3.11523C2.78711 2.47656 3.23242 2.21289 3.83594 2.21289C4.55664 2.21289 5.10742 2.65234 5.10742 3.29102C5.10742 3.9707 4.7793 4.29883 3.81836 4.87891C3.02148 5.36523 2.50586 5.92773 2.50586 6.76562V6.90039C2.50586 7.55664 2.96289 7.99609 3.64258 7.99609ZM3.67188 11.4473C4.42773 11.4473 5.04297 10.8672 5.04297 10.1406C5.04297 9.41406 4.42773 8.83984 3.67188 8.83984C2.91602 8.83984 2.30664 9.41406 2.30664 10.1406C2.30664 10.8672 2.91602 11.4473 3.67188 11.4473Z",
  fill: "currentColor"
}));

// src/components/InfoButton/InfoButton.tsx
var InfoButton = ({
  "aria-label": ariaLabel = "Info",
  onClick
}) => {
  const mobile = isMobile();
  return /* @__PURE__ */ React43.createElement(Box, {
    alignItems: "center",
    "aria-label": ariaLabel,
    as: "button",
    background: "closeButtonBackground",
    borderColor: "actionButtonBorder",
    borderRadius: "full",
    borderStyle: "solid",
    borderWidth: mobile ? "0" : "1",
    className: touchableStyles({ active: "shrinkSm", hover: "growLg" }),
    color: "closeButton",
    display: "flex",
    height: mobile ? "30" : "28",
    justifyContent: "center",
    onClick,
    style: { willChange: "transform" },
    transition: "default",
    type: "button",
    width: mobile ? "30" : "28"
  }, /* @__PURE__ */ React43.createElement(InfoIcon, null));
};

// src/components/ModalSelection/ModalSelection.tsx
import React44, { useContext as useContext12, useState as useState7 } from "react";

// src/components/RainbowKitProvider/useCoolMode.ts
import { useContext as useContext11, useEffect as useEffect13, useRef as useRef4 } from "react";
var useCoolMode = (imageUrl) => {
  const ref = useRef4(null);
  const coolModeEnabled = useContext11(CoolModeContext);
  const resolvedImageUrl = useAsyncImage(imageUrl);
  useEffect13(() => {
    if (coolModeEnabled && ref.current && resolvedImageUrl) {
      return makeElementCool(ref.current, resolvedImageUrl);
    }
  }, [coolModeEnabled, resolvedImageUrl]);
  return ref;
};
var getContainer = () => {
  const id = "_rk_coolMode";
  const existingContainer = document.getElementById(id);
  if (existingContainer) {
    return existingContainer;
  }
  const container = document.createElement("div");
  container.setAttribute("id", id);
  container.setAttribute("style", [
    "overflow:hidden",
    "position:fixed",
    "height:100%",
    "top:0",
    "left:0",
    "right:0",
    "bottom:0",
    "pointer-events:none",
    "z-index:2147483647"
  ].join(";"));
  document.body.appendChild(container);
  return container;
};
var instanceCounter = 0;
function makeElementCool(element2, imageUrl) {
  instanceCounter++;
  const sizes = [15, 20, 25, 35, 45];
  const limit = 35;
  let particles = [];
  let autoAddParticle = false;
  let mouseX = 0;
  let mouseY = 0;
  const container = getContainer();
  function createParticle() {
    const size = sizes[Math.floor(Math.random() * sizes.length)];
    const speedHorz = Math.random() * 10;
    const speedUp = Math.random() * 25;
    const spinVal = Math.random() * 360;
    const spinSpeed = Math.random() * 35 * (Math.random() <= 0.5 ? -1 : 1);
    const top = mouseY - size / 2;
    const left = mouseX - size / 2;
    const direction = Math.random() <= 0.5 ? -1 : 1;
    const particle = document.createElement("div");
    particle.innerHTML = `<img src="${imageUrl}" width="${size}" height="${size}" style="border-radius: 25%">`;
    particle.setAttribute("style", [
      "position:absolute",
      "will-change:transform",
      `top:${top}px`,
      `left:${left}px`,
      `transform:rotate(${spinVal}deg)`
    ].join(";"));
    container.appendChild(particle);
    particles.push({
      direction,
      element: particle,
      left,
      size,
      speedHorz,
      speedUp,
      spinSpeed,
      spinVal,
      top
    });
  }
  function updateParticles() {
    particles.forEach((p) => {
      p.left = p.left - p.speedHorz * p.direction;
      p.top = p.top - p.speedUp;
      p.speedUp = Math.min(p.size, p.speedUp - 1);
      p.spinVal = p.spinVal + p.spinSpeed;
      if (p.top >= Math.max(window.innerHeight, document.body.clientHeight) + p.size) {
        particles = particles.filter((o) => o !== p);
        p.element.remove();
      }
      p.element.setAttribute("style", [
        "position:absolute",
        "will-change:transform",
        `top:${p.top}px`,
        `left:${p.left}px`,
        `transform:rotate(${p.spinVal}deg)`
      ].join(";"));
    });
  }
  let animationFrame;
  function loop() {
    if (autoAddParticle && particles.length < limit) {
      createParticle();
    }
    updateParticles();
    animationFrame = requestAnimationFrame(loop);
  }
  loop();
  const isTouchInteraction = "ontouchstart" in window || navigator.msMaxTouchPoints;
  const tap = isTouchInteraction ? "touchstart" : "mousedown";
  const tapEnd = isTouchInteraction ? "touchend" : "mouseup";
  const move = isTouchInteraction ? "touchmove" : "mousemove";
  const updateMousePosition = (e) => {
    var _a, _b;
    if ("touches" in e) {
      mouseX = (_a = e.touches) == null ? void 0 : _a[0].clientX;
      mouseY = (_b = e.touches) == null ? void 0 : _b[0].clientY;
    } else {
      mouseX = e.clientX;
      mouseY = e.clientY;
    }
  };
  const tapHandler = (e) => {
    updateMousePosition(e);
    autoAddParticle = true;
  };
  const disableAutoAddParticle = () => {
    autoAddParticle = false;
  };
  element2.addEventListener(move, updateMousePosition, { passive: false });
  element2.addEventListener(tap, tapHandler);
  element2.addEventListener(tapEnd, disableAutoAddParticle);
  element2.addEventListener("mouseleave", disableAutoAddParticle);
  return () => {
    element2.removeEventListener(move, updateMousePosition);
    element2.removeEventListener(tap, tapHandler);
    element2.removeEventListener(tapEnd, disableAutoAddParticle);
    element2.removeEventListener("mouseleave", disableAutoAddParticle);
    const interval = setInterval(() => {
      if (animationFrame && particles.length === 0) {
        cancelAnimationFrame(animationFrame);
        clearInterval(interval);
        if (--instanceCounter === 0) {
          container.remove();
        }
      }
    }, 500);
  };
}

// src/components/ModalSelection/ModalSelection.css.ts
var transparentBorder = "g5kl0l0";

// src/components/ModalSelection/ModalSelection.tsx
var ModalSelection = ({
  as = "button",
  currentlySelected = false,
  iconBackground,
  iconUrl,
  name,
  onClick,
  ready,
  recent,
  testId,
  ...urlProps
}) => {
  const coolModeRef = useCoolMode(iconUrl);
  const [isMouseOver, setIsMouseOver] = useState7(false);
  const i18n2 = useContext12(I18nContext);
  return /* @__PURE__ */ React44.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    onMouseEnter: () => setIsMouseOver(true),
    onMouseLeave: () => setIsMouseOver(false),
    ref: coolModeRef
  }, /* @__PURE__ */ React44.createElement(Box, {
    as,
    borderRadius: "menuButton",
    borderStyle: "solid",
    borderWidth: "1",
    className: !currentlySelected ? [
      transparentBorder,
      touchableStyles({
        active: "shrink"
      })
    ] : void 0,
    disabled: currentlySelected,
    onClick,
    padding: "5",
    style: { willChange: "transform" },
    testId,
    transition: "default",
    width: "full",
    ...currentlySelected ? {
      background: "accentColor",
      borderColor: "selectedOptionBorder",
      boxShadow: "selectedWallet"
    } : {
      background: { hover: "menuItemBackground" }
    },
    ...urlProps
  }, /* @__PURE__ */ React44.createElement(Box, {
    color: currentlySelected ? "accentColorForeground" : "modalText",
    disabled: !ready,
    fontFamily: "body",
    fontSize: "16",
    fontWeight: "bold",
    transition: "default"
  }, /* @__PURE__ */ React44.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "12"
  }, /* @__PURE__ */ React44.createElement(AsyncImage, {
    background: iconBackground,
    ...isMouseOver ? {} : { borderColor: "actionButtonBorder" },
    borderRadius: "6",
    height: "28",
    src: iconUrl,
    width: "28"
  }), /* @__PURE__ */ React44.createElement(Box, null, /* @__PURE__ */ React44.createElement(Box, {
    style: { marginTop: recent ? -2 : void 0 }
  }, name), recent && /* @__PURE__ */ React44.createElement(Text, {
    color: currentlySelected ? "accentColorForeground" : "accentColor",
    size: "12",
    style: { lineHeight: 1, marginTop: -1 },
    weight: "medium"
  }, i18n2.t("connect.recent")))))));
};
ModalSelection.displayName = "ModalSelection";

// src/components/ConnectOptions/ConnectDetails.tsx
import React49, { useContext as useContext13, useEffect as useEffect14 } from "react";

// src/utils/colors.ts
var convertHexToRGBA = (hexCode, opacity = 1) => {
  let hex = hexCode.replace("#", "");
  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100;
  }
  return `rgba(${r},${g},${b},${opacity})`;
};
var getGradientRGBAs = (hexColor) => {
  if (!hexColor)
    return null;
  return [
    convertHexToRGBA(hexColor, 0.2),
    convertHexToRGBA(hexColor, 0.14),
    convertHexToRGBA(hexColor, 0.1)
  ];
};
var isHexString = (color) => {
  return /^#([0-9a-f]{3}){1,2}$/i.test(color);
};

// src/components/Icons/Create.tsx
import React45 from "react";
var src3 = async () => (await import("./create-PAJXJDV3.js")).default;
var preloadCreateIcon = () => loadImages(src3);
var CreateIcon = () => /* @__PURE__ */ React45.createElement(AsyncImage, {
  background: "#e3a5e8",
  borderColor: "generalBorder",
  borderRadius: "10",
  height: "48",
  src: src3,
  width: "48"
});

// src/components/Icons/Refresh.tsx
import React46 from "react";
var src4 = async () => (await import("./refresh-5KGGHTJP.js")).default;
var preloadRefreshIcon = () => loadImages(src4);
var RefreshIcon = () => /* @__PURE__ */ React46.createElement(AsyncImage, {
  background: "#515a70",
  borderColor: "generalBorder",
  borderRadius: "10",
  height: "48",
  src: src4,
  width: "48"
});

// src/components/Icons/Scan.tsx
import React47 from "react";
var src5 = async () => (await import("./scan-HZBLXLM4.js")).default;
var preloadScanIcon = () => loadImages(src5);
var ScanIcon = () => /* @__PURE__ */ React47.createElement(AsyncImage, {
  background: "#515a70",
  borderColor: "generalBorder",
  borderRadius: "10",
  height: "48",
  src: src5,
  width: "48"
});

// src/components/QRCode/QRCode.tsx
import QRCodeUtil from "qrcode";
import React48, { useMemo as useMemo6 } from "react";

// src/components/ConnectOptions/DesktopOptions.css.ts
var QRCodeBackgroundClassName = "_1vwt0cg0";
var ScrollClassName = "_1vwt0cg2 ju367v75 ju367v7q";
var sidebar = "_1vwt0cg3";
var sidebarCompactMode = "_1vwt0cg4";

// src/components/QRCode/QRCode.tsx
var generateMatrix = (value, errorCorrectionLevel) => {
  const arr = Array.prototype.slice.call(QRCodeUtil.create(value, { errorCorrectionLevel }).modules.data, 0);
  const sqrt = Math.sqrt(arr.length);
  return arr.reduce((rows, key, index) => (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows, []);
};
function QRCode({
  ecl = "M",
  logoBackground,
  logoMargin = 10,
  logoSize = 50,
  logoUrl,
  size: sizeProp = 200,
  uri
}) {
  const padding = "20";
  const size = sizeProp - parseInt(padding, 10) * 2;
  const dots = useMemo6(() => {
    const dots2 = [];
    const matrix = generateMatrix(uri, ecl);
    const cellSize = size / matrix.length;
    const qrList = [
      { x: 0, y: 0 },
      { x: 1, y: 0 },
      { x: 0, y: 1 }
    ];
    qrList.forEach(({ x, y }) => {
      const x1 = (matrix.length - 7) * cellSize * x;
      const y1 = (matrix.length - 7) * cellSize * y;
      for (let i = 0; i < 3; i++) {
        dots2.push(/* @__PURE__ */ React48.createElement("rect", {
          fill: i % 2 !== 0 ? "white" : "black",
          height: cellSize * (7 - i * 2),
          key: `${i}-${x}-${y}`,
          rx: (i - 2) * -5 + (i === 0 ? 2 : 0),
          ry: (i - 2) * -5 + (i === 0 ? 2 : 0),
          width: cellSize * (7 - i * 2),
          x: x1 + cellSize * i,
          y: y1 + cellSize * i
        }));
      }
    });
    const clearArenaSize = Math.floor((logoSize + 25) / cellSize);
    const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
    const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
    matrix.forEach((row, i) => {
      row.forEach((_, j) => {
        if (matrix[i][j]) {
          if (!(i < 7 && j < 7 || i > matrix.length - 8 && j < 7 || i < 7 && j > matrix.length - 8)) {
            if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
              dots2.push(/* @__PURE__ */ React48.createElement("circle", {
                cx: i * cellSize + cellSize / 2,
                cy: j * cellSize + cellSize / 2,
                fill: "black",
                key: `circle-${i}-${j}`,
                r: cellSize / 3
              }));
            }
          }
        }
      });
    });
    return dots2;
  }, [ecl, logoSize, size, uri]);
  const logoPosition = size / 2 - logoSize / 2;
  const logoWrapperSize = logoSize + logoMargin * 2;
  return /* @__PURE__ */ React48.createElement(Box, {
    borderColor: "generalBorder",
    borderRadius: "menuButton",
    borderStyle: "solid",
    borderWidth: "1",
    className: QRCodeBackgroundClassName,
    padding,
    width: "max"
  }, /* @__PURE__ */ React48.createElement(Box, {
    style: {
      height: size,
      userSelect: "none",
      width: size
    },
    userSelect: "none"
  }, /* @__PURE__ */ React48.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    position: "relative",
    style: {
      height: 0,
      top: logoPosition,
      width: size
    },
    width: "full"
  }, /* @__PURE__ */ React48.createElement(AsyncImage, {
    background: logoBackground,
    borderColor: { custom: "rgba(0, 0, 0, 0.06)" },
    borderRadius: "13",
    height: logoSize,
    src: logoUrl,
    width: logoSize
  })), /* @__PURE__ */ React48.createElement("svg", {
    height: size,
    style: { all: "revert" },
    width: size
  }, /* @__PURE__ */ React48.createElement("defs", null, /* @__PURE__ */ React48.createElement("clipPath", {
    id: "clip-wrapper"
  }, /* @__PURE__ */ React48.createElement("rect", {
    height: logoWrapperSize,
    width: logoWrapperSize
  })), /* @__PURE__ */ React48.createElement("clipPath", {
    id: "clip-logo"
  }, /* @__PURE__ */ React48.createElement("rect", {
    height: logoSize,
    width: logoSize
  }))), /* @__PURE__ */ React48.createElement("rect", {
    fill: "transparent",
    height: size,
    width: size
  }), dots)));
}

// src/components/ConnectOptions/ConnectDetails.tsx
var getBrowserSrc = async () => {
  const browser = getBrowser();
  switch (browser) {
    case "Arc" /* Arc */:
      return (await import("./Arc-QDJFTGH2.js")).default;
    case "Brave" /* Brave */:
      return (await import("./Brave-YATE5BIM.js")).default;
    case "Chrome" /* Chrome */:
      return (await import("./Chrome-LGF33C3S.js")).default;
    case "Edge" /* Edge */:
      return (await import("./Edge-K2JEGI5S.js")).default;
    case "Firefox" /* Firefox */:
      return (await import("./Firefox-NP5SYEK5.js")).default;
    case "Opera" /* Opera */:
      return (await import("./Opera-KV54PXPA.js")).default;
    case "Safari" /* Safari */:
      return (await import("./Safari-2QIYKJ4P.js")).default;
    default:
      return (await import("./Browser-HN7O5MN7.js")).default;
  }
};
var preloadBrowserIcon = () => loadImages(getBrowserSrc);
function GetDetail({
  getWalletDownload,
  compactModeEnabled
}) {
  const wallets = useWalletConnectors();
  const shownWallets = wallets.splice(0, 5);
  const i18n2 = useContext13(I18nContext);
  return /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    marginTop: "18",
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    width: "full"
  }, shownWallets == null ? void 0 : shownWallets.filter((wallet) => {
    var _a;
    return wallet.extensionDownloadUrl || wallet.qrCode && ((_a = wallet.downloadUrls) == null ? void 0 : _a.qrCode);
  }).map((wallet) => {
    const { downloadUrls, iconBackground, iconUrl, id, name, qrCode } = wallet;
    const hasMobileCompanionApp = (downloadUrls == null ? void 0 : downloadUrls.qrCode) && qrCode;
    const hasExtension = !!wallet.extensionDownloadUrl;
    const hasMobileAndExtension = (downloadUrls == null ? void 0 : downloadUrls.qrCode) && hasExtension;
    return /* @__PURE__ */ React49.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "16",
      justifyContent: "space-between",
      key: wallet.id,
      width: "full"
    }, /* @__PURE__ */ React49.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16"
    }, /* @__PURE__ */ React49.createElement(AsyncImage, {
      background: iconBackground,
      borderColor: "actionButtonBorder",
      borderRadius: "10",
      height: "48",
      src: iconUrl,
      width: "48"
    }), /* @__PURE__ */ React49.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      gap: "2"
    }, /* @__PURE__ */ React49.createElement(Text, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, name), /* @__PURE__ */ React49.createElement(Text, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, hasMobileAndExtension ? i18n2.t("get.mobile_and_extension.description") : hasMobileCompanionApp ? i18n2.t("get.mobile.description") : hasExtension ? i18n2.t("get.extension.description") : null))), /* @__PURE__ */ React49.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */ React49.createElement(ActionButton, {
      label: i18n2.t("get.action.label"),
      onClick: () => getWalletDownload(id),
      type: "secondary"
    })));
  })), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "column",
    gap: "8",
    justifyContent: "space-between",
    marginBottom: "4",
    paddingY: "8",
    style: { maxWidth: 275, textAlign: "center" }
  }, /* @__PURE__ */ React49.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, i18n2.t("get.looking_for.title")), /* @__PURE__ */ React49.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, compactModeEnabled ? i18n2.t("get.looking_for.desktop.compact_description") : i18n2.t("get.looking_for.desktop.wide_description"))));
}
var LOGO_SIZE = "44";
function ConnectDetail({
  changeWalletStep,
  compactModeEnabled,
  connectionError,
  onClose,
  qrCodeUri,
  reconnect,
  wallet
}) {
  var _a;
  const {
    downloadUrls,
    iconBackground,
    iconUrl,
    name,
    qrCode,
    ready,
    showWalletConnectModal
  } = wallet;
  const getDesktopDeepLink = (_a = wallet.desktop) == null ? void 0 : _a.getUri;
  const safari = isSafari();
  const i18n2 = useContext13(I18nContext);
  const hasExtension = !!wallet.extensionDownloadUrl;
  const hasQrCodeAndExtension = (downloadUrls == null ? void 0 : downloadUrls.qrCode) && hasExtension;
  const hasQrCode = qrCode && qrCodeUri;
  const secondaryAction = showWalletConnectModal ? {
    description: !compactModeEnabled ? i18n2.t("connect.walletconnect.description.full") : i18n2.t("connect.walletconnect.description.compact"),
    label: i18n2.t("connect.walletconnect.open.label"),
    onClick: () => {
      onClose();
      showWalletConnectModal();
    }
  } : hasQrCode ? {
    description: i18n2.t("connect.secondary_action.get.description", {
      wallet: name
    }),
    label: i18n2.t("connect.secondary_action.get.label"),
    onClick: () => changeWalletStep(hasQrCodeAndExtension ? "DOWNLOAD_OPTIONS" /* DownloadOptions */ : "DOWNLOAD" /* Download */)
  } : null;
  const { width: windowWidth } = useWindowSize();
  const smallWindow = windowWidth && windowWidth < 768;
  useEffect14(() => {
    preloadBrowserIcon();
  }, []);
  return /* @__PURE__ */ React49.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, hasQrCode ? /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    height: "full",
    justifyContent: "center"
  }, /* @__PURE__ */ React49.createElement(QRCode, {
    logoBackground: iconBackground,
    logoSize: compactModeEnabled ? 60 : 72,
    logoUrl: iconUrl,
    size: compactModeEnabled ? 318 : smallWindow ? Math.max(280, Math.min(windowWidth - 308, 382)) : 382,
    uri: qrCodeUri
  })) : /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "8"
  }, /* @__PURE__ */ React49.createElement(Box, {
    borderRadius: "10",
    height: LOGO_SIZE,
    overflow: "hidden"
  }, /* @__PURE__ */ React49.createElement(AsyncImage, {
    height: LOGO_SIZE,
    src: iconUrl,
    width: LOGO_SIZE
  })), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "4",
    paddingX: "32",
    style: { textAlign: "center" }
  }, /* @__PURE__ */ React49.createElement(Text, {
    color: "modalText",
    size: "18",
    weight: "bold"
  }, ready ? i18n2.t("connect.status.opening", {
    wallet: name
  }) : hasExtension ? i18n2.t("connect.status.not_installed", {
    wallet: name
  }) : i18n2.t("connect.status.not_available", {
    wallet: name
  })), !ready && hasExtension ? /* @__PURE__ */ React49.createElement(Box, {
    paddingTop: "20"
  }, /* @__PURE__ */ React49.createElement(ActionButton, {
    href: wallet.extensionDownloadUrl,
    label: i18n2.t("connect.secondary_action.install.label"),
    type: "secondary"
  })) : null, ready && !hasQrCode && /* @__PURE__ */ React49.createElement(React49.Fragment, null, /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, /* @__PURE__ */ React49.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    textAlign: "center",
    weight: "medium"
  }, i18n2.t("connect.status.confirm"))), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    color: "modalText",
    display: "flex",
    flexDirection: "row",
    height: "32",
    marginTop: "8"
  }, connectionError ? /* @__PURE__ */ React49.createElement(ActionButton, {
    label: i18n2.t("connect.secondary_action.retry.label"),
    onClick: getDesktopDeepLink ? async () => {
      const uri = await getDesktopDeepLink();
      window.open(uri, safari ? "_blank" : "_self");
    } : () => {
      reconnect(wallet);
    }
  }) : /* @__PURE__ */ React49.createElement(Box, {
    color: "modalTextSecondary"
  }, /* @__PURE__ */ React49.createElement(SpinnerIcon, null))))))), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "row",
    gap: "8",
    height: "28",
    justifyContent: "space-between",
    marginTop: "12"
  }, ready && secondaryAction && /* @__PURE__ */ React49.createElement(React49.Fragment, null, /* @__PURE__ */ React49.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, secondaryAction.description), /* @__PURE__ */ React49.createElement(ActionButton, {
    label: secondaryAction.label,
    onClick: secondaryAction.onClick,
    type: "secondary"
  }))));
}
var DownloadOptionsBox = ({
  actionLabel,
  description,
  iconAccent,
  iconBackground,
  iconUrl,
  isCompact,
  onAction,
  title,
  url,
  variant
}) => {
  const isBrowserCard = variant === "browser";
  const gradientRgbas = !isBrowserCard && iconAccent && getGradientRGBAs(iconAccent);
  return /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    borderRadius: "13",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    paddingX: isCompact ? "18" : "44",
    position: "relative",
    style: { flex: 1, isolation: "isolate" },
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Box, {
    borderColor: "actionButtonBorder",
    borderRadius: "13",
    borderStyle: "solid",
    borderWidth: "1",
    style: {
      bottom: "0",
      left: "0",
      position: "absolute",
      right: "0",
      top: "0",
      zIndex: 1
    }
  }), isBrowserCard && /* @__PURE__ */ React49.createElement(Box, {
    background: "downloadTopCardBackground",
    height: "full",
    position: "absolute",
    style: {
      zIndex: 0
    },
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    style: {
      bottom: "0",
      filter: "blur(20px)",
      left: "0",
      position: "absolute",
      right: "0",
      top: "0",
      transform: "translate3d(0, 0, 0)"
    }
  }, /* @__PURE__ */ React49.createElement(Box, {
    style: {
      filter: "blur(100px)",
      marginLeft: -27,
      marginTop: -20,
      opacity: 0.6,
      transform: "translate3d(0, 0, 0)"
    }
  }, /* @__PURE__ */ React49.createElement(AsyncImage, {
    borderRadius: "full",
    height: "200",
    src: iconUrl,
    width: "200"
  })), /* @__PURE__ */ React49.createElement(Box, {
    style: {
      filter: "blur(100px)",
      marginRight: 0,
      marginTop: 105,
      opacity: 0.6,
      overflow: "auto",
      transform: "translate3d(0, 0, 0)"
    }
  }, /* @__PURE__ */ React49.createElement(AsyncImage, {
    borderRadius: "full",
    height: "200",
    src: iconUrl,
    width: "200"
  })))), !isBrowserCard && gradientRgbas && /* @__PURE__ */ React49.createElement(Box, {
    background: "downloadBottomCardBackground",
    style: {
      bottom: "0",
      left: "0",
      position: "absolute",
      right: "0",
      top: "0"
    }
  }, /* @__PURE__ */ React49.createElement(Box, {
    position: "absolute",
    style: {
      background: `radial-gradient(50% 50% at 50% 50%, ${gradientRgbas[0]} 0%, ${gradientRgbas[1]} 25%, rgba(0,0,0,0) 100%)`,
      height: 564,
      left: -215,
      top: -197,
      transform: "translate3d(0, 0, 0)",
      width: 564
    }
  }), /* @__PURE__ */ React49.createElement(Box, {
    position: "absolute",
    style: {
      background: `radial-gradient(50% 50% at 50% 50%, ${gradientRgbas[2]} 0%, rgba(0, 0, 0, 0) 100%)`,
      height: 564,
      left: -1,
      top: -76,
      transform: "translate3d(0, 0, 0)",
      width: 564
    }
  })), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    gap: "24",
    height: "max",
    justifyContent: "center",
    style: { zIndex: 1 }
  }, /* @__PURE__ */ React49.createElement(Box, null, /* @__PURE__ */ React49.createElement(AsyncImage, {
    height: "60",
    src: iconUrl,
    width: "60",
    ...iconBackground ? {
      background: iconBackground,
      borderColor: "generalBorder",
      borderRadius: "10"
    } : null
  })), /* @__PURE__ */ React49.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4",
    style: { flex: 1 },
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, title), /* @__PURE__ */ React49.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, description), /* @__PURE__ */ React49.createElement(Box, {
    marginTop: "14",
    width: "max"
  }, /* @__PURE__ */ React49.createElement(ActionButton, {
    href: url,
    label: actionLabel,
    onClick: onAction,
    size: "medium"
  })))));
};
function DownloadOptionsDetail({
  changeWalletStep,
  wallet
}) {
  const browser = getBrowser();
  const modalSize = useContext13(ModalSizeContext);
  const isCompact = modalSize === "compact";
  const { extension, extensionDownloadUrl, mobileDownloadUrl } = wallet;
  const i18n2 = useContext13(I18nContext);
  useEffect14(() => {
    preloadCreateIcon();
    preloadScanIcon();
    preloadRefreshIcon();
  }, []);
  return /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "24",
    height: "full",
    marginBottom: "8",
    marginTop: "4",
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "8",
    height: "full",
    justifyContent: "center",
    width: "full"
  }, extensionDownloadUrl && /* @__PURE__ */ React49.createElement(DownloadOptionsBox, {
    actionLabel: i18n2.t("get_options.extension.download.label", {
      browser
    }),
    description: i18n2.t("get_options.extension.description"),
    iconUrl: getBrowserSrc,
    isCompact,
    onAction: () => changeWalletStep((extension == null ? void 0 : extension.instructions) ? "INSTRUCTIONS_EXTENSION" /* InstructionsExtension */ : "CONNECT" /* Connect */),
    title: i18n2.t("get_options.extension.title", {
      wallet: wallet.name,
      browser
    }),
    url: extensionDownloadUrl,
    variant: "browser"
  }), mobileDownloadUrl && /* @__PURE__ */ React49.createElement(DownloadOptionsBox, {
    actionLabel: i18n2.t("get_options.mobile.download.label", {
      wallet: wallet.name
    }),
    description: i18n2.t("get_options.mobile.description"),
    iconAccent: wallet.iconAccent,
    iconBackground: wallet.iconBackground,
    iconUrl: wallet.iconUrl,
    isCompact,
    onAction: () => {
      changeWalletStep("DOWNLOAD" /* Download */);
    },
    title: i18n2.t("get_options.mobile.title", { wallet: wallet.name }),
    variant: "app"
  })));
}
function DownloadDetail({
  changeWalletStep,
  wallet
}) {
  const { downloadUrls, qrCode } = wallet;
  const i18n2 = useContext13(I18nContext);
  useEffect14(() => {
    preloadCreateIcon();
    preloadScanIcon();
  }, []);
  return /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "24",
    height: "full",
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Box, {
    style: { maxWidth: 220, textAlign: "center" }
  }, /* @__PURE__ */ React49.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "semibold"
  }, i18n2.t("get_mobile.description"))), /* @__PURE__ */ React49.createElement(Box, {
    height: "full"
  }, (downloadUrls == null ? void 0 : downloadUrls.qrCode) ? /* @__PURE__ */ React49.createElement(QRCode, {
    logoSize: 0,
    size: 268,
    uri: downloadUrls.qrCode
  }) : null), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "row",
    gap: "8",
    height: "34",
    justifyContent: "space-between",
    marginBottom: "12",
    paddingY: "8"
  }, /* @__PURE__ */ React49.createElement(ActionButton, {
    label: i18n2.t("get_mobile.continue.label"),
    onClick: () => changeWalletStep((qrCode == null ? void 0 : qrCode.instructions) ? "INSTRUCTIONS_MOBILE" /* InstructionsMobile */ : "CONNECT" /* Connect */)
  })));
}
var stepIcons = {
  create: () => /* @__PURE__ */ React49.createElement(CreateIcon, null),
  install: (wallet) => /* @__PURE__ */ React49.createElement(AsyncImage, {
    background: wallet.iconBackground,
    borderColor: "generalBorder",
    borderRadius: "10",
    height: "48",
    src: wallet.iconUrl,
    width: "48"
  }),
  refresh: () => /* @__PURE__ */ React49.createElement(RefreshIcon, null),
  scan: () => /* @__PURE__ */ React49.createElement(ScanIcon, null)
};
function InstructionMobileDetail({
  connectWallet,
  wallet
}) {
  var _a, _b, _c, _d;
  const i18n2 = useContext13(I18nContext);
  return /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    justifyContent: "center",
    paddingY: "32",
    style: { maxWidth: 320 }
  }, (_b = (_a = wallet == null ? void 0 : wallet.qrCode) == null ? void 0 : _a.instructions) == null ? void 0 : _b.steps.map((d, idx) => {
    var _a2;
    return /* @__PURE__ */ React49.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16",
      key: idx
    }, /* @__PURE__ */ React49.createElement(Box, {
      borderRadius: "10",
      height: "48",
      minWidth: "48",
      overflow: "hidden",
      position: "relative",
      width: "48"
    }, (_a2 = stepIcons[d.step]) == null ? void 0 : _a2.call(stepIcons, wallet)), /* @__PURE__ */ React49.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */ React49.createElement(Text, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, i18n2.t(d.title)), /* @__PURE__ */ React49.createElement(Text, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, i18n2.t(d.description))));
  })), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    marginBottom: "16"
  }, /* @__PURE__ */ React49.createElement(ActionButton, {
    label: i18n2.t("get_instructions.mobile.connect.label"),
    onClick: () => connectWallet(wallet)
  }), /* @__PURE__ */ React49.createElement(Box, {
    as: "a",
    className: touchableStyles({ active: "shrink", hover: "grow" }),
    display: "block",
    href: (_d = (_c = wallet == null ? void 0 : wallet.qrCode) == null ? void 0 : _c.instructions) == null ? void 0 : _d.learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ React49.createElement(Text, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, i18n2.t("get_instructions.mobile.learn_more.label")))));
}
function InstructionExtensionDetail({
  wallet
}) {
  var _a, _b, _c, _d;
  const i18n2 = useContext13(I18nContext);
  return /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, /* @__PURE__ */ React49.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    justifyContent: "center",
    paddingY: "32",
    style: { maxWidth: 320 }
  }, (_b = (_a = wallet == null ? void 0 : wallet.extension) == null ? void 0 : _a.instructions) == null ? void 0 : _b.steps.map((d, idx) => {
    var _a2;
    return /* @__PURE__ */ React49.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16",
      key: idx
    }, /* @__PURE__ */ React49.createElement(Box, {
      borderRadius: "10",
      height: "48",
      minWidth: "48",
      overflow: "hidden",
      position: "relative",
      width: "48"
    }, (_a2 = stepIcons[d.step]) == null ? void 0 : _a2.call(stepIcons, wallet)), /* @__PURE__ */ React49.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */ React49.createElement(Text, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, i18n2.t(d.title)), /* @__PURE__ */ React49.createElement(Text, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, i18n2.t(d.description))));
  })), /* @__PURE__ */ React49.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    marginBottom: "16"
  }, /* @__PURE__ */ React49.createElement(ActionButton, {
    label: i18n2.t("get_instructions.extension.refresh.label"),
    onClick: window.location.reload.bind(window.location)
  }), /* @__PURE__ */ React49.createElement(Box, {
    as: "a",
    className: touchableStyles({ active: "shrink", hover: "grow" }),
    display: "block",
    href: (_d = (_c = wallet == null ? void 0 : wallet.extension) == null ? void 0 : _c.instructions) == null ? void 0 : _d.learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: { willChange: "transform" },
    target: "_blank",
    transition: "default"
  }, /* @__PURE__ */ React49.createElement(Text, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, i18n2.t("get_instructions.extension.learn_more.label")))));
}

// src/components/ConnectOptions/DesktopOptions.tsx
function DesktopOptions({ onClose }) {
  const titleId = "rk_connect_title";
  const safari = isSafari();
  const [selectedOptionId, setSelectedOptionId] = useState8();
  const [selectedWallet, setSelectedWallet] = useState8();
  const [qrCodeUri, setQrCodeUri] = useState8();
  const hasQrCode = !!(selectedWallet == null ? void 0 : selectedWallet.qrCode) && qrCodeUri;
  const [connectionError, setConnectionError] = useState8(false);
  const modalSize = useContext14(ModalSizeContext);
  const compactModeEnabled = modalSize === ModalSizeOptions.COMPACT;
  const { disclaimer: Disclaimer } = useContext14(AppContext);
  const i18n2 = useContext14(I18nContext);
  const wallets = useWalletConnectors().filter((wallet) => wallet.ready || !!wallet.extensionDownloadUrl).sort((a, b) => a.groupIndex - b.groupIndex);
  const groupedWallets = groupBy(wallets, (wallet) => wallet.groupName);
  const supportedI18nGroupNames = [
    "Recommended",
    "Other",
    "Popular",
    "More",
    "Others"
  ];
  const connectToWallet = (wallet) => {
    var _a, _b, _c;
    setConnectionError(false);
    if (wallet.ready) {
      (_b = (_a = wallet == null ? void 0 : wallet.connect) == null ? void 0 : _a.call(wallet)) == null ? void 0 : _b.catch(() => {
        setConnectionError(true);
      });
      const getDesktopDeepLink = (_c = wallet.desktop) == null ? void 0 : _c.getUri;
      if (getDesktopDeepLink) {
        setTimeout(async () => {
          const uri = await getDesktopDeepLink();
          window.open(uri, safari ? "_blank" : "_self");
        }, 0);
      }
    }
  };
  const selectWallet = (wallet) => {
    var _a;
    connectToWallet(wallet);
    setSelectedOptionId(wallet.id);
    if (wallet.ready) {
      let callbackFired = false;
      (_a = wallet == null ? void 0 : wallet.onConnecting) == null ? void 0 : _a.call(wallet, async () => {
        var _a2, _b;
        if (callbackFired)
          return;
        callbackFired = true;
        const sWallet = wallets.find((w) => wallet.id === w.id);
        const uri = await ((_a2 = sWallet == null ? void 0 : sWallet.qrCode) == null ? void 0 : _a2.getUri());
        setQrCodeUri(uri);
        setTimeout(() => {
          setSelectedWallet(sWallet);
          changeWalletStep("CONNECT" /* Connect */);
        }, uri ? 0 : 50);
        const provider = await (sWallet == null ? void 0 : sWallet.connector.getProvider());
        const connection = (_b = provider == null ? void 0 : provider.signer) == null ? void 0 : _b.connection;
        if ((connection == null ? void 0 : connection.on) && (connection == null ? void 0 : connection.off)) {
          const handleConnectionClose = () => {
            removeHandlers();
            selectWallet(wallet);
          };
          const removeHandlers = () => {
            connection.off("close", handleConnectionClose);
            connection.off("open", removeHandlers);
          };
          connection.on("close", handleConnectionClose);
          connection.on("open", removeHandlers);
        }
      });
    } else {
      setSelectedWallet(wallet);
      changeWalletStep((wallet == null ? void 0 : wallet.extensionDownloadUrl) ? "DOWNLOAD_OPTIONS" /* DownloadOptions */ : "CONNECT" /* Connect */);
    }
  };
  const getWalletDownload = (id) => {
    var _a;
    setSelectedOptionId(id);
    const sWallet = wallets.find((w) => id === w.id);
    const isMobile2 = (_a = sWallet == null ? void 0 : sWallet.downloadUrls) == null ? void 0 : _a.qrCode;
    const isExtension = !!(sWallet == null ? void 0 : sWallet.extensionDownloadUrl);
    setSelectedWallet(sWallet);
    if (isMobile2 && isExtension) {
      changeWalletStep("DOWNLOAD_OPTIONS" /* DownloadOptions */);
    } else if (isMobile2) {
      changeWalletStep("DOWNLOAD" /* Download */);
    } else {
      changeWalletStep("INSTRUCTIONS_EXTENSION" /* InstructionsExtension */);
    }
  };
  const clearSelectedWallet = () => {
    setSelectedOptionId(void 0);
    setSelectedWallet(void 0);
    setQrCodeUri(void 0);
  };
  const changeWalletStep = (newWalletStep, isBack = false) => {
    if (isBack && newWalletStep === "GET" /* Get */ && initialWalletStep === "GET" /* Get */) {
      clearSelectedWallet();
    } else if (!isBack && newWalletStep === "GET" /* Get */) {
      setInitialWalletStep("GET" /* Get */);
    } else if (!isBack && newWalletStep === "CONNECT" /* Connect */) {
      setInitialWalletStep("CONNECT" /* Connect */);
    }
    setWalletStep(newWalletStep);
  };
  const [initialWalletStep, setInitialWalletStep] = useState8("NONE" /* None */);
  const [walletStep, setWalletStep] = useState8("NONE" /* None */);
  let walletContent = null;
  let headerLabel = null;
  let headerBackButtonLink = null;
  let headerBackButtonCallback;
  useEffect15(() => {
    setConnectionError(false);
  }, [walletStep, selectedWallet]);
  const hasExtension = !!(selectedWallet == null ? void 0 : selectedWallet.extensionDownloadUrl);
  const hasExtensionAndMobile = !!(hasExtension && (selectedWallet == null ? void 0 : selectedWallet.mobileDownloadUrl));
  switch (walletStep) {
    case "NONE" /* None */:
      walletContent = /* @__PURE__ */ React50.createElement(ConnectModalIntro, {
        getWallet: () => changeWalletStep("GET" /* Get */)
      });
      break;
    case "LEARN_COMPACT" /* LearnCompact */:
      walletContent = /* @__PURE__ */ React50.createElement(ConnectModalIntro, {
        compactModeEnabled,
        getWallet: () => changeWalletStep("GET" /* Get */)
      });
      headerLabel = i18n2.t("intro.title");
      headerBackButtonLink = "NONE" /* None */;
      break;
    case "GET" /* Get */:
      walletContent = /* @__PURE__ */ React50.createElement(GetDetail, {
        getWalletDownload,
        compactModeEnabled
      });
      headerLabel = i18n2.t("get.title");
      headerBackButtonLink = compactModeEnabled ? "LEARN_COMPACT" /* LearnCompact */ : "NONE" /* None */;
      break;
    case "CONNECT" /* Connect */:
      walletContent = selectedWallet && /* @__PURE__ */ React50.createElement(ConnectDetail, {
        changeWalletStep,
        compactModeEnabled,
        connectionError,
        onClose,
        qrCodeUri,
        reconnect: connectToWallet,
        wallet: selectedWallet
      });
      headerLabel = hasQrCode && (selectedWallet.name === "WalletConnect" ? i18n2.t("connect_scan.fallback_title") : i18n2.t("connect_scan.title", {
        wallet: selectedWallet.name
      }));
      headerBackButtonLink = compactModeEnabled ? "NONE" /* None */ : null;
      headerBackButtonCallback = compactModeEnabled ? clearSelectedWallet : () => {
      };
      break;
    case "DOWNLOAD_OPTIONS" /* DownloadOptions */:
      walletContent = selectedWallet && /* @__PURE__ */ React50.createElement(DownloadOptionsDetail, {
        changeWalletStep,
        wallet: selectedWallet
      });
      headerLabel = selectedWallet && i18n2.t("get_options.short_title", { wallet: selectedWallet.name });
      headerBackButtonLink = hasExtensionAndMobile && "CONNECT" /* Connect */ ? initialWalletStep : null;
      break;
    case "DOWNLOAD" /* Download */:
      walletContent = selectedWallet && /* @__PURE__ */ React50.createElement(DownloadDetail, {
        changeWalletStep,
        wallet: selectedWallet
      });
      headerLabel = selectedWallet && i18n2.t("get_mobile.title", { wallet: selectedWallet.name });
      headerBackButtonLink = hasExtensionAndMobile ? "DOWNLOAD_OPTIONS" /* DownloadOptions */ : initialWalletStep;
      break;
    case "INSTRUCTIONS_MOBILE" /* InstructionsMobile */:
      walletContent = selectedWallet && /* @__PURE__ */ React50.createElement(InstructionMobileDetail, {
        connectWallet: selectWallet,
        wallet: selectedWallet
      });
      headerLabel = selectedWallet && i18n2.t("get_options.title", {
        wallet: compactModeEnabled ? selectedWallet.shortName || selectedWallet.name : selectedWallet.name
      });
      headerBackButtonLink = "DOWNLOAD" /* Download */;
      break;
    case "INSTRUCTIONS_EXTENSION" /* InstructionsExtension */:
      walletContent = selectedWallet && /* @__PURE__ */ React50.createElement(InstructionExtensionDetail, {
        wallet: selectedWallet
      });
      headerLabel = selectedWallet && i18n2.t("get_options.title", {
        wallet: compactModeEnabled ? selectedWallet.shortName || selectedWallet.name : selectedWallet.name
      });
      headerBackButtonLink = "DOWNLOAD_OPTIONS" /* DownloadOptions */;
      break;
    default:
      break;
  }
  return /* @__PURE__ */ React50.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    style: { maxHeight: compactModeEnabled ? 468 : 504 }
  }, (compactModeEnabled ? walletStep === "NONE" /* None */ : true) && /* @__PURE__ */ React50.createElement(Box, {
    className: compactModeEnabled ? sidebarCompactMode : sidebar,
    display: "flex",
    flexDirection: "column",
    marginTop: "16"
  }, /* @__PURE__ */ React50.createElement(Box, {
    display: "flex",
    justifyContent: "space-between"
  }, compactModeEnabled && Disclaimer && /* @__PURE__ */ React50.createElement(Box, {
    marginLeft: "16",
    width: "28"
  }, /* @__PURE__ */ React50.createElement(InfoButton, {
    onClick: () => changeWalletStep("LEARN_COMPACT" /* LearnCompact */)
  })), compactModeEnabled && !Disclaimer && /* @__PURE__ */ React50.createElement(Box, {
    marginLeft: "16",
    width: "28"
  }), /* @__PURE__ */ React50.createElement(Box, {
    marginLeft: compactModeEnabled ? "0" : "6",
    paddingBottom: "8",
    paddingTop: "2",
    paddingX: "18"
  }, /* @__PURE__ */ React50.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: "18",
    weight: "heavy",
    testId: "connect-header-label"
  }, i18n2.t("connect.title"))), compactModeEnabled && /* @__PURE__ */ React50.createElement(Box, {
    marginRight: "16"
  }, /* @__PURE__ */ React50.createElement(CloseButton, {
    onClose
  }))), /* @__PURE__ */ React50.createElement(Box, {
    className: ScrollClassName,
    paddingBottom: "18"
  }, Object.entries(groupedWallets).map(([groupName, wallets2], index) => wallets2.length > 0 && /* @__PURE__ */ React50.createElement(Fragment2, {
    key: index
  }, groupName ? /* @__PURE__ */ React50.createElement(Box, {
    marginBottom: "8",
    marginTop: "16",
    marginX: "6"
  }, /* @__PURE__ */ React50.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "bold"
  }, supportedI18nGroupNames.includes(groupName) ? i18n2.t(`connector_group.${groupName.toLowerCase()}`) : groupName)) : null, /* @__PURE__ */ React50.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, wallets2.map((wallet) => {
    return /* @__PURE__ */ React50.createElement(ModalSelection, {
      currentlySelected: wallet.id === selectedOptionId,
      iconBackground: wallet.iconBackground,
      iconUrl: wallet.iconUrl,
      key: wallet.id,
      name: wallet.name,
      onClick: () => selectWallet(wallet),
      ready: wallet.ready,
      recent: wallet.recent,
      testId: `wallet-option-${wallet.id}`
    });
  }))))), compactModeEnabled && /* @__PURE__ */ React50.createElement(React50.Fragment, null, /* @__PURE__ */ React50.createElement(Box, {
    background: "generalBorder",
    height: "1",
    marginTop: "-1"
  }), Disclaimer ? /* @__PURE__ */ React50.createElement(Box, {
    paddingX: "24",
    paddingY: "16",
    textAlign: "center"
  }, /* @__PURE__ */ React50.createElement(Disclaimer, {
    Link: DisclaimerLink,
    Text: DisclaimerText
  })) : /* @__PURE__ */ React50.createElement(Box, {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    paddingX: "24",
    paddingY: "16"
  }, /* @__PURE__ */ React50.createElement(Box, {
    paddingY: "4"
  }, /* @__PURE__ */ React50.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, i18n2.t("connect.new_to_ethereum.description"))), /* @__PURE__ */ React50.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "4",
    justifyContent: "center"
  }, /* @__PURE__ */ React50.createElement(Box, {
    className: touchableStyles({
      active: "shrink",
      hover: "grow"
    }),
    cursor: "pointer",
    onClick: () => changeWalletStep("LEARN_COMPACT" /* LearnCompact */),
    paddingY: "4",
    style: { willChange: "transform" },
    transition: "default"
  }, /* @__PURE__ */ React50.createElement(Text, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, i18n2.t("connect.new_to_ethereum.learn_more.label"))))))), (compactModeEnabled ? walletStep !== "NONE" /* None */ : true) && /* @__PURE__ */ React50.createElement(React50.Fragment, null, !compactModeEnabled && /* @__PURE__ */ React50.createElement(Box, {
    background: "generalBorder",
    minWidth: "1",
    width: "1"
  }), /* @__PURE__ */ React50.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    margin: "16",
    style: { flexGrow: 1 }
  }, /* @__PURE__ */ React50.createElement(Box, {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12"
  }, /* @__PURE__ */ React50.createElement(Box, {
    width: "28"
  }, headerBackButtonLink && /* @__PURE__ */ React50.createElement(Box, {
    as: "button",
    className: touchableStyles({
      active: "shrinkSm",
      hover: "growLg"
    }),
    color: "accentColor",
    onClick: () => {
      headerBackButtonLink && changeWalletStep(headerBackButtonLink, true);
      headerBackButtonCallback == null ? void 0 : headerBackButtonCallback();
    },
    paddingX: "8",
    paddingY: "4",
    style: {
      boxSizing: "content-box",
      height: 17,
      willChange: "transform"
    },
    transition: "default",
    type: "button"
  }, /* @__PURE__ */ React50.createElement(BackIcon, null))), /* @__PURE__ */ React50.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    style: { flexGrow: 1 }
  }, headerLabel && /* @__PURE__ */ React50.createElement(Text, {
    color: "modalText",
    size: "18",
    textAlign: "center",
    weight: "heavy"
  }, headerLabel)), /* @__PURE__ */ React50.createElement(CloseButton, {
    onClose
  })), /* @__PURE__ */ React50.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    style: { minHeight: compactModeEnabled ? 396 : 432 }
  }, /* @__PURE__ */ React50.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "6",
    height: "full",
    justifyContent: "center",
    marginX: "8"
  }, walletContent)))));
}

// src/components/ConnectOptions/MobileOptions.tsx
import React51, { useCallback as useCallback8, useContext as useContext15, useState as useState9 } from "react";

// src/components/ConnectOptions/MobileOptions.css.ts
var scroll = "_1am14410";

// src/components/ConnectOptions/MobileOptions.tsx
function WalletButton({
  onClose,
  wallet
}) {
  const {
    connect: connect14,
    connector,
    iconBackground,
    iconUrl,
    id,
    mobile,
    name,
    onConnecting,
    ready,
    shortName
  } = wallet;
  const getMobileUri = mobile == null ? void 0 : mobile.getUri;
  const coolModeRef = useCoolMode(iconUrl);
  const i18n2 = useContext15(I18nContext);
  return /* @__PURE__ */ React51.createElement(Box, {
    as: "button",
    color: ready ? "modalText" : "modalTextSecondary",
    disabled: !ready,
    fontFamily: "body",
    key: id,
    onClick: useCallback8(async () => {
      if (id === "walletConnect")
        onClose == null ? void 0 : onClose();
      connect14 == null ? void 0 : connect14();
      let callbackFired = false;
      onConnecting == null ? void 0 : onConnecting(async () => {
        if (callbackFired)
          return;
        callbackFired = true;
        if (getMobileUri) {
          const mobileUri = await getMobileUri();
          if (connector.id === "walletConnect" || connector.id === "walletConnectLegacy") {
            setWalletConnectDeepLink({ mobileUri, name });
          }
          if (mobileUri.startsWith("http")) {
            const link = document.createElement("a");
            link.href = mobileUri;
            link.target = "_blank";
            link.rel = "noreferrer noopener";
            link.click();
          } else {
            window.location.href = mobileUri;
          }
        }
      });
    }, [connector, connect14, getMobileUri, onConnecting, onClose, name, id]),
    ref: coolModeRef,
    style: { overflow: "visible", textAlign: "center" },
    testId: `wallet-option-${id}`,
    type: "button",
    width: "full"
  }, /* @__PURE__ */ React51.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, /* @__PURE__ */ React51.createElement(Box, {
    paddingBottom: "8",
    paddingTop: "10"
  }, /* @__PURE__ */ React51.createElement(AsyncImage, {
    background: iconBackground,
    borderRadius: "13",
    boxShadow: "walletLogo",
    height: "60",
    src: iconUrl,
    width: "60"
  })), /* @__PURE__ */ React51.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    textAlign: "center"
  }, /* @__PURE__ */ React51.createElement(Text, {
    as: "h2",
    color: wallet.ready ? "modalText" : "modalTextSecondary",
    size: "13",
    weight: "medium"
  }, /* @__PURE__ */ React51.createElement(Box, {
    as: "span",
    position: "relative"
  }, shortName != null ? shortName : name, !wallet.ready && " (unsupported)")), wallet.recent && /* @__PURE__ */ React51.createElement(Text, {
    color: "accentColor",
    size: "12",
    weight: "medium"
  }, i18n2.t("connect.recent")))));
}
function MobileOptions({ onClose }) {
  var _a;
  const titleId = "rk_connect_title";
  const wallets = useWalletConnectors();
  const { disclaimer: Disclaimer, learnMoreUrl } = useContext15(AppContext);
  let headerLabel = null;
  let walletContent = null;
  let headerBackgroundContrast = false;
  let headerBackButtonLink = null;
  const [walletStep, setWalletStep] = useState9("CONNECT" /* Connect */);
  const i18n2 = useContext15(I18nContext);
  const ios = isIOS();
  switch (walletStep) {
    case "CONNECT" /* Connect */: {
      headerLabel = i18n2.t("connect.title");
      headerBackgroundContrast = true;
      walletContent = /* @__PURE__ */ React51.createElement(Box, null, /* @__PURE__ */ React51.createElement(Box, {
        background: "profileForeground",
        className: scroll,
        display: "flex",
        paddingBottom: "20",
        paddingTop: "6"
      }, /* @__PURE__ */ React51.createElement(Box, {
        display: "flex",
        style: { margin: "0 auto" }
      }, wallets.filter((wallet) => wallet.ready).map((wallet) => {
        return /* @__PURE__ */ React51.createElement(Box, {
          key: wallet.id,
          paddingX: "20"
        }, /* @__PURE__ */ React51.createElement(Box, {
          width: "60"
        }, /* @__PURE__ */ React51.createElement(WalletButton, {
          onClose,
          wallet
        })));
      }))), /* @__PURE__ */ React51.createElement(Box, {
        background: "generalBorder",
        height: "1",
        marginBottom: "32",
        marginTop: "-1"
      }), /* @__PURE__ */ React51.createElement(Box, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "32",
        paddingX: "32",
        style: { textAlign: "center" }
      }, /* @__PURE__ */ React51.createElement(Box, {
        display: "flex",
        flexDirection: "column",
        gap: "8",
        textAlign: "center"
      }, /* @__PURE__ */ React51.createElement(Text, {
        color: "modalText",
        size: "16",
        weight: "bold"
      }, i18n2.t("intro.title")), /* @__PURE__ */ React51.createElement(Text, {
        color: "modalTextSecondary",
        size: "16"
      }, i18n2.t("intro.description")))), /* @__PURE__ */ React51.createElement(Box, {
        paddingTop: "32",
        paddingX: "20"
      }, /* @__PURE__ */ React51.createElement(Box, {
        display: "flex",
        gap: "14",
        justifyContent: "center"
      }, /* @__PURE__ */ React51.createElement(ActionButton, {
        label: i18n2.t("intro.get.label"),
        onClick: () => setWalletStep("GET" /* Get */),
        size: "large",
        type: "secondary"
      }), /* @__PURE__ */ React51.createElement(ActionButton, {
        href: learnMoreUrl,
        label: i18n2.t("intro.learn_more.label"),
        size: "large",
        type: "secondary"
      }))), Disclaimer && /* @__PURE__ */ React51.createElement(Box, {
        marginTop: "28",
        marginX: "32",
        textAlign: "center"
      }, /* @__PURE__ */ React51.createElement(Disclaimer, {
        Link: DisclaimerLink,
        Text: DisclaimerText
      })));
      break;
    }
    case "GET" /* Get */: {
      headerLabel = i18n2.t("get.title");
      headerBackButtonLink = "CONNECT" /* Connect */;
      const mobileWallets = (_a = wallets == null ? void 0 : wallets.filter((wallet) => {
        var _a2, _b, _c;
        return ((_a2 = wallet.downloadUrls) == null ? void 0 : _a2.ios) || ((_b = wallet.downloadUrls) == null ? void 0 : _b.android) || ((_c = wallet.downloadUrls) == null ? void 0 : _c.mobile);
      })) == null ? void 0 : _a.splice(0, 3);
      walletContent = /* @__PURE__ */ React51.createElement(Box, null, /* @__PURE__ */ React51.createElement(Box, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        height: "full",
        marginBottom: "36",
        marginTop: "5",
        paddingTop: "12",
        width: "full"
      }, mobileWallets.map((wallet, index) => {
        const { downloadUrls, iconBackground, iconUrl, name } = wallet;
        if (!(downloadUrls == null ? void 0 : downloadUrls.ios) && !(downloadUrls == null ? void 0 : downloadUrls.android) && !(downloadUrls == null ? void 0 : downloadUrls.mobile)) {
          return null;
        }
        return /* @__PURE__ */ React51.createElement(Box, {
          display: "flex",
          gap: "16",
          key: wallet.id,
          paddingX: "20",
          width: "full"
        }, /* @__PURE__ */ React51.createElement(Box, {
          style: { minHeight: 48, minWidth: 48 }
        }, /* @__PURE__ */ React51.createElement(AsyncImage, {
          background: iconBackground,
          borderColor: "generalBorder",
          borderRadius: "10",
          height: "48",
          src: iconUrl,
          width: "48"
        })), /* @__PURE__ */ React51.createElement(Box, {
          display: "flex",
          flexDirection: "column",
          width: "full"
        }, /* @__PURE__ */ React51.createElement(Box, {
          alignItems: "center",
          display: "flex",
          height: "48"
        }, /* @__PURE__ */ React51.createElement(Box, {
          width: "full"
        }, /* @__PURE__ */ React51.createElement(Text, {
          color: "modalText",
          size: "18",
          weight: "bold"
        }, name)), /* @__PURE__ */ React51.createElement(ActionButton, {
          href: (ios ? downloadUrls == null ? void 0 : downloadUrls.ios : downloadUrls == null ? void 0 : downloadUrls.android) || (downloadUrls == null ? void 0 : downloadUrls.mobile),
          label: i18n2.t("get.action.label"),
          size: "small",
          type: "secondary"
        })), index < mobileWallets.length - 1 && /* @__PURE__ */ React51.createElement(Box, {
          background: "generalBorderDim",
          height: "1",
          marginY: "10",
          width: "full"
        })));
      })), /* @__PURE__ */ React51.createElement(Box, {
        style: { marginBottom: "42px" }
      }), /* @__PURE__ */ React51.createElement(Box, {
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        gap: "36",
        paddingX: "36",
        style: { textAlign: "center" }
      }, /* @__PURE__ */ React51.createElement(Box, {
        display: "flex",
        flexDirection: "column",
        gap: "12",
        textAlign: "center"
      }, /* @__PURE__ */ React51.createElement(Text, {
        color: "modalText",
        size: "16",
        weight: "bold"
      }, i18n2.t("get.looking_for.title")), /* @__PURE__ */ React51.createElement(Text, {
        color: "modalTextSecondary",
        size: "16"
      }, i18n2.t("get.looking_for.mobile.description")))));
      break;
    }
  }
  return /* @__PURE__ */ React51.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "36"
  }, /* @__PURE__ */ React51.createElement(Box, {
    background: headerBackgroundContrast ? "profileForeground" : "modalBackground",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "4",
    paddingTop: "14"
  }, /* @__PURE__ */ React51.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "6",
    paddingX: "20",
    position: "relative"
  }, headerBackButtonLink && /* @__PURE__ */ React51.createElement(Box, {
    display: "flex",
    position: "absolute",
    style: {
      left: 0,
      marginBottom: -20,
      marginTop: -20
    }
  }, /* @__PURE__ */ React51.createElement(Box, {
    alignItems: "center",
    as: "button",
    className: touchableStyles({
      active: "shrinkSm",
      hover: "growLg"
    }),
    color: "accentColor",
    display: "flex",
    marginLeft: "4",
    marginTop: "20",
    onClick: () => setWalletStep(headerBackButtonLink),
    padding: "16",
    style: { height: 17, willChange: "transform" },
    transition: "default",
    type: "button"
  }, /* @__PURE__ */ React51.createElement(BackIcon, null))), /* @__PURE__ */ React51.createElement(Box, {
    marginTop: "4",
    textAlign: "center",
    width: "full"
  }, /* @__PURE__ */ React51.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: "20",
    weight: "bold"
  }, headerLabel)), /* @__PURE__ */ React51.createElement(Box, {
    alignItems: "center",
    display: "flex",
    height: "32",
    paddingRight: "14",
    position: "absolute",
    right: "0"
  }, /* @__PURE__ */ React51.createElement(Box, {
    style: { marginBottom: -20, marginTop: -20 }
  }, /* @__PURE__ */ React51.createElement(CloseButton, {
    onClose
  }))))), /* @__PURE__ */ React51.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, walletContent));
}

// src/components/ConnectOptions/ConnectOptions.tsx
function ConnectOptions({ onClose }) {
  return isMobile() ? /* @__PURE__ */ React52.createElement(MobileOptions, {
    onClose
  }) : /* @__PURE__ */ React52.createElement(DesktopOptions, {
    onClose
  });
}

// src/components/ConnectModal/ConnectModal.tsx
function ConnectModal({ onClose, open }) {
  const titleId = "rk_connect_title";
  const connectionStatus = useConnectionStatus();
  const { disconnect } = useDisconnect3();
  const onAuthCancel = React53.useCallback(() => {
    onClose();
    disconnect();
  }, [onClose, disconnect]);
  if (connectionStatus === "disconnected") {
    return /* @__PURE__ */ React53.createElement(Dialog, {
      onClose,
      open,
      titleId
    }, /* @__PURE__ */ React53.createElement(DialogContent, {
      bottomSheetOnMobile: true,
      padding: "0",
      wide: true
    }, /* @__PURE__ */ React53.createElement(ConnectOptions, {
      onClose
    })));
  }
  if (connectionStatus === "unauthenticated") {
    return /* @__PURE__ */ React53.createElement(Dialog, {
      onClose: onAuthCancel,
      open,
      titleId
    }, /* @__PURE__ */ React53.createElement(DialogContent, {
      bottomSheetOnMobile: true,
      padding: "0"
    }, /* @__PURE__ */ React53.createElement(SignIn, {
      onClose: onAuthCancel
    })));
  }
  return null;
}

// src/components/RainbowKitProvider/ModalContext.tsx
function useModalStateValue() {
  const [isModalOpen, setModalOpen] = useState10(false);
  return {
    closeModal: useCallback9(() => setModalOpen(false), []),
    isModalOpen,
    openModal: useCallback9(() => setModalOpen(true), [])
  };
}
var ModalContext = createContext11({
  accountModalOpen: false,
  chainModalOpen: false,
  connectModalOpen: false
});
function ModalProvider({ children }) {
  const {
    closeModal: closeConnectModal,
    isModalOpen: connectModalOpen,
    openModal: openConnectModal
  } = useModalStateValue();
  const {
    closeModal: closeAccountModal,
    isModalOpen: accountModalOpen,
    openModal: openAccountModal
  } = useModalStateValue();
  const {
    closeModal: closeChainModal,
    isModalOpen: chainModalOpen,
    openModal: openChainModal
  } = useModalStateValue();
  const connectionStatus = useConnectionStatus();
  const { chain } = useNetwork6();
  const chainSupported = !(chain == null ? void 0 : chain.unsupported);
  function closeModals({
    keepConnectModalOpen = false
  } = {}) {
    if (!keepConnectModalOpen) {
      closeConnectModal();
    }
    closeAccountModal();
    closeChainModal();
  }
  const isUnauthenticated = useAuthenticationStatus() === "unauthenticated";
  useAccount10({
    onConnect: () => closeModals({ keepConnectModalOpen: isUnauthenticated }),
    onDisconnect: () => closeModals()
  });
  return /* @__PURE__ */ React54.createElement(ModalContext.Provider, {
    value: useMemo7(() => ({
      accountModalOpen,
      chainModalOpen,
      connectModalOpen,
      openAccountModal: chainSupported && connectionStatus === "connected" ? openAccountModal : void 0,
      openChainModal: connectionStatus === "connected" ? openChainModal : void 0,
      openConnectModal: connectionStatus === "disconnected" || connectionStatus === "unauthenticated" ? openConnectModal : void 0
    }), [
      connectionStatus,
      chainSupported,
      accountModalOpen,
      chainModalOpen,
      connectModalOpen,
      openAccountModal,
      openChainModal,
      openConnectModal
    ])
  }, children, /* @__PURE__ */ React54.createElement(ConnectModal, {
    onClose: closeConnectModal,
    open: connectModalOpen
  }), /* @__PURE__ */ React54.createElement(AccountModal, {
    onClose: closeAccountModal,
    open: accountModalOpen
  }), /* @__PURE__ */ React54.createElement(ChainModal, {
    onClose: closeChainModal,
    open: chainModalOpen
  }));
}
function useModalState() {
  const { accountModalOpen, chainModalOpen, connectModalOpen } = useContext16(ModalContext);
  return {
    accountModalOpen,
    chainModalOpen,
    connectModalOpen
  };
}
function useAccountModal() {
  const { accountModalOpen, openAccountModal } = useContext16(ModalContext);
  return { accountModalOpen, openAccountModal };
}
function useChainModal() {
  const { chainModalOpen, openChainModal } = useContext16(ModalContext);
  return { chainModalOpen, openChainModal };
}
function useConnectModal() {
  const { connectModalOpen, openConnectModal } = useContext16(ModalContext);
  return { connectModalOpen, openConnectModal };
}

// src/components/ConnectButton/ConnectButtonRenderer.tsx
var noop = () => {
};
function ConnectButtonRenderer({
  children
}) {
  var _a, _b, _c, _d;
  const mounted = useIsMounted();
  const { address } = useAccount11();
  const ensName = useMainnetEnsName(address);
  const ensAvatar = useMainnetEnsAvatar(ensName);
  const { data: balanceData } = useBalance2({ address });
  const { chain: activeChain } = useNetwork7();
  const rainbowkitChainsById = useRainbowKitChainsById();
  const authenticationStatus = (_a = useAuthenticationStatus()) != null ? _a : void 0;
  const rainbowKitChain = activeChain ? rainbowkitChainsById[activeChain.id] : void 0;
  const chainName = (_b = rainbowKitChain == null ? void 0 : rainbowKitChain.name) != null ? _b : void 0;
  const chainIconUrl = (_c = rainbowKitChain == null ? void 0 : rainbowKitChain.iconUrl) != null ? _c : void 0;
  const chainIconBackground = (_d = rainbowKitChain == null ? void 0 : rainbowKitChain.iconBackground) != null ? _d : void 0;
  const resolvedChainIconUrl = useAsyncImage(chainIconUrl);
  const showRecentTransactions = useContext17(ShowRecentTransactionsContext);
  const hasPendingTransactions = useRecentTransactions().some(({ status }) => status === "pending") && showRecentTransactions;
  const displayBalance = balanceData ? `${abbreviateETHBalance(parseFloat(balanceData.formatted))} ${balanceData.symbol}` : void 0;
  const { openConnectModal } = useConnectModal();
  const { openChainModal } = useChainModal();
  const { openAccountModal } = useAccountModal();
  const { accountModalOpen, chainModalOpen, connectModalOpen } = useModalState();
  return /* @__PURE__ */ React55.createElement(React55.Fragment, null, children({
    account: address ? {
      address,
      balanceDecimals: balanceData == null ? void 0 : balanceData.decimals,
      balanceFormatted: balanceData == null ? void 0 : balanceData.formatted,
      balanceSymbol: balanceData == null ? void 0 : balanceData.symbol,
      displayBalance,
      displayName: ensName ? formatENS(ensName) : formatAddress(address),
      ensAvatar: ensAvatar != null ? ensAvatar : void 0,
      ensName: ensName != null ? ensName : void 0,
      hasPendingTransactions
    } : void 0,
    accountModalOpen,
    authenticationStatus,
    chain: activeChain ? {
      hasIcon: Boolean(chainIconUrl),
      iconBackground: chainIconBackground,
      iconUrl: resolvedChainIconUrl,
      id: activeChain.id,
      name: chainName != null ? chainName : activeChain.name,
      unsupported: activeChain.unsupported
    } : void 0,
    chainModalOpen,
    connectModalOpen,
    mounted,
    openAccountModal: openAccountModal != null ? openAccountModal : noop,
    openChainModal: openChainModal != null ? openChainModal : noop,
    openConnectModal: openConnectModal != null ? openConnectModal : noop
  }));
}
ConnectButtonRenderer.displayName = "ConnectButton.Custom";

// src/components/ConnectButton/ConnectButton.tsx
var defaultProps = {
  accountStatus: "full",
  chainStatus: { largeScreen: "full", smallScreen: "icon" },
  label: "Connect Wallet",
  showBalance: { largeScreen: true, smallScreen: false }
};
function ConnectButton({
  accountStatus = defaultProps.accountStatus,
  chainStatus = defaultProps.chainStatus,
  label = defaultProps.label,
  showBalance = defaultProps.showBalance
}) {
  const chains14 = useRainbowKitChains();
  const connectionStatus = useConnectionStatus();
  const i18n2 = useContext18(I18nContext);
  return /* @__PURE__ */ React56.createElement(ConnectButtonRenderer, null, ({
    account,
    chain,
    mounted,
    openAccountModal,
    openChainModal,
    openConnectModal
  }) => {
    var _a, _b, _c;
    const ready = mounted && connectionStatus !== "loading";
    const unsupportedChain = (_a = chain == null ? void 0 : chain.unsupported) != null ? _a : false;
    return /* @__PURE__ */ React56.createElement(Box, {
      display: "flex",
      gap: "12",
      ...!ready && {
        "aria-hidden": true,
        style: {
          opacity: 0,
          pointerEvents: "none",
          userSelect: "none"
        }
      }
    }, ready && account && connectionStatus === "connected" ? /* @__PURE__ */ React56.createElement(React56.Fragment, null, chain && (chains14.length > 1 || unsupportedChain) && /* @__PURE__ */ React56.createElement(Box, {
      alignItems: "center",
      "aria-label": "Chain Selector",
      as: "button",
      background: unsupportedChain ? "connectButtonBackgroundError" : "connectButtonBackground",
      borderRadius: "connectButton",
      boxShadow: "connectButton",
      className: touchableStyles({
        active: "shrink",
        hover: "grow"
      }),
      color: unsupportedChain ? "connectButtonTextError" : "connectButtonText",
      display: mapResponsiveValue(chainStatus, (value) => value === "none" ? "none" : "flex"),
      fontFamily: "body",
      fontWeight: "bold",
      gap: "6",
      key: unsupportedChain ? "unsupported" : "supported",
      onClick: openChainModal,
      paddingX: "10",
      paddingY: "8",
      testId: unsupportedChain ? "wrong-network-button" : "chain-button",
      transition: "default",
      type: "button"
    }, unsupportedChain ? /* @__PURE__ */ React56.createElement(Box, {
      alignItems: "center",
      display: "flex",
      height: "24",
      paddingX: "4"
    }, "Wrong network") : /* @__PURE__ */ React56.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "6"
    }, chain.hasIcon ? /* @__PURE__ */ React56.createElement(Box, {
      display: mapResponsiveValue(chainStatus, (value) => value === "full" || value === "icon" ? "block" : "none"),
      height: "24",
      width: "24"
    }, /* @__PURE__ */ React56.createElement(AsyncImage, {
      alt: (_b = chain.name) != null ? _b : "Chain icon",
      background: chain.iconBackground,
      borderRadius: "full",
      height: "24",
      src: chain.iconUrl,
      width: "24"
    })) : null, /* @__PURE__ */ React56.createElement(Box, {
      display: mapResponsiveValue(chainStatus, (value) => {
        if (value === "icon" && !chain.iconUrl) {
          return "block";
        }
        return value === "full" || value === "name" ? "block" : "none";
      })
    }, (_c = chain.name) != null ? _c : chain.id)), /* @__PURE__ */ React56.createElement(DropdownIcon, null)), !unsupportedChain && /* @__PURE__ */ React56.createElement(Box, {
      alignItems: "center",
      as: "button",
      background: "connectButtonBackground",
      borderRadius: "connectButton",
      boxShadow: "connectButton",
      className: touchableStyles({
        active: "shrink",
        hover: "grow"
      }),
      color: "connectButtonText",
      display: "flex",
      fontFamily: "body",
      fontWeight: "bold",
      onClick: openAccountModal,
      testId: "account-button",
      transition: "default",
      type: "button"
    }, account.displayBalance && /* @__PURE__ */ React56.createElement(Box, {
      display: mapResponsiveValue(showBalance, (value) => value ? "block" : "none"),
      padding: "8",
      paddingLeft: "12"
    }, account.displayBalance), /* @__PURE__ */ React56.createElement(Box, {
      background: normalizeResponsiveValue(showBalance)[isMobile() ? "smallScreen" : "largeScreen"] ? "connectButtonInnerBackground" : "connectButtonBackground",
      borderColor: "connectButtonBackground",
      borderRadius: "connectButton",
      borderStyle: "solid",
      borderWidth: "2",
      color: "connectButtonText",
      fontFamily: "body",
      fontWeight: "bold",
      paddingX: "8",
      paddingY: "6",
      transition: "default"
    }, /* @__PURE__ */ React56.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "6",
      height: "24"
    }, /* @__PURE__ */ React56.createElement(Box, {
      display: mapResponsiveValue(accountStatus, (value) => value === "full" || value === "avatar" ? "block" : "none")
    }, /* @__PURE__ */ React56.createElement(Avatar, {
      address: account.address,
      imageUrl: account.ensAvatar,
      loading: account.hasPendingTransactions,
      size: 24
    })), /* @__PURE__ */ React56.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "6"
    }, /* @__PURE__ */ React56.createElement(Box, {
      display: mapResponsiveValue(accountStatus, (value) => value === "full" || value === "address" ? "block" : "none")
    }, account.displayName), /* @__PURE__ */ React56.createElement(DropdownIcon, null)))))) : /* @__PURE__ */ React56.createElement(Box, {
      as: "button",
      background: "accentColor",
      borderRadius: "connectButton",
      boxShadow: "connectButton",
      className: touchableStyles({ active: "shrink", hover: "grow" }),
      color: "accentColorForeground",
      fontFamily: "body",
      fontWeight: "bold",
      height: "40",
      key: "connect",
      onClick: openConnectModal,
      paddingX: "14",
      testId: "connect-button",
      transition: "default",
      type: "button"
    }, mounted && label === "Connect Wallet" ? i18n2.t("connect_wallet.label") : label));
  });
}
ConnectButton.__defaultProps = defaultProps;
ConnectButton.Custom = ConnectButtonRenderer;

export {
  createAuthenticationAdapter,
  RainbowKitAuthenticationProvider,
  isAndroid,
  isIOS,
  isMobile,
  useChainId,
  useTransactionStore,
  cssObjectFromTheme,
  cssStringFromTheme,
  RainbowKitProvider,
  dialogContent,
  dialogContentMobile,
  isHexString,
  DesktopOptions,
  MobileOptions,
  useAccountModal,
  useChainModal,
  useConnectModal,
  ConnectButton
};
